/* tslint:disable */
/* eslint-disable */
/**
 * 
 * @export
 * @interface Absentee
 */
export interface Absentee {
    /**
     * 
     * @type {WorkerView}
     * @memberof Absentee
     */
    worker: WorkerView;
    /**
     * 
     * @type {number}
     * @memberof Absentee
     */
    numberOfAssignedProductionLots: number;
}
/**
 * 
 * @export
 * @interface AbsenteesResponse
 */
export interface AbsenteesResponse {
    /**
     * 
     * @type {Array<Absentee>}
     * @memberof AbsenteesResponse
     */
    absentees?: Array<Absentee>;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * AddressId
     * @type {number}
     * @memberof Address
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    streetAndNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    streetNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    houseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    postTown?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    iln?: string;
    /**
     * 
     * @type {Coordinates}
     * @memberof Address
     */
    coordinates?: Coordinates;
}
/**
 * @type AjaxAction
 * 
 * @export
 */
export type AjaxAction = { name: 'closeModal' } & CloseModal | { name: 'failure' } & AjaxFailure | { name: 'openModal' } & ShowModalAction | { name: 'redirect' } & RedirectAction | { name: 'refresh' } & RefreshPageAction | { name: 'refreshAfterModal' } & RefreshAfterModal | { name: 'revertDnDOnModalClose' } & RevertDnDOnModalClose | { name: 'showMessages' } & MessagesAction | { name: 'success' } & AjaxSuccess | { name: 'validationResult' } & ValidationResult;
/**
 * 
 * @export
 * @interface AjaxActionResponse
 */
export interface AjaxActionResponse {
    /**
     * 
     * @type {Array<AjaxAction>}
     * @memberof AjaxActionResponse
     */
    actions?: Array<AjaxAction>;
}
/**
 * 
 * @export
 * @interface AjaxFailure
 */
export interface AjaxFailure {
    /**
     * 
     * @type {string}
     * @memberof AjaxFailure
     */
    name: string;
}
/**
 * 
 * @export
 * @interface AjaxSuccess
 */
export interface AjaxSuccess {
    /**
     * 
     * @type {string}
     * @memberof AjaxSuccess
     */
    name: string;
}
/**
 * 
 * @export
 * @interface AjaxSuccessWithParam
 */
export interface AjaxSuccessWithParam {
    /**
     * 
     * @type {string}
     * @memberof AjaxSuccessWithParam
     */
    name: string;
    /**
     * 
     * @type {JsObject3}
     * @memberof AjaxSuccessWithParam
     */
    params: JsObject3;
}
/**
 * 
 * @export
 * @interface AllContractorsItemGroup
 */
export interface AllContractorsItemGroup {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof AllContractorsItemGroup
     */
    id?: number;
    /**
     * 
     * @type {ItemTypeTag}
     * @memberof AllContractorsItemGroup
     */
    itemTypeTag: ItemTypeTag;
    /**
     * 
     * @type {number}
     * @memberof AllContractorsItemGroup
     */
    discount: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof AllContractorsItemGroup
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface AllContractorsSingleItemType
 */
export interface AllContractorsSingleItemType {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof AllContractorsSingleItemType
     */
    id?: number;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof AllContractorsSingleItemType
     */
    itemTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof AllContractorsSingleItemType
     */
    discount: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof AllContractorsSingleItemType
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface AllMachines
 */
export interface AllMachines {
    /**
     * 
     * @type {EstimatedProductionTimeScopeType}
     * @memberof AllMachines
     */
    scopeType: EstimatedProductionTimeScopeType;
}
/**
 * 
 * @export
 * @interface AllMachinesInTheArea
 */
export interface AllMachinesInTheArea {
    /**
     * MachineAreaId
     * @type {number}
     * @memberof AllMachinesInTheArea
     */
    areaId: number;
    /**
     * 
     * @type {EstimatedProductionTimeScopeType}
     * @memberof AllMachinesInTheArea
     */
    scopeType: EstimatedProductionTimeScopeType;
}
/**
 * Code was resolved as EAN but it points to more than one item, more scans are needed to fully resolve item
 * @export
 * @interface AmbiguousEan
 */
export interface AmbiguousEan {
    /**
     * 
     * @type {string}
     * @memberof AmbiguousEan
     */
    ean: string;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof AmbiguousEan
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface AmbiguousPlaceDefined
 */
export interface AmbiguousPlaceDefined {
    /**
     * 
     * @type {string}
     * @memberof AmbiguousPlaceDefined
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AmbiguousPlaceDefined
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof AmbiguousPlaceDefined
     */
    index: number;
}
/**
 * @type AmbiguousPlaceDefinedOrNoPlaceDefined
 * 
 * @export
 */
export type AmbiguousPlaceDefinedOrNoPlaceDefined = { name: 'AmbiguousPlaceDefined' } & AmbiguousPlaceDefined | { name: 'NoPlaceDefined' } & NoPlaceDefined;
/**
 * @type AmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor
 * 
 * @export
 */
export type AmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor = { name: 'AmbiguousPlaceDefined' } & AmbiguousPlaceDefined | { name: 'NoPlaceDefined' } & NoPlaceDefined | { name: 'SupplyOrderHasNoContractor' } & SupplyOrderHasNoContractor;
/**
 * 
 * @export
 * @interface AmountInPlace
 */
export interface AmountInPlace {
    /**
     * 
     * @type {Place}
     * @memberof AmountInPlace
     */
    place: Place;
    /**
     * 
     * @type {number}
     * @memberof AmountInPlace
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface AmountOfItemTypeVariant
 */
export interface AmountOfItemTypeVariant {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof AmountOfItemTypeVariant
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof AmountOfItemTypeVariant
     */
    amountWithUnit: AmountWithUnit;
}
/**
 * 
 * @export
 * @interface AmountToProduce
 */
export interface AmountToProduce {
    /**
     * 
     * @type {AmountWithEstimatedTime}
     * @memberof AmountToProduce
     */
    toMinimalState: AmountWithEstimatedTime;
    /**
     * 
     * @type {AmountWithEstimatedTime}
     * @memberof AmountToProduce
     */
    toSafetyStock: AmountWithEstimatedTime;
    /**
     * 
     * @type {AmountWithEstimatedTime}
     * @memberof AmountToProduce
     */
    toZero: AmountWithEstimatedTime;
    /**
     * 
     * @type {AmountWithEstimatedTime}
     * @memberof AmountToProduce
     */
    toShiftTime: AmountWithEstimatedTime;
}
/**
 * 
 * @export
 * @interface AmountUpdate
 */
export interface AmountUpdate {
    /**
     * 
     * @type {number}
     * @memberof AmountUpdate
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof AmountUpdate
     */
    materialWidth?: string;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof AmountUpdate
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface AmountWithEstimatedTime
 */
export interface AmountWithEstimatedTime {
    /**
     * 
     * @type {number}
     * @memberof AmountWithEstimatedTime
     */
    amount: number;
    /**
     * Count of seconds
     * @type {number}
     * @memberof AmountWithEstimatedTime
     */
    estimatedTime: number;
}
/**
 * 
 * @export
 * @interface AmountWithOptionalUnit
 */
export interface AmountWithOptionalUnit {
    /**
     * 
     * @type {number}
     * @memberof AmountWithOptionalUnit
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof AmountWithOptionalUnit
     */
    maybeUnitType?: string;
}
/**
 * 
 * @export
 * @interface AmountWithUnit
 */
export interface AmountWithUnit {
    /**
     * 
     * @type {number}
     * @memberof AmountWithUnit
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof AmountWithUnit
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface AnnualLeaveCalendarEvent
 */
export interface AnnualLeaveCalendarEvent {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof AnnualLeaveCalendarEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AnnualLeaveCalendarEvent
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof AnnualLeaveCalendarEvent
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof AnnualLeaveCalendarEvent
     */
    registrantName: string;
    /**
     * 
     * @type {string}
     * @memberof AnnualLeaveCalendarEvent
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AnnualLeaveCalendarEvent
     */
    allDay: boolean;
    /**
     * 
     * @type {CalendarEventType}
     * @memberof AnnualLeaveCalendarEvent
     */
    calendarEventType: CalendarEventType;
    /**
     * 
     * @type {WorkerEventCalendarType}
     * @memberof AnnualLeaveCalendarEvent
     */
    eventType: WorkerEventCalendarType;
}
/**
 * 
 * @export
 * @interface ApiProductionLotView
 */
export interface ApiProductionLotView {
    /**
     * 
     * @type {string}
     * @memberof ApiProductionLotView
     */
    code: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiProductionLotView
     */
    childrenCodes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiProductionLotView
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiProductionLotView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ApiProductionLotView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof ApiProductionLotView
     */
    operationCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiProductionLotView
     */
    productCode: string;
    /**
     * 
     * @type {string}
     * @memberof ApiProductionLotView
     */
    recipeVersionName: string;
    /**
     * 
     * @type {string}
     * @memberof ApiProductionLotView
     */
    productName?: string;
}
/**
 * 
 * @export
 * @interface ApiProductionOrderImportView
 */
export interface ApiProductionOrderImportView {
    /**
     * 
     * @type {Array<ApiProductionLotView>}
     * @memberof ApiProductionOrderImportView
     */
    lotViews?: Array<ApiProductionLotView>;
    /**
     * 
     * @type {ErpType}
     * @memberof ApiProductionOrderImportView
     */
    erp: ErpType;
    /**
     * 
     * @type {string}
     * @memberof ApiProductionOrderImportView
     */
    code: string;
}
/**
 * 
 * @export
 * @interface AppConfiguration
 */
export interface AppConfiguration {
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof AppConfiguration
     */
    serverVersion: string;
    /**
     * 
     * @type {AppEnv}
     * @memberof AppConfiguration
     */
    env: AppEnv;
    /**
     * 
     * @type {NewLotCreationForUnfinished}
     * @memberof AppConfiguration
     */
    newLotCreationForUnfinished: NewLotCreationForUnfinished;
    /**
     * 
     * @type {boolean}
     * @memberof AppConfiguration
     */
    fastCompletionAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppConfiguration
     */
    splitProductionOrderByRootOnSave: boolean;
    /**
     * 
     * @type {number}
     * @memberof AppConfiguration
     */
    overduePeriodThreshold: number;
    /**
     * 
     * @type {WorkstationReportThresholds}
     * @memberof AppConfiguration
     */
    workstationReportThresholds: WorkstationReportThresholds;
}

/**
 * 
 * @export
 */
export const AppEnv = {
    local: 1,
    test: 2,
    stage: 3,
    prod: 4
} as const;
export type AppEnv = typeof AppEnv[keyof typeof AppEnv];

/**
 * 
 * @export
 * @interface Applied
 */
export interface Applied {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof Applied
     */
    mapping: { [key: string]: number; };
    /**
     * 
     * @type {NexelemMergeImportStateType}
     * @memberof Applied
     */
    tpe: NexelemMergeImportStateType;
}
/**
 * 
 * @export
 * @interface AutoAssignWorkersOnAreasRequest
 */
export interface AutoAssignWorkersOnAreasRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AutoAssignWorkersOnAreasRequest
     */
    machineAreaIds: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AutoAssignWorkersOnAreasRequest
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof AutoAssignWorkersOnAreasRequest
     */
    to: string;
}
/**
 * 
 * @export
 * @interface AutoAssignWorkersRequest
 */
export interface AutoAssignWorkersRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AutoAssignWorkersRequest
     */
    machineAreaIds: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AutoAssignWorkersRequest
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof AutoAssignWorkersRequest
     */
    to: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AutoAssignWorkersRequest
     */
    workerGroupIds: Array<number>;
    /**
     * 
     * @type {WorkerAssignmentRankingConfig}
     * @memberof AutoAssignWorkersRequest
     */
    rankingConfig?: WorkerAssignmentRankingConfig;
    /**
     * 
     * @type {WorkerAutoAssignmentPolicySettings}
     * @memberof AutoAssignWorkersRequest
     */
    policySettings?: WorkerAutoAssignmentPolicySettings;
}
/**
 * 
 * @export
 * @interface AutoAssignWorkersResultView
 */
export interface AutoAssignWorkersResultView {
    /**
     * 
     * @type {Array<MachineAssignmentsGroupView>}
     * @memberof AutoAssignWorkersResultView
     */
    assignmentsByMachine?: Array<MachineAssignmentsGroupView>;
    /**
     * 
     * @type {Array<UnassignedLotView>}
     * @memberof AutoAssignWorkersResultView
     */
    unassignedLots?: Array<UnassignedLotView>;
}
/**
 * @type AutoAssignmentRunningErrorOrEmptyMachineAreaIdsOrInvalidAssignTimeWindowOrResourceAssignmentsSyncFailedOrUnresolvedWorkerAssignment
 * 
 * @export
 */
export type AutoAssignmentRunningErrorOrEmptyMachineAreaIdsOrInvalidAssignTimeWindowOrResourceAssignmentsSyncFailedOrUnresolvedWorkerAssignment = { name: 'AutoAssignmentRunningError' } & LemmaSimpleErrorView | { name: 'EmptyMachineAreaIds' } & LemmaSimpleErrorView | { name: 'InvalidAssignTimeWindow' } & InvalidAssignTimeWindow | { name: 'ResourceAssignmentsSyncFailed' } & ResourceAssignmentsSyncFailed | { name: 'UnresolvedWorkerAssignment' } & UnresolvedWorkerAssignment;
/**
 * 
 * @export
 * @interface AvailabilityDetailsResponse
 */
export interface AvailabilityDetailsResponse {
    /**
     * 
     * @type {AvailabilitySummary}
     * @memberof AvailabilityDetailsResponse
     */
    summary: AvailabilitySummary;
    /**
     * 
     * @type {AvailabilityNorms}
     * @memberof AvailabilityDetailsResponse
     */
    norms: AvailabilityNorms;
    /**
     * 
     * @type {Array<WorkstationAvailabilityView>}
     * @memberof AvailabilityDetailsResponse
     */
    workstations?: Array<WorkstationAvailabilityView>;
}
/**
 * 
 * @export
 * @interface AvailabilityInputView
 */
export interface AvailabilityInputView {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityInputView
     */
    dateTime: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof AvailabilityInputView
     */
    placeId: number;
}
/**
 * 
 * @export
 * @interface AvailabilityNorms
 */
export interface AvailabilityNorms {
    /**
     * 
     * @type {number}
     * @memberof AvailabilityNorms
     */
    normOee: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilityNorms
     */
    normAvailability: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilityNorms
     */
    lowestIndicator: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilityNorms
     */
    highestIndicator: number;
}
/**
 * 
 * @export
 * @interface AvailabilitySummary
 */
export interface AvailabilitySummary {
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySummary
     */
    workPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySummary
     */
    breakPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySummary
     */
    downtimePercentage: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySummary
     */
    failurePercentage: number;
    /**
     * 
     * @type {number}
     * @memberof AvailabilitySummary
     */
    servicePercentage: number;
}
/**
 * 
 * @export
 * @interface BankAccount
 */
export interface BankAccount {
    /**
     * BankAccountId
     * @type {number}
     * @memberof BankAccount
     */
    id?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof BankAccount
     */
    contractorId: number;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    number: string;
}
/**
 * @type BarcodeAction
 * 
 * @export
 */
export type BarcodeAction = { tpe: 'ambiguous_ean' } & AmbiguousEan | { tpe: 'amount' } & AmountUpdate | { tpe: 'contractor' } & ContractorUpdate | { tpe: 'external_production_unit' } & ExternalProductionUnitResult | { tpe: 'item_type_variant' } & ItemTypeVariantResult | { tpe: 'lot_number' } & LotNumberUpdate | { tpe: 'order_number' } & OrderNumberUpdate | { tpe: 'place_label' } & PlaceLabelUpdate | { tpe: 'production_unit' } & ProductionUnitResult | { tpe: 'unrecognized' } & Unrecognized;

/**
 * 
 * @export
 */
export const BarcodeActionType = {
    ProductionUnit: 'production_unit',
    ItemTypeVariant: 'item_type_variant',
    Contractor: 'contractor',
    OrderNumber: 'order_number',
    AmbiguousEan: 'ambiguous_ean',
    Amount: 'amount',
    PlaceLabel: 'place_label',
    LotNumber: 'lot_number',
    Unrecognized: 'unrecognized',
    ExternalProductionUnit: 'external_production_unit'
} as const;
export type BarcodeActionType = typeof BarcodeActionType[keyof typeof BarcodeActionType];

/**
 * 
 * @export
 * @interface BarcodeResultData
 */
export interface BarcodeResultData {
    /**
     * 
     * @type {string}
     * @memberof BarcodeResultData
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof BarcodeResultData
     */
    params: object;
}
/**
 * 
 * @export
 * @interface BarcodeScanContext
 */
export interface BarcodeScanContext {
    /**
     * 
     * @type {RawBarcode}
     * @memberof BarcodeScanContext
     */
    rawBarcode: RawBarcode;
    /**
     * 
     * @type {Url}
     * @memberof BarcodeScanContext
     */
    context: Url;
}
/**
 * 
 * @export
 * @interface BarcodesView
 */
export interface BarcodesView {
    /**
     * 
     * @type {Array<string>}
     * @memberof BarcodesView
     */
    barcodes: Array<string>;
}

/**
 * 
 * @export
 */
export const BaseStockInteractionTypes = {
    orderItem: 1,
    productionLot: 2,
    supplyCardItem: 4,
    supplyOrderItem: 6
} as const;
export type BaseStockInteractionTypes = typeof BaseStockInteractionTypes[keyof typeof BaseStockInteractionTypes];

/**
 * 
 * @export
 * @interface BasicMachinePlanningView
 */
export interface BasicMachinePlanningView {
    /**
     * 
     * @type {Machine}
     * @memberof BasicMachinePlanningView
     */
    machine: Machine;
}
/**
 * 
 * @export
 * @interface BasicPackaging
 */
export interface BasicPackaging {
    /**
     * PackagingId
     * @type {number}
     * @memberof BasicPackaging
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof BasicPackaging
     */
    packagingType: number;
    /**
     * 
     * @type {Array<PackagingIngredient>}
     * @memberof BasicPackaging
     */
    ingredients?: Array<PackagingIngredient>;
}
/**
 * 
 * @export
 * @interface BatchDowntimeReportDurationSaveView
 */
export interface BatchDowntimeReportDurationSaveView {
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof BatchDowntimeReportDurationSaveView
     */
    groupId?: number;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof BatchDowntimeReportDurationSaveView
     */
    reason: number;
    /**
     * Time in s
     * @type {number}
     * @memberof BatchDowntimeReportDurationSaveView
     */
    duration: number;
    /**
     * 
     * @type {string}
     * @memberof BatchDowntimeReportDurationSaveView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface BatchDowntimeReportEndStopwatchView
 */
export interface BatchDowntimeReportEndStopwatchView {
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof BatchDowntimeReportEndStopwatchView
     */
    id: number;
    /**
     * Using server time instead
     * @type {string}
     * @memberof BatchDowntimeReportEndStopwatchView
     * @deprecated
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof BatchDowntimeReportEndStopwatchView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface BatchDowntimeReportStartEndSaveView
 */
export interface BatchDowntimeReportStartEndSaveView {
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof BatchDowntimeReportStartEndSaveView
     */
    groupId?: number;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof BatchDowntimeReportStartEndSaveView
     */
    reason: number;
    /**
     * 
     * @type {string}
     * @memberof BatchDowntimeReportStartEndSaveView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof BatchDowntimeReportStartEndSaveView
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof BatchDowntimeReportStartEndSaveView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface BatchShort
 */
export interface BatchShort {
    /**
     * BatchId
     * @type {number}
     * @memberof BatchShort
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof BatchShort
     */
    ordinal: number;
}
/**
 * 
 * @export
 * @interface BlobItemListView
 */
export interface BlobItemListView {
    /**
     * StockItemId
     * @type {number}
     * @memberof BlobItemListView
     */
    id: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof BlobItemListView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof BlobItemListView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof BlobItemListView
     */
    placeName: string;
    /**
     * 
     * @type {number}
     * @memberof BlobItemListView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof BlobItemListView
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface BoardAdd
 */
export interface BoardAdd {
    /**
     * BatchId
     * @type {number}
     * @memberof BoardAdd
     */
    batchId?: number;
    /**
     * MachineId
     * @type {number}
     * @memberof BoardAdd
     */
    machineId?: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof BoardAdd
     */
    productionLotId?: number;
    /**
     * 
     * @type {KanbanTile}
     * @memberof BoardAdd
     */
    tile: KanbanTile;
    /**
     * 
     * @type {BatchShort}
     * @memberof BoardAdd
     */
    batch?: BatchShort;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof BoardAdd
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {KanbanWebsocketOutputType}
     * @memberof BoardAdd
     */
    outputType: KanbanWebsocketOutputType;
}
/**
 * @type BoardChange
 * 
 * @export
 */
export type BoardChange = { outputType: '1' } & BoardAdd | { outputType: '2' } & BoardRemove | { outputType: '3' } & BoardUpdates | { outputType: '4' } & TotalCounts;
/**
 * 
 * @export
 * @interface BoardRemove
 */
export interface BoardRemove {
    /**
     * BatchId
     * @type {number}
     * @memberof BoardRemove
     */
    batchId?: number;
    /**
     * MachineId
     * @type {number}
     * @memberof BoardRemove
     */
    machineId?: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof BoardRemove
     */
    productionLotId?: number;
    /**
     * 
     * @type {KanbanTile}
     * @memberof BoardRemove
     */
    tile: KanbanTile;
    /**
     * 
     * @type {BatchShort}
     * @memberof BoardRemove
     */
    batch?: BatchShort;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof BoardRemove
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {KanbanWebsocketOutputType}
     * @memberof BoardRemove
     */
    outputType: KanbanWebsocketOutputType;
}
/**
 * 
 * @export
 * @interface BoardUpdate
 */
export interface BoardUpdate {
    /**
     * BatchId
     * @type {number}
     * @memberof BoardUpdate
     */
    batchId?: number;
    /**
     * MachineId
     * @type {number}
     * @memberof BoardUpdate
     */
    machineId?: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof BoardUpdate
     */
    productionLotId?: number;
    /**
     * 
     * @type {KanbanTile}
     * @memberof BoardUpdate
     */
    tile: KanbanTile;
    /**
     * 
     * @type {BatchShort}
     * @memberof BoardUpdate
     */
    batch?: BatchShort;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof BoardUpdate
     */
    status: ProductionLotStatus;
}
/**
 * 
 * @export
 * @interface BoardUpdates
 */
export interface BoardUpdates {
    /**
     * 
     * @type {Array<BoardUpdate>}
     * @memberof BoardUpdates
     */
    updates?: Array<BoardUpdate>;
    /**
     * 
     * @type {KanbanWebsocketOutputType}
     * @memberof BoardUpdates
     */
    outputType: KanbanWebsocketOutputType;
}

/**
 * 
 * @export
 */
export const BomCalculationType = {
    EmptyBom: 1,
    PiecesBom: 2
} as const;
export type BomCalculationType = typeof BomCalculationType[keyof typeof BomCalculationType];

/**
 * @type BomCalculationView
 * 
 * @export
 */
export type BomCalculationView = { calculationType: '1' } & EmptyBomCalculationView | { calculationType: '2' } & PiecesBomCalculationView;
/**
 * 
 * @export
 * @interface BomReportEntryAdded
 */
export interface BomReportEntryAdded {
    /**
     * 
     * @type {BomReportEntryDiffType}
     * @memberof BomReportEntryAdded
     */
    tpe: BomReportEntryDiffType;
}
/**
 * @type BomReportEntryDiffStatus
 * 
 * @export
 */
export type BomReportEntryDiffStatus = { tpe: 'added' } & BomReportEntryAdded | { tpe: 'modified' } & BomReportEntryModified | { tpe: 'removed' } & BomReportEntryRemoved;

/**
 * 
 * @export
 */
export const BomReportEntryDiffType = {
    Modified: 'modified',
    Removed: 'removed',
    Added: 'added'
} as const;
export type BomReportEntryDiffType = typeof BomReportEntryDiffType[keyof typeof BomReportEntryDiffType];

/**
 * 
 * @export
 * @interface BomReportEntryModified
 */
export interface BomReportEntryModified {
    /**
     * 
     * @type {BomCalculationView}
     * @memberof BomReportEntryModified
     */
    previousCalculation: BomCalculationView;
    /**
     * 
     * @type {number}
     * @memberof BomReportEntryModified
     */
    previousTotal: number;
    /**
     * 
     * @type {BomReportEntryDiffType}
     * @memberof BomReportEntryModified
     */
    tpe: BomReportEntryDiffType;
}
/**
 * 
 * @export
 * @interface BomReportEntryRemoved
 */
export interface BomReportEntryRemoved {
    /**
     * 
     * @type {BomReportEntryDiffType}
     * @memberof BomReportEntryRemoved
     */
    tpe: BomReportEntryDiffType;
}
/**
 * 
 * @export
 * @interface BomReportEntryView
 */
export interface BomReportEntryView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof BomReportEntryView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof BomReportEntryView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof BomReportEntryView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof BomReportEntryView
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof BomReportEntryView
     */
    total: number;
    /**
     * 
     * @type {BomCalculationView}
     * @memberof BomReportEntryView
     */
    calculation: BomCalculationView;
    /**
     * 
     * @type {BomReportEntryDiffStatus}
     * @memberof BomReportEntryView
     */
    diffStatus?: BomReportEntryDiffStatus;
}
/**
 * 
 * @export
 * @interface BomReportSaveView
 */
export interface BomReportSaveView {
    /**
     * 
     * @type {Array<Item1>}
     * @memberof BomReportSaveView
     */
    items?: Array<Item1>;
}

/**
 * 
 * @export
 */
export const BorrowStatus = {
    notAvailable: 1,
    available: 2
} as const;
export type BorrowStatus = typeof BorrowStatus[keyof typeof BorrowStatus];

/**
 * 
 * @export
 * @interface BpscExportRequest
 */
export interface BpscExportRequest {
    /**
     * 
     * @type {string}
     * @memberof BpscExportRequest
     */
    erp: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof BpscExportRequest
     */
    orderIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface ByMachineFeatures
 */
export interface ByMachineFeatures {
    /**
     * MatchConditionId
     * @type {number}
     * @memberof ByMachineFeatures
     */
    matchConditionId?: number;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof ByMachineFeatures
     */
    itemTypeVariant: ItemTypeVariant;
    /**
     * 
     * @type {Array<number>}
     * @memberof ByMachineFeatures
     */
    machineFeatures?: Array<number>;
    /**
     * 
     * @type {MatchConditionType}
     * @memberof ByMachineFeatures
     */
    matchConditionType: MatchConditionType;
}
/**
 * 
 * @export
 * @interface ByProducedItemTags
 */
export interface ByProducedItemTags {
    /**
     * MatchConditionId
     * @type {number}
     * @memberof ByProducedItemTags
     */
    matchConditionId?: number;
    /**
     * 
     * @type {Array<ItemTypeTag>}
     * @memberof ByProducedItemTags
     */
    itemTypeTags?: Array<ItemTypeTag>;
    /**
     * 
     * @type {number}
     * @memberof ByProducedItemTags
     */
    recipeType?: number;
    /**
     * 
     * @type {MatchConditionType}
     * @memberof ByProducedItemTags
     */
    matchConditionType: MatchConditionType;
}
/**
 * 
 * @export
 * @interface ByProducedVariant
 */
export interface ByProducedVariant {
    /**
     * MatchConditionId
     * @type {number}
     * @memberof ByProducedVariant
     */
    matchConditionId?: number;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof ByProducedVariant
     */
    itemTypeVariant: ItemTypeVariant;
    /**
     * 
     * @type {boolean}
     * @memberof ByProducedVariant
     */
    defaultForItemType: boolean;
    /**
     * 
     * @type {MatchConditionType}
     * @memberof ByProducedVariant
     */
    matchConditionType: MatchConditionType;
}
/**
 * 
 * @export
 * @interface ByRecipeAmount
 */
export interface ByRecipeAmount {
    /**
     * CostSpecificationEntryId
     * @type {number}
     * @memberof ByRecipeAmount
     */
    id?: number;
    /**
     * 
     * @type {CostDescription}
     * @memberof ByRecipeAmount
     */
    specifier: CostDescription;
    /**
     * 
     * @type {number}
     * @memberof ByRecipeAmount
     */
    recipeUnitCost: number;
}
/**
 * 
 * @export
 * @interface CalculatedDateTime
 */
export interface CalculatedDateTime {
    /**
     * 
     * @type {string}
     * @memberof CalculatedDateTime
     */
    dateTime: string;
    /**
     * 
     * @type {EstimationStatus}
     * @memberof CalculatedDateTime
     */
    status: EstimationStatus;
}
/**
 * 
 * @export
 * @interface CalculationInputAmount
 */
export interface CalculationInputAmount {
    /**
     * 
     * @type {number}
     * @memberof CalculationInputAmount
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof CalculationInputAmount
     */
    maybeUnitType?: string;
}
/**
 * 
 * @export
 * @interface CalculationPropertyTypesView
 */
export interface CalculationPropertyTypesView {
    /**
     * 
     * @type {PunchingDiePropertyTypesView}
     * @memberof CalculationPropertyTypesView
     */
    punchingDieProperties: PunchingDiePropertyTypesView;
    /**
     * 
     * @type {ProductPropertyTypesView}
     * @memberof CalculationPropertyTypesView
     */
    productProperties: ProductPropertyTypesView;
}
/**
 * 
 * @export
 * @interface CalendarAssigneeMultipleRequestView
 */
export interface CalendarAssigneeMultipleRequestView {
    /**
     * 
     * @type {string}
     * @memberof CalendarAssigneeMultipleRequestView
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof CalendarAssigneeMultipleRequestView
     */
    calendarSubjectId: number;
    /**
     * 
     * @type {CalendarSubjectType}
     * @memberof CalendarAssigneeMultipleRequestView
     */
    calendarSubjectType: CalendarSubjectType;
}
/**
 * 
 * @export
 * @interface CalendarAssigneeRequestView
 */
export interface CalendarAssigneeRequestView {
    /**
     * 
     * @type {string}
     * @memberof CalendarAssigneeRequestView
     */
    date: string;
}
/**
 * 
 * @export
 * @interface CalendarAssigneesMultipleEntryView
 */
export interface CalendarAssigneesMultipleEntryView {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof CalendarAssigneesMultipleEntryView
     */
    calendarEventId: number;
    /**
     * 
     * @type {string}
     * @memberof CalendarAssigneesMultipleEntryView
     */
    date: string;
    /**
     * 
     * @type {Array<CalendarEventAssigneeView>}
     * @memberof CalendarAssigneesMultipleEntryView
     */
    assignees?: Array<CalendarEventAssigneeView>;
}
/**
 * 
 * @export
 * @interface CalendarAssigneesMultipleView
 */
export interface CalendarAssigneesMultipleView {
    /**
     * 
     * @type {string}
     * @memberof CalendarAssigneesMultipleView
     */
    startOfMonth: string;
    /**
     * 
     * @type {Array<CalendarAssigneesMultipleEntryView>}
     * @memberof CalendarAssigneesMultipleView
     */
    entries?: Array<CalendarAssigneesMultipleEntryView>;
}
/**
 * 
 * @export
 * @interface CalendarAssigneesSaveView
 */
export interface CalendarAssigneesSaveView {
    /**
     * 
     * @type {Array<CalendarEventAssigneeView>}
     * @memberof CalendarAssigneesSaveView
     */
    calendarEventAssignees?: Array<CalendarEventAssigneeView>;
    /**
     * 
     * @type {string}
     * @memberof CalendarAssigneesSaveView
     */
    date: string;
}
/**
 * @type CalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement
 * 
 * @export
 */
export type CalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement = { name: 'CalendarError' } & LemmaSimpleErrorView | { name: 'RateDefined' } & LemmaSimpleErrorView | { name: 'RateNotDefined' } & LemmaSimpleErrorView | { name: 'ValidationBeforeAchievement' } & LemmaSimpleErrorView;
/**
 * 
 * @export
 * @interface CalendarEventAssigneeView
 */
export interface CalendarEventAssigneeView {
    /**
     * UserId
     * @type {number}
     * @memberof CalendarEventAssigneeView
     */
    userId: number;
    /**
     * 
     * @type {CalendarEventRole}
     * @memberof CalendarEventAssigneeView
     */
    calendarEventRole: CalendarEventRole;
}
/**
 * 
 * @export
 * @interface CalendarEventMeta
 */
export interface CalendarEventMeta {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof CalendarEventMeta
     */
    id?: number;
    /**
     * 
     * @type {CalendarEventTypeView}
     * @memberof CalendarEventMeta
     */
    eventType: CalendarEventTypeView;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventMeta
     */
    ruleName: string;
    /**
     * 
     * @type {CalendarEventRecurringOptionView}
     * @memberof CalendarEventMeta
     */
    rule?: CalendarEventRecurringOptionView;
    /**
     * 
     * @type {Array<any>}
     * @memberof CalendarEventMeta
     */
    ruleDateExceptions?: Array<any>;
}
/**
 * 
 * @export
 * @interface CalendarEventRecurringOption
 */
export interface CalendarEventRecurringOption {
    /**
     * 
     * @type {Frequency}
     * @memberof CalendarEventRecurringOption
     */
    frequency: Frequency;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventRecurringOption
     */
    interval: number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventRecurringOption
     */
    byMonthOfYear?: number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventRecurringOption
     */
    byDayOfMonth?: number;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof CalendarEventRecurringOption
     */
    byDayOfWeek?: Array<DayOfWeek>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarEventRecurringOption
     */
    dateExceptions?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventRecurringOption
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface CalendarEventRecurringOptionView
 */
export interface CalendarEventRecurringOptionView {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventRecurringOptionView
     */
    freq: string;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventRecurringOptionView
     */
    interval: number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventRecurringOptionView
     */
    byMonthOfYear?: number;
    /**
     * 
     * @type {number}
     * @memberof CalendarEventRecurringOptionView
     */
    byDayOfMonth?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarEventRecurringOptionView
     */
    byDayOfWeek?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventRecurringOptionView
     */
    to?: string;
}

/**
 * 
 * @export
 */
export const CalendarEventRole = {
    Other: 1,
    Worker: 2,
    Foreman: 3
} as const;
export type CalendarEventRole = typeof CalendarEventRole[keyof typeof CalendarEventRole];


/**
 * 
 * @export
 */
export const CalendarEventType = {
    Other: 1,
    Availability: 2,
    Downtime: 3,
    AnnualLeave: 4,
    SickLeave: 5
} as const;
export type CalendarEventType = typeof CalendarEventType[keyof typeof CalendarEventType];

/**
 * 
 * @export
 * @interface CalendarEventTypeView
 */
export interface CalendarEventTypeView {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventTypeView
     */
    name: string;
    /**
     * 
     * @type {ColorView}
     * @memberof CalendarEventTypeView
     */
    color: ColorView;
    /**
     * 
     * @type {CalendarEventType}
     * @memberof CalendarEventTypeView
     */
    eventTypeEnum: CalendarEventType;
}
/**
 * 
 * @export
 * @interface CalendarEventView
 */
export interface CalendarEventView {
    /**
     * 
     * @type {string}
     * @memberof CalendarEventView
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventView
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventView
     */
    end: string;
    /**
     * 
     * @type {boolean}
     * @memberof CalendarEventView
     */
    allDay: boolean;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventView
     */
    comment?: string;
    /**
     * 
     * @type {CalendarEventMeta}
     * @memberof CalendarEventView
     */
    meta: CalendarEventMeta;
}

/**
 * 
 * @export
 */
export const CalendarSubjectType = {
    Machine: 1,
    Worker: 2,
    OrderAssignment: 3,
    CompetenceDueDate: 4,
    DocumentDueDate: 5
} as const;
export type CalendarSubjectType = typeof CalendarSubjectType[keyof typeof CalendarSubjectType];

/**
 * @type CanDeleteOnlyManualDowntime
 * 
 * @export
 */
export type CanDeleteOnlyManualDowntime = { name: 'CanDeleteOnlyManualDowntime' } & LemmaSimpleErrorView;
/**
 * @type CancelNotAvailableForStatusOrInvalidStatusTransition
 * 
 * @export
 */
export type CancelNotAvailableForStatusOrInvalidStatusTransition = { name: 'CancelNotAvailableForStatus' } & LemmaSimpleErrorView | { name: 'InvalidStatusTransition' } & InvalidStatusTransition;
/**
 * 
 * @export
 * @interface CancelProductionLots
 */
export interface CancelProductionLots {
    /**
     * 
     * @type {Array<number>}
     * @memberof CancelProductionLots
     */
    productionLotIds?: Array<number>;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof CancelProductionLots
     */
    reloadColumn?: ProductionLotStatus;
}
/**
 * 
 * @export
 * @interface CancelProductionLotsInColumn
 */
export interface CancelProductionLotsInColumn {
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof CancelProductionLotsInColumn
     */
    column: ProductionLotStatus;
    /**
     * 
     * @type {KanbanFilterData}
     * @memberof CancelProductionLotsInColumn
     */
    filter: KanbanFilterData;
}
/**
 * 
 * @export
 * @interface CannotAbortLotWhichIsNotInProduction
 */
export interface CannotAbortLotWhichIsNotInProduction {
    /**
     * 
     * @type {string}
     * @memberof CannotAbortLotWhichIsNotInProduction
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CannotAbortLotWhichIsNotInProduction
     */
    description: string;
    /**
     * 
     * @type {{ [key: string]: Array<number>; }}
     * @memberof CannotAbortLotWhichIsNotInProduction
     */
    forbiddenStatusesWithLots: { [key: string]: Array<number>; };
}
/**
 * @type CannotAbortLotWhichIsNotInProductionOrLegacyLemmaErrorOrLotIsPartOfMultiBatch
 * 
 * @export
 */
export type CannotAbortLotWhichIsNotInProductionOrLegacyLemmaErrorOrLotIsPartOfMultiBatch = { name: 'CannotAbortLotWhichIsNotInProduction' } & CannotAbortLotWhichIsNotInProduction | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotIsPartOfMultiBatch' } & LotIsPartOfMultiBatch;
/**
 * @type CannotChangeProductionStartDateOrCannotReportOnBehalfOfOthersOrInconsistentMachinesInTheBatchOrInvalidSplitPriorityConfigurationOrLegacyLemmaErrorOrListOfExceededReportedAmountThresholdOrLotHasNoMachineAssignedOrLotIsPartOfMultiBatchOrLotsHaveNoMachineAssignedOrMissingProductionReportForLotOrNoAmountAvailableForSplitOrNoWorkstationReportsCreatedOrNonPositiveAmountSuppliedOrProductionLotAlreadyHasAmountReports
 * 
 * @export
 */
export type CannotChangeProductionStartDateOrCannotReportOnBehalfOfOthersOrInconsistentMachinesInTheBatchOrInvalidSplitPriorityConfigurationOrLegacyLemmaErrorOrListOfExceededReportedAmountThresholdOrLotHasNoMachineAssignedOrLotIsPartOfMultiBatchOrLotsHaveNoMachineAssignedOrMissingProductionReportForLotOrNoAmountAvailableForSplitOrNoWorkstationReportsCreatedOrNonPositiveAmountSuppliedOrProductionLotAlreadyHasAmountReports = { name: 'CannotChangeProductionStartDate' } & LemmaSimpleErrorView | { name: 'CannotReportOnBehalfOfOthers' } & LemmaSimpleErrorView | { name: 'InconsistentMachinesInTheBatch' } & InconsistentMachinesInTheBatch | { name: 'InvalidSplitPriorityConfiguration' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'ListOf__ExceededReportedAmountThreshold_' } & ListOfExceededReportedAmountThreshold | { name: 'LotHasNoMachineAssigned' } & LotHasNoMachineAssigned | { name: 'LotIsPartOfMultiBatch' } & LotIsPartOfMultiBatch | { name: 'LotsHaveNoMachineAssigned' } & LotsHaveNoMachineAssigned | { name: 'MissingProductionReportForLot' } & MissingProductionReportForLot | { name: 'NoAmountAvailableForSplit' } & LemmaSimpleErrorView | { name: 'NoWorkstationReportsCreated' } & LemmaSimpleErrorView | { name: 'NonPositiveAmountSupplied' } & LemmaSimpleErrorView | { name: 'ProductionLotAlreadyHasAmountReports' } & LemmaSimpleErrorView;
/**
 * @type CannotMergeWithDifferentVariantOrCannotMergeWithMergedChildren
 * 
 * @export
 */
export type CannotMergeWithDifferentVariantOrCannotMergeWithMergedChildren = { name: 'CannotMergeWithDifferentVariant' } & LemmaSimpleErrorView | { name: 'CannotMergeWithMergedChildren' } & LemmaSimpleErrorView;
/**
 * @type CannotProduceInputOrMergedChildrenErrorOrNoLotWithIdInTreeOrSimulationGraphCycle
 * 
 * @export
 */
export type CannotProduceInputOrMergedChildrenErrorOrNoLotWithIdInTreeOrSimulationGraphCycle = { name: 'CannotProduceInput' } & LemmaSimpleErrorView | { name: 'MergedChildrenError' } & MergedChildrenError | { name: 'NoLotWithIdInTree' } & NoLotWithIdInTree | { name: 'SimulationGraphCycle' } & LemmaSimpleErrorView;
/**
 * @type CannotReportOnBehalfOfOthersOrLegacyLemmaErrorOrListOfExceededReportedAmountThreshold
 * 
 * @export
 */
export type CannotReportOnBehalfOfOthersOrLegacyLemmaErrorOrListOfExceededReportedAmountThreshold = { name: 'CannotReportOnBehalfOfOthers' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'ListOf__ExceededReportedAmountThreshold_' } & ListOfExceededReportedAmountThreshold;
/**
 * @type CannotSplitWithMergedChildrenOrCannotSplitZeroOrSplitAmountsShouldSum
 * 
 * @export
 */
export type CannotSplitWithMergedChildrenOrCannotSplitZeroOrSplitAmountsShouldSum = { name: 'CannotSplitWithMergedChildren' } & LemmaSimpleErrorView | { name: 'CannotSplitZero' } & LemmaSimpleErrorView | { name: 'SplitAmountsShouldSum' } & LemmaSimpleErrorView;
/**
 * @type CannotUpdateNonDraftOrIncompatibleOrderItemVariantOrNonPositiveAmountSuppliedOrNothingToSaveOrTechnologyMissing
 * 
 * @export
 */
export type CannotUpdateNonDraftOrIncompatibleOrderItemVariantOrNonPositiveAmountSuppliedOrNothingToSaveOrTechnologyMissing = { name: 'CannotUpdateNonDraft' } & LemmaSimpleErrorView | { name: 'IncompatibleOrderItemVariant' } & IncompatibleOrderItemVariant | { name: 'NonPositiveAmountSupplied' } & LemmaSimpleErrorView | { name: 'NothingToSave' } & LemmaSimpleErrorView | { name: 'TechnologyMissing' } & TechnologyMissing;

/**
 * 
 * @export
 */
export const CertaintyType = {
    Forecast: 1,
    Applied: 2
} as const;
export type CertaintyType = typeof CertaintyType[keyof typeof CertaintyType];

/**
 * 
 * @export
 * @interface ClientSpecification
 */
export interface ClientSpecification {
    /**
     * ClientSpecificationId
     * @type {number}
     * @memberof ClientSpecification
     */
    id?: number;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof ClientSpecification
     */
    itemTypeVariant: ItemTypeVariant;
    /**
     * 
     * @type {PackagingSpecification}
     * @memberof ClientSpecification
     */
    packagingSpecification?: PackagingSpecification;
    /**
     * 
     * @type {string}
     * @memberof ClientSpecification
     */
    buyerItemCode?: string;
    /**
     * 
     * @type {OrderedAmount}
     * @memberof ClientSpecification
     */
    clientAmount?: OrderedAmount;
    /**
     * 
     * @type {ProductSpecificationGraph}
     * @memberof ClientSpecification
     */
    productSpecificationGraph?: ProductSpecificationGraph;
    /**
     * 
     * @type {MachineSpecification}
     * @memberof ClientSpecification
     */
    machineSpecification?: MachineSpecification;
}
/**
 * 
 * @export
 * @interface ClonedOrderView
 */
export interface ClonedOrderView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof ClonedOrderView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    buyerOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof ClonedOrderView
     */
    source: OrderSource;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    ediUuid?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof ClonedOrderView
     */
    buyerId?: number;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    buyerName?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof ClonedOrderView
     */
    recipientId?: number;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    recipientName?: string;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof ClonedOrderView
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    deliveryTime?: string;
    /**
     * UserId
     * @type {number}
     * @memberof ClonedOrderView
     */
    authorId?: number;
    /**
     * 
     * @type {OrderStatus}
     * @memberof ClonedOrderView
     */
    status: OrderStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ClonedOrderView
     */
    signed: boolean;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof ClonedOrderView
     */
    items?: Array<SalesEntryItemView>;
    /**
     * 
     * @type {number}
     * @memberof ClonedOrderView
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof ClonedOrderView
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof ClonedOrderView
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * UserId
     * @type {number}
     * @memberof ClonedOrderView
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof ClonedOrderView
     */
    methodOfPayment?: MethodOfPayment;
    /**
     * 
     * @type {boolean}
     * @memberof ClonedOrderView
     */
    marketingRulesApplied: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClonedOrderView
     */
    globalDeliveryDate: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClonedOrderView
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyExchangeRate}
     * @memberof ClonedOrderView
     */
    exchangeRate?: CurrencyExchangeRate;
}
/**
 * 
 * @export
 * @interface CloseModal
 */
export interface CloseModal {
    /**
     * 
     * @type {string}
     * @memberof CloseModal
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ColorView
 */
export interface ColorView {
    /**
     * 
     * @type {string}
     * @memberof ColorView
     */
    primary: string;
    /**
     * 
     * @type {string}
     * @memberof ColorView
     */
    secondary: string;
}
/**
 * @type ColorsCount
 * 
 * @export
 */
export type ColorsCount = ColorsCountPerMode | CommonColorsCount;
/**
 * 
 * @export
 * @interface ColorsCountPerMode
 */
export interface ColorsCountPerMode {
    /**
     * ColorsCountId
     * @type {number}
     * @memberof ColorsCountPerMode
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ColorsCountPerMode
     */
    onBaseCount: number;
    /**
     * 
     * @type {number}
     * @memberof ColorsCountPerMode
     */
    onGlueCount: number;
    /**
     * 
     * @type {number}
     * @memberof ColorsCountPerMode
     */
    onTopCount: number;
    /**
     * 
     * @type {number}
     * @memberof ColorsCountPerMode
     */
    onUnderlay: number;
}
/**
 * 
 * @export
 * @interface CommentView
 */
export interface CommentView {
    /**
     * 
     * @type {string}
     * @memberof CommentView
     */
    comment: string;
}
/**
 * 
 * @export
 * @interface CommonColorsCount
 */
export interface CommonColorsCount {
    /**
     * ColorsCountId
     * @type {number}
     * @memberof CommonColorsCount
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CommonColorsCount
     */
    count: number;
}
/**
 * 
 * @export
 * @interface Competence
 */
export interface Competence {
    /**
     * CompetenceId
     * @type {number}
     * @memberof Competence
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Competence
     */
    name: string;
    /**
     * 
     * @type {CompetenceKind}
     * @memberof Competence
     */
    kind: CompetenceKind;
    /**
     * CompetenceCategoryId
     * @type {number}
     * @memberof Competence
     */
    categoryId: number;
    /**
     * 
     * @type {EvaluationMode}
     * @memberof Competence
     */
    evaluationMode: EvaluationMode;
    /**
     * 
     * @type {boolean}
     * @memberof Competence
     */
    hasAuthority: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Competence
     */
    hasFiles: boolean;
}
/**
 * 
 * @export
 * @interface CompetenceAuthority
 */
export interface CompetenceAuthority {
    /**
     * CompetenceAuthorityId
     * @type {number}
     * @memberof CompetenceAuthority
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompetenceAuthority
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CompetenceCategoryListViewRow
 */
export interface CompetenceCategoryListViewRow {
    /**
     * CompetenceCategoryId
     * @type {number}
     * @memberof CompetenceCategoryListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CompetenceCategoryListViewRow
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CompetenceDueDateCalendarEvent
 */
export interface CompetenceDueDateCalendarEvent {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof CompetenceDueDateCalendarEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CompetenceDueDateCalendarEvent
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof CompetenceDueDateCalendarEvent
     */
    to: string;
    /**
     * WorkerCompetenceId
     * @type {number}
     * @memberof CompetenceDueDateCalendarEvent
     */
    workerCompetenceId: number;
    /**
     * 
     * @type {string}
     * @memberof CompetenceDueDateCalendarEvent
     */
    title: string;
    /**
     * 
     * @type {CalendarEventType}
     * @memberof CompetenceDueDateCalendarEvent
     */
    calendarEventType: CalendarEventType;
    /**
     * 
     * @type {WorkerEventCalendarType}
     * @memberof CompetenceDueDateCalendarEvent
     */
    eventType: WorkerEventCalendarType;
}

/**
 * 
 * @export
 */
export const CompetenceKind = {
    withRate: 1,
    other: 2
} as const;
export type CompetenceKind = typeof CompetenceKind[keyof typeof CompetenceKind];

/**
 * 
 * @export
 * @interface CompetenceListViewRow
 */
export interface CompetenceListViewRow {
    /**
     * CompetenceId
     * @type {number}
     * @memberof CompetenceListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CompetenceListViewRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompetenceListViewRow
     */
    categoryName: string;
    /**
     * 
     * @type {string}
     * @memberof CompetenceListViewRow
     */
    nameAndCategory: string;
    /**
     * CompetenceCategoryId
     * @type {number}
     * @memberof CompetenceListViewRow
     */
    competenceCategoryId: number;
    /**
     * 
     * @type {CompetenceKind}
     * @memberof CompetenceListViewRow
     */
    kind: CompetenceKind;
    /**
     * 
     * @type {EvaluationMode}
     * @memberof CompetenceListViewRow
     */
    evaluationMode: EvaluationMode;
    /**
     * 
     * @type {boolean}
     * @memberof CompetenceListViewRow
     */
    hasAuthority: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompetenceListViewRow
     */
    hasFiles: boolean;
}
/**
 * 
 * @export
 * @interface CompetenceMatrixCompetenceView
 */
export interface CompetenceMatrixCompetenceView {
    /**
     * CompetenceId
     * @type {number}
     * @memberof CompetenceMatrixCompetenceView
     */
    competenceId: number;
    /**
     * 
     * @type {string}
     * @memberof CompetenceMatrixCompetenceView
     */
    competenceName: string;
    /**
     * 
     * @type {string}
     * @memberof CompetenceMatrixCompetenceView
     */
    categoryName: string;
    /**
     * 
     * @type {CompetenceRate}
     * @memberof CompetenceMatrixCompetenceView
     */
    level?: CompetenceRate;
    /**
     * 
     * @type {string}
     * @memberof CompetenceMatrixCompetenceView
     */
    achievementDate?: string;
    /**
     * 
     * @type {CompetenceMatrixEvaluationModeView}
     * @memberof CompetenceMatrixCompetenceView
     */
    evaluationMode?: CompetenceMatrixEvaluationModeView;
}
/**
 * @type CompetenceMatrixEvaluationModeView
 * 
 * @export
 */
export type CompetenceMatrixEvaluationModeView = { tpe: 'evaluated' } & EvaluatedMatrixView | { tpe: 'infinite' } & InfiniteMatrixView;
/**
 * 
 * @export
 * @interface CompetenceMatrixListView
 */
export interface CompetenceMatrixListView {
    /**
     * WorkerId
     * @type {number}
     * @memberof CompetenceMatrixListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CompetenceMatrixListView
     */
    comboSearch: string;
    /**
     * 
     * @type {string}
     * @memberof CompetenceMatrixListView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CompetenceMatrixListView
     */
    lastName: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CompetenceMatrixListView
     */
    roleIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompetenceMatrixListView
     */
    roleNames?: Array<string>;
    /**
     * 
     * @type {Array<CompetenceMatrixCompetenceView>}
     * @memberof CompetenceMatrixListView
     */
    competences?: Array<CompetenceMatrixCompetenceView>;
}

/**
 * 
 * @export
 */
export const CompetenceRate = {
    learning: 1,
    supervised: 2,
    independent: 3,
    specialist: 4,
    expert: 5
} as const;
export type CompetenceRate = typeof CompetenceRate[keyof typeof CompetenceRate];

/**
 * 
 * @export
 * @interface CompoundResultActiveVehicleListController
 */
export interface CompoundResultActiveVehicleListController {
    /**
     * 
     * @type {PostBackVehiclesListFilterRequest}
     * @memberof CompoundResultActiveVehicleListController
     */
    filter: PostBackVehiclesListFilterRequest;
    /**
     * 
     * @type {FilterResultActiveVehicleListController}
     * @memberof CompoundResultActiveVehicleListController
     */
    result: FilterResultActiveVehicleListController;
}
/**
 * 
 * @export
 * @interface CompoundResultBlobItemsListController
 */
export interface CompoundResultBlobItemsListController {
    /**
     * 
     * @type {PostBackUnitsBlobsListFilterRequest}
     * @memberof CompoundResultBlobItemsListController
     */
    filter: PostBackUnitsBlobsListFilterRequest;
    /**
     * 
     * @type {FilterResultBlobItemsListController}
     * @memberof CompoundResultBlobItemsListController
     */
    result: FilterResultBlobItemsListController;
}
/**
 * 
 * @export
 * @interface CompoundResultCompetenceCategoryListViewController
 */
export interface CompoundResultCompetenceCategoryListViewController {
    /**
     * 
     * @type {PostBackWorkersCompetenceCategoriesListFilterRequest}
     * @memberof CompoundResultCompetenceCategoryListViewController
     */
    filter: PostBackWorkersCompetenceCategoriesListFilterRequest;
    /**
     * 
     * @type {FilterResultCompetenceCategoryListViewController}
     * @memberof CompoundResultCompetenceCategoryListViewController
     */
    result: FilterResultCompetenceCategoryListViewController;
}
/**
 * 
 * @export
 * @interface CompoundResultCompetenceListViewController
 */
export interface CompoundResultCompetenceListViewController {
    /**
     * 
     * @type {PostBackWorkersCompetencesListFilterRequest}
     * @memberof CompoundResultCompetenceListViewController
     */
    filter: PostBackWorkersCompetencesListFilterRequest;
    /**
     * 
     * @type {FilterResultCompetenceListViewController}
     * @memberof CompoundResultCompetenceListViewController
     */
    result: FilterResultCompetenceListViewController;
}
/**
 * 
 * @export
 * @interface CompoundResultCompetenceMatrixListController
 */
export interface CompoundResultCompetenceMatrixListController {
    /**
     * 
     * @type {PostBackWorkersCompetencesMatrixListFilterRequest}
     * @memberof CompoundResultCompetenceMatrixListController
     */
    filter: PostBackWorkersCompetencesMatrixListFilterRequest;
    /**
     * 
     * @type {FilterResultCompetenceMatrixListController}
     * @memberof CompoundResultCompetenceMatrixListController
     */
    result: FilterResultCompetenceMatrixListController;
}
/**
 * 
 * @export
 * @interface CompoundResultContactsListController
 */
export interface CompoundResultContactsListController {
    /**
     * 
     * @type {PostBackContractorsContactsListFilterRequest}
     * @memberof CompoundResultContactsListController
     */
    filter: PostBackContractorsContactsListFilterRequest;
    /**
     * 
     * @type {FilterResultContactsListController}
     * @memberof CompoundResultContactsListController
     */
    result: FilterResultContactsListController;
}
/**
 * 
 * @export
 * @interface CompoundResultContractorsListController
 */
export interface CompoundResultContractorsListController {
    /**
     * 
     * @type {PostBackContractorsListFilterRequest}
     * @memberof CompoundResultContractorsListController
     */
    filter: PostBackContractorsListFilterRequest;
    /**
     * 
     * @type {FilterResultContractorsListController}
     * @memberof CompoundResultContractorsListController
     */
    result: FilterResultContractorsListController;
}
/**
 * 
 * @export
 * @interface CompoundResultCountsheetEntriesListController
 */
export interface CompoundResultCountsheetEntriesListController {
    /**
     * 
     * @type {PostBackStocktakingCountsheetListFilterRequest}
     * @memberof CompoundResultCountsheetEntriesListController
     */
    filter: PostBackStocktakingCountsheetListFilterRequest;
    /**
     * 
     * @type {FilterResultCountsheetEntriesListController}
     * @memberof CompoundResultCountsheetEntriesListController
     */
    result: FilterResultCountsheetEntriesListController;
}
/**
 * 
 * @export
 * @interface CompoundResultDemandListController
 */
export interface CompoundResultDemandListController {
    /**
     * 
     * @type {PostBackStocksDemandsListFilterRequest}
     * @memberof CompoundResultDemandListController
     */
    filter: PostBackStocksDemandsListFilterRequest;
    /**
     * 
     * @type {FilterResultDemandListController}
     * @memberof CompoundResultDemandListController
     */
    result: FilterResultDemandListController;
}
/**
 * 
 * @export
 * @interface CompoundResultDemandsManagerListController
 */
export interface CompoundResultDemandsManagerListController {
    /**
     * 
     * @type {PostBackStocksListFilterRequest}
     * @memberof CompoundResultDemandsManagerListController
     */
    filter: PostBackStocksListFilterRequest;
    /**
     * 
     * @type {FilterResultDemandsManagerListController}
     * @memberof CompoundResultDemandsManagerListController
     */
    result: FilterResultDemandsManagerListController;
}
/**
 * 
 * @export
 * @interface CompoundResultDocumentStatusListController
 */
export interface CompoundResultDocumentStatusListController {
    /**
     * 
     * @type {PostBackDocumentsDocumentStatusListFilterRequest}
     * @memberof CompoundResultDocumentStatusListController
     */
    filter: PostBackDocumentsDocumentStatusListFilterRequest;
    /**
     * 
     * @type {FilterResultDocumentStatusListController}
     * @memberof CompoundResultDocumentStatusListController
     */
    result: FilterResultDocumentStatusListController;
}
/**
 * 
 * @export
 * @interface CompoundResultDowntimeReasonsListController
 */
export interface CompoundResultDowntimeReasonsListController {
    /**
     * 
     * @type {PostBackReportsDowntimeReasonsFilterRequest}
     * @memberof CompoundResultDowntimeReasonsListController
     */
    filter: PostBackReportsDowntimeReasonsFilterRequest;
    /**
     * 
     * @type {FilterResultDowntimeReasonsListController}
     * @memberof CompoundResultDowntimeReasonsListController
     */
    result: FilterResultDowntimeReasonsListController;
}
/**
 * 
 * @export
 * @interface CompoundResultDriverListController
 */
export interface CompoundResultDriverListController {
    /**
     * 
     * @type {PostBackShippingDriversListFilterRequest}
     * @memberof CompoundResultDriverListController
     */
    filter: PostBackShippingDriversListFilterRequest;
    /**
     * 
     * @type {FilterResultDriverListController}
     * @memberof CompoundResultDriverListController
     */
    result: FilterResultDriverListController;
}
/**
 * 
 * @export
 * @interface CompoundResultEquipmentDemandListController
 */
export interface CompoundResultEquipmentDemandListController {
    /**
     * 
     * @type {PostBackOrdersEquipmentDemandsListFilterRequest}
     * @memberof CompoundResultEquipmentDemandListController
     */
    filter: PostBackOrdersEquipmentDemandsListFilterRequest;
    /**
     * 
     * @type {FilterResultEquipmentDemandListController}
     * @memberof CompoundResultEquipmentDemandListController
     */
    result: FilterResultEquipmentDemandListController;
}
/**
 * 
 * @export
 * @interface CompoundResultEquipmentListController
 */
export interface CompoundResultEquipmentListController {
    /**
     * 
     * @type {PostBackUnitsEquipmentListFilterRequest}
     * @memberof CompoundResultEquipmentListController
     */
    filter: PostBackUnitsEquipmentListFilterRequest;
    /**
     * 
     * @type {FilterResultEquipmentListController}
     * @memberof CompoundResultEquipmentListController
     */
    result: FilterResultEquipmentListController;
}
/**
 * 
 * @export
 * @interface CompoundResultItemTypePropertySetListController
 */
export interface CompoundResultItemTypePropertySetListController {
    /**
     * 
     * @type {PostBackItemsPropertySetsListFilterRequest}
     * @memberof CompoundResultItemTypePropertySetListController
     */
    filter: PostBackItemsPropertySetsListFilterRequest;
    /**
     * 
     * @type {FilterResultItemTypePropertySetListController}
     * @memberof CompoundResultItemTypePropertySetListController
     */
    result: FilterResultItemTypePropertySetListController;
}
/**
 * 
 * @export
 * @interface CompoundResultItemTypePropertyTypesListController
 */
export interface CompoundResultItemTypePropertyTypesListController {
    /**
     * 
     * @type {PostBackItemsPropertyTypesFilterRequest}
     * @memberof CompoundResultItemTypePropertyTypesListController
     */
    filter: PostBackItemsPropertyTypesFilterRequest;
    /**
     * 
     * @type {FilterResultItemTypePropertyTypesListController}
     * @memberof CompoundResultItemTypePropertyTypesListController
     */
    result: FilterResultItemTypePropertyTypesListController;
}
/**
 * 
 * @export
 * @interface CompoundResultItemTypeTagListController
 */
export interface CompoundResultItemTypeTagListController {
    /**
     * 
     * @type {PostBackItemsItemTypeTagsListFilterRequest}
     * @memberof CompoundResultItemTypeTagListController
     */
    filter: PostBackItemsItemTypeTagsListFilterRequest;
    /**
     * 
     * @type {FilterResultItemTypeTagListController}
     * @memberof CompoundResultItemTypeTagListController
     */
    result: FilterResultItemTypeTagListController;
}
/**
 * 
 * @export
 * @interface CompoundResultItemTypeTotalStockListController
 */
export interface CompoundResultItemTypeTotalStockListController {
    /**
     * 
     * @type {PostBackUnitsItemsListFilterRequest}
     * @memberof CompoundResultItemTypeTotalStockListController
     */
    filter: PostBackUnitsItemsListFilterRequest;
    /**
     * 
     * @type {FilterResultItemTypeTotalStockListController}
     * @memberof CompoundResultItemTypeTotalStockListController
     */
    result: FilterResultItemTypeTotalStockListController;
}
/**
 * 
 * @export
 * @interface CompoundResultItemTypeVariantListController
 */
export interface CompoundResultItemTypeVariantListController {
    /**
     * 
     * @type {PostBackItemsVariantsFilterRequest}
     * @memberof CompoundResultItemTypeVariantListController
     */
    filter: PostBackItemsVariantsFilterRequest;
    /**
     * 
     * @type {FilterResultItemTypeVariantListController}
     * @memberof CompoundResultItemTypeVariantListController
     */
    result: FilterResultItemTypeVariantListController;
}
/**
 * 
 * @export
 * @interface CompoundResultItemTypeVariantWithPropertySetListController
 */
export interface CompoundResultItemTypeVariantWithPropertySetListController {
    /**
     * 
     * @type {PostBackItemsVariantsPropertySetFilterRequest}
     * @memberof CompoundResultItemTypeVariantWithPropertySetListController
     */
    filter: PostBackItemsVariantsPropertySetFilterRequest;
    /**
     * 
     * @type {FilterResultItemTypeVariantWithPropertySetListController}
     * @memberof CompoundResultItemTypeVariantWithPropertySetListController
     */
    result: FilterResultItemTypeVariantWithPropertySetListController;
}
/**
 * 
 * @export
 * @interface CompoundResultLegacyProductionLotListController
 */
export interface CompoundResultLegacyProductionLotListController {
    /**
     * 
     * @type {PostBackProductionOrdersLegacyLotsFilterRequest}
     * @memberof CompoundResultLegacyProductionLotListController
     */
    filter: PostBackProductionOrdersLegacyLotsFilterRequest;
    /**
     * 
     * @type {FilterResultLegacyProductionLotListController}
     * @memberof CompoundResultLegacyProductionLotListController
     */
    result: FilterResultLegacyProductionLotListController;
}
/**
 * 
 * @export
 * @interface CompoundResultLegacyProductionOrdersListController
 */
export interface CompoundResultLegacyProductionOrdersListController {
    /**
     * 
     * @type {PostBackProductionOrdersLegacyListFilterRequest}
     * @memberof CompoundResultLegacyProductionOrdersListController
     */
    filter: PostBackProductionOrdersLegacyListFilterRequest;
    /**
     * 
     * @type {FilterResultLegacyProductionOrdersListController}
     * @memberof CompoundResultLegacyProductionOrdersListController
     */
    result: FilterResultLegacyProductionOrdersListController;
}
/**
 * 
 * @export
 * @interface CompoundResultLoadCardListController
 */
export interface CompoundResultLoadCardListController {
    /**
     * 
     * @type {PostBackReportsLoadCardsListFilterRequest}
     * @memberof CompoundResultLoadCardListController
     */
    filter: PostBackReportsLoadCardsListFilterRequest;
    /**
     * 
     * @type {FilterResultLoadCardListController}
     * @memberof CompoundResultLoadCardListController
     */
    result: FilterResultLoadCardListController;
}
/**
 * 
 * @export
 * @interface CompoundResultMachineAreasListController
 */
export interface CompoundResultMachineAreasListController {
    /**
     * 
     * @type {PostBackMachineAreasListFilterRequest}
     * @memberof CompoundResultMachineAreasListController
     */
    filter: PostBackMachineAreasListFilterRequest;
    /**
     * 
     * @type {FilterResultMachineAreasListController}
     * @memberof CompoundResultMachineAreasListController
     */
    result: FilterResultMachineAreasListController;
}
/**
 * 
 * @export
 * @interface CompoundResultMachinesListController
 */
export interface CompoundResultMachinesListController {
    /**
     * 
     * @type {PostBackMachinesListFilterRequest}
     * @memberof CompoundResultMachinesListController
     */
    filter: PostBackMachinesListFilterRequest;
    /**
     * 
     * @type {FilterResultMachinesListController}
     * @memberof CompoundResultMachinesListController
     */
    result: FilterResultMachinesListController;
}
/**
 * 
 * @export
 * @interface CompoundResultMarketingKeepersListController
 */
export interface CompoundResultMarketingKeepersListController {
    /**
     * 
     * @type {PostBackContractorsMarketingKeepersListFilterRequest}
     * @memberof CompoundResultMarketingKeepersListController
     */
    filter: PostBackContractorsMarketingKeepersListFilterRequest;
    /**
     * 
     * @type {FilterResultMarketingKeepersListController}
     * @memberof CompoundResultMarketingKeepersListController
     */
    result: FilterResultMarketingKeepersListController;
}
/**
 * 
 * @export
 * @interface CompoundResultMarketingRulesListController
 */
export interface CompoundResultMarketingRulesListController {
    /**
     * 
     * @type {PostBackMarketingrulesListFilterRequest}
     * @memberof CompoundResultMarketingRulesListController
     */
    filter: PostBackMarketingrulesListFilterRequest;
    /**
     * 
     * @type {FilterResultMarketingRulesListController}
     * @memberof CompoundResultMarketingRulesListController
     */
    result: FilterResultMarketingRulesListController;
}
/**
 * 
 * @export
 * @interface CompoundResultMaterialMovementListController
 */
export interface CompoundResultMaterialMovementListController {
    /**
     * 
     * @type {PostBackMaterialMovementsListFilterRequest}
     * @memberof CompoundResultMaterialMovementListController
     */
    filter: PostBackMaterialMovementsListFilterRequest;
    /**
     * 
     * @type {FilterResultMaterialMovementListController}
     * @memberof CompoundResultMaterialMovementListController
     */
    result: FilterResultMaterialMovementListController;
}
/**
 * 
 * @export
 * @interface CompoundResultMeasurementDevicesListController
 */
export interface CompoundResultMeasurementDevicesListController {
    /**
     * 
     * @type {PostBackMeasurementsMeasurementDevicesFilterRequest}
     * @memberof CompoundResultMeasurementDevicesListController
     */
    filter: PostBackMeasurementsMeasurementDevicesFilterRequest;
    /**
     * 
     * @type {FilterResultMeasurementDevicesListController}
     * @memberof CompoundResultMeasurementDevicesListController
     */
    result: FilterResultMeasurementDevicesListController;
}
/**
 * 
 * @export
 * @interface CompoundResultMeasurementStandardsListController
 */
export interface CompoundResultMeasurementStandardsListController {
    /**
     * 
     * @type {PostBackMeasurementsMeasurementDevicesFilterRequest}
     * @memberof CompoundResultMeasurementStandardsListController
     */
    filter: PostBackMeasurementsMeasurementDevicesFilterRequest;
    /**
     * 
     * @type {FilterResultMeasurementStandardsListController}
     * @memberof CompoundResultMeasurementStandardsListController
     */
    result: FilterResultMeasurementStandardsListController;
}
/**
 * 
 * @export
 * @interface CompoundResultMethodsOfPaymentListController
 */
export interface CompoundResultMethodsOfPaymentListController {
    /**
     * 
     * @type {PostBackMeasurementsMeasurementDevicesFilterRequest}
     * @memberof CompoundResultMethodsOfPaymentListController
     */
    filter: PostBackMeasurementsMeasurementDevicesFilterRequest;
    /**
     * 
     * @type {FilterResultMethodsOfPaymentListController}
     * @memberof CompoundResultMethodsOfPaymentListController
     */
    result: FilterResultMethodsOfPaymentListController;
}
/**
 * 
 * @export
 * @interface CompoundResultOffersListController
 */
export interface CompoundResultOffersListController {
    /**
     * 
     * @type {PostBackOffersListFilterRequest}
     * @memberof CompoundResultOffersListController
     */
    filter: PostBackOffersListFilterRequest;
    /**
     * 
     * @type {FilterResultOffersListController}
     * @memberof CompoundResultOffersListController
     */
    result: FilterResultOffersListController;
}
/**
 * 
 * @export
 * @interface CompoundResultOrderDemandsToProductionListController
 */
export interface CompoundResultOrderDemandsToProductionListController {
    /**
     * 
     * @type {PostBackProductionOrdersOrderDemandsListFilterRequest}
     * @memberof CompoundResultOrderDemandsToProductionListController
     */
    filter: PostBackProductionOrdersOrderDemandsListFilterRequest;
    /**
     * 
     * @type {FilterResultOrderDemandsToProductionListController}
     * @memberof CompoundResultOrderDemandsToProductionListController
     */
    result: FilterResultOrderDemandsToProductionListController;
}
/**
 * 
 * @export
 * @interface CompoundResultOrderItemCostsGroupListController
 */
export interface CompoundResultOrderItemCostsGroupListController {
    /**
     * 
     * @type {PostBackPresentationsOrderItemsItemsGroupListFilterRequest}
     * @memberof CompoundResultOrderItemCostsGroupListController
     */
    filter: PostBackPresentationsOrderItemsItemsGroupListFilterRequest;
    /**
     * 
     * @type {FilterResultOrderItemCostsGroupListController}
     * @memberof CompoundResultOrderItemCostsGroupListController
     */
    result: FilterResultOrderItemCostsGroupListController;
}
/**
 * 
 * @export
 * @interface CompoundResultOrdersListController
 */
export interface CompoundResultOrdersListController {
    /**
     * 
     * @type {PostBackOrdersListFilterRequest}
     * @memberof CompoundResultOrdersListController
     */
    filter: PostBackOrdersListFilterRequest;
    /**
     * 
     * @type {FilterResultOrdersListController}
     * @memberof CompoundResultOrdersListController
     */
    result: FilterResultOrdersListController;
}
/**
 * 
 * @export
 * @interface CompoundResultOtherDemandListController
 */
export interface CompoundResultOtherDemandListController {
    /**
     * 
     * @type {PostBackOrdersOtherDemandsListFilterRequest}
     * @memberof CompoundResultOtherDemandListController
     */
    filter: PostBackOrdersOtherDemandsListFilterRequest;
    /**
     * 
     * @type {FilterResultOtherDemandListController}
     * @memberof CompoundResultOtherDemandListController
     */
    result: FilterResultOtherDemandListController;
}
/**
 * 
 * @export
 * @interface CompoundResultPriceListsListController
 */
export interface CompoundResultPriceListsListController {
    /**
     * 
     * @type {PostBackItemsPriceListsFilterRequest}
     * @memberof CompoundResultPriceListsListController
     */
    filter: PostBackItemsPriceListsFilterRequest;
    /**
     * 
     * @type {FilterResultPriceListsListController}
     * @memberof CompoundResultPriceListsListController
     */
    result: FilterResultPriceListsListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductCatalogListController
 */
export interface CompoundResultProductCatalogListController {
    /**
     * 
     * @type {PostBackProductcatalogListFilterRequest}
     * @memberof CompoundResultProductCatalogListController
     */
    filter: PostBackProductcatalogListFilterRequest;
    /**
     * 
     * @type {FilterResultProductCatalogListController}
     * @memberof CompoundResultProductCatalogListController
     */
    result: FilterResultProductCatalogListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionLotListController
 */
export interface CompoundResultProductionLotListController {
    /**
     * 
     * @type {PostBackProductionOrdersLotsListFilterRequest}
     * @memberof CompoundResultProductionLotListController
     */
    filter: PostBackProductionOrdersLotsListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionLotListController}
     * @memberof CompoundResultProductionLotListController
     */
    result: FilterResultProductionLotListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionLotPeriodsGroupListController
 */
export interface CompoundResultProductionLotPeriodsGroupListController {
    /**
     * 
     * @type {PostBackPresentationsProductionLotPeriodsGroupListFilterRequest}
     * @memberof CompoundResultProductionLotPeriodsGroupListController
     */
    filter: PostBackPresentationsProductionLotPeriodsGroupListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionLotPeriodsGroupListController}
     * @memberof CompoundResultProductionLotPeriodsGroupListController
     */
    result: FilterResultProductionLotPeriodsGroupListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionLotRawMaterialsUsageListController
 */
export interface CompoundResultProductionLotRawMaterialsUsageListController {
    /**
     * 
     * @type {PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest}
     * @memberof CompoundResultProductionLotRawMaterialsUsageListController
     */
    filter: PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionLotRawMaterialsUsageListController}
     * @memberof CompoundResultProductionLotRawMaterialsUsageListController
     */
    result: FilterResultProductionLotRawMaterialsUsageListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionLotTagListController
 */
export interface CompoundResultProductionLotTagListController {
    /**
     * 
     * @type {PostBackProductionSpecificationTagsListFilterRequest}
     * @memberof CompoundResultProductionLotTagListController
     */
    filter: PostBackProductionSpecificationTagsListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionLotTagListController}
     * @memberof CompoundResultProductionLotTagListController
     */
    result: FilterResultProductionLotTagListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionOrderCreatorListController
 */
export interface CompoundResultProductionOrderCreatorListController {
    /**
     * 
     * @type {PostBackProductionOrdersCreatorListFilterRequest}
     * @memberof CompoundResultProductionOrderCreatorListController
     */
    filter: PostBackProductionOrdersCreatorListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionOrderCreatorListController}
     * @memberof CompoundResultProductionOrderCreatorListController
     */
    result: FilterResultProductionOrderCreatorListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionOrderLotListController
 */
export interface CompoundResultProductionOrderLotListController {
    /**
     * 
     * @type {PostBackProductionOrdersProductionOrderLotsListFilterRequest}
     * @memberof CompoundResultProductionOrderLotListController
     */
    filter: PostBackProductionOrdersProductionOrderLotsListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionOrderLotListController}
     * @memberof CompoundResultProductionOrderLotListController
     */
    result: FilterResultProductionOrderLotListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionOrderRawMaterialsUsageListController
 */
export interface CompoundResultProductionOrderRawMaterialsUsageListController {
    /**
     * 
     * @type {PostBackProductionOrdersRawMaterialsUsageListFilterRequest}
     * @memberof CompoundResultProductionOrderRawMaterialsUsageListController
     */
    filter: PostBackProductionOrdersRawMaterialsUsageListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionOrderRawMaterialsUsageListController}
     * @memberof CompoundResultProductionOrderRawMaterialsUsageListController
     */
    result: FilterResultProductionOrderRawMaterialsUsageListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionOrderWorktimeListController
 */
export interface CompoundResultProductionOrderWorktimeListController {
    /**
     * 
     * @type {PostBackProductionOrdersWorktimeListFilterRequest}
     * @memberof CompoundResultProductionOrderWorktimeListController
     */
    filter: PostBackProductionOrdersWorktimeListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionOrderWorktimeListController}
     * @memberof CompoundResultProductionOrderWorktimeListController
     */
    result: FilterResultProductionOrderWorktimeListController;
}
/**
 * 
 * @export
 * @interface CompoundResultProductionOrdersListController
 */
export interface CompoundResultProductionOrdersListController {
    /**
     * 
     * @type {PostBackProductionOrdersListFilterRequest}
     * @memberof CompoundResultProductionOrdersListController
     */
    filter: PostBackProductionOrdersListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionOrdersListController}
     * @memberof CompoundResultProductionOrdersListController
     */
    result: FilterResultProductionOrdersListController;
}
/**
 * 
 * @export
 * @interface CompoundResultPushStatusListController
 */
export interface CompoundResultPushStatusListController {
    /**
     * 
     * @type {PostBackPushListFilterRequest}
     * @memberof CompoundResultPushStatusListController
     */
    filter: PostBackPushListFilterRequest;
    /**
     * 
     * @type {FilterResultPushStatusListController}
     * @memberof CompoundResultPushStatusListController
     */
    result: FilterResultPushStatusListController;
}
/**
 * 
 * @export
 * @interface CompoundResultReleaseListController
 */
export interface CompoundResultReleaseListController {
    /**
     * 
     * @type {PostBackReleasesListFilterRequest}
     * @memberof CompoundResultReleaseListController
     */
    filter: PostBackReleasesListFilterRequest;
    /**
     * 
     * @type {FilterResultReleaseListController}
     * @memberof CompoundResultReleaseListController
     */
    result: FilterResultReleaseListController;
}
/**
 * 
 * @export
 * @interface CompoundResultReleasePlanListController
 */
export interface CompoundResultReleasePlanListController {
    /**
     * 
     * @type {PostBackReleasesPlanListFilterRequest}
     * @memberof CompoundResultReleasePlanListController
     */
    filter: PostBackReleasesPlanListFilterRequest;
    /**
     * 
     * @type {FilterResultReleasePlanListController}
     * @memberof CompoundResultReleasePlanListController
     */
    result: FilterResultReleasePlanListController;
}
/**
 * 
 * @export
 * @interface CompoundResultRolesListViewController
 */
export interface CompoundResultRolesListViewController {
    /**
     * 
     * @type {PostUmRolesListFilterRequest}
     * @memberof CompoundResultRolesListViewController
     */
    filter: PostUmRolesListFilterRequest;
    /**
     * 
     * @type {FilterResultRolesListViewController}
     * @memberof CompoundResultRolesListViewController
     */
    result: FilterResultRolesListViewController;
}
/**
 * 
 * @export
 * @interface CompoundResultSalesEntryDocumentListViewController
 */
export interface CompoundResultSalesEntryDocumentListViewController {
    /**
     * 
     * @type {PostBackSalesDocumentsListFilterRequest}
     * @memberof CompoundResultSalesEntryDocumentListViewController
     */
    filter: PostBackSalesDocumentsListFilterRequest;
    /**
     * 
     * @type {FilterResultSalesEntryDocumentListViewController}
     * @memberof CompoundResultSalesEntryDocumentListViewController
     */
    result: FilterResultSalesEntryDocumentListViewController;
}
/**
 * 
 * @export
 * @interface CompoundResultSalesEntryTagListController
 */
export interface CompoundResultSalesEntryTagListController {
    /**
     * 
     * @type {PostBackSalesTagsListFilterRequest}
     * @memberof CompoundResultSalesEntryTagListController
     */
    filter: PostBackSalesTagsListFilterRequest;
    /**
     * 
     * @type {FilterResultSalesEntryTagListController}
     * @memberof CompoundResultSalesEntryTagListController
     */
    result: FilterResultSalesEntryTagListController;
}
/**
 * 
 * @export
 * @interface CompoundResultSpecificationsByMachineFeaturesListController
 */
export interface CompoundResultSpecificationsByMachineFeaturesListController {
    /**
     * 
     * @type {PostBackSpecificationsByMachineFeaturesListFilterRequest}
     * @memberof CompoundResultSpecificationsByMachineFeaturesListController
     */
    filter: PostBackSpecificationsByMachineFeaturesListFilterRequest;
    /**
     * 
     * @type {FilterResultSpecificationsByMachineFeaturesListController}
     * @memberof CompoundResultSpecificationsByMachineFeaturesListController
     */
    result: FilterResultSpecificationsByMachineFeaturesListController;
}
/**
 * 
 * @export
 * @interface CompoundResultSpecificationsByProducedItemTagsListController
 */
export interface CompoundResultSpecificationsByProducedItemTagsListController {
    /**
     * 
     * @type {PostBackSpecificationsByProducedItemTagsListFilterRequest}
     * @memberof CompoundResultSpecificationsByProducedItemTagsListController
     */
    filter: PostBackSpecificationsByProducedItemTagsListFilterRequest;
    /**
     * 
     * @type {FilterResultSpecificationsByProducedItemTagsListController}
     * @memberof CompoundResultSpecificationsByProducedItemTagsListController
     */
    result: FilterResultSpecificationsByProducedItemTagsListController;
}
/**
 * 
 * @export
 * @interface CompoundResultSpecificationsByProducedVariantListController
 */
export interface CompoundResultSpecificationsByProducedVariantListController {
    /**
     * 
     * @type {PostBackSpecificationsByProducedVariantListFilterRequest}
     * @memberof CompoundResultSpecificationsByProducedVariantListController
     */
    filter: PostBackSpecificationsByProducedVariantListFilterRequest;
    /**
     * 
     * @type {FilterResultSpecificationsByProducedVariantListController}
     * @memberof CompoundResultSpecificationsByProducedVariantListController
     */
    result: FilterResultSpecificationsByProducedVariantListController;
}
/**
 * 
 * @export
 * @interface CompoundResultSpecificationsByProducedVariantListControllerV2
 */
export interface CompoundResultSpecificationsByProducedVariantListControllerV2 {
    /**
     * 
     * @type {PostBackSpecificationsV2ByProducedVariantListFilterRequest}
     * @memberof CompoundResultSpecificationsByProducedVariantListControllerV2
     */
    filter: PostBackSpecificationsV2ByProducedVariantListFilterRequest;
    /**
     * 
     * @type {FilterResultSpecificationsByProducedVariantListControllerV2}
     * @memberof CompoundResultSpecificationsByProducedVariantListControllerV2
     */
    result: FilterResultSpecificationsByProducedVariantListControllerV2;
}
/**
 * 
 * @export
 * @interface CompoundResultStandardParametersListController
 */
export interface CompoundResultStandardParametersListController {
    /**
     * 
     * @type {PostBackSpecificationsStandardParametersFilterRequest}
     * @memberof CompoundResultStandardParametersListController
     */
    filter: PostBackSpecificationsStandardParametersFilterRequest;
    /**
     * 
     * @type {FilterResultStandardParametersListController}
     * @memberof CompoundResultStandardParametersListController
     */
    result: FilterResultStandardParametersListController;
}
/**
 * 
 * @export
 * @interface CompoundResultStocksToSupplementListViewController
 */
export interface CompoundResultStocksToSupplementListViewController {
    /**
     * 
     * @type {PostBackStocksSupplementListFilterRequest}
     * @memberof CompoundResultStocksToSupplementListViewController
     */
    filter: PostBackStocksSupplementListFilterRequest;
    /**
     * 
     * @type {FilterResultStocksToSupplementListViewController}
     * @memberof CompoundResultStocksToSupplementListViewController
     */
    result: FilterResultStocksToSupplementListViewController;
}
/**
 * 
 * @export
 * @interface CompoundResultStocktakingListController
 */
export interface CompoundResultStocktakingListController {
    /**
     * 
     * @type {PostBackStocktakingListFilterRequest}
     * @memberof CompoundResultStocktakingListController
     */
    filter: PostBackStocktakingListFilterRequest;
    /**
     * 
     * @type {FilterResultStocktakingListController}
     * @memberof CompoundResultStocktakingListController
     */
    result: FilterResultStocktakingListController;
}
/**
 * 
 * @export
 * @interface CompoundResultSupplyCardListController
 */
export interface CompoundResultSupplyCardListController {
    /**
     * 
     * @type {PostBackQsCardListFilterRequest}
     * @memberof CompoundResultSupplyCardListController
     */
    filter: PostBackQsCardListFilterRequest;
    /**
     * 
     * @type {FilterResultSupplyCardListController}
     * @memberof CompoundResultSupplyCardListController
     */
    result: FilterResultSupplyCardListController;
}
/**
 * 
 * @export
 * @interface CompoundResultSupplyOrderCreatorListController
 */
export interface CompoundResultSupplyOrderCreatorListController {
    /**
     * 
     * @type {PostBackSupplyOrdersCreatorListFilterRequest}
     * @memberof CompoundResultSupplyOrderCreatorListController
     */
    filter: PostBackSupplyOrdersCreatorListFilterRequest;
    /**
     * 
     * @type {FilterResultSupplyOrderCreatorListController}
     * @memberof CompoundResultSupplyOrderCreatorListController
     */
    result: FilterResultSupplyOrderCreatorListController;
}
/**
 * 
 * @export
 * @interface CompoundResultSupplyOrderListController
 */
export interface CompoundResultSupplyOrderListController {
    /**
     * 
     * @type {PostBackSupplyListFilterRequest}
     * @memberof CompoundResultSupplyOrderListController
     */
    filter: PostBackSupplyListFilterRequest;
    /**
     * 
     * @type {FilterResultSupplyOrderListController}
     * @memberof CompoundResultSupplyOrderListController
     */
    result: FilterResultSupplyOrderListController;
}
/**
 * 
 * @export
 * @interface CompoundResultSynchronizationStatusListController
 */
export interface CompoundResultSynchronizationStatusListController {
    /**
     * 
     * @type {PostBackErpSynchronizationStatusesFilterRequest}
     * @memberof CompoundResultSynchronizationStatusListController
     */
    filter: PostBackErpSynchronizationStatusesFilterRequest;
    /**
     * 
     * @type {FilterResultSynchronizationStatusListController}
     * @memberof CompoundResultSynchronizationStatusListController
     */
    result: FilterResultSynchronizationStatusListController;
}
/**
 * 
 * @export
 * @interface CompoundResultTicketsListController
 */
export interface CompoundResultTicketsListController {
    /**
     * 
     * @type {PostBackTicketsListFilterRequest}
     * @memberof CompoundResultTicketsListController
     */
    filter: PostBackTicketsListFilterRequest;
    /**
     * 
     * @type {FilterResultTicketsListController}
     * @memberof CompoundResultTicketsListController
     */
    result: FilterResultTicketsListController;
}
/**
 * 
 * @export
 * @interface CompoundResultUsersListController
 */
export interface CompoundResultUsersListController {
    /**
     * 
     * @type {PostUmUsersListFilterRequest}
     * @memberof CompoundResultUsersListController
     */
    filter: PostUmUsersListFilterRequest;
    /**
     * 
     * @type {FilterResultUsersListController}
     * @memberof CompoundResultUsersListController
     */
    result: FilterResultUsersListController;
}
/**
 * 
 * @export
 * @interface CompoundResultWarehouseStateListController
 */
export interface CompoundResultWarehouseStateListController {
    /**
     * 
     * @type {PostBackProductionOrdersWarehouseStateListFilterRequest}
     * @memberof CompoundResultWarehouseStateListController
     */
    filter: PostBackProductionOrdersWarehouseStateListFilterRequest;
    /**
     * 
     * @type {FilterResultWarehouseStateListController}
     * @memberof CompoundResultWarehouseStateListController
     */
    result: FilterResultWarehouseStateListController;
}
/**
 * 
 * @export
 * @interface CompoundResultWarehouseStateToProductionListController
 */
export interface CompoundResultWarehouseStateToProductionListController {
    /**
     * 
     * @type {PostBackProductionOrdersWarehouseToProductionListFilterRequest}
     * @memberof CompoundResultWarehouseStateToProductionListController
     */
    filter: PostBackProductionOrdersWarehouseToProductionListFilterRequest;
    /**
     * 
     * @type {FilterResultWarehouseStateToProductionListController}
     * @memberof CompoundResultWarehouseStateToProductionListController
     */
    result: FilterResultWarehouseStateToProductionListController;
}
/**
 * 
 * @export
 * @interface CompoundResultWarehouseTagListController
 */
export interface CompoundResultWarehouseTagListController {
    /**
     * 
     * @type {PostBackSupplyWarehouseTagListFilterRequest}
     * @memberof CompoundResultWarehouseTagListController
     */
    filter: PostBackSupplyWarehouseTagListFilterRequest;
    /**
     * 
     * @type {FilterResultWarehouseTagListController}
     * @memberof CompoundResultWarehouseTagListController
     */
    result: FilterResultWarehouseTagListController;
}
/**
 * 
 * @export
 * @interface CompoundResultWasteCausesListController
 */
export interface CompoundResultWasteCausesListController {
    /**
     * 
     * @type {PostBackMeasurementsMeasurementDevicesFilterRequest}
     * @memberof CompoundResultWasteCausesListController
     */
    filter: PostBackMeasurementsMeasurementDevicesFilterRequest;
    /**
     * 
     * @type {FilterResultWasteCausesListController}
     * @memberof CompoundResultWasteCausesListController
     */
    result: FilterResultWasteCausesListController;
}
/**
 * 
 * @export
 * @interface CompoundResultWithSummaryProductionUnitListViewRow
 */
export interface CompoundResultWithSummaryProductionUnitListViewRow {
    /**
     * 
     * @type {PostBackUnitsListFilterRequest}
     * @memberof CompoundResultWithSummaryProductionUnitListViewRow
     */
    filter: PostBackUnitsListFilterRequest;
    /**
     * 
     * @type {FilterResultProductionUnitListViewRow}
     * @memberof CompoundResultWithSummaryProductionUnitListViewRow
     */
    result: FilterResultProductionUnitListViewRow;
    /**
     * 
     * @type {ProductionUnitListSummary}
     * @memberof CompoundResultWithSummaryProductionUnitListViewRow
     */
    summary: ProductionUnitListSummary;
}
/**
 * 
 * @export
 * @interface CompoundResultWorkerCompetenceListViewController
 */
export interface CompoundResultWorkerCompetenceListViewController {
    /**
     * 
     * @type {PostBackWorkersWorkerCompetencesListFilterRequest}
     * @memberof CompoundResultWorkerCompetenceListViewController
     */
    filter: PostBackWorkersWorkerCompetencesListFilterRequest;
    /**
     * 
     * @type {FilterResultWorkerCompetenceListViewController}
     * @memberof CompoundResultWorkerCompetenceListViewController
     */
    result: FilterResultWorkerCompetenceListViewController;
}
/**
 * 
 * @export
 * @interface CompoundResultWorkerDocumentListViewController
 */
export interface CompoundResultWorkerDocumentListViewController {
    /**
     * 
     * @type {PostBackWorkersDocumentsListFilterRequest}
     * @memberof CompoundResultWorkerDocumentListViewController
     */
    filter: PostBackWorkersDocumentsListFilterRequest;
    /**
     * 
     * @type {FilterResultWorkerDocumentListViewController}
     * @memberof CompoundResultWorkerDocumentListViewController
     */
    result: FilterResultWorkerDocumentListViewController;
}
/**
 * 
 * @export
 * @interface CompoundResultWorkerListViewController
 */
export interface CompoundResultWorkerListViewController {
    /**
     * 
     * @type {PostBackWorkersListFilterRequest}
     * @memberof CompoundResultWorkerListViewController
     */
    filter: PostBackWorkersListFilterRequest;
    /**
     * 
     * @type {FilterResultWorkerListViewController}
     * @memberof CompoundResultWorkerListViewController
     */
    result: FilterResultWorkerListViewController;
}

/**
 * 
 * @export
 */
export const ConfirmationType = {
    Oks: 'oks',
    Noks: 'noks',
    Downtime: 'downtime',
    Packing: 'packing'
} as const;
export type ConfirmationType = typeof ConfirmationType[keyof typeof ConfirmationType];

/**
 * 
 * @export
 * @interface ConflictingAssignmentView
 */
export interface ConflictingAssignmentView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ConflictingAssignmentView
     */
    lotId: number;
    /**
     * MachineId
     * @type {number}
     * @memberof ConflictingAssignmentView
     */
    machineId: number;
    /**
     * 
     * @type {string}
     * @memberof ConflictingAssignmentView
     */
    machineName: string;
    /**
     * 
     * @type {string}
     * @memberof ConflictingAssignmentView
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof ConflictingAssignmentView
     */
    endTime: string;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * ContactId
     * @type {number}
     * @memberof Contact
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    isPrimary?: boolean;
}
/**
 * 
 * @export
 * @interface ContactDataUpdateView
 */
export interface ContactDataUpdateView {
    /**
     * 
     * @type {string}
     * @memberof ContactDataUpdateView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactDataUpdateView
     */
    phone?: string;
}
/**
 * 
 * @export
 * @interface ContactRow
 */
export interface ContactRow {
    /**
     * ContactId
     * @type {number}
     * @memberof ContactRow
     */
    id?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof ContactRow
     */
    contractorId: number;
    /**
     * 
     * @type {string}
     * @memberof ContactRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContactRow
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactRow
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContactRow
     */
    isPrimary: boolean;
}
/**
 * 
 * @export
 * @interface ContextualDefaultItemTypeVariant
 */
export interface ContextualDefaultItemTypeVariant {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ContextualDefaultItemTypeVariant
     */
    id?: number;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ContextualDefaultItemTypeVariant
     */
    itemTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContextualDefaultItemTypeVariant
     */
    name?: string;
    /**
     * 
     * @type {Array<ItemTypeProperty>}
     * @memberof ContextualDefaultItemTypeVariant
     */
    properties?: Array<ItemTypeProperty>;
    /**
     * 
     * @type {number}
     * @memberof ContextualDefaultItemTypeVariant
     */
    minimalAmount?: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof ContextualDefaultItemTypeVariant
     */
    defaultPlace?: number;
}
/**
 * 
 * @export
 * @interface ContextualItemTypeVariant
 */
export interface ContextualItemTypeVariant {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ContextualItemTypeVariant
     */
    id?: number;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ContextualItemTypeVariant
     */
    itemTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof ContextualItemTypeVariant
     */
    name?: string;
    /**
     * 
     * @type {Array<ItemTypeProperty>}
     * @memberof ContextualItemTypeVariant
     */
    properties?: Array<ItemTypeProperty>;
    /**
     * 
     * @type {number}
     * @memberof ContextualItemTypeVariant
     */
    minimalAmount?: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof ContextualItemTypeVariant
     */
    defaultPlace?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContextualItemTypeVariant
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface Contractor
 */
export interface Contractor {
    /**
     * ContractorId
     * @type {number}
     * @memberof Contractor
     */
    id?: number;
    /**
     * UserId
     * @type {number}
     * @memberof Contractor
     */
    marketingKeeperId?: number;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    regon?: string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    phoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contractor
     */
    isExport: boolean;
    /**
     * 
     * @type {number}
     * @memberof Contractor
     */
    gln?: number;
    /**
     * 
     * @type {number}
     * @memberof Contractor
     */
    gs1ContractorPrefix?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Contractor
     */
    active: boolean;
    /**
     * ContactId
     * @type {number}
     * @memberof Contractor
     */
    contactId?: number;
    /**
     * BankAccountId
     * @type {number}
     * @memberof Contractor
     */
    defaultBankAccountId?: number;
    /**
     * 
     * @type {number}
     * @memberof Contractor
     */
    creditLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof Contractor
     */
    expiredLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof Contractor
     */
    afterTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof Contractor
     */
    liabilities?: number;
    /**
     * 
     * @type {number}
     * @memberof Contractor
     */
    advances?: number;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contractor
     */
    internal: boolean;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    orderDisableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Contractor
     */
    transactionDisableDate?: string;
    /**
     * 
     * @type {Array<ContractorKind>}
     * @memberof Contractor
     */
    kinds: Array<ContractorKind>;
}
/**
 * 
 * @export
 * @interface ContractorCommentUpdateView
 */
export interface ContractorCommentUpdateView {
    /**
     * 
     * @type {string}
     * @memberof ContractorCommentUpdateView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface ContractorGroupAllItems
 */
export interface ContractorGroupAllItems {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof ContractorGroupAllItems
     */
    id?: number;
    /**
     * 
     * @type {ContractorTag}
     * @memberof ContractorGroupAllItems
     */
    contractorTag: ContractorTag;
    /**
     * 
     * @type {number}
     * @memberof ContractorGroupAllItems
     */
    discount: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof ContractorGroupAllItems
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface ContractorGroupItemGroup
 */
export interface ContractorGroupItemGroup {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof ContractorGroupItemGroup
     */
    id?: number;
    /**
     * 
     * @type {ContractorTag}
     * @memberof ContractorGroupItemGroup
     */
    contractorTag: ContractorTag;
    /**
     * 
     * @type {ItemTypeTag}
     * @memberof ContractorGroupItemGroup
     */
    itemTypeTag: ItemTypeTag;
    /**
     * 
     * @type {number}
     * @memberof ContractorGroupItemGroup
     */
    discount: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof ContractorGroupItemGroup
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface ContractorGroupSingleItem
 */
export interface ContractorGroupSingleItem {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof ContractorGroupSingleItem
     */
    id?: number;
    /**
     * 
     * @type {ContractorTag}
     * @memberof ContractorGroupSingleItem
     */
    contractorTag: ContractorTag;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ContractorGroupSingleItem
     */
    itemTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorGroupSingleItem
     */
    discount: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof ContractorGroupSingleItem
     */
    marketingRuleType: MarketingRuleType;
}

/**
 * 
 * @export
 */
export const ContractorKind = {
    buyer: 1,
    supplier: 2
} as const;
export type ContractorKind = typeof ContractorKind[keyof typeof ContractorKind];

/**
 * 
 * @export
 * @interface ContractorListViewRow
 */
export interface ContractorListViewRow {
    /**
     * ContractorId
     * @type {number}
     * @memberof ContractorListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    regon?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    marketingKeeperName?: string;
    /**
     * UserId
     * @type {number}
     * @memberof ContractorListViewRow
     */
    marketingKeeperId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorListViewRow
     */
    active: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ContractorListViewRow
     */
    contractorTagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractorListViewRow
     */
    contractorTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    lastActivity?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    comment?: string;
    /**
     * 
     * @type {Array<ContractorKind>}
     * @memberof ContractorListViewRow
     */
    kinds?: Array<ContractorKind>;
    /**
     * 
     * @type {string}
     * @memberof ContractorListViewRow
     */
    comboNameSearch: string;
}
/**
 * @type ContractorNotFoundOrInvalidTaxId
 * 
 * @export
 */
export type ContractorNotFoundOrInvalidTaxId = { name: 'ContractorNotFound' } & LemmaSimpleErrorView | { name: 'InvalidTaxId' } & LemmaSimpleErrorView;
/**
 * 
 * @export
 * @interface ContractorShortView
 */
export interface ContractorShortView {
    /**
     * ContractorId
     * @type {number}
     * @memberof ContractorShortView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorShortView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorShortView
     */
    externalId?: string;
}
/**
 * 
 * @export
 * @interface ContractorTag
 */
export interface ContractorTag {
    /**
     * ContractorTagId
     * @type {number}
     * @memberof ContractorTag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorTag
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ContractorUpdate
 */
export interface ContractorUpdate {
    /**
     * 
     * @type {ContractorView}
     * @memberof ContractorUpdate
     */
    contractor: ContractorView;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof ContractorUpdate
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface ContractorView
 */
export interface ContractorView {
    /**
     * ContractorId
     * @type {number}
     * @memberof ContractorView
     */
    id?: number;
    /**
     * UserId
     * @type {number}
     * @memberof ContractorView
     */
    marketingKeeperId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    marketingKeeperName?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    shortName: string;
    /**
     * 
     * @type {Address}
     * @memberof ContractorView
     */
    hq: Address;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    regon?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    externalId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorView
     */
    isExport: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContractorView
     */
    gln?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorView
     */
    gs1ContractorPrefix?: number;
    /**
     * 
     * @type {Array<ContractorTag>}
     * @memberof ContractorView
     */
    tags?: Array<ContractorTag>;
    /**
     * 
     * @type {Array<ContractorTag>}
     * @memberof ContractorView
     */
    externalTags?: Array<ContractorTag>;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorView
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractorView
     */
    internal: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    orderDisableDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    transactionDisableDate?: string;
    /**
     * 
     * @type {Contact}
     * @memberof ContractorView
     */
    contact?: Contact;
    /**
     * BankAccountId
     * @type {number}
     * @memberof ContractorView
     */
    bankAccountId?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorView
     */
    creditLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorView
     */
    expiredLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorView
     */
    afterTerm?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorView
     */
    liabilities?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractorView
     */
    advances?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractorView
     */
    comment?: string;
    /**
     * 
     * @type {Array<ContractorKind>}
     * @memberof ContractorView
     */
    kinds: Array<ContractorKind>;
}
/**
 * 
 * @export
 * @interface Coordinates
 */
export interface Coordinates {
    /**
     * 
     * @type {number}
     * @memberof Coordinates
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof Coordinates
     */
    longitude: number;
}
/**
 * @type CostDescription
 * 
 * @export
 */
export type CostDescription = VariantDescription;
/**
 * 
 * @export
 * @interface CostEntry
 */
export interface CostEntry {
    /**
     * CostEntryId
     * @type {number}
     * @memberof CostEntry
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CostEntry
     */
    name: string;
    /**
     * 
     * @type {AmountWithOptionalUnit}
     * @memberof CostEntry
     */
    amount?: AmountWithOptionalUnit;
    /**
     * 
     * @type {number}
     * @memberof CostEntry
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof CostEntry
     */
    unitPriceInBaseCurrency?: number;
    /**
     * 
     * @type {number}
     * @memberof CostEntry
     */
    discount?: number;
}
/**
 * 
 * @export
 * @interface CostEstimate
 */
export interface CostEstimate {
    /**
     * 
     * @type {number}
     * @memberof CostEstimate
     */
    profitMargin?: number;
    /**
     * 
     * @type {CostSet}
     * @memberof CostEstimate
     */
    costSet: CostSet;
}
/**
 * 
 * @export
 * @interface CostEstimateResult
 */
export interface CostEstimateResult {
    /**
     * 
     * @type {Array<CostEntry>}
     * @memberof CostEstimateResult
     */
    costEstimates?: Array<CostEntry>;
    /**
     * 
     * @type {Array<CostEntry>}
     * @memberof CostEstimateResult
     */
    additionalCosts?: Array<CostEntry>;
}
/**
 * 
 * @export
 * @interface CostEstimateSummary
 */
export interface CostEstimateSummary {
    /**
     * 
     * @type {number}
     * @memberof CostEstimateSummary
     */
    baseProductUnitCost: number;
    /**
     * 
     * @type {number}
     * @memberof CostEstimateSummary
     */
    baseProductCalculatedDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof CostEstimateSummary
     */
    baseProductTotalDiscountedCost: number;
}
/**
 * 
 * @export
 * @interface CostSet
 */
export interface CostSet {
    /**
     * CostSetId
     * @type {number}
     * @memberof CostSet
     */
    id?: number;
    /**
     * 
     * @type {Array<CostEntry>}
     * @memberof CostSet
     */
    entries?: Array<CostEntry>;
}
/**
 * 
 * @export
 * @interface CostSpecification
 */
export interface CostSpecification {
    /**
     * CostSpecificationId
     * @type {number}
     * @memberof CostSpecification
     */
    id?: number;
    /**
     * 
     * @type {Array<CostSpecificationEntry>}
     * @memberof CostSpecification
     */
    costSpecificationEntries?: Array<CostSpecificationEntry>;
}
/**
 * @type CostSpecificationEntry
 * 
 * @export
 */
export type CostSpecificationEntry = ByRecipeAmount;

/**
 * 
 * @export
 */
export const CostUnit = {
    baseCurrency: 1
} as const;
export type CostUnit = typeof CostUnit[keyof typeof CostUnit];

/**
 * 
 * @export
 * @interface CouldNotAcquireUpdateLockForLots
 */
export interface CouldNotAcquireUpdateLockForLots {
    /**
     * 
     * @type {string}
     * @memberof CouldNotAcquireUpdateLockForLots
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CouldNotAcquireUpdateLockForLots
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouldNotAcquireUpdateLockForLots
     */
    requestedLocks?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CouldNotAcquireUpdateLockForLots
     */
    alreadyLockedLots?: Array<number>;
}
/**
 * @type CouldNotAcquireUpdateLockForLotsOrEmptyBatchErrorOrLegacyLemmaError
 * 
 * @export
 */
export type CouldNotAcquireUpdateLockForLotsOrEmptyBatchErrorOrLegacyLemmaError = { name: 'CouldNotAcquireUpdateLockForLots' } & CouldNotAcquireUpdateLockForLots | { name: 'EmptyBatchError' } & EmptyBatchError | { name: 'LegacyLemmaError' } & LegacyLemmaError;
/**
 * @type CouldNotAcquireUpdateLockForLotsOrLegacyLemmaErrorOrLotIsPartOfMultiBatch
 * 
 * @export
 */
export type CouldNotAcquireUpdateLockForLotsOrLegacyLemmaErrorOrLotIsPartOfMultiBatch = { name: 'CouldNotAcquireUpdateLockForLots' } & CouldNotAcquireUpdateLockForLots | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotIsPartOfMultiBatch' } & LotIsPartOfMultiBatch;
/**
 * 
 * @export
 * @interface CountsheetEntryListRow
 */
export interface CountsheetEntryListRow {
    /**
     * CountsheetEntryId
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    id: number;
    /**
     * StocktakingId
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    stocktakingId: number;
    /**
     * CountsheetId
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    countsheetId: number;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntryListRow
     */
    comboSearch: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    productId: number;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntryListRow
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntryListRow
     */
    productCode?: string;
    /**
     * StockItemId
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    productionUnitId?: number;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntryListRow
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    systemAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    entryAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    diff?: number;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntryListRow
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntryListRow
     */
    placeName: string;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntryListRow
     */
    placeLabel?: string;
    /**
     * 
     * @type {Array<ItemTypeTag>}
     * @memberof CountsheetEntryListRow
     */
    itemTypeTags?: Array<ItemTypeTag>;
    /**
     * 
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    value?: number;
    /**
     * 
     * @type {number}
     * @memberof CountsheetEntryListRow
     */
    valueDiff?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CountsheetEntryListRow
     */
    counted: boolean;
}
/**
 * 
 * @export
 * @interface CountsheetEntrySaveView
 */
export interface CountsheetEntrySaveView {
    /**
     * CountsheetEntryId
     * @type {number}
     * @memberof CountsheetEntrySaveView
     */
    id?: number;
    /**
     * CountsheetId
     * @type {number}
     * @memberof CountsheetEntrySaveView
     */
    countsheetId: number;
    /**
     * StockItemId
     * @type {number}
     * @memberof CountsheetEntrySaveView
     */
    productionUnitId?: number;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntrySaveView
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntrySaveView
     */
    placeLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof CountsheetEntrySaveView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof CountsheetEntrySaveView
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface CountsheetInitView
 */
export interface CountsheetInitView {
    /**
     * 
     * @type {number}
     * @memberof CountsheetInitView
     */
    ordinal: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof CountsheetInitView
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof CountsheetInitView
     */
    placeName: string;
    /**
     * 
     * @type {number}
     * @memberof CountsheetInitView
     */
    entries: number;
}
/**
 * 
 * @export
 * @interface CountsheetSaveView
 */
export interface CountsheetSaveView {
    /**
     * PlaceId
     * @type {number}
     * @memberof CountsheetSaveView
     */
    placeId?: number;
    /**
     * UserId
     * @type {number}
     * @memberof CountsheetSaveView
     */
    responsiblePerson?: number;
}

/**
 * 
 * @export
 */
export const CountsheetStatus = {
    planned: 1,
    inProgress: 2,
    done: 3
} as const;
export type CountsheetStatus = typeof CountsheetStatus[keyof typeof CountsheetStatus];

/**
 * @type CurrencyExchangeRate
 * 
 * @export
 */
export type CurrencyExchangeRate = IdentityRate | ManualRate | SynchronizedRate;

/**
 * 
 * @export
 */
export const DayOfWeek = {
    SU: 0,
    MO: 1,
    TU: 2,
    WE: 3,
    TH: 4,
    FR: 5,
    SA: 6
} as const;
export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];

/**
 * 
 * @export
 * @interface DaysExceededError
 */
export interface DaysExceededError {
    /**
     * 
     * @type {string}
     * @memberof DaysExceededError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DaysExceededError
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof DaysExceededError
     */
    requestedDays: number;
    /**
     * 
     * @type {number}
     * @memberof DaysExceededError
     */
    maxDays: number;
}
/**
 * 
 * @export
 * @interface DeadlineMarketingRuleForContractor
 */
export interface DeadlineMarketingRuleForContractor {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof DeadlineMarketingRuleForContractor
     */
    id?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof DeadlineMarketingRuleForContractor
     */
    contractorId: number;
    /**
     * 
     * @type {number}
     * @memberof DeadlineMarketingRuleForContractor
     */
    deadline: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof DeadlineMarketingRuleForContractor
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface DefinedOccurrence
 */
export interface DefinedOccurrence {
    /**
     * 
     * @type {string}
     * @memberof DefinedOccurrence
     */
    dateTime: string;
    /**
     * 
     * @type {OccurrenceType}
     * @memberof DefinedOccurrence
     */
    occurrenceType: OccurrenceType;
}
/**
 * 
 * @export
 * @interface DeliveryDate
 */
export interface DeliveryDate {
    /**
     * 
     * @type {string}
     * @memberof DeliveryDate
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryDate
     */
    deliveryTime?: string;
}
/**
 * 
 * @export
 * @interface DeliveryPoint
 */
export interface DeliveryPoint {
    /**
     * DeliveryPointId
     * @type {number}
     * @memberof DeliveryPoint
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPoint
     */
    name?: string;
    /**
     * 
     * @type {Address}
     * @memberof DeliveryPoint
     */
    address: Address;
}
/**
 * 
 * @export
 * @interface DemandDestination
 */
export interface DemandDestination {
    /**
     * 
     * @type {DestinationType}
     * @memberof DemandDestination
     */
    destinationType: DestinationType;
    /**
     * PlaceId
     * @type {number}
     * @memberof DemandDestination
     */
    placeId?: number;
    /**
     * 
     * @type {number}
     * @memberof DemandDestination
     */
    share: number;
}
/**
 * 
 * @export
 * @interface DemandForOrderItemNotFound
 */
export interface DemandForOrderItemNotFound {
    /**
     * 
     * @type {string}
     * @memberof DemandForOrderItemNotFound
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DemandForOrderItemNotFound
     */
    description: string;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof DemandForOrderItemNotFound
     */
    orderItemId: number;
}
/**
 * @type DemandForOrderItemNotFoundOrLegacyLemmaErrorOrNoIngredientOfVariantForLotOrSupplyOrderItemsAlreadyExistsOrUnitNotDefinedAsSecondary
 * 
 * @export
 */
export type DemandForOrderItemNotFoundOrLegacyLemmaErrorOrNoIngredientOfVariantForLotOrSupplyOrderItemsAlreadyExistsOrUnitNotDefinedAsSecondary = { name: 'DemandForOrderItemNotFound' } & DemandForOrderItemNotFound | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'NoIngredientOfVariantForLot' } & NoIngredientOfVariantForLot | { name: 'SupplyOrderItemsAlreadyExists' } & SupplyOrderItemsAlreadyExists | { name: 'UnitNotDefinedAsSecondary' } & UnitNotDefinedAsSecondary;
/**
 * @type DemandForOrderItemNotFoundOrNoIngredientOfVariantForLotOrUnitNotDefinedAsSecondary
 * 
 * @export
 */
export type DemandForOrderItemNotFoundOrNoIngredientOfVariantForLotOrUnitNotDefinedAsSecondary = { name: 'DemandForOrderItemNotFound' } & DemandForOrderItemNotFound | { name: 'NoIngredientOfVariantForLot' } & NoIngredientOfVariantForLot | { name: 'UnitNotDefinedAsSecondary' } & UnitNotDefinedAsSecondary;
/**
 * 
 * @export
 * @interface DemandListView
 */
export interface DemandListView {
    /**
     * StockInteractionId
     * @type {number}
     * @memberof DemandListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DemandListView
     */
    itemTypeVariantName: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof DemandListView
     */
    variantId: number;
    /**
     * 
     * @type {number}
     * @memberof DemandListView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof DemandListView
     */
    unitType: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof DemandListView
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof DemandListView
     */
    place: string;
    /**
     * 
     * @type {string}
     * @memberof DemandListView
     */
    occurrence?: string;
    /**
     * 
     * @type {BaseStockInteractionTypes}
     * @memberof DemandListView
     */
    sourceType: BaseStockInteractionTypes;
    /**
     * 
     * @type {number}
     * @memberof DemandListView
     */
    sourceId: number;
    /**
     * 
     * @type {string}
     * @memberof DemandListView
     */
    sourceNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DemandListView
     */
    isFulfilled: boolean;
    /**
     * 
     * @type {number}
     * @memberof DemandListView
     */
    toFulfill: number;
    /**
     * 
     * @type {DestinationType}
     * @memberof DemandListView
     */
    destination?: DestinationType;
    /**
     * 
     * @type {Array<DemandDestination>}
     * @memberof DemandListView
     */
    destinations?: Array<DemandDestination>;
    /**
     * 
     * @type {boolean}
     * @memberof DemandListView
     */
    destinationsEditedManually: boolean;
    /**
     * 
     * @type {CertaintyType}
     * @memberof DemandListView
     */
    certainty: CertaintyType;
}

/**
 * 
 * @export
 */
export const DemandStatus = {
    notExisting: 1,
    notAddressed: 2,
    notFulfilled: 3,
    fulfilled: 4,
    partiallyFulfilled: 5
} as const;
export type DemandStatus = typeof DemandStatus[keyof typeof DemandStatus];

/**
 * 
 * @export
 * @interface DemandsManagerListView
 */
export interface DemandsManagerListView {
    /**
     * StockInteractionId
     * @type {number}
     * @memberof DemandsManagerListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DemandsManagerListView
     */
    itemTypeVariantName: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof DemandsManagerListView
     */
    variantId: number;
    /**
     * 
     * @type {number}
     * @memberof DemandsManagerListView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof DemandsManagerListView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof DemandsManagerListView
     */
    placeName: string;
    /**
     * 
     * @type {string}
     * @memberof DemandsManagerListView
     */
    occurrence?: string;
    /**
     * 
     * @type {BaseStockInteractionTypes}
     * @memberof DemandsManagerListView
     */
    sourceType: BaseStockInteractionTypes;
    /**
     * 
     * @type {Array<DestinationTypeExtended>}
     * @memberof DemandsManagerListView
     */
    demandDestination?: Array<DestinationTypeExtended>;
}

/**
 * 
 * @export
 */
export const DestinationType = {
    production: 0,
    warehouse: 2,
    supplyOrder: 3
} as const;
export type DestinationType = typeof DestinationType[keyof typeof DestinationType];


/**
 * 
 * @export
 */
export const DestinationTypeExtended = {
    production: 0,
    internalTransport: 1,
    warehouse: 2,
    supplyOrder: 3,
    empty: 4
} as const;
export type DestinationTypeExtended = typeof DestinationTypeExtended[keyof typeof DestinationTypeExtended];

/**
 * 
 * @export
 * @interface Digital1
 */
export interface Digital1 {
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof Digital1
     */
    paint?: PropertySetSelector;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof Digital1
     */
    reliefPlate?: number;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof Digital1
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof Digital1
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * 
     * @type {StepMode}
     * @memberof Digital1
     */
    stepMode: StepMode;
}
/**
 * 
 * @export
 * @interface DigitalView
 */
export interface DigitalView {
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof DigitalView
     */
    paint?: PropertySetSelectorView;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof DigitalView
     */
    reliefPlate?: ItemTypeVariant;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof DigitalView
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof DigitalView
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * 
     * @type {StepMode}
     * @memberof DigitalView
     */
    stepMode: StepMode;
    /**
     * 
     * @type {StepType}
     * @memberof DigitalView
     */
    stepType: StepType;
}
/**
 * 
 * @export
 * @interface DirectProductionLotSavingView
 */
export interface DirectProductionLotSavingView {
    /**
     * 
     * @type {ProductionLotSavingViewId}
     * @memberof DirectProductionLotSavingView
     */
    id: ProductionLotSavingViewId;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof DirectProductionLotSavingView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {number}
     * @memberof DirectProductionLotSavingView
     */
    amount: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DirectProductionLotSavingView
     */
    salesEntryItemIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DirectProductionLotSavingView
     */
    parentLotIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DirectProductionLotSavingView
     */
    dueDate?: string;
    /**
     * ProductionSpecificationId
     * @type {number}
     * @memberof DirectProductionLotSavingView
     */
    productionSpecificationId?: number;
    /**
     * 
     * @type {Array<ProductionLotSavingView>}
     * @memberof DirectProductionLotSavingView
     */
    children?: Array<ProductionLotSavingView>;
    /**
     * 
     * @type {ProductionLotSavingViewType}
     * @memberof DirectProductionLotSavingView
     */
    tpe: ProductionLotSavingViewType;
}
/**
 * 
 * @export
 * @interface DocumentDueDateCalendarEvent
 */
export interface DocumentDueDateCalendarEvent {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof DocumentDueDateCalendarEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDueDateCalendarEvent
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDueDateCalendarEvent
     */
    to: string;
    /**
     * 
     * @type {WorkerDocumentType}
     * @memberof DocumentDueDateCalendarEvent
     */
    documentType: WorkerDocumentType;
    /**
     * 
     * @type {string}
     * @memberof DocumentDueDateCalendarEvent
     */
    documentName: string;
    /**
     * WorkerDocumentId
     * @type {number}
     * @memberof DocumentDueDateCalendarEvent
     */
    workerDocumentId: number;
    /**
     * 
     * @type {CalendarEventType}
     * @memberof DocumentDueDateCalendarEvent
     */
    calendarEventType: CalendarEventType;
    /**
     * 
     * @type {WorkerEventCalendarType}
     * @memberof DocumentDueDateCalendarEvent
     */
    eventType: WorkerEventCalendarType;
}

/**
 * 
 * @export
 */
export const DocumentStatusTypes = {
    created: 1,
    warning: 2,
    failed: 3
} as const;
export type DocumentStatusTypes = typeof DocumentStatusTypes[keyof typeof DocumentStatusTypes];

/**
 * 
 * @export
 * @interface DocumentStatusView
 */
export interface DocumentStatusView {
    /**
     * PushStatusId
     * @type {number}
     * @memberof DocumentStatusView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusView
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusView
     */
    internalId?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusView
     */
    comboNumberSearch?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentStatusView
     */
    internalEntityId?: number;
    /**
     * 
     * @type {InternalEntityType}
     * @memberof DocumentStatusView
     */
    internalEntityType: InternalEntityType;
    /**
     * TargetId
     * @type {number}
     * @memberof DocumentStatusView
     */
    targetId: number;
    /**
     * 
     * @type {DocumentTypes}
     * @memberof DocumentStatusView
     */
    targetType: DocumentTypes;
    /**
     * 
     * @type {PushStatusTypes}
     * @memberof DocumentStatusView
     */
    pushStatus: PushStatusTypes;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusView
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusView
     */
    sendAttemptTime: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusView
     */
    syncAttemptTime?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentStatusView
     */
    failureCounter: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusView
     */
    lastSuccessfulSyncTime?: string;
    /**
     * 
     * @type {DocumentStatusTypes}
     * @memberof DocumentStatusView
     */
    documentStatus?: DocumentStatusTypes;
    /**
     * 
     * @type {InternalDocumentTypes}
     * @memberof DocumentStatusView
     */
    documentType?: InternalDocumentTypes;
    /**
     * 
     * @type {string}
     * @memberof DocumentStatusView
     */
    documentDescription?: string;
}

/**
 * 
 * @export
 */
export const DocumentTypes = {
    pwpProduct: 1,
    pwpWaste: 2,
    pz: 3,
    mm: 4,
    rwProductionUnit: 5,
    pw: 6,
    wzForOrder: 7,
    wzForExternal: 8,
    rwProductionLot: 9,
    pwProductionUnit: 10,
    pwWaste: 11,
    rwRollback: 12,
    pwRollback: 13,
    pm: 14,
    wm: 15,
    itemType: 16,
    wzForDelivery: 17,
    contractor: 18,
    countsheetPw: 19,
    countsheetRw: 20,
    aggregationPwp: 21,
    productionOrder: 22,
    okProductionConfirmation: 23,
    nokProductionConfirmation: 24,
    downtimeProductionConfirmation: 25,
    packingProductionConfirmation: 26,
    planExport: 27
} as const;
export type DocumentTypes = typeof DocumentTypes[keyof typeof DocumentTypes];

/**
 * 
 * @export
 * @interface DowntimeBatchGroupReportView
 */
export interface DowntimeBatchGroupReportView {
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof DowntimeBatchGroupReportView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DowntimeBatchGroupReportView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeBatchGroupReportView
     */
    to?: string;
    /**
     * 
     * @type {DowntimeReasonView}
     * @memberof DowntimeBatchGroupReportView
     */
    reason?: DowntimeReasonView;
    /**
     * 
     * @type {UserView1}
     * @memberof DowntimeBatchGroupReportView
     */
    user?: UserView1;
    /**
     * 
     * @type {string}
     * @memberof DowntimeBatchGroupReportView
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DowntimeBatchGroupReportView
     */
    fromSensor: boolean;
}
/**
 * 
 * @export
 * @interface DowntimeCausePercentage
 */
export interface DowntimeCausePercentage {
    /**
     * 
     * @type {DowntimeReasonView}
     * @memberof DowntimeCausePercentage
     */
    reason: DowntimeReasonView;
    /**
     * 
     * @type {number}
     * @memberof DowntimeCausePercentage
     */
    percentage: number;
}
/**
 * 
 * @export
 * @interface DowntimeEmployeeTime
 */
export interface DowntimeEmployeeTime {
    /**
     * 
     * @type {WorkerView}
     * @memberof DowntimeEmployeeTime
     */
    worker: WorkerView;
    /**
     * 
     * @type {number}
     * @memberof DowntimeEmployeeTime
     */
    totalDowntimeMinutes: number;
}
/**
 * 
 * @export
 * @interface DowntimeEmployeeTimeV2
 */
export interface DowntimeEmployeeTimeV2 {
    /**
     * 
     * @type {WorkerView}
     * @memberof DowntimeEmployeeTimeV2
     */
    worker: WorkerView;
    /**
     * 
     * @type {number}
     * @memberof DowntimeEmployeeTimeV2
     */
    percentage: number;
}
/**
 * @type DowntimeEndingInTheFutureOrDowntimeReportAlreadyClosedOrDowntimeReportFromDifferentLotErrorOrDowntimeReportWithoutReasonOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound
 * 
 * @export
 */
export type DowntimeEndingInTheFutureOrDowntimeReportAlreadyClosedOrDowntimeReportFromDifferentLotErrorOrDowntimeReportWithoutReasonOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound = { name: 'DowntimeEndingInTheFuture' } & LemmaSimpleErrorView | { name: 'DowntimeReportAlreadyClosed' } & LemmaSimpleErrorView | { name: 'DowntimeReportFromDifferentLotError' } & LemmaSimpleErrorView | { name: 'DowntimeReportWithoutReason' } & LemmaSimpleErrorView | { name: 'EmptyBatch' } & EmptyBatch | { name: 'EmptyResultWhenAtLeastOneExpected' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotStillPaused' } & LemmaSimpleErrorView | { name: 'NoReportsFound' } & NoReportsFound;
/**
 * @type DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrNoReportsFoundOrProductionLotNotStarted
 * 
 * @export
 */
export type DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrNoReportsFoundOrProductionLotNotStarted = { name: 'DowntimeEndingInTheFuture' } & LemmaSimpleErrorView | { name: 'DowntimeReportFromDifferentLotError' } & LemmaSimpleErrorView | { name: 'EmptyBatch' } & EmptyBatch | { name: 'EmptyResultWhenAtLeastOneExpected' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotHasActiveDowntime' } & LotHasActiveDowntime | { name: 'LotStillPaused' } & LemmaSimpleErrorView | { name: 'NoReportsFound' } & NoReportsFound | { name: 'ProductionLotNotStarted' } & LemmaSimpleErrorView;
/**
 * @type DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted
 * 
 * @export
 */
export type DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted = { name: 'DowntimeEndingInTheFuture' } & LemmaSimpleErrorView | { name: 'DowntimeReportFromDifferentLotError' } & LemmaSimpleErrorView | { name: 'EmptyResultWhenAtLeastOneExpected' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotHasActiveDowntime' } & LotHasActiveDowntime | { name: 'LotStillPaused' } & LemmaSimpleErrorView | { name: 'ProductionLotNotStarted' } & LemmaSimpleErrorView;
/**
 * @type DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted
 * 
 * @export
 */
export type DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted = { name: 'DowntimeEndingInTheFuture' } & LemmaSimpleErrorView | { name: 'EmptyBatch' } & EmptyBatch | { name: 'EmptyResultWhenAtLeastOneExpected' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotHasActiveDowntime' } & LotHasActiveDowntime | { name: 'LotStillPaused' } & LemmaSimpleErrorView | { name: 'ProductionLotNotStarted' } & LemmaSimpleErrorView;
/**
 * @type DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound
 * 
 * @export
 */
export type DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound = { name: 'DowntimeEndingInTheFuture' } & LemmaSimpleErrorView | { name: 'EmptyBatch' } & EmptyBatch | { name: 'EmptyResultWhenAtLeastOneExpected' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotStillPaused' } & LemmaSimpleErrorView | { name: 'NoReportsFound' } & NoReportsFound;
/**
 * 
 * @export
 * @interface DowntimeEventView
 */
export interface DowntimeEventView {
    /**
     * 
     * @type {GroupLeaderEventIndentification}
     * @memberof DowntimeEventView
     */
    identification: GroupLeaderEventIndentification;
    /**
     * 
     * @type {GroupLeaderEventType}
     * @memberof DowntimeEventView
     */
    eventType: GroupLeaderEventType;
}
/**
 * 
 * @export
 * @interface DowntimeInfo
 */
export interface DowntimeInfo {
    /**
     * 
     * @type {string}
     * @memberof DowntimeInfo
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeInfo
     */
    to: string;
    /**
     * 
     * @type {DowntimeReasonView}
     * @memberof DowntimeInfo
     */
    reason?: DowntimeReasonView;
    /**
     * 
     * @type {MachineView}
     * @memberof DowntimeInfo
     */
    machine: MachineView;
    /**
     * 
     * @type {string}
     * @memberof DowntimeInfo
     */
    itemTypeVariantName?: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeInfo
     */
    productCode?: string;
    /**
     * 
     * @type {WorkerView}
     * @memberof DowntimeInfo
     */
    worker?: WorkerView;
}
/**
 * 
 * @export
 * @interface DowntimePercentage
 */
export interface DowntimePercentage {
    /**
     * 
     * @type {MachineView}
     * @memberof DowntimePercentage
     */
    machine: MachineView;
    /**
     * 
     * @type {string}
     * @memberof DowntimePercentage
     */
    timePoint: string;
    /**
     * 
     * @type {number}
     * @memberof DowntimePercentage
     */
    percentage: number;
}
/**
 * 
 * @export
 * @interface DowntimeProductTime
 */
export interface DowntimeProductTime {
    /**
     * 
     * @type {string}
     * @memberof DowntimeProductTime
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeProductTime
     */
    productCode?: string;
    /**
     * 
     * @type {number}
     * @memberof DowntimeProductTime
     */
    totalDowntimeMinutes: number;
}
/**
 * 
 * @export
 * @interface DowntimeProductTimeV2
 */
export interface DowntimeProductTimeV2 {
    /**
     * 
     * @type {string}
     * @memberof DowntimeProductTimeV2
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeProductTimeV2
     */
    productCode?: string;
    /**
     * 
     * @type {number}
     * @memberof DowntimeProductTimeV2
     */
    percentage: number;
}
/**
 * 
 * @export
 * @interface DowntimeReasonPercentageV2
 */
export interface DowntimeReasonPercentageV2 {
    /**
     * 
     * @type {DowntimeReasonView}
     * @memberof DowntimeReasonPercentageV2
     */
    reason?: DowntimeReasonView;
    /**
     * 
     * @type {number}
     * @memberof DowntimeReasonPercentageV2
     */
    percentage: number;
}

/**
 * 
 * @export
 */
export const DowntimeReasonType = {
    StartEnd: 'start_end',
    Duration: 'duration',
    Stopwatch: 'stopwatch'
} as const;
export type DowntimeReasonType = typeof DowntimeReasonType[keyof typeof DowntimeReasonType];

/**
 * 
 * @export
 * @interface DowntimeReasonView
 */
export interface DowntimeReasonView {
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof DowntimeReasonView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReasonView
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof DowntimeReasonView
     */
    isBreakdown: boolean;
    /**
     * 
     * @type {DowntimeReasonType}
     * @memberof DowntimeReasonView
     */
    tpe: DowntimeReasonType;
}
/**
 * @type DowntimeReportAlreadyClosedOrDowntimeReportFromDifferentLotErrorOrDowntimeReportWithoutReasonOrLegacyLemmaError
 * 
 * @export
 */
export type DowntimeReportAlreadyClosedOrDowntimeReportFromDifferentLotErrorOrDowntimeReportWithoutReasonOrLegacyLemmaError = { name: 'DowntimeReportAlreadyClosed' } & LemmaSimpleErrorView | { name: 'DowntimeReportFromDifferentLotError' } & LemmaSimpleErrorView | { name: 'DowntimeReportWithoutReason' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError;
/**
 * 
 * @export
 * @interface DowntimeReportDurationSaveView
 */
export interface DowntimeReportDurationSaveView {
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof DowntimeReportDurationSaveView
     */
    id?: number;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof DowntimeReportDurationSaveView
     */
    reason: number;
    /**
     * Time in s
     * @type {number}
     * @memberof DowntimeReportDurationSaveView
     */
    duration: number;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportDurationSaveView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface DowntimeReportEndStopwatchView
 */
export interface DowntimeReportEndStopwatchView {
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof DowntimeReportEndStopwatchView
     */
    id: number;
    /**
     * Using server time instead
     * @type {string}
     * @memberof DowntimeReportEndStopwatchView
     * @deprecated
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportEndStopwatchView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface DowntimeReportStartEndSaveView
 */
export interface DowntimeReportStartEndSaveView {
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof DowntimeReportStartEndSaveView
     */
    id?: number;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof DowntimeReportStartEndSaveView
     */
    reason: number;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportStartEndSaveView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportStartEndSaveView
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportStartEndSaveView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface DowntimeReportStartStopwatchView
 */
export interface DowntimeReportStartStopwatchView {
    /**
     * Using server time instead
     * @type {string}
     * @memberof DowntimeReportStartStopwatchView
     * @deprecated
     */
    from: string;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof DowntimeReportStartStopwatchView
     */
    reason: number;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportStartStopwatchView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface DowntimeReportView
 */
export interface DowntimeReportView {
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof DowntimeReportView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportView
     */
    to?: string;
    /**
     * 
     * @type {DowntimeReasonView}
     * @memberof DowntimeReportView
     */
    reason?: DowntimeReasonView;
    /**
     * 
     * @type {UserView1}
     * @memberof DowntimeReportView
     */
    user?: UserView1;
    /**
     * 
     * @type {string}
     * @memberof DowntimeReportView
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DowntimeReportView
     */
    fromSensor: boolean;
}
/**
 * 
 * @export
 * @interface DowntimesOverTimeRequest
 */
export interface DowntimesOverTimeRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof DowntimesOverTimeRequest
     */
    downtimeReasons?: Array<number>;
    /**
     * 
     * @type {GroupLeaderDashboardFilters}
     * @memberof DowntimesOverTimeRequest
     */
    filters: GroupLeaderDashboardFilters;
}
/**
 * 
 * @export
 * @interface DowntimesOverTimeRequestV2
 */
export interface DowntimesOverTimeRequestV2 {
    /**
     * 
     * @type {GroupLeaderDashboardFilters}
     * @memberof DowntimesOverTimeRequestV2
     */
    filters: GroupLeaderDashboardFilters;
    /**
     * 
     * @type {string}
     * @memberof DowntimesOverTimeRequestV2
     */
    timeStep: string;
}
/**
 * 
 * @export
 * @interface DowntimesOverTimeResponse
 */
export interface DowntimesOverTimeResponse {
    /**
     * 
     * @type {Array<DowntimeInfo>}
     * @memberof DowntimesOverTimeResponse
     */
    downtimes?: Array<DowntimeInfo>;
}
/**
 * 
 * @export
 * @interface DowntimesOverTimeResponseV2
 */
export interface DowntimesOverTimeResponseV2 {
    /**
     * 
     * @type {Array<DowntimePercentage>}
     * @memberof DowntimesOverTimeResponseV2
     */
    downtimes?: Array<DowntimePercentage>;
}
/**
 * 
 * @export
 * @interface DriverListView
 */
export interface DriverListView {
    /**
     * DriverId
     * @type {number}
     * @memberof DriverListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DriverListView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DriverListView
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof DriverListView
     */
    externalLogisticsProviderName?: string;
}
/**
 * 
 * @export
 * @interface DuplicateEstimationIds
 */
export interface DuplicateEstimationIds {
    /**
     * 
     * @type {string}
     * @memberof DuplicateEstimationIds
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateEstimationIds
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DuplicateEstimationIds
     */
    estimationIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface EmptyBatch
 */
export interface EmptyBatch {
    /**
     * BatchId
     * @type {number}
     * @memberof EmptyBatch
     */
    batchId: number;
}
/**
 * 
 * @export
 * @interface EmptyBatchError
 */
export interface EmptyBatchError {
    /**
     * 
     * @type {string}
     * @memberof EmptyBatchError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EmptyBatchError
     */
    description: string;
    /**
     * BatchId
     * @type {number}
     * @memberof EmptyBatchError
     */
    batchId: number;
}
/**
 * 
 * @export
 * @interface EmptyBomCalculationView
 */
export interface EmptyBomCalculationView {
    /**
     * 
     * @type {BomCalculationType}
     * @memberof EmptyBomCalculationView
     */
    calculationType: BomCalculationType;
}
/**
 * @type Ennoblement
 * 
 * @export
 */
export type Ennoblement = Lacquering | Lamination | NarrowedLacquering | NarrowedSieveLacquering | Stamping | object;
/**
 * 
 * @export
 * @interface EntityVersionTW
 */
export interface EntityVersionTW {
    /**
     * 
     * @type {VersionT}
     * @memberof EntityVersionTW
     */
    version: VersionT;
    /**
     * 
     * @type {ItemTypeHistoryView}
     * @memberof EntityVersionTW
     */
    entity: ItemTypeHistoryView;
}
/**
 * 
 * @export
 * @interface EquipmentDemandListView
 */
export interface EquipmentDemandListView {
    /**
     * EquipmentDemandId
     * @type {number}
     * @memberof EquipmentDemandListView
     */
    id: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof EquipmentDemandListView
     */
    salesEntryId: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandListView
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandListView
     */
    equipmentName: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandListView
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandListView
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandListView
     */
    externalIdAndName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EquipmentDemandListView
     */
    itemTypeTagsNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof EquipmentDemandListView
     */
    itemTypeTagsIds?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof EquipmentDemandListView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandListView
     */
    unit: string;
}
/**
 * 
 * @export
 * @interface EquipmentDemandSavingView
 */
export interface EquipmentDemandSavingView {
    /**
     * EquipmentDemandId
     * @type {number}
     * @memberof EquipmentDemandSavingView
     */
    id?: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof EquipmentDemandSavingView
     */
    salesEntryId: number;
    /**
     * UserId
     * @type {number}
     * @memberof EquipmentDemandSavingView
     */
    userId: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof EquipmentDemandSavingView
     */
    equipmentId: number;
    /**
     * 
     * @type {number}
     * @memberof EquipmentDemandSavingView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandSavingView
     */
    expectedReceiptDate: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandSavingView
     */
    remark?: string;
}
/**
 * 
 * @export
 * @interface EquipmentDemandView
 */
export interface EquipmentDemandView {
    /**
     * EquipmentDemandId
     * @type {number}
     * @memberof EquipmentDemandView
     */
    id: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof EquipmentDemandView
     */
    salesEntryId: number;
    /**
     * UserId
     * @type {number}
     * @memberof EquipmentDemandView
     */
    userId: number;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof EquipmentDemandView
     */
    equipment: ItemTypeVariant;
    /**
     * 
     * @type {string}
     * @memberof EquipmentDemandView
     */
    creationDate: string;
}
/**
 * 
 * @export
 * @interface EquipmentListViewRow
 */
export interface EquipmentListViewRow {
    /**
     * StockItemId
     * @type {number}
     * @memberof EquipmentListViewRow
     */
    productionUnitId: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentListViewRow
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentListViewRow
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentListViewRow
     */
    unitType: string;
    /**
     * 
     * @type {BorrowStatus}
     * @memberof EquipmentListViewRow
     */
    status: BorrowStatus;
    /**
     * 
     * @type {string}
     * @memberof EquipmentListViewRow
     */
    itemTypeShortName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EquipmentListViewRow
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EquipmentListViewRow
     */
    placeName: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof EquipmentListViewRow
     */
    equipmentId: number;
    /**
     * 
     * @type {string}
     * @memberof EquipmentListViewRow
     */
    lastUsage?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentListViewRow
     */
    receptionDate?: string;
    /**
     * 
     * @type {string}
     * @memberof EquipmentListViewRow
     */
    defaultPlaceName?: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof EquipmentListViewRow
     */
    defaultPlaceId?: number;
}

/**
 * 
 * @export
 */
export const ErpSyncUnit = {
    warehouses: 1,
    discounts: 2,
    items: 3,
    contractors: 4,
    stocks: 5,
    wzs: 6,
    invoices: 7,
    recipes: 8,
    currencyTypes: 9,
    orders: 10,
    productionOrders: 11,
    competences: 12,
    workers: 13,
    machines: 14,
    workerGroups: 15,
    calendarEvents: 16,
    supplyOrders: 17,
    productionOrderExecutions: 18,
    productionLotDependencies: 19,
    productionTimes: 20
} as const;
export type ErpSyncUnit = typeof ErpSyncUnit[keyof typeof ErpSyncUnit];


/**
 * 
 * @export
 */
export const ErpType = {
    Optima: 'OPTIMA',
    Internal: 'INTERNAL',
    Xl: 'XL',
    Ekoplast: 'EKOPLAST',
    Src: 'SRC',
    Impuls: 'IMPULS',
    MachineFactory: 'MACHINE_FACTORY'
} as const;
export type ErpType = typeof ErpType[keyof typeof ErpType];

/**
 * 
 * @export
 * @interface ErrorResultAcceptSupplyOrder
 */
export interface ErrorResultAcceptSupplyOrder {
    /**
     * 
     * @type {InvalidSupplyOrderStatusTransitionOrSupplyOrderDoesNotRequireAcceptance}
     * @memberof ErrorResultAcceptSupplyOrder
     */
    error: InvalidSupplyOrderStatusTransitionOrSupplyOrderDoesNotRequireAcceptance;
}
/**
 * 
 * @export
 * @interface ErrorResultBackProductionOrderOrderProductionorderidDelete
 */
export interface ErrorResultBackProductionOrderOrderProductionorderidDelete {
    /**
     * 
     * @type {ProductionOrderStatusNotDeletable}
     * @memberof ErrorResultBackProductionOrderOrderProductionorderidDelete
     */
    error: ProductionOrderStatusNotDeletable;
}
/**
 * 
 * @export
 * @interface ErrorResultCancelLot
 */
export interface ErrorResultCancelLot {
    /**
     * 
     * @type {InvalidStatusToCancelOrLegacyLemmaError}
     * @memberof ErrorResultCancelLot
     */
    error: InvalidStatusToCancelOrLegacyLemmaError;
}
/**
 * 
 * @export
 * @interface ErrorResultCancelOrderItem
 */
export interface ErrorResultCancelOrderItem {
    /**
     * 
     * @type {CancelNotAvailableForStatusOrInvalidStatusTransition}
     * @memberof ErrorResultCancelOrderItem
     */
    error: CancelNotAvailableForStatusOrInvalidStatusTransition;
}
/**
 * 
 * @export
 * @interface ErrorResultCancelSupplyOrder
 */
export interface ErrorResultCancelSupplyOrder {
    /**
     * 
     * @type {InvalidSupplyOrderStatusTransition}
     * @memberof ErrorResultCancelSupplyOrder
     */
    error: InvalidSupplyOrderStatusTransition;
}
/**
 * 
 * @export
 * @interface ErrorResultClearMeasurement
 */
export interface ErrorResultClearMeasurement {
    /**
     * 
     * @type {InvalidMeasurementType}
     * @memberof ErrorResultClearMeasurement
     */
    error: InvalidMeasurementType;
}
/**
 * 
 * @export
 * @interface ErrorResultConfirmSingleSupplyOrder
 */
export interface ErrorResultConfirmSingleSupplyOrder {
    /**
     * 
     * @type {InvalidSupplyOrderStatusTransition}
     * @memberof ErrorResultConfirmSingleSupplyOrder
     */
    error: InvalidSupplyOrderStatusTransition;
}
/**
 * 
 * @export
 * @interface ErrorResultConfirmSupplyOrders
 */
export interface ErrorResultConfirmSupplyOrders {
    /**
     * 
     * @type {SubordersHaveMultipleSuppliers}
     * @memberof ErrorResultConfirmSupplyOrders
     */
    error: SubordersHaveMultipleSuppliers;
}
/**
 * 
 * @export
 * @interface ErrorResultCreateMeasurement
 */
export interface ErrorResultCreateMeasurement {
    /**
     * 
     * @type {InvalidMeasurementType}
     * @memberof ErrorResultCreateMeasurement
     */
    error: InvalidMeasurementType;
}
/**
 * 
 * @export
 * @interface ErrorResultDeleteManualBatchDowntime
 */
export interface ErrorResultDeleteManualBatchDowntime {
    /**
     * 
     * @type {CanDeleteOnlyManualDowntime}
     * @memberof ErrorResultDeleteManualBatchDowntime
     */
    error: CanDeleteOnlyManualDowntime;
}
/**
 * 
 * @export
 * @interface ErrorResultDeleteManualDowntime
 */
export interface ErrorResultDeleteManualDowntime {
    /**
     * 
     * @type {CanDeleteOnlyManualDowntime}
     * @memberof ErrorResultDeleteManualDowntime
     */
    error: CanDeleteOnlyManualDowntime;
}
/**
 * 
 * @export
 * @interface ErrorResultDeleteMeasurement
 */
export interface ErrorResultDeleteMeasurement {
    /**
     * 
     * @type {InvalidMeasurementType}
     * @memberof ErrorResultDeleteMeasurement
     */
    error: InvalidMeasurementType;
}
/**
 * 
 * @export
 * @interface ErrorResultEndStopwatchBatchDowntime
 */
export interface ErrorResultEndStopwatchBatchDowntime {
    /**
     * 
     * @type {DowntimeEndingInTheFutureOrDowntimeReportAlreadyClosedOrDowntimeReportFromDifferentLotErrorOrDowntimeReportWithoutReasonOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound}
     * @memberof ErrorResultEndStopwatchBatchDowntime
     */
    error: DowntimeEndingInTheFutureOrDowntimeReportAlreadyClosedOrDowntimeReportFromDifferentLotErrorOrDowntimeReportWithoutReasonOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound;
}
/**
 * 
 * @export
 * @interface ErrorResultEndStopwatchDowntime
 */
export interface ErrorResultEndStopwatchDowntime {
    /**
     * 
     * @type {DowntimeReportAlreadyClosedOrDowntimeReportFromDifferentLotErrorOrDowntimeReportWithoutReasonOrLegacyLemmaError}
     * @memberof ErrorResultEndStopwatchDowntime
     */
    error: DowntimeReportAlreadyClosedOrDowntimeReportFromDifferentLotErrorOrDowntimeReportWithoutReasonOrLegacyLemmaError;
}
/**
 * 
 * @export
 * @interface ErrorResultEstimateProductionTimes
 */
export interface ErrorResultEstimateProductionTimes {
    /**
     * 
     * @type {EstimationError}
     * @memberof ErrorResultEstimateProductionTimes
     */
    error: EstimationError;
}
/**
 * 
 * @export
 * @interface ErrorResultGetBackSupplyPlannedSupplyorderid
 */
export interface ErrorResultGetBackSupplyPlannedSupplyorderid {
    /**
     * 
     * @type {SupplyOrderLocked}
     * @memberof ErrorResultGetBackSupplyPlannedSupplyorderid
     */
    error: SupplyOrderLocked;
}
/**
 * 
 * @export
 * @interface ErrorResultGetExpectedTotalAvailability
 */
export interface ErrorResultGetExpectedTotalAvailability {
    /**
     * 
     * @type {UnitNotDefinedAsSecondary}
     * @memberof ErrorResultGetExpectedTotalAvailability
     */
    error: UnitNotDefinedAsSecondary;
}
/**
 * 
 * @export
 * @interface ErrorResultGetExternalSynchronizationRunSaga
 */
export interface ErrorResultGetExternalSynchronizationRunSaga {
    /**
     * 
     * @type {ExternalSynchronizationRunSagaError}
     * @memberof ErrorResultGetExternalSynchronizationRunSaga
     */
    error: ExternalSynchronizationRunSagaError;
}
/**
 * 
 * @export
 * @interface ErrorResultGetSupplyWarehouseState
 */
export interface ErrorResultGetSupplyWarehouseState {
    /**
     * 
     * @type {DaysExceededError}
     * @memberof ErrorResultGetSupplyWarehouseState
     */
    error: DaysExceededError;
}
/**
 * 
 * @export
 * @interface ErrorResultImportProductionOrder
 */
export interface ErrorResultImportProductionOrder {
    /**
     * 
     * @type {ProductionOrderImportError}
     * @memberof ErrorResultImportProductionOrder
     */
    error: ProductionOrderImportError;
}
/**
 * 
 * @export
 * @interface ErrorResultLotFinishTask
 */
export interface ErrorResultLotFinishTask {
    /**
     * 
     * @type {CannotChangeProductionStartDateOrCannotReportOnBehalfOfOthersOrInconsistentMachinesInTheBatchOrInvalidSplitPriorityConfigurationOrLegacyLemmaErrorOrListOfExceededReportedAmountThresholdOrLotHasNoMachineAssignedOrLotIsPartOfMultiBatchOrLotsHaveNoMachineAssignedOrMissingProductionReportForLotOrNoAmountAvailableForSplitOrNoWorkstationReportsCreatedOrNonPositiveAmountSuppliedOrProductionLotAlreadyHasAmountReports}
     * @memberof ErrorResultLotFinishTask
     */
    error: CannotChangeProductionStartDateOrCannotReportOnBehalfOfOthersOrInconsistentMachinesInTheBatchOrInvalidSplitPriorityConfigurationOrLegacyLemmaErrorOrListOfExceededReportedAmountThresholdOrLotHasNoMachineAssignedOrLotIsPartOfMultiBatchOrLotsHaveNoMachineAssignedOrMissingProductionReportForLotOrNoAmountAvailableForSplitOrNoWorkstationReportsCreatedOrNonPositiveAmountSuppliedOrProductionLotAlreadyHasAmountReports;
}
/**
 * 
 * @export
 * @interface ErrorResultMarkSupplyOrderInProgress
 */
export interface ErrorResultMarkSupplyOrderInProgress {
    /**
     * 
     * @type {InvalidSupplyOrderStatusTransition}
     * @memberof ErrorResultMarkSupplyOrderInProgress
     */
    error: InvalidSupplyOrderStatusTransition;
}
/**
 * 
 * @export
 * @interface ErrorResultOrdersEndpointsConfirm
 */
export interface ErrorResultOrdersEndpointsConfirm {
    /**
     * 
     * @type {LegacyLemmaError}
     * @memberof ErrorResultOrdersEndpointsConfirm
     */
    error: LegacyLemmaError;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackContractorsFetchDetails
 */
export interface ErrorResultPostBackContractorsFetchDetails {
    /**
     * 
     * @type {ListOfContractorNotFoundOrInvalidTaxId}
     * @memberof ErrorResultPostBackContractorsFetchDetails
     */
    error: ListOfContractorNotFoundOrInvalidTaxId;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackProductionLotAutoAssignWorkers
 */
export interface ErrorResultPostBackProductionLotAutoAssignWorkers {
    /**
     * 
     * @type {WorkerAutoAssignmentValidationSagaAutoAssignWorkersError}
     * @memberof ErrorResultPostBackProductionLotAutoAssignWorkers
     */
    error: WorkerAutoAssignmentValidationSagaAutoAssignWorkersError;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackProductionLotAutoAssignWorkersOnAreas
 */
export interface ErrorResultPostBackProductionLotAutoAssignWorkersOnAreas {
    /**
     * 
     * @type {AutoAssignmentRunningErrorOrEmptyMachineAreaIdsOrInvalidAssignTimeWindowOrResourceAssignmentsSyncFailedOrUnresolvedWorkerAssignment}
     * @memberof ErrorResultPostBackProductionLotAutoAssignWorkersOnAreas
     */
    error: AutoAssignmentRunningErrorOrEmptyMachineAreaIdsOrInvalidAssignTimeWindowOrResourceAssignmentsSyncFailedOrUnresolvedWorkerAssignment;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackProductionOrderCreateQuick
 */
export interface ErrorResultPostBackProductionOrderCreateQuick {
    /**
     * 
     * @type {ProductionOrderSavingSagaFromSimulationErr}
     * @memberof ErrorResultPostBackProductionOrderCreateQuick
     */
    error: ProductionOrderSavingSagaFromSimulationErr;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackProductionOrderOrderCreate
 */
export interface ErrorResultPostBackProductionOrderOrderCreate {
    /**
     * 
     * @type {CannotUpdateNonDraftOrIncompatibleOrderItemVariantOrNonPositiveAmountSuppliedOrNothingToSaveOrTechnologyMissing}
     * @memberof ErrorResultPostBackProductionOrderOrderCreate
     */
    error: CannotUpdateNonDraftOrIncompatibleOrderItemVariantOrNonPositiveAmountSuppliedOrNothingToSaveOrTechnologyMissing;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackProductionOrderSimulationGet
 */
export interface ErrorResultPostBackProductionOrderSimulationGet {
    /**
     * 
     * @type {ProductionOrderSimulationSagaErr}
     * @memberof ErrorResultPostBackProductionOrderSimulationGet
     */
    error: ProductionOrderSimulationSagaErr;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackProductionOrderSimulationQuery
 */
export interface ErrorResultPostBackProductionOrderSimulationQuery {
    /**
     * 
     * @type {ProductionOrderSimulationSagaErr}
     * @memberof ErrorResultPostBackProductionOrderSimulationQuery
     */
    error: ProductionOrderSimulationSagaErr;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackQsPlannedSupplyCardCreate
 */
export interface ErrorResultPostBackQsPlannedSupplyCardCreate {
    /**
     * 
     * @type {LegacyLemmaErrorOrListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractorOrSupplyOrderLocked}
     * @memberof ErrorResultPostBackQsPlannedSupplyCardCreate
     */
    error: LegacyLemmaErrorOrListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractorOrSupplyOrderLocked;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackQsSpontaneousSupplyCardCreate
 */
export interface ErrorResultPostBackQsSpontaneousSupplyCardCreate {
    /**
     * 
     * @type {LegacyLemmaErrorOrListOfAmbiguousPlaceDefinedOrNoPlaceDefined}
     * @memberof ErrorResultPostBackQsSpontaneousSupplyCardCreate
     */
    error: LegacyLemmaErrorOrListOfAmbiguousPlaceDefinedOrNoPlaceDefined;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackReportsWorkstationReportsAmountProductionlotid
 */
export interface ErrorResultPostBackReportsWorkstationReportsAmountProductionlotid {
    /**
     * 
     * @type {CannotReportOnBehalfOfOthersOrLegacyLemmaErrorOrListOfExceededReportedAmountThreshold}
     * @memberof ErrorResultPostBackReportsWorkstationReportsAmountProductionlotid
     */
    error: CannotReportOnBehalfOfOthersOrLegacyLemmaErrorOrListOfExceededReportedAmountThreshold;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackReportsWorkstationReportsLoadUpdate
 */
export interface ErrorResultPostBackReportsWorkstationReportsLoadUpdate {
    /**
     * 
     * @type {LegacyLemmaErrorOrListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups}
     * @memberof ErrorResultPostBackReportsWorkstationReportsLoadUpdate
     */
    error: LegacyLemmaErrorOrListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackReportsWorkstationsByBatchBatchidAbort
 */
export interface ErrorResultPostBackReportsWorkstationsByBatchBatchidAbort {
    /**
     * 
     * @type {CannotAbortLotWhichIsNotInProductionOrLegacyLemmaErrorOrLotIsPartOfMultiBatch}
     * @memberof ErrorResultPostBackReportsWorkstationsByBatchBatchidAbort
     */
    error: CannotAbortLotWhichIsNotInProductionOrLegacyLemmaErrorOrLotIsPartOfMultiBatch;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackReportsWorkstationsByBatchBatchidStart
 */
export interface ErrorResultPostBackReportsWorkstationsByBatchBatchidStart {
    /**
     * 
     * @type {CouldNotAcquireUpdateLockForLotsOrEmptyBatchErrorOrLegacyLemmaError}
     * @memberof ErrorResultPostBackReportsWorkstationsByBatchBatchidStart
     */
    error: CouldNotAcquireUpdateLockForLotsOrEmptyBatchErrorOrLegacyLemmaError;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackReportsWorkstationsByLotBatchidFinish
 */
export interface ErrorResultPostBackReportsWorkstationsByLotBatchidFinish {
    /**
     * 
     * @type {ProductionFinishError}
     * @memberof ErrorResultPostBackReportsWorkstationsByLotBatchidFinish
     */
    error: ProductionFinishError;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackReportsWorkstationsByLotProductionlotidAbort
 */
export interface ErrorResultPostBackReportsWorkstationsByLotProductionlotidAbort {
    /**
     * 
     * @type {CannotAbortLotWhichIsNotInProductionOrLegacyLemmaErrorOrLotIsPartOfMultiBatch}
     * @memberof ErrorResultPostBackReportsWorkstationsByLotProductionlotidAbort
     */
    error: CannotAbortLotWhichIsNotInProductionOrLegacyLemmaErrorOrLotIsPartOfMultiBatch;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackReportsWorkstationsByLotProductionlotidFinish
 */
export interface ErrorResultPostBackReportsWorkstationsByLotProductionlotidFinish {
    /**
     * 
     * @type {ProductionFinishError}
     * @memberof ErrorResultPostBackReportsWorkstationsByLotProductionlotidFinish
     */
    error: ProductionFinishError;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackReportsWorkstationsByLotProductionlotidStart
 */
export interface ErrorResultPostBackReportsWorkstationsByLotProductionlotidStart {
    /**
     * 
     * @type {CouldNotAcquireUpdateLockForLotsOrLegacyLemmaErrorOrLotIsPartOfMultiBatch}
     * @memberof ErrorResultPostBackReportsWorkstationsByLotProductionlotidStart
     */
    error: CouldNotAcquireUpdateLockForLotsOrLegacyLemmaErrorOrLotIsPartOfMultiBatch;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackSupplyPlannedSupplyorderidCancel
 */
export interface ErrorResultPostBackSupplyPlannedSupplyorderidCancel {
    /**
     * 
     * @type {SupplyOrderNotLocked}
     * @memberof ErrorResultPostBackSupplyPlannedSupplyorderidCancel
     */
    error: SupplyOrderNotLocked;
}
/**
 * 
 * @export
 * @interface ErrorResultPostBackWorkersWorkerCompetencesSave
 */
export interface ErrorResultPostBackWorkersWorkerCompetencesSave {
    /**
     * 
     * @type {ListOfCalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement}
     * @memberof ErrorResultPostBackWorkersWorkerCompetencesSave
     */
    error: ListOfCalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement;
}
/**
 * 
 * @export
 * @interface ErrorResultProductionOrderLotMerge
 */
export interface ErrorResultProductionOrderLotMerge {
    /**
     * 
     * @type {CannotMergeWithDifferentVariantOrCannotMergeWithMergedChildren}
     * @memberof ErrorResultProductionOrderLotMerge
     */
    error: CannotMergeWithDifferentVariantOrCannotMergeWithMergedChildren;
}
/**
 * 
 * @export
 * @interface ErrorResultProductionOrderLotSplit
 */
export interface ErrorResultProductionOrderLotSplit {
    /**
     * 
     * @type {CannotSplitWithMergedChildrenOrCannotSplitZeroOrSplitAmountsShouldSum}
     * @memberof ErrorResultProductionOrderLotSplit
     */
    error: CannotSplitWithMergedChildrenOrCannotSplitZeroOrSplitAmountsShouldSum;
}
/**
 * 
 * @export
 * @interface ErrorResultQuerySupplyOrderItems
 */
export interface ErrorResultQuerySupplyOrderItems {
    /**
     * 
     * @type {DemandForOrderItemNotFoundOrNoIngredientOfVariantForLotOrUnitNotDefinedAsSecondary}
     * @memberof ErrorResultQuerySupplyOrderItems
     */
    error: DemandForOrderItemNotFoundOrNoIngredientOfVariantForLotOrUnitNotDefinedAsSecondary;
}
/**
 * 
 * @export
 * @interface ErrorResultQuickSaveSupplyOrderItems
 */
export interface ErrorResultQuickSaveSupplyOrderItems {
    /**
     * 
     * @type {DemandForOrderItemNotFoundOrLegacyLemmaErrorOrNoIngredientOfVariantForLotOrSupplyOrderItemsAlreadyExistsOrUnitNotDefinedAsSecondary}
     * @memberof ErrorResultQuickSaveSupplyOrderItems
     */
    error: DemandForOrderItemNotFoundOrLegacyLemmaErrorOrNoIngredientOfVariantForLotOrSupplyOrderItemsAlreadyExistsOrUnitNotDefinedAsSecondary;
}
/**
 * 
 * @export
 * @interface ErrorResultRecalculateProductionOrderSimulation
 */
export interface ErrorResultRecalculateProductionOrderSimulation {
    /**
     * 
     * @type {CannotProduceInputOrMergedChildrenErrorOrNoLotWithIdInTreeOrSimulationGraphCycle}
     * @memberof ErrorResultRecalculateProductionOrderSimulation
     */
    error: CannotProduceInputOrMergedChildrenErrorOrNoLotWithIdInTreeOrSimulationGraphCycle;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveBomReport
 */
export interface ErrorResultSaveBomReport {
    /**
     * 
     * @type {LegacyLemmaErrorOrNonUniqueVariantIdOrProductionReportNotFoundOrRecipeIsNotPieces}
     * @memberof ErrorResultSaveBomReport
     */
    error: LegacyLemmaErrorOrNonUniqueVariantIdOrProductionReportNotFoundOrRecipeIsNotPieces;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveDurationBatchDowntime
 */
export interface ErrorResultSaveDurationBatchDowntime {
    /**
     * 
     * @type {DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrNoReportsFoundOrProductionLotNotStarted}
     * @memberof ErrorResultSaveDurationBatchDowntime
     */
    error: DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrNoReportsFoundOrProductionLotNotStarted;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveDurationBatchDowntimeV2
 */
export interface ErrorResultSaveDurationBatchDowntimeV2 {
    /**
     * 
     * @type {DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrNoReportsFoundOrProductionLotNotStarted}
     * @memberof ErrorResultSaveDurationBatchDowntimeV2
     */
    error: DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrNoReportsFoundOrProductionLotNotStarted;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveDurationDowntime
 */
export interface ErrorResultSaveDurationDowntime {
    /**
     * 
     * @type {DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted}
     * @memberof ErrorResultSaveDurationDowntime
     */
    error: DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveDurationDowntimeV2
 */
export interface ErrorResultSaveDurationDowntimeV2 {
    /**
     * 
     * @type {DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted}
     * @memberof ErrorResultSaveDurationDowntimeV2
     */
    error: DowntimeEndingInTheFutureOrDowntimeReportFromDifferentLotErrorOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted;
}
/**
 * 
 * @export
 * @interface ErrorResultSavePlannedRelease
 */
export interface ErrorResultSavePlannedRelease {
    /**
     * 
     * @type {InsufficientAmountInPUOrNotEnoughAmountOrPlanAlreadyExecutedOrUnitNotDefinedAsSecondaryOrVariantMismatch}
     * @memberof ErrorResultSavePlannedRelease
     */
    error: InsufficientAmountInPUOrNotEnoughAmountOrPlanAlreadyExecutedOrUnitNotDefinedAsSecondaryOrVariantMismatch;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveSpontaneousRelease
 */
export interface ErrorResultSaveSpontaneousRelease {
    /**
     * 
     * @type {InsufficientAmountInPUOrNotEnoughAmountOrUnitNotDefinedAsSecondary}
     * @memberof ErrorResultSaveSpontaneousRelease
     */
    error: InsufficientAmountInPUOrNotEnoughAmountOrUnitNotDefinedAsSecondary;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveStartEndBatchDowntime
 */
export interface ErrorResultSaveStartEndBatchDowntime {
    /**
     * 
     * @type {DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound}
     * @memberof ErrorResultSaveStartEndBatchDowntime
     */
    error: DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveStartEndBatchDowntimeV2
 */
export interface ErrorResultSaveStartEndBatchDowntimeV2 {
    /**
     * 
     * @type {DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound}
     * @memberof ErrorResultSaveStartEndBatchDowntimeV2
     */
    error: DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotStillPausedOrNoReportsFound;
}
/**
 * 
 * @export
 * @interface ErrorResultSaveSupplyOrderItems
 */
export interface ErrorResultSaveSupplyOrderItems {
    /**
     * 
     * @type {LegacyLemmaErrorOrSupplyOrderItemsAlreadyExists}
     * @memberof ErrorResultSaveSupplyOrderItems
     */
    error: LegacyLemmaErrorOrSupplyOrderItemsAlreadyExists;
}
/**
 * 
 * @export
 * @interface ErrorResultSendExternalDocuments
 */
export interface ErrorResultSendExternalDocuments {
    /**
     * 
     * @type {LegacyLemmaError}
     * @memberof ErrorResultSendExternalDocuments
     */
    error: LegacyLemmaError;
}
/**
 * 
 * @export
 * @interface ErrorResultStartSimulationMerge
 */
export interface ErrorResultStartSimulationMerge {
    /**
     * 
     * @type {TriedToStartMergeFromIllegalState}
     * @memberof ErrorResultStartSimulationMerge
     */
    error: TriedToStartMergeFromIllegalState;
}
/**
 * 
 * @export
 * @interface ErrorResultStartStopwatchBatchDowntime
 */
export interface ErrorResultStartStopwatchBatchDowntime {
    /**
     * 
     * @type {DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted}
     * @memberof ErrorResultStartStopwatchBatchDowntime
     */
    error: DowntimeEndingInTheFutureOrEmptyBatchOrEmptyResultWhenAtLeastOneExpectedOrLegacyLemmaErrorOrLotHasActiveDowntimeOrLotStillPausedOrProductionLotNotStarted;
}
/**
 * 
 * @export
 * @interface ErrorResultStartStopwatchDowntime
 */
export interface ErrorResultStartStopwatchDowntime {
    /**
     * 
     * @type {LegacyLemmaErrorOrLotHasActiveDowntimeOrProductionLotNotStarted}
     * @memberof ErrorResultStartStopwatchDowntime
     */
    error: LegacyLemmaErrorOrLotHasActiveDowntimeOrProductionLotNotStarted;
}
/**
 * 
 * @export
 * @interface ErrorResultUpdateMeasurement
 */
export interface ErrorResultUpdateMeasurement {
    /**
     * 
     * @type {InvalidMeasurementUpdate}
     * @memberof ErrorResultUpdateMeasurement
     */
    error: InvalidMeasurementUpdate;
}
/**
 * 
 * @export
 * @interface ErrorResultUpdateRfid
 */
export interface ErrorResultUpdateRfid {
    /**
     * 
     * @type {RfidEmptyOrRfidNotUnique}
     * @memberof ErrorResultUpdateRfid
     */
    error: RfidEmptyOrRfidNotUnique;
}
/**
 * @type EstimatedDateTime
 * 
 * @export
 */
export type EstimatedDateTime = { status: '1' } & CalculatedDateTime | { status: '2' } & NotCalculatedDateTime | { status: '3' } & EstimatedDateTimeExceedsBoundary;
/**
 * 
 * @export
 * @interface EstimatedDateTimeExceedsBoundary
 */
export interface EstimatedDateTimeExceedsBoundary {
    /**
     * 
     * @type {EstimationStatus}
     * @memberof EstimatedDateTimeExceedsBoundary
     */
    status: EstimationStatus;
}
/**
 * @type EstimatedProductionTimeScope
 * 
 * @export
 */
export type EstimatedProductionTimeScope = { scopeType: '1' } & AllMachinesInTheArea | { scopeType: '2' } & SingleMachine | { scopeType: '3' } & AllMachines;

/**
 * 
 * @export
 */
export const EstimatedProductionTimeScopeType = {
    Area: 'area',
    Machine: 'machine',
    All: 'all'
} as const;
export type EstimatedProductionTimeScopeType = typeof EstimatedProductionTimeScopeType[keyof typeof EstimatedProductionTimeScopeType];

/**
 * @type EstimationError
 * 
 * @export
 */
export type EstimationError = { name: 'DuplicateEstimationIds' } & DuplicateEstimationIds | { name: 'NonPositiveAmount' } & NonPositiveAmount;

/**
 * 
 * @export
 */
export const EstimationStatus = {
    Calculated: 1,
    NotCalculated: 2,
    ExceededBoundary: 3
} as const;
export type EstimationStatus = typeof EstimationStatus[keyof typeof EstimationStatus];

/**
 * 
 * @export
 * @interface Evaluated
 */
export interface Evaluated {
    /**
     * 
     * @type {string}
     * @memberof Evaluated
     */
    period?: string;
    /**
     * 
     * @type {EvaluationModeType}
     * @memberof Evaluated
     */
    tpe: EvaluationModeType;
}
/**
 * 
 * @export
 * @interface EvaluatedMatrixView
 */
export interface EvaluatedMatrixView {
    /**
     * 
     * @type {string}
     * @memberof EvaluatedMatrixView
     */
    nextEvaluation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EvaluatedMatrixView
     */
    needsEvaluation: boolean;
    /**
     * 
     * @type {EvaluationModeType}
     * @memberof EvaluatedMatrixView
     */
    tpe: EvaluationModeType;
}
/**
 * @type EvaluationMode
 * 
 * @export
 */
export type EvaluationMode = { tpe: 'evaluated' } & Evaluated | { tpe: 'infinite' } & Infinite;

/**
 * 
 * @export
 */
export const EvaluationModeType = {
    Evaluated: 'evaluated',
    Infinite: 'infinite'
} as const;
export type EvaluationModeType = typeof EvaluationModeType[keyof typeof EvaluationModeType];

/**
 * 
 * @export
 * @interface ExceededReportedAmountThreshold
 */
export interface ExceededReportedAmountThreshold {
    /**
     * 
     * @type {string}
     * @memberof ExceededReportedAmountThreshold
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExceededReportedAmountThreshold
     */
    description: string;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ExceededReportedAmountThreshold
     */
    lotId: number;
    /**
     * 
     * @type {number}
     * @memberof ExceededReportedAmountThreshold
     */
    amount: number;
    /**
     * 
     * @type {WorkstationReportAmountType}
     * @memberof ExceededReportedAmountThreshold
     */
    tpe: WorkstationReportAmountType;
}
/**
 * 
 * @export
 * @interface ExistingPunchingDie
 */
export interface ExistingPunchingDie {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ExistingPunchingDie
     */
    itemTypeVariantId: number;
}
/**
 * 
 * @export
 * @interface External
 */
export interface External {
    /**
     * ItemTypeId
     * @type {number}
     * @memberof External
     */
    id: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof External
     */
    internalItemTypeTags?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof External
     */
    defaultVariantMinimalStock?: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof External
     */
    defaultPlace?: number;
    /**
     * 
     * @type {string}
     * @memberof External
     */
    description?: string;
    /**
     * 
     * @type {Type}
     * @memberof External
     */
    tpe: Type;
}
/**
 * 
 * @export
 * @interface ExternalContractorDetailsView
 */
export interface ExternalContractorDetailsView {
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    regon?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    streetNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    houseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalContractorDetailsView
     */
    postTown?: string;
}
/**
 * 
 * @export
 * @interface ExternalContractorSavingView
 */
export interface ExternalContractorSavingView {
    /**
     * ContractorId
     * @type {number}
     * @memberof ExternalContractorSavingView
     */
    id: number;
    /**
     * 
     * @type {Array<ContractorKind>}
     * @memberof ExternalContractorSavingView
     */
    kinds: Array<ContractorKind>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExternalContractorSavingView
     */
    itemTypeTags?: Array<number>;
}
/**
 * 
 * @export
 * @interface ExternalIdView
 */
export interface ExternalIdView {
    /**
     * 
     * @type {string}
     * @memberof ExternalIdView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalIdView
     */
    value: string;
}
/**
 * 
 * @export
 * @interface ExternalOrder
 */
export interface ExternalOrder {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof ExternalOrder
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalOrder
     */
    title?: string;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof ExternalOrder
     */
    offerId?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalOrder
     */
    buyerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalOrder
     */
    supplierNumber?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof ExternalOrder
     */
    source: OrderSource;
    /**
     * 
     * @type {string}
     * @memberof ExternalOrder
     */
    ediUuid?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof ExternalOrder
     */
    buyerId: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof ExternalOrder
     */
    recipientId: number;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof ExternalOrder
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {string}
     * @memberof ExternalOrder
     */
    comments?: string;
    /**
     * UserId
     * @type {number}
     * @memberof ExternalOrder
     */
    authorId?: number;
    /**
     * 
     * @type {OrderStatus}
     * @memberof ExternalOrder
     */
    status: OrderStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalOrder
     */
    isExport: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExternalOrder
     */
    creationDate?: string;
    /**
     * 
     * @type {DeliveryDate}
     * @memberof ExternalOrder
     */
    deliveryDate: DeliveryDate;
    /**
     * 
     * @type {ShippingDate}
     * @memberof ExternalOrder
     */
    shippingDate: ShippingDate;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof ExternalOrder
     */
    items?: Array<SalesEntryItemView>;
    /**
     * 
     * @type {number}
     * @memberof ExternalOrder
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof ExternalOrder
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof ExternalOrder
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * UserId
     * @type {number}
     * @memberof ExternalOrder
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof ExternalOrder
     */
    methodOfPayment: MethodOfPayment;
    /**
     * 
     * @type {string}
     * @memberof ExternalOrder
     */
    methodOfPaymentName?: string;
    /**
     * 
     * @type {SalesOptions}
     * @memberof ExternalOrder
     */
    options: SalesOptions;
    /**
     * 
     * @type {SalesRate}
     * @memberof ExternalOrder
     */
    rate: SalesRate;
    /**
     * 
     * @type {Array<SalesEntryTag>}
     * @memberof ExternalOrder
     */
    tags?: Array<SalesEntryTag>;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalOrder
     */
    globalDeliveryDate: boolean;
    /**
     * 
     * @type {SplitOrder}
     * @memberof ExternalOrder
     */
    splitFrom?: SplitOrder;
}
/**
 * Fallback of ProductionUnit in case barcode indicates production unit but it can't be found in the system
 * @export
 * @interface ExternalProductionUnitResult
 */
export interface ExternalProductionUnitResult {
    /**
     * 
     * @type {string}
     * @memberof ExternalProductionUnitResult
     */
    number: string;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof ExternalProductionUnitResult
     */
    tpe: BarcodeActionType;
}
/**
 * @type ExternalSynchronizationRunSagaError
 * 
 * @export
 */
export type ExternalSynchronizationRunSagaError = { name: 'MissingErpTriggerService' } & LemmaSimpleErrorView | { name: 'SynchronizationTriggerError' } & SynchronizationTriggerError;
/**
 * 
 * @export
 * @interface Extrusion1
 */
export interface Extrusion1 {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof Extrusion1
     */
    reliefPlate?: number;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof Extrusion1
     */
    reliefPlateType: ReliefPlateType;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof Extrusion1
     */
    secondReliefPlate?: number;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof Extrusion1
     */
    secondReliefPlateType: ReliefPlateType;
}
/**
 * 
 * @export
 * @interface ExtrusionView
 */
export interface ExtrusionView {
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof ExtrusionView
     */
    reliefPlate?: ItemTypeVariant;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof ExtrusionView
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof ExtrusionView
     */
    secondReliefPlate?: ItemTypeVariant;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof ExtrusionView
     */
    secondReliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {StepType}
     * @memberof ExtrusionView
     */
    stepType: StepType;
}
/**
 * 
 * @export
 * @interface FieldVisibility
 */
export interface FieldVisibility {
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    itemTypeExternalId: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    discount: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    vat: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    summary: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldVisibility
     */
    technology: boolean;
}
/**
 * 
 * @export
 * @interface FilterRangeBigDecimal
 */
export interface FilterRangeBigDecimal {
    /**
     * 
     * @type {number}
     * @memberof FilterRangeBigDecimal
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterRangeBigDecimal
     */
    to?: number;
}
/**
 * 
 * @export
 * @interface FilterRangeDateTime
 */
export interface FilterRangeDateTime {
    /**
     * 
     * @type {string}
     * @memberof FilterRangeDateTime
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterRangeDateTime
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface FilterRangeLocalDate
 */
export interface FilterRangeLocalDate {
    /**
     * 
     * @type {string}
     * @memberof FilterRangeLocalDate
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterRangeLocalDate
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface FilterRangeOptionBigDecimal
 */
export interface FilterRangeOptionBigDecimal {
    /**
     * 
     * @type {number}
     * @memberof FilterRangeOptionBigDecimal
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterRangeOptionBigDecimal
     */
    to?: number;
}
/**
 * 
 * @export
 * @interface FilterRangeOptionDateTime
 */
export interface FilterRangeOptionDateTime {
    /**
     * 
     * @type {string}
     * @memberof FilterRangeOptionDateTime
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterRangeOptionDateTime
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface FilterRangeOptionDuration
 */
export interface FilterRangeOptionDuration {
    /**
     * 
     * @type {string}
     * @memberof FilterRangeOptionDuration
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterRangeOptionDuration
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface FilterRangeOptionLocalDate
 */
export interface FilterRangeOptionLocalDate {
    /**
     * 
     * @type {string}
     * @memberof FilterRangeOptionLocalDate
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterRangeOptionLocalDate
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface FilterRangeOptionint
 */
export interface FilterRangeOptionint {
    /**
     * 
     * @type {number}
     * @memberof FilterRangeOptionint
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof FilterRangeOptionint
     */
    to?: number;
}
/**
 * 
 * @export
 * @interface FilterResultActiveVehicleListController
 */
export interface FilterResultActiveVehicleListController {
    /**
     * 
     * @type {Array<VehicleListView>}
     * @memberof FilterResultActiveVehicleListController
     */
    data?: Array<VehicleListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultActiveVehicleListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultBlobItemsListController
 */
export interface FilterResultBlobItemsListController {
    /**
     * 
     * @type {Array<BlobItemListView>}
     * @memberof FilterResultBlobItemsListController
     */
    data?: Array<BlobItemListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultBlobItemsListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultCompetenceCategoryListViewController
 */
export interface FilterResultCompetenceCategoryListViewController {
    /**
     * 
     * @type {Array<CompetenceCategoryListViewRow>}
     * @memberof FilterResultCompetenceCategoryListViewController
     */
    data?: Array<CompetenceCategoryListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultCompetenceCategoryListViewController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultCompetenceListViewController
 */
export interface FilterResultCompetenceListViewController {
    /**
     * 
     * @type {Array<CompetenceListViewRow>}
     * @memberof FilterResultCompetenceListViewController
     */
    data?: Array<CompetenceListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultCompetenceListViewController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultCompetenceMatrixListController
 */
export interface FilterResultCompetenceMatrixListController {
    /**
     * 
     * @type {Array<CompetenceMatrixListView>}
     * @memberof FilterResultCompetenceMatrixListController
     */
    data?: Array<CompetenceMatrixListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultCompetenceMatrixListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultContactsListController
 */
export interface FilterResultContactsListController {
    /**
     * 
     * @type {Array<ContactRow>}
     * @memberof FilterResultContactsListController
     */
    data?: Array<ContactRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultContactsListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultContractorsListController
 */
export interface FilterResultContractorsListController {
    /**
     * 
     * @type {Array<ContractorListViewRow>}
     * @memberof FilterResultContractorsListController
     */
    data?: Array<ContractorListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultContractorsListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultCountsheetEntriesListController
 */
export interface FilterResultCountsheetEntriesListController {
    /**
     * 
     * @type {Array<CountsheetEntryListRow>}
     * @memberof FilterResultCountsheetEntriesListController
     */
    data?: Array<CountsheetEntryListRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultCountsheetEntriesListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultDemandListController
 */
export interface FilterResultDemandListController {
    /**
     * 
     * @type {Array<DemandListView>}
     * @memberof FilterResultDemandListController
     */
    data?: Array<DemandListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultDemandListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultDemandsManagerListController
 */
export interface FilterResultDemandsManagerListController {
    /**
     * 
     * @type {Array<DemandsManagerListView>}
     * @memberof FilterResultDemandsManagerListController
     */
    data?: Array<DemandsManagerListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultDemandsManagerListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultDocumentStatusListController
 */
export interface FilterResultDocumentStatusListController {
    /**
     * 
     * @type {Array<DocumentStatusView>}
     * @memberof FilterResultDocumentStatusListController
     */
    data?: Array<DocumentStatusView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultDocumentStatusListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultDowntimeReasonsListController
 */
export interface FilterResultDowntimeReasonsListController {
    /**
     * 
     * @type {Array<DowntimeReasonView>}
     * @memberof FilterResultDowntimeReasonsListController
     */
    data?: Array<DowntimeReasonView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultDowntimeReasonsListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultDriverListController
 */
export interface FilterResultDriverListController {
    /**
     * 
     * @type {Array<DriverListView>}
     * @memberof FilterResultDriverListController
     */
    data?: Array<DriverListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultDriverListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultEquipmentDemandListController
 */
export interface FilterResultEquipmentDemandListController {
    /**
     * 
     * @type {Array<EquipmentDemandListView>}
     * @memberof FilterResultEquipmentDemandListController
     */
    data?: Array<EquipmentDemandListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultEquipmentDemandListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultEquipmentListController
 */
export interface FilterResultEquipmentListController {
    /**
     * 
     * @type {Array<EquipmentListViewRow>}
     * @memberof FilterResultEquipmentListController
     */
    data?: Array<EquipmentListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultEquipmentListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultItemTypePropertySetListController
 */
export interface FilterResultItemTypePropertySetListController {
    /**
     * 
     * @type {Array<ItemTypePropertySetListView>}
     * @memberof FilterResultItemTypePropertySetListController
     */
    data?: Array<ItemTypePropertySetListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultItemTypePropertySetListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultItemTypePropertyTypesListController
 */
export interface FilterResultItemTypePropertyTypesListController {
    /**
     * 
     * @type {Array<ItemTypePropertyTypeRow>}
     * @memberof FilterResultItemTypePropertyTypesListController
     */
    data?: Array<ItemTypePropertyTypeRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultItemTypePropertyTypesListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultItemTypeTagListController
 */
export interface FilterResultItemTypeTagListController {
    /**
     * 
     * @type {Array<ItemTypeTagListView>}
     * @memberof FilterResultItemTypeTagListController
     */
    data?: Array<ItemTypeTagListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultItemTypeTagListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultItemTypeTotalStockListController
 */
export interface FilterResultItemTypeTotalStockListController {
    /**
     * 
     * @type {Array<ItemTypeTotalStockListView>}
     * @memberof FilterResultItemTypeTotalStockListController
     */
    data?: Array<ItemTypeTotalStockListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultItemTypeTotalStockListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultItemTypeVariantListController
 */
export interface FilterResultItemTypeVariantListController {
    /**
     * 
     * @type {Array<ItemTypeVariantListView>}
     * @memberof FilterResultItemTypeVariantListController
     */
    data?: Array<ItemTypeVariantListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultItemTypeVariantListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultItemTypeVariantWithPropertySetListController
 */
export interface FilterResultItemTypeVariantWithPropertySetListController {
    /**
     * 
     * @type {Array<ItemTypeVariantWithPropertySetListView>}
     * @memberof FilterResultItemTypeVariantWithPropertySetListController
     */
    data?: Array<ItemTypeVariantWithPropertySetListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultItemTypeVariantWithPropertySetListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultLegacyProductionLotListController
 */
export interface FilterResultLegacyProductionLotListController {
    /**
     * 
     * @type {Array<LegacyProductionLotListView>}
     * @memberof FilterResultLegacyProductionLotListController
     */
    data?: Array<LegacyProductionLotListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultLegacyProductionLotListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultLegacyProductionOrdersListController
 */
export interface FilterResultLegacyProductionOrdersListController {
    /**
     * 
     * @type {Array<LegacyProductionOrderListView>}
     * @memberof FilterResultLegacyProductionOrdersListController
     */
    data?: Array<LegacyProductionOrderListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultLegacyProductionOrdersListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultLoadCardListController
 */
export interface FilterResultLoadCardListController {
    /**
     * 
     * @type {Array<LoadCardListViewOld>}
     * @memberof FilterResultLoadCardListController
     */
    data?: Array<LoadCardListViewOld>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultLoadCardListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultMachineAreasListController
 */
export interface FilterResultMachineAreasListController {
    /**
     * 
     * @type {Array<MachineAreaListViewRow>}
     * @memberof FilterResultMachineAreasListController
     */
    data?: Array<MachineAreaListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultMachineAreasListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultMachinesListController
 */
export interface FilterResultMachinesListController {
    /**
     * 
     * @type {Array<MachineView>}
     * @memberof FilterResultMachinesListController
     */
    data?: Array<MachineView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultMachinesListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultMarketingKeepersListController
 */
export interface FilterResultMarketingKeepersListController {
    /**
     * 
     * @type {Array<MarketingKeepersListViewRow>}
     * @memberof FilterResultMarketingKeepersListController
     */
    data?: Array<MarketingKeepersListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultMarketingKeepersListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultMarketingRulesListController
 */
export interface FilterResultMarketingRulesListController {
    /**
     * 
     * @type {Array<MarketingRulesView>}
     * @memberof FilterResultMarketingRulesListController
     */
    data?: Array<MarketingRulesView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultMarketingRulesListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultMaterialMovementListController
 */
export interface FilterResultMaterialMovementListController {
    /**
     * 
     * @type {Array<MaterialMovementListView>}
     * @memberof FilterResultMaterialMovementListController
     */
    data?: Array<MaterialMovementListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultMaterialMovementListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultMeasurementDevicesListController
 */
export interface FilterResultMeasurementDevicesListController {
    /**
     * 
     * @type {Array<MeasurementDeviceView>}
     * @memberof FilterResultMeasurementDevicesListController
     */
    data?: Array<MeasurementDeviceView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultMeasurementDevicesListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultMeasurementStandardsListController
 */
export interface FilterResultMeasurementStandardsListController {
    /**
     * 
     * @type {Array<MeasurementStandardView>}
     * @memberof FilterResultMeasurementStandardsListController
     */
    data?: Array<MeasurementStandardView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultMeasurementStandardsListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultMethodsOfPaymentListController
 */
export interface FilterResultMethodsOfPaymentListController {
    /**
     * 
     * @type {Array<MethodOfPaymentView>}
     * @memberof FilterResultMethodsOfPaymentListController
     */
    data?: Array<MethodOfPaymentView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultMethodsOfPaymentListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultOffersListController
 */
export interface FilterResultOffersListController {
    /**
     * 
     * @type {Array<OfferListViewRow>}
     * @memberof FilterResultOffersListController
     */
    data?: Array<OfferListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultOffersListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultOrderDemandsToProductionListController
 */
export interface FilterResultOrderDemandsToProductionListController {
    /**
     * 
     * @type {Array<OrderDemandsToProductionListView>}
     * @memberof FilterResultOrderDemandsToProductionListController
     */
    data?: Array<OrderDemandsToProductionListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultOrderDemandsToProductionListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultOrderItemCostsGroupListController
 */
export interface FilterResultOrderItemCostsGroupListController {
    /**
     * 
     * @type {Array<OrderItemCostsReportItemRow>}
     * @memberof FilterResultOrderItemCostsGroupListController
     */
    data?: Array<OrderItemCostsReportItemRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultOrderItemCostsGroupListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultOrdersListController
 */
export interface FilterResultOrdersListController {
    /**
     * 
     * @type {Array<OrderListView>}
     * @memberof FilterResultOrdersListController
     */
    data?: Array<OrderListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultOrdersListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultOtherDemandListController
 */
export interface FilterResultOtherDemandListController {
    /**
     * 
     * @type {Array<OtherDemandListView>}
     * @memberof FilterResultOtherDemandListController
     */
    data?: Array<OtherDemandListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultOtherDemandListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultPriceListsListController
 */
export interface FilterResultPriceListsListController {
    /**
     * 
     * @type {Array<PriceList>}
     * @memberof FilterResultPriceListsListController
     */
    data?: Array<PriceList>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultPriceListsListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductCatalogListController
 */
export interface FilterResultProductCatalogListController {
    /**
     * 
     * @type {Array<ProductCatalogItemListViewRow>}
     * @memberof FilterResultProductCatalogListController
     */
    data?: Array<ProductCatalogItemListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductCatalogListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionLotListController
 */
export interface FilterResultProductionLotListController {
    /**
     * 
     * @type {Array<ProductionLotListView>}
     * @memberof FilterResultProductionLotListController
     */
    data?: Array<ProductionLotListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionLotListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionLotPeriodsGroupListController
 */
export interface FilterResultProductionLotPeriodsGroupListController {
    /**
     * 
     * @type {Array<ProductionSummaryReportItemRow>}
     * @memberof FilterResultProductionLotPeriodsGroupListController
     */
    data?: Array<ProductionSummaryReportItemRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionLotPeriodsGroupListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionLotRawMaterialsUsageListController
 */
export interface FilterResultProductionLotRawMaterialsUsageListController {
    /**
     * 
     * @type {Array<ProductionLotRawMaterialsUsageListView>}
     * @memberof FilterResultProductionLotRawMaterialsUsageListController
     */
    data?: Array<ProductionLotRawMaterialsUsageListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionLotRawMaterialsUsageListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionLotTagListController
 */
export interface FilterResultProductionLotTagListController {
    /**
     * 
     * @type {Array<ProductionLotTagRow>}
     * @memberof FilterResultProductionLotTagListController
     */
    data?: Array<ProductionLotTagRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionLotTagListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionOrderCreatorListController
 */
export interface FilterResultProductionOrderCreatorListController {
    /**
     * 
     * @type {Array<FulfillmentCreatorListView>}
     * @memberof FilterResultProductionOrderCreatorListController
     */
    data?: Array<FulfillmentCreatorListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionOrderCreatorListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionOrderLotListController
 */
export interface FilterResultProductionOrderLotListController {
    /**
     * 
     * @type {Array<ProductionOrderLotListView>}
     * @memberof FilterResultProductionOrderLotListController
     */
    data?: Array<ProductionOrderLotListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionOrderLotListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionOrderRawMaterialsUsageListController
 */
export interface FilterResultProductionOrderRawMaterialsUsageListController {
    /**
     * 
     * @type {Array<ProductionOrderRawMaterialsUsageListView>}
     * @memberof FilterResultProductionOrderRawMaterialsUsageListController
     */
    data?: Array<ProductionOrderRawMaterialsUsageListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionOrderRawMaterialsUsageListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionOrderWorktimeListController
 */
export interface FilterResultProductionOrderWorktimeListController {
    /**
     * 
     * @type {Array<ProductionOrderWorktimeListView>}
     * @memberof FilterResultProductionOrderWorktimeListController
     */
    data?: Array<ProductionOrderWorktimeListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionOrderWorktimeListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionOrdersListController
 */
export interface FilterResultProductionOrdersListController {
    /**
     * 
     * @type {Array<ProductionOrderListView>}
     * @memberof FilterResultProductionOrdersListController
     */
    data?: Array<ProductionOrderListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionOrdersListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultProductionUnitListViewRow
 */
export interface FilterResultProductionUnitListViewRow {
    /**
     * 
     * @type {Array<ProductionUnitListViewRow>}
     * @memberof FilterResultProductionUnitListViewRow
     */
    data?: Array<ProductionUnitListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultProductionUnitListViewRow
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultPushStatusListController
 */
export interface FilterResultPushStatusListController {
    /**
     * 
     * @type {Array<PushStatusListView>}
     * @memberof FilterResultPushStatusListController
     */
    data?: Array<PushStatusListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultPushStatusListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultReleaseListController
 */
export interface FilterResultReleaseListController {
    /**
     * 
     * @type {Array<ReleaseListView>}
     * @memberof FilterResultReleaseListController
     */
    data?: Array<ReleaseListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultReleaseListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultReleasePlanListController
 */
export interface FilterResultReleasePlanListController {
    /**
     * 
     * @type {Array<ReleasePlanListView>}
     * @memberof FilterResultReleasePlanListController
     */
    data?: Array<ReleasePlanListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultReleasePlanListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultRolesListViewController
 */
export interface FilterResultRolesListViewController {
    /**
     * 
     * @type {Array<RoleRow>}
     * @memberof FilterResultRolesListViewController
     */
    data?: Array<RoleRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultRolesListViewController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSalesEntryDocumentListViewController
 */
export interface FilterResultSalesEntryDocumentListViewController {
    /**
     * 
     * @type {Array<SalesEntryDocumentListViewRow>}
     * @memberof FilterResultSalesEntryDocumentListViewController
     */
    data?: Array<SalesEntryDocumentListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSalesEntryDocumentListViewController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSalesEntryTagListController
 */
export interface FilterResultSalesEntryTagListController {
    /**
     * 
     * @type {Array<SalesEntryTagRow>}
     * @memberof FilterResultSalesEntryTagListController
     */
    data?: Array<SalesEntryTagRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSalesEntryTagListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSpecificationsByMachineFeaturesListController
 */
export interface FilterResultSpecificationsByMachineFeaturesListController {
    /**
     * 
     * @type {Array<SpecificationTemplateByMachineFeaturesRow>}
     * @memberof FilterResultSpecificationsByMachineFeaturesListController
     */
    data?: Array<SpecificationTemplateByMachineFeaturesRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSpecificationsByMachineFeaturesListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSpecificationsByProducedItemTagsListController
 */
export interface FilterResultSpecificationsByProducedItemTagsListController {
    /**
     * 
     * @type {Array<SpecificationTemplateByProducedItemTagsRow>}
     * @memberof FilterResultSpecificationsByProducedItemTagsListController
     */
    data?: Array<SpecificationTemplateByProducedItemTagsRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSpecificationsByProducedItemTagsListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSpecificationsByProducedVariantListController
 */
export interface FilterResultSpecificationsByProducedVariantListController {
    /**
     * 
     * @type {Array<SpecificationTemplateByProducedVariantViewRow>}
     * @memberof FilterResultSpecificationsByProducedVariantListController
     */
    data?: Array<SpecificationTemplateByProducedVariantViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSpecificationsByProducedVariantListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSpecificationsByProducedVariantListControllerV2
 */
export interface FilterResultSpecificationsByProducedVariantListControllerV2 {
    /**
     * 
     * @type {Array<SpecificationTemplateByProducedVariantViewRowV2>}
     * @memberof FilterResultSpecificationsByProducedVariantListControllerV2
     */
    data?: Array<SpecificationTemplateByProducedVariantViewRowV2>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSpecificationsByProducedVariantListControllerV2
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultStandardParametersListController
 */
export interface FilterResultStandardParametersListController {
    /**
     * 
     * @type {Array<StandardParameterView>}
     * @memberof FilterResultStandardParametersListController
     */
    data?: Array<StandardParameterView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultStandardParametersListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultStocksToSupplementListViewController
 */
export interface FilterResultStocksToSupplementListViewController {
    /**
     * 
     * @type {Array<ItemUnderMinimalAmountViewRow>}
     * @memberof FilterResultStocksToSupplementListViewController
     */
    data?: Array<ItemUnderMinimalAmountViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultStocksToSupplementListViewController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultStocktakingListController
 */
export interface FilterResultStocktakingListController {
    /**
     * 
     * @type {Array<StocktakingListRow>}
     * @memberof FilterResultStocktakingListController
     */
    data?: Array<StocktakingListRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultStocktakingListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSupplyCardListController
 */
export interface FilterResultSupplyCardListController {
    /**
     * 
     * @type {Array<SupplyCardListView>}
     * @memberof FilterResultSupplyCardListController
     */
    data?: Array<SupplyCardListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSupplyCardListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSupplyOrderCreatorListController
 */
export interface FilterResultSupplyOrderCreatorListController {
    /**
     * 
     * @type {Array<FulfillmentCreatorListView>}
     * @memberof FilterResultSupplyOrderCreatorListController
     */
    data?: Array<FulfillmentCreatorListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSupplyOrderCreatorListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSupplyOrderListController
 */
export interface FilterResultSupplyOrderListController {
    /**
     * 
     * @type {Array<SupplyOrderListView>}
     * @memberof FilterResultSupplyOrderListController
     */
    data?: Array<SupplyOrderListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSupplyOrderListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultSynchronizationStatusListController
 */
export interface FilterResultSynchronizationStatusListController {
    /**
     * 
     * @type {Array<SynchronizationStatusListView>}
     * @memberof FilterResultSynchronizationStatusListController
     */
    data?: Array<SynchronizationStatusListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultSynchronizationStatusListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultTicketsListController
 */
export interface FilterResultTicketsListController {
    /**
     * 
     * @type {Array<TaskTicketListElementView>}
     * @memberof FilterResultTicketsListController
     */
    data?: Array<TaskTicketListElementView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultTicketsListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultUsersListController
 */
export interface FilterResultUsersListController {
    /**
     * 
     * @type {Array<UserListView>}
     * @memberof FilterResultUsersListController
     */
    data?: Array<UserListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultUsersListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultWarehouseStateListController
 */
export interface FilterResultWarehouseStateListController {
    /**
     * 
     * @type {Array<WarehouseStateListViewRow>}
     * @memberof FilterResultWarehouseStateListController
     */
    data?: Array<WarehouseStateListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultWarehouseStateListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultWarehouseStateToProductionListController
 */
export interface FilterResultWarehouseStateToProductionListController {
    /**
     * 
     * @type {Array<WarehouseStateToProductionListView>}
     * @memberof FilterResultWarehouseStateToProductionListController
     */
    data?: Array<WarehouseStateToProductionListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultWarehouseStateToProductionListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultWarehouseTagListController
 */
export interface FilterResultWarehouseTagListController {
    /**
     * 
     * @type {Array<WarehouseTagListView>}
     * @memberof FilterResultWarehouseTagListController
     */
    data?: Array<WarehouseTagListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultWarehouseTagListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultWasteCausesListController
 */
export interface FilterResultWasteCausesListController {
    /**
     * 
     * @type {Array<WasteCauseView>}
     * @memberof FilterResultWasteCausesListController
     */
    data?: Array<WasteCauseView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultWasteCausesListController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultWorkerCompetenceListViewController
 */
export interface FilterResultWorkerCompetenceListViewController {
    /**
     * 
     * @type {Array<WorkerCompetenceListViewRow>}
     * @memberof FilterResultWorkerCompetenceListViewController
     */
    data?: Array<WorkerCompetenceListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultWorkerCompetenceListViewController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultWorkerDocumentListViewController
 */
export interface FilterResultWorkerDocumentListViewController {
    /**
     * 
     * @type {Array<WorkerDocumentListViewRow>}
     * @memberof FilterResultWorkerDocumentListViewController
     */
    data?: Array<WorkerDocumentListViewRow>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultWorkerDocumentListViewController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FilterResultWorkerListViewController
 */
export interface FilterResultWorkerListViewController {
    /**
     * 
     * @type {Array<WorkerListView>}
     * @memberof FilterResultWorkerListViewController
     */
    data?: Array<WorkerListView>;
    /**
     * 
     * @type {number}
     * @memberof FilterResultWorkerListViewController
     */
    total: number;
}
/**
 * 
 * @export
 * @interface FinishTaskView
 */
export interface FinishTaskView {
    /**
     * 
     * @type {string}
     * @memberof FinishTaskView
     */
    endDate: string;
    /**
     * UserId
     * @type {number}
     * @memberof FinishTaskView
     */
    workerId: number;
    /**
     * 
     * @type {number}
     * @memberof FinishTaskView
     */
    oks: number;
    /**
     * 
     * @type {number}
     * @memberof FinishTaskView
     */
    noks: number;
}
/**
 * 
 * @export
 * @interface FitAcrossRibbon
 */
export interface FitAcrossRibbon {
    /**
     * 
     * @type {number}
     * @memberof FitAcrossRibbon
     */
    paperWidth: number;
    /**
     * 
     * @type {number}
     * @memberof FitAcrossRibbon
     */
    innerMarginAcrossRibbon: number;
    /**
     * 
     * @type {number}
     * @memberof FitAcrossRibbon
     */
    outerMarginAcrossRibbon: number;
    /**
     * 
     * @type {number}
     * @memberof FitAcrossRibbon
     */
    labelsCountAcrossRibbon: number;
}
/**
 * 
 * @export
 * @interface FitAlongRibbon
 */
export interface FitAlongRibbon {
    /**
     * 
     * @type {number}
     * @memberof FitAlongRibbon
     */
    innerMarginAlongRibbon: number;
    /**
     * 
     * @type {number}
     * @memberof FitAlongRibbon
     */
    labelsCountAlongRibbon: number;
    /**
     * 
     * @type {number}
     * @memberof FitAlongRibbon
     */
    cogsCount: number;
}
/**
 * 
 * @export
 * @interface FlexoColor
 */
export interface FlexoColor {
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof FlexoColor
     */
    paint?: PropertySetSelector;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof FlexoColor
     */
    reliefPlate?: number;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof FlexoColor
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof FlexoColor
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof FlexoColor
     */
    dosageRoller?: number;
    /**
     * 
     * @type {StepMode}
     * @memberof FlexoColor
     */
    stepMode: StepMode;
}
/**
 * 
 * @export
 * @interface FlexoColorView
 */
export interface FlexoColorView {
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof FlexoColorView
     */
    paint?: PropertySetSelectorView;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof FlexoColorView
     */
    reliefPlate?: ItemTypeVariant;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof FlexoColorView
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof FlexoColorView
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof FlexoColorView
     */
    dosageRoller?: ItemTypeVariant;
    /**
     * 
     * @type {StepMode}
     * @memberof FlexoColorView
     */
    stepMode: StepMode;
    /**
     * 
     * @type {StepType}
     * @memberof FlexoColorView
     */
    stepType: StepType;
}

/**
 * 
 * @export
 */
export const Frequency = {
    DAILY: 0,
    WEEKLY: 1,
    MONTHLY: 2,
    YEARLY: 3
} as const;
export type Frequency = typeof Frequency[keyof typeof Frequency];

/**
 * @type FulfillmentCreatorDemandSource
 * 
 * @export
 */
export type FulfillmentCreatorDemandSource = { tpe: 'minimal_state' } & FulfillmentCreatorMinimalStateDemandSource | { tpe: 'order_item' } & FulfillmentCreatorOrderItemDemandSource | { tpe: 'production_lot' } & FulfillmentCreatorLotDemandSource;

/**
 * 
 * @export
 */
export const FulfillmentCreatorDemandSourceType = {
    OrderItem: 'order_item',
    ProductionLot: 'production_lot',
    MinimalState: 'minimal_state'
} as const;
export type FulfillmentCreatorDemandSourceType = typeof FulfillmentCreatorDemandSourceType[keyof typeof FulfillmentCreatorDemandSourceType];

/**
 * 
 * @export
 * @interface FulfillmentCreatorListView
 */
export interface FulfillmentCreatorListView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof FulfillmentCreatorListView
     */
    productVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorListView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorListView
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorListView
     */
    unitType: string;
    /**
     * 
     * @type {Array<FulfillmentCreatorDemandSource>}
     * @memberof FulfillmentCreatorListView
     */
    demandSources?: Array<FulfillmentCreatorDemandSource>;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorListView
     */
    earliestDueDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FulfillmentCreatorListView
     */
    clientNames?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorListView
     */
    neededAmount: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorListView
     */
    totalNeededAmount: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorListView
     */
    fulfilled: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorListView
     */
    available: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorListView
     */
    nowInWarehouses: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorListView
     */
    amountToFulfill: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorListView
     */
    minimalAmount?: number;
}
/**
 * 
 * @export
 * @interface FulfillmentCreatorLotDemandSource
 */
export interface FulfillmentCreatorLotDemandSource {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    productionLotNumber: string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    neededAmount: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    totalNeededAmount: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    fulfilled: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    amountToFulfill: number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    estimatedProductionTime?: string;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    fromWarehouse: number;
    /**
     * 
     * @type {FulfillmentCreatorDemandSourceType}
     * @memberof FulfillmentCreatorLotDemandSource
     */
    tpe: FulfillmentCreatorDemandSourceType;
}
/**
 * 
 * @export
 * @interface FulfillmentCreatorMinimalStateDemandSource
 */
export interface FulfillmentCreatorMinimalStateDemandSource {
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorMinimalStateDemandSource
     */
    neededAmount: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorMinimalStateDemandSource
     */
    totalNeededAmount: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorMinimalStateDemandSource
     */
    available: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorMinimalStateDemandSource
     */
    fulfilled: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorMinimalStateDemandSource
     */
    amountToFulfill: number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorMinimalStateDemandSource
     */
    estimatedProductionTime?: string;
    /**
     * 
     * @type {FulfillmentCreatorDemandSourceType}
     * @memberof FulfillmentCreatorMinimalStateDemandSource
     */
    tpe: FulfillmentCreatorDemandSourceType;
}
/**
 * 
 * @export
 * @interface FulfillmentCreatorOrderItemDemandSource
 */
export interface FulfillmentCreatorOrderItemDemandSource {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    orderItemId: number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    orderPositionRef: string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    buyerName: string;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    neededAmount: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    totalNeededAmount: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    fulfilled: number;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    amountToFulfill: number;
    /**
     * 
     * @type {string}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    estimatedProductionTime?: string;
    /**
     * 
     * @type {number}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    fromWarehouse: number;
    /**
     * 
     * @type {FulfillmentCreatorDemandSourceType}
     * @memberof FulfillmentCreatorOrderItemDemandSource
     */
    tpe: FulfillmentCreatorDemandSourceType;
}
/**
 * 
 * @export
 * @interface GeneratedPassword
 */
export interface GeneratedPassword {
    /**
     * 
     * @type {string}
     * @memberof GeneratedPassword
     */
    generatedPassword: string;
}
/**
 * 
 * @export
 * @interface GeneratingPasswordLength
 */
export interface GeneratingPasswordLength {
    /**
     * 
     * @type {number}
     * @memberof GeneratingPasswordLength
     */
    generatingPasswordLength: number;
}
/**
 * @type GenericMatchCondition
 * 
 * @export
 */
export type GenericMatchCondition = { matchConditionType: '1' } & ByProducedVariant | { matchConditionType: '2' } & ByMachineFeatures | { matchConditionType: '3' } & ByProducedItemTags;
/**
 * @type GenericMeasurement
 * 
 * @export
 */
export type GenericMeasurement = { measurementType: '1' } & MeasurementMinAvgMax | { measurementType: '2' } & MeasurementFromTo | { measurementType: '3' } & MeasurementSimpleVal | { measurementType: '4' } & MeasurementTextSimpleVal;
/**
 * @type GenericPackaging
 * 
 * @export
 */
export type GenericPackaging = { packagingType: '16' } & LabelsPackaging | { packagingType: '6' } & BasicPackaging;
/**
 * @type GenericRecipe
 * 
 * @export
 */
export type GenericRecipe = { recipeType: '10' } & ReliefPlateRecipe | { recipeType: '11' } & ScrollingRecipe | { recipeType: '2' } & PiecesRecipe | { recipeType: '9' } & PrintingRecipe;
/**
 * @type GenericRecipeView
 * 
 * @export
 */
export type GenericRecipeView = { recipeType: '10' } & ReliefPlateRecipeView | { recipeType: '11' } & ScrollingRecipe | { recipeType: '2' } & PiecesRecipe | { recipeType: '9' } & PrintingRecipeView;
/**
 * 
 * @export
 * @interface GroupLeaderDashboardFilters
 */
export interface GroupLeaderDashboardFilters {
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderDashboardFilters
     */
    dateFrom: string;
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderDashboardFilters
     */
    dateTo: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GroupLeaderDashboardFilters
     */
    areas?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GroupLeaderDashboardFilters
     */
    machines?: Array<number>;
}
/**
 * 
 * @export
 * @interface GroupLeaderEventIndentification
 */
export interface GroupLeaderEventIndentification {
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderEventIndentification
     */
    occurrenceDate: string;
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderEventIndentification
     */
    causeName: string;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof GroupLeaderEventIndentification
     */
    productionLotId?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderEventIndentification
     */
    productionLotNumber?: string;
    /**
     * 
     * @type {MachineView}
     * @memberof GroupLeaderEventIndentification
     */
    machine: MachineView;
    /**
     * 
     * @type {WorkerView}
     * @memberof GroupLeaderEventIndentification
     */
    worker?: WorkerView;
}
/**
 * @type GroupLeaderEventInfo
 * 
 * @export
 */
export type GroupLeaderEventInfo = { eventType: 'downtime' } & DowntimeEventView | { eventType: 'pause' } & PauseEventView;

/**
 * 
 * @export
 */
export const GroupLeaderEventType = {
    downtime: 1,
    pause: 2
} as const;
export type GroupLeaderEventType = typeof GroupLeaderEventType[keyof typeof GroupLeaderEventType];

/**
 * 
 * @export
 * @interface GroupLeaderEventsResponse
 */
export interface GroupLeaderEventsResponse {
    /**
     * 
     * @type {Array<GroupLeaderEventInfo>}
     * @memberof GroupLeaderEventsResponse
     */
    events?: Array<GroupLeaderEventInfo>;
}
/**
 * 
 * @export
 * @interface GroupLeaderIndicatorsView
 */
export interface GroupLeaderIndicatorsView {
    /**
     * 
     * @type {number}
     * @memberof GroupLeaderIndicatorsView
     */
    oee: number;
    /**
     * 
     * @type {number}
     * @memberof GroupLeaderIndicatorsView
     */
    availability: number;
    /**
     * 
     * @type {number}
     * @memberof GroupLeaderIndicatorsView
     */
    performance: number;
    /**
     * 
     * @type {number}
     * @memberof GroupLeaderIndicatorsView
     */
    quality: number;
}
/**
 * 
 * @export
 * @interface GroupLeaderNoksReport
 */
export interface GroupLeaderNoksReport {
    /**
     * 
     * @type {MachineView}
     * @memberof GroupLeaderNoksReport
     */
    machine: MachineView;
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderNoksReport
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderNoksReport
     */
    productCode?: string;
    /**
     * 
     * @type {WorkerView}
     * @memberof GroupLeaderNoksReport
     */
    worker?: WorkerView;
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderNoksReport
     */
    closingTime?: string;
    /**
     * 
     * @type {NokWithCause}
     * @memberof GroupLeaderNoksReport
     */
    noksWithCause: NokWithCause;
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderNoksReport
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface GroupLeaderNoksReportV2
 */
export interface GroupLeaderNoksReportV2 {
    /**
     * 
     * @type {MachineView}
     * @memberof GroupLeaderNoksReportV2
     */
    machine: MachineView;
    /**
     * 
     * @type {string}
     * @memberof GroupLeaderNoksReportV2
     */
    timePoint: string;
    /**
     * 
     * @type {number}
     * @memberof GroupLeaderNoksReportV2
     */
    percentage: number;
}
/**
 * 
 * @export
 * @interface HistoricalParallelMachinePairView
 */
export interface HistoricalParallelMachinePairView {
    /**
     * 
     * @type {number}
     * @memberof HistoricalParallelMachinePairView
     */
    firstMachineId: number;
    /**
     * 
     * @type {string}
     * @memberof HistoricalParallelMachinePairView
     */
    firstMachineTag: string;
    /**
     * 
     * @type {number}
     * @memberof HistoricalParallelMachinePairView
     */
    secondMachineId: number;
    /**
     * 
     * @type {string}
     * @memberof HistoricalParallelMachinePairView
     */
    secondMachineTag: string;
    /**
     * 
     * @type {number}
     * @memberof HistoricalParallelMachinePairView
     */
    frequency: number;
}
/**
 * 
 * @export
 * @interface HistoricalParallelMachinePairsView
 */
export interface HistoricalParallelMachinePairsView {
    /**
     * 
     * @type {Array<HistoricalParallelMachineView>}
     * @memberof HistoricalParallelMachinePairsView
     */
    machines?: Array<HistoricalParallelMachineView>;
    /**
     * 
     * @type {Array<HistoricalParallelMachinePairView>}
     * @memberof HistoricalParallelMachinePairsView
     */
    pairs?: Array<HistoricalParallelMachinePairView>;
}
/**
 * 
 * @export
 * @interface HistoricalParallelMachineView
 */
export interface HistoricalParallelMachineView {
    /**
     * 
     * @type {number}
     * @memberof HistoricalParallelMachineView
     */
    machineId: number;
    /**
     * 
     * @type {string}
     * @memberof HistoricalParallelMachineView
     */
    tag: string;
}
/**
 * 
 * @export
 * @interface IdWithName
 */
export interface IdWithName {
    /**
     * 
     * @type {number}
     * @memberof IdWithName
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IdWithName
     */
    name: string;
}
/**
 * 
 * @export
 * @interface IdWithNumberMaterialMovementId
 */
export interface IdWithNumberMaterialMovementId {
    /**
     * MaterialMovementId
     * @type {number}
     * @memberof IdWithNumberMaterialMovementId
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IdWithNumberMaterialMovementId
     */
    number: string;
}
/**
 * 
 * @export
 * @interface IdWithNumberStocktakingId
 */
export interface IdWithNumberStocktakingId {
    /**
     * StocktakingId
     * @type {number}
     * @memberof IdWithNumberStocktakingId
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IdWithNumberStocktakingId
     */
    number: string;
}
/**
 * 
 * @export
 * @interface IdWithNumberSupplyOrderId
 */
export interface IdWithNumberSupplyOrderId {
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof IdWithNumberSupplyOrderId
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IdWithNumberSupplyOrderId
     */
    number: string;
}
/**
 * 
 * @export
 * @interface IdentityRate
 */
export interface IdentityRate {
    /**
     * CurrencyExchangeRateId
     * @type {number}
     * @memberof IdentityRate
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IdentityRate
     */
    code: string;
}
/**
 * 
 * @export
 * @interface IdxPathNode
 */
export interface IdxPathNode {
    /**
     * 
     * @type {number}
     * @memberof IdxPathNode
     */
    idx: number;
}
/**
 * 
 * @export
 * @interface ImportResult
 */
export interface ImportResult {
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof ImportResult
     */
    productionOrderId: number;
    /**
     * Created lots mapping for production order
     * @type {{ [key: string]: number; }}
     * @memberof ImportResult
     */
    savedLotsMapping: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface IncompatibleOrderItemVariant
 */
export interface IncompatibleOrderItemVariant {
    /**
     * 
     * @type {string}
     * @memberof IncompatibleOrderItemVariant
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IncompatibleOrderItemVariant
     */
    description: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof IncompatibleOrderItemVariant
     */
    expected: number;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof IncompatibleOrderItemVariant
     */
    salesEntryItemId: number;
}
/**
 * @type InconsistentLoadGroupLoadCardsOrInconsistentLoadGroups
 * 
 * @export
 */
export type InconsistentLoadGroupLoadCardsOrInconsistentLoadGroups = { name: 'InconsistentLoadGroupLoadCards' } & LemmaSimpleErrorView | { name: 'InconsistentLoadGroups' } & LemmaSimpleErrorView;
/**
 * 
 * @export
 * @interface InconsistentMachinesInTheBatch
 */
export interface InconsistentMachinesInTheBatch {
    /**
     * 
     * @type {string}
     * @memberof InconsistentMachinesInTheBatch
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InconsistentMachinesInTheBatch
     */
    description: string;
    /**
     * BatchId
     * @type {number}
     * @memberof InconsistentMachinesInTheBatch
     */
    batchId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InconsistentMachinesInTheBatch
     */
    machineIds?: Array<number>;
}

/**
 * 
 * @export
 */
export const InferredSupplyOrderStatus = {
    pending: 1,
    inProgress: 2,
    partiallyReceived: 3,
    received: 4,
    draft: 5,
    toAccept: 6,
    ordered: 7,
    cancelled: 8
} as const;
export type InferredSupplyOrderStatus = typeof InferredSupplyOrderStatus[keyof typeof InferredSupplyOrderStatus];

/**
 * 
 * @export
 * @interface Infinite
 */
export interface Infinite {
    /**
     * 
     * @type {EvaluationModeType}
     * @memberof Infinite
     */
    tpe: EvaluationModeType;
}
/**
 * 
 * @export
 * @interface InfiniteMatrixView
 */
export interface InfiniteMatrixView {
    /**
     * 
     * @type {EvaluationModeType}
     * @memberof InfiniteMatrixView
     */
    tpe: EvaluationModeType;
}
/**
 * 
 * @export
 * @interface InsufficientAmountInPU
 */
export interface InsufficientAmountInPU {
    /**
     * 
     * @type {string}
     * @memberof InsufficientAmountInPU
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InsufficientAmountInPU
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof InsufficientAmountInPU
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof InsufficientAmountInPU
     */
    productionUnitNumber: string;
    /**
     * 
     * @type {number}
     * @memberof InsufficientAmountInPU
     */
    required: number;
    /**
     * 
     * @type {number}
     * @memberof InsufficientAmountInPU
     */
    available: number;
}
/**
 * @type InsufficientAmountInPUOrNotEnoughAmountOrPlanAlreadyExecutedOrUnitNotDefinedAsSecondaryOrVariantMismatch
 * 
 * @export
 */
export type InsufficientAmountInPUOrNotEnoughAmountOrPlanAlreadyExecutedOrUnitNotDefinedAsSecondaryOrVariantMismatch = { name: 'InsufficientAmountInPU' } & InsufficientAmountInPU | { name: 'NotEnoughAmount' } & NotEnoughAmount | { name: 'PlanAlreadyExecuted' } & PlanAlreadyExecuted | { name: 'UnitNotDefinedAsSecondary' } & UnitNotDefinedAsSecondary | { name: 'VariantMismatch' } & VariantMismatch;
/**
 * @type InsufficientAmountInPUOrNotEnoughAmountOrUnitNotDefinedAsSecondary
 * 
 * @export
 */
export type InsufficientAmountInPUOrNotEnoughAmountOrUnitNotDefinedAsSecondary = { name: 'InsufficientAmountInPU' } & InsufficientAmountInPU | { name: 'NotEnoughAmount' } & NotEnoughAmount | { name: 'UnitNotDefinedAsSecondary' } & UnitNotDefinedAsSecondary;
/**
 * 
 * @export
 * @interface Internal
 */
export interface Internal {
    /**
     * ItemTypeId
     * @type {number}
     * @memberof Internal
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Internal
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Internal
     */
    itemTypeTags?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof Internal
     */
    defaultVariantMinimalStock?: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof Internal
     */
    defaultPlace?: number;
    /**
     * 
     * @type {string}
     * @memberof Internal
     */
    description?: string;
    /**
     * 
     * @type {Type}
     * @memberof Internal
     */
    tpe: Type;
}

/**
 * 
 * @export
 */
export const InternalDocumentTypes = {
    producedItemsDocument: 1,
    ingredientUsageDocument: 2,
    supplyDocument: 3
} as const;
export type InternalDocumentTypes = typeof InternalDocumentTypes[keyof typeof InternalDocumentTypes];


/**
 * 
 * @export
 */
export const InternalEntityType = {
    productionLot: 1,
    order: 2,
    supplyCard: 3,
    itemType: 4,
    other: 5,
    productionOrder: 6,
    planExport: 7
} as const;
export type InternalEntityType = typeof InternalEntityType[keyof typeof InternalEntityType];

/**
 * 
 * @export
 * @interface InvalidAssignTimeWindow
 */
export interface InvalidAssignTimeWindow {
    /**
     * 
     * @type {string}
     * @memberof InvalidAssignTimeWindow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidAssignTimeWindow
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidAssignTimeWindow
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidAssignTimeWindow
     */
    to: string;
}
/**
 * 
 * @export
 * @interface InvalidMeasurementType
 */
export interface InvalidMeasurementType {
    /**
     * 
     * @type {string}
     * @memberof InvalidMeasurementType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidMeasurementType
     */
    description: string;
    /**
     * 
     * @type {MeasurementType}
     * @memberof InvalidMeasurementType
     */
    tpe: MeasurementType;
}
/**
 * 
 * @export
 * @interface InvalidMeasurementUpdate
 */
export interface InvalidMeasurementUpdate {
    /**
     * 
     * @type {string}
     * @memberof InvalidMeasurementUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidMeasurementUpdate
     */
    description: string;
    /**
     * 
     * @type {MeasurementUpdateView}
     * @memberof InvalidMeasurementUpdate
     */
    measurement: MeasurementUpdateView;
}
/**
 * 
 * @export
 * @interface InvalidStatusToCancel
 */
export interface InvalidStatusToCancel {
    /**
     * 
     * @type {string}
     * @memberof InvalidStatusToCancel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidStatusToCancel
     */
    description: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof InvalidStatusToCancel
     */
    status: ProductionLotStatus;
}
/**
 * @type InvalidStatusToCancelOrLegacyLemmaError
 * 
 * @export
 */
export type InvalidStatusToCancelOrLegacyLemmaError = { name: 'InvalidStatusToCancel' } & InvalidStatusToCancel | { name: 'LegacyLemmaError' } & LegacyLemmaError;
/**
 * 
 * @export
 * @interface InvalidStatusTransition
 */
export interface InvalidStatusTransition {
    /**
     * 
     * @type {string}
     * @memberof InvalidStatusTransition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidStatusTransition
     */
    description: string;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof InvalidStatusTransition
     */
    id: number;
    /**
     * 
     * @type {SalesEntryItemStatus}
     * @memberof InvalidStatusTransition
     */
    status: SalesEntryItemStatus;
    /**
     * 
     * @type {SalesEntryItemStatus}
     * @memberof InvalidStatusTransition
     */
    from: SalesEntryItemStatus;
    /**
     * 
     * @type {SalesEntryItemStatus}
     * @memberof InvalidStatusTransition
     */
    to: SalesEntryItemStatus;
}
/**
 * 
 * @export
 * @interface InvalidSupplyOrderStatusTransition
 */
export interface InvalidSupplyOrderStatusTransition {
    /**
     * 
     * @type {string}
     * @memberof InvalidSupplyOrderStatusTransition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InvalidSupplyOrderStatusTransition
     */
    description: string;
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof InvalidSupplyOrderStatusTransition
     */
    supplyOrderId: number;
    /**
     * 
     * @type {InferredSupplyOrderStatus}
     * @memberof InvalidSupplyOrderStatusTransition
     */
    from: InferredSupplyOrderStatus;
    /**
     * 
     * @type {InferredSupplyOrderStatus}
     * @memberof InvalidSupplyOrderStatusTransition
     */
    to: InferredSupplyOrderStatus;
}
/**
 * @type InvalidSupplyOrderStatusTransitionOrSupplyOrderDoesNotRequireAcceptance
 * 
 * @export
 */
export type InvalidSupplyOrderStatusTransitionOrSupplyOrderDoesNotRequireAcceptance = { name: 'InvalidSupplyOrderStatusTransition' } & InvalidSupplyOrderStatusTransition | { name: 'SupplyOrderDoesNotRequireAcceptance' } & SupplyOrderDoesNotRequireAcceptance;
/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Item
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface Item1
 */
export interface Item1 {
    /**
     * RecipePieceId
     * @type {number}
     * @memberof Item1
     */
    id?: number;
    /**
     * ClientSpecificationId
     * @type {number}
     * @memberof Item1
     */
    clientSpecificationId?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof Item1
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {number}
     * @memberof Item1
     */
    amount: number;
}

/**
 * 
 * @export
 */
export const ItemKind = {
    finishedProduct: 1,
    intermediate: 2,
    rawMaterial: 3,
    service: 4,
    equipment: 5
} as const;
export type ItemKind = typeof ItemKind[keyof typeof ItemKind];

/**
 * @type ItemTypeBasicInfoSaveView
 * 
 * @export
 */
export type ItemTypeBasicInfoSaveView = { tpe: 'external' } & External | { tpe: 'internal' } & Internal | { tpe: 'new' } & New;
/**
 * 
 * @export
 * @interface ItemTypeFootprint
 */
export interface ItemTypeFootprint {
    /**
     * UserId
     * @type {number}
     * @memberof ItemTypeFootprint
     */
    userId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeFootprint
     */
    updateFromErp: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypeHistoryView
 */
export interface ItemTypeHistoryView {
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ItemTypeHistoryView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeHistoryView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeHistoryView
     */
    unitType: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeHistoryView
     */
    secondaryUnitTypes?: Array<string>;
    /**
     * 
     * @type {VatRateView}
     * @memberof ItemTypeHistoryView
     */
    salesVat?: VatRateView;
    /**
     * 
     * @type {VatRateView}
     * @memberof ItemTypeHistoryView
     */
    purchaseVat?: VatRateView;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeHistoryView
     */
    salesVatPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeHistoryView
     */
    purchaseVatPercentage?: number;
    /**
     * 
     * @type {Array<ItemTypeTagView>}
     * @memberof ItemTypeHistoryView
     */
    itemTypeTags?: Array<ItemTypeTagView>;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeHistoryView
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeHistoryView
     */
    catalogNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeHistoryView
     */
    internal: boolean;
    /**
     * 
     * @type {ItemTypeStatus}
     * @memberof ItemTypeHistoryView
     */
    status: ItemTypeStatus;
    /**
     * 
     * @type {ItemKind}
     * @memberof ItemTypeHistoryView
     */
    kind: ItemKind;
    /**
     * 
     * @type {Array<ItemTypePropertyView>}
     * @memberof ItemTypeHistoryView
     */
    properties?: Array<ItemTypePropertyView>;
    /**
     * 
     * @type {Array<ItemTypeParameterView>}
     * @memberof ItemTypeHistoryView
     */
    parameters?: Array<ItemTypeParameterView>;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeHistoryView
     */
    ean?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeHistoryView
     */
    isSimpleType: boolean;
    /**
     * 
     * @type {LastModificationDataView}
     * @memberof ItemTypeHistoryView
     */
    lastModificationData?: LastModificationDataView;
    /**
     * 
     * @type {Array<PriceListEntryView>}
     * @memberof ItemTypeHistoryView
     */
    priceListEntries?: Array<PriceListEntryView>;
}
/**
 * 
 * @export
 * @interface ItemTypeParameterView
 */
export interface ItemTypeParameterView {
    /**
     * 
     * @type {ItemTypePropertyTypeView}
     * @memberof ItemTypeParameterView
     */
    itemTypeViewPropertyType: ItemTypePropertyTypeView;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeParameterView
     */
    fromErp: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypePricingSaveView
 */
export interface ItemTypePricingSaveView {
    /**
     * VatRateId
     * @type {number}
     * @memberof ItemTypePricingSaveView
     */
    vat?: number;
    /**
     * 
     * @type {Array<PriceListEntrySavingView>}
     * @memberof ItemTypePricingSaveView
     */
    entries?: Array<PriceListEntrySavingView>;
}
/**
 * 
 * @export
 * @interface ItemTypeProperty
 */
export interface ItemTypeProperty {
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof ItemTypeProperty
     */
    itemTypePropertyType: ItemTypePropertyType;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeProperty
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeProperty
     */
    fromErp: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypePropertyFilterRange
 */
export interface ItemTypePropertyFilterRange {
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof ItemTypePropertyFilterRange
     */
    value: FilterRangeBigDecimal;
    /**
     * 
     * @type {number}
     * @memberof ItemTypePropertyFilterRange
     */
    propertyType: number;
}
/**
 * 
 * @export
 * @interface ItemTypePropertyFilterStringValue
 */
export interface ItemTypePropertyFilterStringValue {
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyFilterStringValue
     */
    value: string;
    /**
     * 
     * @type {number}
     * @memberof ItemTypePropertyFilterStringValue
     */
    propertyType: number;
}
/**
 * 
 * @export
 * @interface ItemTypePropertySaveView
 */
export interface ItemTypePropertySaveView {
    /**
     * ItemTypePropertyTypeId
     * @type {number}
     * @memberof ItemTypePropertySaveView
     */
    propertyType: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertySaveView
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface ItemTypePropertySet
 */
export interface ItemTypePropertySet {
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof ItemTypePropertySet
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertySet
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ItemTypePropertySet
     */
    defaultItemTypeVariantsId?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ItemTypePropertySet
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertySet
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertySet
     */
    itemTypeTag?: string;
    /**
     * 
     * @type {Array<ItemTypeProperty>}
     * @memberof ItemTypePropertySet
     */
    itemTypeProperties?: Array<ItemTypeProperty>;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypePropertySet
     */
    isActive: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypePropertySetListView
 */
export interface ItemTypePropertySetListView {
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof ItemTypePropertySetListView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertySetListView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertySetListView
     */
    itemTypeTag?: string;
    /**
     * 
     * @type {number}
     * @memberof ItemTypePropertySetListView
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertySetListView
     */
    unitType: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypePropertySetListView
     */
    isActive: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypePropertyType
 */
export interface ItemTypePropertyType {
    /**
     * ItemTypePropertyTypeId
     * @type {number}
     * @memberof ItemTypePropertyType
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyType
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyType
     */
    regex?: string;
    /**
     * 
     * @type {PropertyType}
     * @memberof ItemTypePropertyType
     */
    propertyType: PropertyType;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypePropertyType
     */
    exposeWithPossibleValues?: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypePropertyTypeRow
 */
export interface ItemTypePropertyTypeRow {
    /**
     * ItemTypePropertyTypeId
     * @type {number}
     * @memberof ItemTypePropertyTypeRow
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyTypeRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyTypeRow
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyTypeRow
     */
    regex?: string;
    /**
     * 
     * @type {PropertyType}
     * @memberof ItemTypePropertyTypeRow
     */
    propertyType: PropertyType;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypePropertyTypeRow
     */
    exposeWithPossibleValues: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypePropertyTypeView
 */
export interface ItemTypePropertyTypeView {
    /**
     * ItemTypePropertyTypeId
     * @type {number}
     * @memberof ItemTypePropertyTypeView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyTypeView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyTypeView
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyTypeView
     */
    regex?: string;
    /**
     * 
     * @type {PropertyType}
     * @memberof ItemTypePropertyTypeView
     */
    propertyType: PropertyType;
}
/**
 * 
 * @export
 * @interface ItemTypePropertyTypeWithValuesView
 */
export interface ItemTypePropertyTypeWithValuesView {
    /**
     * ItemTypePropertyTypeId
     * @type {number}
     * @memberof ItemTypePropertyTypeWithValuesView
     */
    propertyId: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyTypeWithValuesView
     */
    propertyName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypePropertyTypeWithValuesView
     */
    possibleValues?: Array<string>;
}
/**
 * 
 * @export
 * @interface ItemTypePropertyView
 */
export interface ItemTypePropertyView {
    /**
     * 
     * @type {ItemTypePropertyTypeView}
     * @memberof ItemTypePropertyView
     */
    itemTypeViewPropertyType: ItemTypePropertyTypeView;
    /**
     * 
     * @type {string}
     * @memberof ItemTypePropertyView
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypePropertyView
     */
    fromErp: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypeSavingView
 */
export interface ItemTypeSavingView {
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ItemTypeSavingView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeSavingView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeSavingView
     */
    unitType: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeSavingView
     */
    secondaryUnitTypes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeSavingView
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeSavingView
     */
    catalogNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeSavingView
     */
    internal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeSavingView
     */
    isSimpleType: boolean;
    /**
     * 
     * @type {Array<ItemTypeTag>}
     * @memberof ItemTypeSavingView
     */
    itemTypeTags?: Array<ItemTypeTag>;
    /**
     * 
     * @type {Array<ItemTypePropertyView>}
     * @memberof ItemTypeSavingView
     */
    properties?: Array<ItemTypePropertyView>;
    /**
     * 
     * @type {Array<ItemTypeParameterView>}
     * @memberof ItemTypeSavingView
     */
    parameters?: Array<ItemTypeParameterView>;
    /**
     * 
     * @type {VatRateView}
     * @memberof ItemTypeSavingView
     */
    salesVat?: VatRateView;
    /**
     * 
     * @type {VatRateView}
     * @memberof ItemTypeSavingView
     */
    purchaseVat?: VatRateView;
    /**
     * 
     * @type {Array<PriceListEntrySavingView>}
     * @memberof ItemTypeSavingView
     */
    priceListEntries?: Array<PriceListEntrySavingView>;
    /**
     * 
     * @type {ContextualDefaultItemTypeVariant}
     * @memberof ItemTypeSavingView
     */
    defaultVariant?: ContextualDefaultItemTypeVariant;
    /**
     * 
     * @type {ItemKind}
     * @memberof ItemTypeSavingView
     */
    kind: ItemKind;
}
/**
 * 
 * @export
 * @interface ItemTypeSearchCriteriaView
 */
export interface ItemTypeSearchCriteriaView {
    /**
     * 
     * @type {Array<number>}
     * @memberof ItemTypeSearchCriteriaView
     */
    ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeSearchCriteriaView
     */
    text?: string;
    /**
     * 
     * @type {Array<ItemTypePropertyView>}
     * @memberof ItemTypeSearchCriteriaView
     */
    properties?: Array<ItemTypePropertyView>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeSearchCriteriaView
     */
    commodityGroups?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeSearchCriteriaView
     */
    commodityGroupsOut?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeSearchCriteriaView
     */
    filterOutInactiveItems?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeSearchCriteriaView
     */
    filterOutSimpleItems?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeSearchCriteriaView
     */
    filterOutInternalItems?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeSearchCriteriaView
     */
    maxResults?: number;
}
/**
 * 
 * @export
 * @interface ItemTypeServiceSavingView
 */
export interface ItemTypeServiceSavingView {
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ItemTypeServiceSavingView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeServiceSavingView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeServiceSavingView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeServiceSavingView
     */
    netValue: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeServiceSavingView
     */
    currency: string;
    /**
     * VatRateId
     * @type {number}
     * @memberof ItemTypeServiceSavingView
     */
    vatRateId?: number;
}
/**
 * 
 * @export
 * @interface ItemTypeServiceView
 */
export interface ItemTypeServiceView {
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ItemTypeServiceView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeServiceView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeServiceView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeServiceView
     */
    netValue?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeServiceView
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeServiceView
     */
    vatRate?: string;
}

/**
 * 
 * @export
 */
export const ItemTypeStatus = {
    draft: 1,
    active: 2,
    inactive: 3
} as const;
export type ItemTypeStatus = typeof ItemTypeStatus[keyof typeof ItemTypeStatus];

/**
 * 
 * @export
 * @interface ItemTypeTag
 */
export interface ItemTypeTag {
    /**
     * ItemTypeTagId
     * @type {number}
     * @memberof ItemTypeTag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTag
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeTag
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypeTagListView
 */
export interface ItemTypeTagListView {
    /**
     * ItemTypeTagId
     * @type {number}
     * @memberof ItemTypeTagListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTagListView
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeTagListView
     */
    isActive: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypeTagView
 */
export interface ItemTypeTagView {
    /**
     * ItemTypeTagId
     * @type {number}
     * @memberof ItemTypeTagView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTagView
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeTagView
     */
    isActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeTagView
     */
    fromErp: boolean;
}
/**
 * 
 * @export
 * @interface ItemTypeTotalStockListView
 */
export interface ItemTypeTotalStockListView {
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ItemTypeTotalStockListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    catalogNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeTotalStockListView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    unitType: string;
    /**
     * 
     * @type {ItemTypeStatus}
     * @memberof ItemTypeTotalStockListView
     */
    status: ItemTypeStatus;
    /**
     * 
     * @type {ItemKind}
     * @memberof ItemTypeTotalStockListView
     */
    kind: ItemKind;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeTotalStockListView
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    propertiesValues: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    variantsNames: string;
    /**
     * Keys are strings representing property type names
     * @type {{ [key: string]: PropertyValue; }}
     * @memberof ItemTypeTotalStockListView
     */
    properties: { [key: string]: PropertyValue; };
    /**
     * 
     * @type {Array<TechnologyView>}
     * @memberof ItemTypeTotalStockListView
     */
    technologies?: Array<TechnologyView>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ItemTypeTotalStockListView
     */
    technologyIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeTotalStockListView
     */
    technologyNames?: Array<string>;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof ItemTypeTotalStockListView
     */
    technologiesActive?: Array<boolean>;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeTotalStockListView
     */
    noTechnologies: boolean;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeTotalStockListView
     */
    variantsCount: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    ean?: string;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeTotalStockListView
     */
    minimalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeTotalStockListView
     */
    minimalAmountPercentageFilled?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeTotalStockListView
     */
    defaultPlaceName?: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof ItemTypeTotalStockListView
     */
    defaultPlaceId?: number;
}
/**
 * 
 * @export
 * @interface ItemTypeVariant
 */
export interface ItemTypeVariant {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ItemTypeVariant
     */
    id?: number;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ItemTypeVariant
     */
    itemTypeId: number;
    /**
     * 
     * @type {Array<ItemTypeProperty>}
     * @memberof ItemTypeVariant
     */
    properties?: Array<ItemTypeProperty>;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeVariant
     */
    minimalAmount?: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof ItemTypeVariant
     */
    defaultPlace?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeVariant
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariant
     */
    itemTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariant
     */
    variantName?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariant
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariant
     */
    shortName?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariant
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ItemTypeVariantListView
 */
export interface ItemTypeVariantListView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ItemTypeVariantListView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantListView
     */
    itemTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantListView
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantListView
     */
    variantName?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantListView
     */
    comboNameSearch: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeVariantListView
     */
    variantActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantListView
     */
    catalogNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantListView
     */
    propertiesString?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeVariantListView
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {ItemKind}
     * @memberof ItemTypeVariantListView
     */
    kind: ItemKind;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ItemTypeVariantListView
     */
    itemTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantListView
     */
    unitType: string;
    /**
     * 
     * @type {VatRateView}
     * @memberof ItemTypeVariantListView
     */
    salesVatView?: VatRateView;
    /**
     * 
     * @type {Array<PriceListEntryView>}
     * @memberof ItemTypeVariantListView
     */
    priceListEntries?: Array<PriceListEntryView>;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeVariantListView
     */
    availableAmount: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantListView
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeVariantListView
     */
    isAvailable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeVariantListView
     */
    isInternal: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeVariantListView
     */
    secondaryUnitTypes?: Array<string>;
}
/**
 * 
 * @export
 * @interface ItemTypeVariantPiece
 */
export interface ItemTypeVariantPiece {
    /**
     * PiecesProductSpecificationPieceId
     * @type {number}
     * @memberof ItemTypeVariantPiece
     */
    id?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ItemTypeVariantPiece
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantPiece
     */
    itemTypeVariantName?: string;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeVariantPiece
     */
    amount: number;
    /**
     * CostEntryId
     * @type {number}
     * @memberof ItemTypeVariantPiece
     */
    costEntryId?: number;
    /**
     * 
     * @type {PieceType}
     * @memberof ItemTypeVariantPiece
     */
    pieceType: PieceType;
}
/**
 * 
 * @export
 * @interface ItemTypeVariantResult
 */
export interface ItemTypeVariantResult {
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof ItemTypeVariantResult
     */
    itemTypeVariant: ItemTypeVariant;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof ItemTypeVariantResult
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface ItemTypeVariantWithPropertySetListView
 */
export interface ItemTypeVariantWithPropertySetListView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ItemTypeVariantWithPropertySetListView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantWithPropertySetListView
     */
    itemTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantWithPropertySetListView
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantWithPropertySetListView
     */
    variantName?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeVariantWithPropertySetListView
     */
    catalogNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeVariantWithPropertySetListView
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeVariantWithPropertySetListView
     */
    matchingPropertySets?: Array<string>;
}
/**
 * 
 * @export
 * @interface ItemTypeView
 */
export interface ItemTypeView {
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ItemTypeView
     */
    id?: number;
    /**
     * 
     * @type {ExternalIdView}
     * @memberof ItemTypeView
     */
    externalId?: ExternalIdView;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeView
     */
    unitType: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemTypeView
     */
    secondaryUnitTypes?: Array<string>;
    /**
     * 
     * @type {VatRateView}
     * @memberof ItemTypeView
     */
    salesVat?: VatRateView;
    /**
     * 
     * @type {VatRateView}
     * @memberof ItemTypeView
     */
    purchaseVat?: VatRateView;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeView
     */
    salesVatPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeView
     */
    purchaseVatPercentage?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeView
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeView
     */
    catalogNumber?: string;
    /**
     * 
     * @type {Array<ItemTypeTagView>}
     * @memberof ItemTypeView
     */
    itemTypeTags?: Array<ItemTypeTagView>;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeView
     */
    internal: boolean;
    /**
     * 
     * @type {ItemTypeStatus}
     * @memberof ItemTypeView
     */
    status: ItemTypeStatus;
    /**
     * 
     * @type {ItemKind}
     * @memberof ItemTypeView
     */
    kind: ItemKind;
    /**
     * 
     * @type {Array<ItemTypePropertyView>}
     * @memberof ItemTypeView
     */
    properties?: Array<ItemTypePropertyView>;
    /**
     * 
     * @type {Array<ItemTypeParameterView>}
     * @memberof ItemTypeView
     */
    parameters?: Array<ItemTypeParameterView>;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeView
     */
    ean?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ItemTypeView
     */
    isSimpleType: boolean;
    /**
     * 
     * @type {LastModificationDataView}
     * @memberof ItemTypeView
     */
    lastModificationData?: LastModificationDataView;
    /**
     * 
     * @type {Array<PriceListEntryView>}
     * @memberof ItemTypeView
     */
    priceListEntries?: Array<PriceListEntryView>;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeView
     */
    variantsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemTypeView
     */
    singleVariantMinimalAmount?: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof ItemTypeView
     */
    singleVariantDefaultPlace?: number;
    /**
     * 
     * @type {string}
     * @memberof ItemTypeView
     */
    singleVariantDefaultPlaceName?: string;
}
/**
 * 
 * @export
 * @interface ItemTypeWithTemplateSavingView
 */
export interface ItemTypeWithTemplateSavingView {
    /**
     * 
     * @type {ItemTypeSavingView}
     * @memberof ItemTypeWithTemplateSavingView
     */
    itemType: ItemTypeSavingView;
    /**
     * 
     * @type {SpecificationTemplateWithItemTypeSavingView}
     * @memberof ItemTypeWithTemplateSavingView
     */
    template: SpecificationTemplateWithItemTypeSavingView;
}
/**
 * 
 * @export
 * @interface ItemUnderMinimalAmountViewRow
 */
export interface ItemUnderMinimalAmountViewRow {
    /**
     * 
     * @type {number}
     * @memberof ItemUnderMinimalAmountViewRow
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof ItemUnderMinimalAmountViewRow
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ItemUnderMinimalAmountViewRow
     */
    minimalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ItemUnderMinimalAmountViewRow
     */
    shortfall: number;
    /**
     * 
     * @type {string}
     * @memberof ItemUnderMinimalAmountViewRow
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof ItemUnderMinimalAmountViewRow
     */
    occurrenceOfStockUnderMinAmount: string;
}
/**
 * 
 * @export
 * @interface JsError
 */
export interface JsError {
    /**
     * 
     * @type {Array<Tuple2JsPathSeqJsonValidationError>}
     * @memberof JsError
     */
    errors?: Array<Tuple2JsPathSeqJsonValidationError>;
}
/**
 * 
 * @export
 * @interface JsObject
 */
export interface JsObject {
    /**
     * 
     * @type {string}
     * @memberof JsObject
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof JsObject
     */
    fullscreen: boolean;
    /**
     * 
     * @type {any}
     * @memberof JsObject
     */
    params: any | null;
}
/**
 * 
 * @export
 * @interface JsObject2
 */
export interface JsObject2 {
    /**
     * 
     * @type {any}
     * @memberof JsObject2
     */
    messages: any | null;
}
/**
 * 
 * @export
 * @interface JsObject3
 */
export interface JsObject3 {
    /**
     * 
     * @type {any}
     * @memberof JsObject3
     */
    value: any | null;
}
/**
 * 
 * @export
 * @interface JsPath
 */
export interface JsPath {
    /**
     * 
     * @type {Array<PathNode>}
     * @memberof JsPath
     */
    path?: Array<PathNode>;
}
/**
 * 
 * @export
 * @interface JsonValidationError
 */
export interface JsonValidationError {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonValidationError
     */
    messages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonValidationError
     */
    args?: Array<string>;
}
/**
 * 
 * @export
 * @interface KanbanBatch
 */
export interface KanbanBatch {
    /**
     * 
     * @type {Array<KanbanTile>}
     * @memberof KanbanBatch
     */
    lots?: Array<KanbanTile>;
    /**
     * BatchId
     * @type {number}
     * @memberof KanbanBatch
     */
    batchId?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanBatch
     */
    ordinal: number;
}
/**
 * 
 * @export
 * @interface KanbanCounts
 */
export interface KanbanCounts {
    /**
     * 
     * @type {KanbanCountsByStatus}
     * @memberof KanbanCounts
     */
    totalInBase: KanbanCountsByStatus;
    /**
     * 
     * @type {KanbanCountsByStatus}
     * @memberof KanbanCounts
     */
    filtered: KanbanCountsByStatus;
}
/**
 * 
 * @export
 * @interface KanbanCountsByStatus
 */
export interface KanbanCountsByStatus {
    /**
     * 
     * @type {number}
     * @memberof KanbanCountsByStatus
     */
    toSpec: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanCountsByStatus
     */
    specified: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanCountsByStatus
     */
    planned: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanCountsByStatus
     */
    inProduction: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanCountsByStatus
     */
    inWarehouse: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanCountsByStatus
     */
    done: number;
}
/**
 * 
 * @export
 * @interface KanbanFilterData
 */
export interface KanbanFilterData {
    /**
     * 
     * @type {Array<number>}
     * @memberof KanbanFilterData
     */
    workers?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof KanbanFilterData
     */
    machines?: Array<number>;
    /**
     * 
     * @type {Array<Array<MachineRequirementView>>}
     * @memberof KanbanFilterData
     */
    machinesRequirements?: Array<Array<MachineRequirementView>>;
    /**
     * 
     * @type {Array<ProductionLotStatus>}
     * @memberof KanbanFilterData
     */
    statuses?: Array<ProductionLotStatus>;
    /**
     * 
     * @type {Array<ProductionSpecificationStatus>}
     * @memberof KanbanFilterData
     */
    specificationStatuses?: Array<ProductionSpecificationStatus>;
    /**
     * 
     * @type {Array<string>}
     * @memberof KanbanFilterData
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof KanbanFilterData
     */
    itemTypeVariantIds?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof KanbanFilterData
     */
    ordinal?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof KanbanFilterData
     */
    contractors?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof KanbanFilterData
     */
    itemTypeNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof KanbanFilterData
     */
    orderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanFilterData
     */
    buyerOrderNumber?: string;
    /**
     * 
     * @type {OptionalDateRange}
     * @memberof KanbanFilterData
     */
    dueDateRange?: OptionalDateRange;
    /**
     * 
     * @type {Array<number>}
     * @memberof KanbanFilterData
     */
    recipeTypes?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof KanbanFilterData
     */
    recipeSummary?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof KanbanFilterData
     */
    productionLotTags?: Array<number>;
    /**
     * 
     * @type {Array<ProductionLotWarning>}
     * @memberof KanbanFilterData
     */
    warnings?: Array<ProductionLotWarning>;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanFilterData
     */
    isChild?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanFilterData
     */
    hasChildren?: boolean;
    /**
     * 
     * @type {Array<DemandStatus>}
     * @memberof KanbanFilterData
     */
    demandStatus?: Array<DemandStatus>;
}
/**
 * 
 * @export
 * @interface KanbanFilterDefinition
 */
export interface KanbanFilterDefinition {
    /**
     * 
     * @type {KanbanFilterData}
     * @memberof KanbanFilterDefinition
     */
    data: KanbanFilterData;
    /**
     * 
     * @type {KanbanFilterSlicing}
     * @memberof KanbanFilterDefinition
     */
    slicing?: KanbanFilterSlicing;
    /**
     * 
     * @type {number}
     * @memberof KanbanFilterDefinition
     */
    id?: number;
    /**
     * 
     * @type {KanbanFilterData}
     * @memberof KanbanFilterDefinition
     */
    originalData?: KanbanFilterData;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanFilterDefinition
     */
    onlyCounts?: boolean;
}
/**
 * 
 * @export
 * @interface KanbanFilterDefinition1
 */
export interface KanbanFilterDefinition1 {
    /**
     * 
     * @type {KanbanFilterData}
     * @memberof KanbanFilterDefinition1
     */
    data: KanbanFilterData;
    /**
     * 
     * @type {KanbanFilterSlicing}
     * @memberof KanbanFilterDefinition1
     */
    slicing?: KanbanFilterSlicing;
    /**
     * 
     * @type {number}
     * @memberof KanbanFilterDefinition1
     */
    id?: number;
    /**
     * 
     * @type {KanbanFilterData}
     * @memberof KanbanFilterDefinition1
     */
    originalData?: KanbanFilterData;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanFilterDefinition1
     */
    onlyCounts?: boolean;
    /**
     * 
     * @type {KanbanWebsocketOutputType}
     * @memberof KanbanFilterDefinition1
     */
    outputType: KanbanWebsocketOutputType;
}
/**
 * 
 * @export
 * @interface KanbanFilterResult
 */
export interface KanbanFilterResult {
    /**
     * 
     * @type {KanbanFilterDefinition}
     * @memberof KanbanFilterResult
     */
    filter: KanbanFilterDefinition;
    /**
     * 
     * @type {KanbanResult}
     * @memberof KanbanFilterResult
     */
    result: KanbanResult;
    /**
     * 
     * @type {KanbanWebsocketOutputType}
     * @memberof KanbanFilterResult
     */
    outputType: KanbanWebsocketOutputType;
}
/**
 * 
 * @export
 * @interface KanbanFilterSlicing
 */
export interface KanbanFilterSlicing {
    /**
     * 
     * @type {number}
     * @memberof KanbanFilterSlicing
     */
    lastOrdinal: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof KanbanFilterSlicing
     */
    lastLotId: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanFilterSlicing
     */
    take: number;
}
/**
 * 
 * @export
 * @interface KanbanGroupedByStatus
 */
export interface KanbanGroupedByStatus {
    /**
     * 
     * @type {Array<KanbanGrouping>}
     * @memberof KanbanGroupedByStatus
     */
    toSpec?: Array<KanbanGrouping>;
    /**
     * 
     * @type {Array<KanbanGrouping>}
     * @memberof KanbanGroupedByStatus
     */
    specified?: Array<KanbanGrouping>;
    /**
     * 
     * @type {Array<KanbanGrouping>}
     * @memberof KanbanGroupedByStatus
     */
    planned?: Array<KanbanGrouping>;
    /**
     * 
     * @type {Array<KanbanGrouping>}
     * @memberof KanbanGroupedByStatus
     */
    inProduction?: Array<KanbanGrouping>;
    /**
     * 
     * @type {Array<KanbanGrouping>}
     * @memberof KanbanGroupedByStatus
     */
    inWarehouse?: Array<KanbanGrouping>;
    /**
     * 
     * @type {Array<KanbanGrouping>}
     * @memberof KanbanGroupedByStatus
     */
    done?: Array<KanbanGrouping>;
}
/**
 * @type KanbanGrouping
 * 
 * @export
 */
export type KanbanGrouping = KanbanGroupingOneOf | KanbanGroupingOneOf1 | KanbanGroupingOneOf2;
/**
 * 
 * @export
 * @interface KanbanGroupingOneOf
 */
export interface KanbanGroupingOneOf {
    /**
     * 
     * @type {KanbanBatch}
     * @memberof KanbanGroupingOneOf
     */
    kanbanBatch: KanbanBatch;
}
/**
 * 
 * @export
 * @interface KanbanGroupingOneOf1
 */
export interface KanbanGroupingOneOf1 {
    /**
     * 
     * @type {KanbanTile}
     * @memberof KanbanGroupingOneOf1
     */
    kanbanTile: KanbanTile;
}
/**
 * 
 * @export
 * @interface KanbanGroupingOneOf2
 */
export interface KanbanGroupingOneOf2 {
    /**
     * 
     * @type {MachineBatches}
     * @memberof KanbanGroupingOneOf2
     */
    machineBatches: MachineBatches;
}
/**
 * 
 * @export
 * @interface KanbanResult
 */
export interface KanbanResult {
    /**
     * 
     * @type {KanbanGroupedByStatus}
     * @memberof KanbanResult
     */
    data: KanbanGroupedByStatus;
    /**
     * 
     * @type {KanbanCounts}
     * @memberof KanbanResult
     */
    counts: KanbanCounts;
    /**
     * 
     * @type {number}
     * @memberof KanbanResult
     */
    total: number;
}
/**
 * 
 * @export
 * @interface KanbanTile
 */
export interface KanbanTile {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof KanbanTile
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    productionLotNumber?: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof KanbanTile
     */
    productionLotStatus: ProductionLotStatus;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTile
     */
    productionLotAccepted: boolean;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    productionLotOrdinal?: number;
    /**
     * 
     * @type {LegacyProductionOrderStatus}
     * @memberof KanbanTile
     */
    productionOrderStatus: LegacyProductionOrderStatus;
    /**
     * 
     * @type {ProductionSpecificationStatus}
     * @memberof KanbanTile
     */
    productionSpecificationStatus?: ProductionSpecificationStatus;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof KanbanTile
     */
    itemTypeId: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof KanbanTile
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    itemTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    orderedUnitType: string;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof KanbanTile
     */
    orderId?: number;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    buyerOrderNumber?: string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof KanbanTile
     */
    orderStatus?: OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    buyerName?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof KanbanTile
     */
    buyerId?: number;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof KanbanTile
     */
    orderItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    orderItemAmount?: number;
    /**
     * 
     * @type {SalesEntryItemStatus}
     * @memberof KanbanTile
     */
    orderItemStatus?: SalesEntryItemStatus;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    orderItemDueDate?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    orderedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    productAmount: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    recipeAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    reportedRecipeAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    recipeUnitType?: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    recipeSummary?: string;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    recipeType?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    packagingType?: number;
    /**
     * MachineId
     * @type {number}
     * @memberof KanbanTile
     */
    machineId?: number;
    /**
     * UserId
     * @type {number}
     * @memberof KanbanTile
     */
    workerId?: number;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    workerName?: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    initiatorName?: string;
    /**
     * BatchId
     * @type {number}
     * @memberof KanbanTile
     */
    batchId?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    batchSize?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    batchOrdinal?: number;
    /**
     * 
     * @type {QualityStatus}
     * @memberof KanbanTile
     */
    qualityStatus?: QualityStatus;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTile
     */
    qualityReportAccepted: boolean;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    productionEndDate?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    productionStartDate?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    estimatedProductionDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    estimatedStartDate?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    estimatedEndDate?: number;
    /**
     * 
     * @type {EstimationStatus}
     * @memberof KanbanTile
     */
    estimationStatus?: EstimationStatus;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    productionPlanDueDate?: number;
    /**
     * MachineSpecificationId
     * @type {number}
     * @memberof KanbanTile
     */
    machinesSpecificationId?: number;
    /**
     * 
     * @type {Array<MachineRequirementView>}
     * @memberof KanbanTile
     */
    machinesRequirements?: Array<MachineRequirementView>;
    /**
     * 
     * @type {string}
     * @memberof KanbanTile
     */
    physicalParameters?: string;
    /**
     * 
     * @type {DemandStatus}
     * @memberof KanbanTile
     */
    demandStatus: DemandStatus;
    /**
     * 
     * @type {Array<ProductionLotWarning>}
     * @memberof KanbanTile
     */
    warnings?: Array<ProductionLotWarning>;
    /**
     * 
     * @type {Array<ProductionLotTag>}
     * @memberof KanbanTile
     */
    tags?: Array<ProductionLotTag>;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTile
     */
    isChild: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTile
     */
    hasChildren: boolean;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    consecutiveOrdinal?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTile
     */
    orderDueDate?: number;
}
/**
 * @type KanbanWebsocketOutput
 * 
 * @export
 */
export type KanbanWebsocketOutput = { outputType: '1' } & BoardAdd | { outputType: '2' } & BoardRemove | { outputType: '3' } & BoardUpdates | { outputType: '4' } & TotalCounts | { outputType: '5' } & KanbanFilterDefinition1 | { outputType: '7' } & KanbanFilterResult;

/**
 * 
 * @export
 */
export const KanbanWebsocketOutputType = {
    add: 1,
    remove: 2,
    update: 3,
    counts: 4,
    filter: 5,
    ping: 6,
    filterResult: 7,
    boardChanges: 8
} as const;
export type KanbanWebsocketOutputType = typeof KanbanWebsocketOutputType[keyof typeof KanbanWebsocketOutputType];

/**
 * 
 * @export
 * @interface KeyPathNode
 */
export interface KeyPathNode {
    /**
     * 
     * @type {string}
     * @memberof KeyPathNode
     */
    key: string;
}
/**
 * 
 * @export
 * @interface LabelDimensionsView
 */
export interface LabelDimensionsView {
    /**
     * 
     * @type {number}
     * @memberof LabelDimensionsView
     */
    labelSizeAcrossRibbon?: number;
    /**
     * 
     * @type {number}
     * @memberof LabelDimensionsView
     */
    labelSizeAlongRibbon?: number;
}
/**
 * 
 * @export
 * @interface LabelEditabilityView
 */
export interface LabelEditabilityView {
    /**
     * 
     * @type {LabelView}
     * @memberof LabelEditabilityView
     */
    view: LabelView;
    /**
     * 
     * @type {LabelInputPropertiesEditability}
     * @memberof LabelEditabilityView
     */
    editability: LabelInputPropertiesEditability;
}
/**
 * 
 * @export
 * @interface LabelInputPropertiesEditability
 */
export interface LabelInputPropertiesEditability {
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    productName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    catalogNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    productionDate: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    ean: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    producedBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    batchNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty1: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty2: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty3: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty4: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty5: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty6: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty7: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty8: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty9: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty10: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty11: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty12: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty13: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty14: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelInputPropertiesEditability
     */
    labelProperty15: boolean;
}
/**
 * 
 * @export
 * @interface LabelProperty
 */
export interface LabelProperty {
    /**
     * 
     * @type {string}
     * @memberof LabelProperty
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof LabelProperty
     */
    value: string;
}
/**
 * 
 * @export
 * @interface LabelView
 */
export interface LabelView {
    /**
     * 
     * @type {number}
     * @memberof LabelView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof LabelView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof LabelView
     */
    catalogNumber: string;
    /**
     * 
     * @type {string}
     * @memberof LabelView
     */
    productionDate: string;
    /**
     * 
     * @type {string}
     * @memberof LabelView
     */
    ean: string;
    /**
     * 
     * @type {string}
     * @memberof LabelView
     */
    producedBy: string;
    /**
     * 
     * @type {string}
     * @memberof LabelView
     */
    batchNumber: string;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty1?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty2?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty3?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty4?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty5?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty6?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty7?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty8?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty9?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty10?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty11?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty12?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty13?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty14?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof LabelView
     */
    labelProperty15?: LabelProperty;
}
/**
 * 
 * @export
 * @interface LabelsPackaging
 */
export interface LabelsPackaging {
    /**
     * PackagingId
     * @type {number}
     * @memberof LabelsPackaging
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LabelsPackaging
     */
    windingType: string;
    /**
     * 
     * @type {string}
     * @memberof LabelsPackaging
     */
    casingDiameter?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LabelsPackaging
     */
    numerationIncluded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LabelsPackaging
     */
    shouldBeScrolled: boolean;
    /**
     * 
     * @type {Array<PackagingIngredient>}
     * @memberof LabelsPackaging
     */
    ingredients?: Array<PackagingIngredient>;
    /**
     * 
     * @type {number}
     * @memberof LabelsPackaging
     */
    packagingType: number;
}
/**
 * 
 * @export
 * @interface Lacquering
 */
export interface Lacquering {
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof Lacquering
     */
    material: number;
}
/**
 * 
 * @export
 * @interface Lacquering1
 */
export interface Lacquering1 {
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof Lacquering1
     */
    material: PropertySetSelector;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof Lacquering1
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof Lacquering1
     */
    dosageRoller?: number;
    /**
     * 
     * @type {StepMode}
     * @memberof Lacquering1
     */
    stepMode: StepMode;
}
/**
 * 
 * @export
 * @interface LacqueringView
 */
export interface LacqueringView {
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof LacqueringView
     */
    material: PropertySetSelectorView;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof LacqueringView
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof LacqueringView
     */
    dosageRoller?: ItemTypeVariant;
    /**
     * 
     * @type {StepMode}
     * @memberof LacqueringView
     */
    stepMode: StepMode;
    /**
     * 
     * @type {StepType}
     * @memberof LacqueringView
     */
    stepType: StepType;
}
/**
 * 
 * @export
 * @interface Lamination
 */
export interface Lamination {
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof Lamination
     */
    material: number;
}
/**
 * 
 * @export
 * @interface Lamination1
 */
export interface Lamination1 {
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof Lamination1
     */
    material: PropertySetSelector;
}
/**
 * 
 * @export
 * @interface LaminationView
 */
export interface LaminationView {
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof LaminationView
     */
    material: PropertySetSelectorView;
    /**
     * 
     * @type {StepType}
     * @memberof LaminationView
     */
    stepType: StepType;
}
/**
 * 
 * @export
 * @interface Lang
 */
export interface Lang {
    /**
     * 
     * @type {string}
     * @memberof Lang
     */
    locale: string;
}
/**
 * 
 * @export
 * @interface LastModificationDataView
 */
export interface LastModificationDataView {
    /**
     * 
     * @type {string}
     * @memberof LastModificationDataView
     */
    modificationDate: string;
    /**
     * 
     * @type {string}
     * @memberof LastModificationDataView
     */
    user?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LastModificationDataView
     */
    fromErp: boolean;
}
/**
 * 
 * @export
 * @interface LegacyLemmaError
 */
export interface LegacyLemmaError {
    /**
     * 
     * @type {string}
     * @memberof LegacyLemmaError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyLemmaError
     */
    description: string;
    /**
     * 
     * @type {JsError}
     * @memberof LegacyLemmaError
     */
    messages: JsError;
}
/**
 * @type LegacyLemmaErrorOrListOfAmbiguousPlaceDefinedOrNoPlaceDefined
 * 
 * @export
 */
export type LegacyLemmaErrorOrListOfAmbiguousPlaceDefinedOrNoPlaceDefined = { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'ListOf__AmbiguousPlaceDefined_or_NoPlaceDefined_' } & ListOfAmbiguousPlaceDefinedOrNoPlaceDefined;
/**
 * @type LegacyLemmaErrorOrListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractorOrSupplyOrderLocked
 * 
 * @export
 */
export type LegacyLemmaErrorOrListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractorOrSupplyOrderLocked = { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'ListOf__AmbiguousPlaceDefined_or_NoPlaceDefined_or_SupplyOrderHasNoContractor_' } & ListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor | { name: 'SupplyOrderLocked' } & SupplyOrderLocked;
/**
 * @type LegacyLemmaErrorOrListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups
 * 
 * @export
 */
export type LegacyLemmaErrorOrListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups = { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'ListOf__InconsistentLoadGroupLoadCards_or_InconsistentLoadGroups_' } & ListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups;
/**
 * @type LegacyLemmaErrorOrLotHasActiveDowntimeOrProductionLotNotStarted
 * 
 * @export
 */
export type LegacyLemmaErrorOrLotHasActiveDowntimeOrProductionLotNotStarted = { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotHasActiveDowntime' } & LotHasActiveDowntime | { name: 'ProductionLotNotStarted' } & LemmaSimpleErrorView;
/**
 * @type LegacyLemmaErrorOrNonUniqueVariantIdOrProductionReportNotFoundOrRecipeIsNotPieces
 * 
 * @export
 */
export type LegacyLemmaErrorOrNonUniqueVariantIdOrProductionReportNotFoundOrRecipeIsNotPieces = { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'NonUniqueVariantId' } & LemmaSimpleErrorView | { name: 'ProductionReportNotFound' } & LemmaSimpleErrorView | { name: 'RecipeIsNotPieces' } & LemmaSimpleErrorView;
/**
 * @type LegacyLemmaErrorOrSupplyOrderItemsAlreadyExists
 * 
 * @export
 */
export type LegacyLemmaErrorOrSupplyOrderItemsAlreadyExists = { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'SupplyOrderItemsAlreadyExists' } & SupplyOrderItemsAlreadyExists;
/**
 * 
 * @export
 * @interface LegacyOfferView
 */
export interface LegacyOfferView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof LegacyOfferView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    supplierNumber?: string;
    /**
     * 
     * @type {OfferStatus}
     * @memberof LegacyOfferView
     */
    status: OfferStatus;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof LegacyOfferView
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * ContractorId
     * @type {number}
     * @memberof LegacyOfferView
     */
    buyerId?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    buyerNumber?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof LegacyOfferView
     */
    recipientId?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    recipientName?: string;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof LegacyOfferView
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {DeliveryDate}
     * @memberof LegacyOfferView
     */
    deliveryDate?: DeliveryDate;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    creationDate?: string;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof LegacyOfferView
     */
    items?: Array<SalesEntryItemView>;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyOfferView
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {FieldVisibility}
     * @memberof LegacyOfferView
     */
    visibility: FieldVisibility;
    /**
     * 
     * @type {boolean}
     * @memberof LegacyOfferView
     */
    marketingRulesApplied: boolean;
    /**
     * UserId
     * @type {number}
     * @memberof LegacyOfferView
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {User}
     * @memberof LegacyOfferView
     */
    responsibleUser?: User;
    /**
     * 
     * @type {Array<OfferAnnotation>}
     * @memberof LegacyOfferView
     */
    offerAnnotations?: Array<OfferAnnotation>;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof LegacyOfferView
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof LegacyOfferView
     */
    methodOfPayment?: MethodOfPayment;
    /**
     * MethodOfPaymentId
     * @type {number}
     * @memberof LegacyOfferView
     */
    methodOfPaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    methodOfPaymentName?: string;
    /**
     * 
     * @type {SalesRate}
     * @memberof LegacyOfferView
     */
    rate: SalesRate;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyExchangeRate}
     * @memberof LegacyOfferView
     */
    exchangeRate?: CurrencyExchangeRate;
    /**
     * 
     * @type {Array<SalesEntryTag>}
     * @memberof LegacyOfferView
     */
    tags?: Array<SalesEntryTag>;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    lastViewer?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyOfferView
     */
    lastDateOfView?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyOfferView
     */
    netValue: number;
    /**
     * 
     * @type {number}
     * @memberof LegacyOfferView
     */
    attachmentCount: number;
}
/**
 * 
 * @export
 * @interface LegacyProductionLotListView
 */
export interface LegacyProductionLotListView {
    [key: string]: string | any;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof LegacyProductionLotListView
     */
    id: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof LegacyProductionLotListView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    batchNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    contractorExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof LegacyProductionLotListView
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    itemTypeUnit?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyProductionLotListView
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    machineName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegacyProductionLotListView
     */
    specificationTagsOr?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegacyProductionLotListView
     */
    specificationTagsAnd?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegacyProductionLotListView
     */
    specificationTagsColors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    specificationTaskAssignee?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    specificationTaskCreationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    specificationTaskDeadline?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    specificationTaskCompletionDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    productionEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    dueDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegacyProductionLotListView
     */
    recipeSummary?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof LegacyProductionLotListView
     */
    recipeType?: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    orderCreationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionLotListView
     */
    orderItemDeliveryDate?: string;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof LegacyProductionLotListView
     */
    orderItemId?: number;
}
/**
 * 
 * @export
 * @interface LegacyProductionOrderListView
 */
export interface LegacyProductionOrderListView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof LegacyProductionOrderListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionOrderListView
     */
    number?: string;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof LegacyProductionOrderListView
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionOrderListView
     */
    lotNumber?: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof LegacyProductionOrderListView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionOrderListView
     */
    productName: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyProductionOrderListView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionOrderListView
     */
    unitType: string;
    /**
     * 
     * @type {LegacyProductionOrderStatus}
     * @memberof LegacyProductionOrderListView
     */
    status: LegacyProductionOrderStatus;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionOrderListView
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyProductionOrderListView
     */
    creationDate: string;
}

/**
 * 
 * @export
 */
export const LegacyProductionOrderStatus = {
    draft: 1,
    accepted: 2,
    cancelled: 3,
    done: 4,
    archived: 5
} as const;
export type LegacyProductionOrderStatus = typeof LegacyProductionOrderStatus[keyof typeof LegacyProductionOrderStatus];


/**
 * 
 * @export
 */
export const LegacyReleasePlanStatus = {
    planning: 1,
    planned: 2,
    inProgress: 3,
    released: 4,
    partiallyReleased: 5
} as const;
export type LegacyReleasePlanStatus = typeof LegacyReleasePlanStatus[keyof typeof LegacyReleasePlanStatus];

/**
 * 
 * @export
 * @interface LemmaSimpleErrorView
 */
export interface LemmaSimpleErrorView {
    /**
     * 
     * @type {string}
     * @memberof LemmaSimpleErrorView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LemmaSimpleErrorView
     */
    description: string;
}

/**
 * 
 * @export
 */
export const LendingLedgerDirection = {
    borrow: 1,
    return: 2
} as const;
export type LendingLedgerDirection = typeof LendingLedgerDirection[keyof typeof LendingLedgerDirection];

/**
 * 
 * @export
 * @interface LendingLedgerEntrySaveView
 */
export interface LendingLedgerEntrySaveView {
    /**
     * UserId
     * @type {number}
     * @memberof LendingLedgerEntrySaveView
     */
    borrowerId: number;
    /**
     * StockItemId
     * @type {number}
     * @memberof LendingLedgerEntrySaveView
     */
    equipmentUnitId: number;
    /**
     * 
     * @type {LendingLedgerDirection}
     * @memberof LendingLedgerEntrySaveView
     */
    direction: LendingLedgerDirection;
    /**
     * 
     * @type {string}
     * @memberof LendingLedgerEntrySaveView
     */
    comment?: string;
    /**
     * EquipmentDemandId
     * @type {number}
     * @memberof LendingLedgerEntrySaveView
     */
    equipmentDemandId?: number;
}
/**
 * 
 * @export
 * @interface ListOfAmbiguousPlaceDefinedOrNoPlaceDefined
 */
export interface ListOfAmbiguousPlaceDefinedOrNoPlaceDefined {
    /**
     * 
     * @type {string}
     * @memberof ListOfAmbiguousPlaceDefinedOrNoPlaceDefined
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListOfAmbiguousPlaceDefinedOrNoPlaceDefined
     */
    description: string;
    /**
     * 
     * @type {Array<AmbiguousPlaceDefinedOrNoPlaceDefined>}
     * @memberof ListOfAmbiguousPlaceDefinedOrNoPlaceDefined
     */
    list: Array<AmbiguousPlaceDefinedOrNoPlaceDefined>;
}
/**
 * 
 * @export
 * @interface ListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor
 */
export interface ListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor {
    /**
     * 
     * @type {string}
     * @memberof ListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor
     */
    description: string;
    /**
     * 
     * @type {Array<AmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor>}
     * @memberof ListOfAmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor
     */
    list: Array<AmbiguousPlaceDefinedOrNoPlaceDefinedOrSupplyOrderHasNoContractor>;
}
/**
 * 
 * @export
 * @interface ListOfCalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement
 */
export interface ListOfCalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement {
    /**
     * 
     * @type {string}
     * @memberof ListOfCalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListOfCalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement
     */
    description: string;
    /**
     * 
     * @type {Array<CalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement>}
     * @memberof ListOfCalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement
     */
    list: Array<CalendarErrorOrRateDefinedOrRateNotDefinedOrValidationBeforeAchievement>;
}
/**
 * 
 * @export
 * @interface ListOfContractorNotFoundOrInvalidTaxId
 */
export interface ListOfContractorNotFoundOrInvalidTaxId {
    /**
     * 
     * @type {string}
     * @memberof ListOfContractorNotFoundOrInvalidTaxId
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListOfContractorNotFoundOrInvalidTaxId
     */
    description: string;
    /**
     * 
     * @type {Array<ContractorNotFoundOrInvalidTaxId>}
     * @memberof ListOfContractorNotFoundOrInvalidTaxId
     */
    list: Array<ContractorNotFoundOrInvalidTaxId>;
}
/**
 * 
 * @export
 * @interface ListOfExceededReportedAmountThreshold
 */
export interface ListOfExceededReportedAmountThreshold {
    /**
     * 
     * @type {string}
     * @memberof ListOfExceededReportedAmountThreshold
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListOfExceededReportedAmountThreshold
     */
    description: string;
    /**
     * 
     * @type {Array<ExceededReportedAmountThreshold>}
     * @memberof ListOfExceededReportedAmountThreshold
     */
    list: Array<ExceededReportedAmountThreshold>;
}
/**
 * 
 * @export
 * @interface ListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups
 */
export interface ListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups {
    /**
     * 
     * @type {string}
     * @memberof ListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups
     */
    description: string;
    /**
     * 
     * @type {Array<InconsistentLoadGroupLoadCardsOrInconsistentLoadGroups>}
     * @memberof ListOfInconsistentLoadGroupLoadCardsOrInconsistentLoadGroups
     */
    list: Array<InconsistentLoadGroupLoadCardsOrInconsistentLoadGroups>;
}
/**
 * 
 * @export
 * @interface LoadCardListViewOld
 */
export interface LoadCardListViewOld {
    /**
     * LoadCardId
     * @type {number}
     * @memberof LoadCardListViewOld
     */
    id: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof LoadCardListViewOld
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {boolean}
     * @memberof LoadCardListViewOld
     */
    finalized: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoadCardListViewOld
     */
    linked: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoadCardListViewOld
     */
    loadDate?: string;
}
/**
 * 
 * @export
 * @interface LoadCardSaveView
 */
export interface LoadCardSaveView {
    /**
     * LoadCardId
     * @type {number}
     * @memberof LoadCardSaveView
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LoadCardSaveView
     */
    amount: number;
    /**
     * StockItemId
     * @type {number}
     * @memberof LoadCardSaveView
     */
    productionUnitId: number;
}
/**
 * 
 * @export
 * @interface LoadCardView
 */
export interface LoadCardView {
    /**
     * LoadCardId
     * @type {number}
     * @memberof LoadCardView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof LoadCardView
     */
    amount: number;
    /**
     * StockItemId
     * @type {number}
     * @memberof LoadCardView
     */
    productionUnitId: number;
    /**
     * 
     * @type {string}
     * @memberof LoadCardView
     */
    productionUnitNumber: string;
    /**
     * 
     * @type {number}
     * @memberof LoadCardView
     */
    usedAmount: number;
}
/**
 * @type LoadGroupSaveView
 * 
 * @export
 */
export type LoadGroupSaveView = { groupType: '1' } & LoadGroupWithAmountSaveView | { groupType: '2' } & LoadGroupWithLoadCardsSaveView;

/**
 * 
 * @export
 */
export const LoadGroupType = {
    WithAmount: 1,
    WithLoadCards: 2
} as const;
export type LoadGroupType = typeof LoadGroupType[keyof typeof LoadGroupType];

/**
 * @type LoadGroupView
 * 
 * @export
 */
export type LoadGroupView = { groupType: '1' } & LoadGroupWithAmountView | { groupType: '2' } & LoadGroupWithLoadCardsView;
/**
 * 
 * @export
 * @interface LoadGroupWithAmountSaveView
 */
export interface LoadGroupWithAmountSaveView {
    /**
     * 
     * @type {number}
     * @memberof LoadGroupWithAmountSaveView
     */
    amount: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof LoadGroupWithAmountSaveView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {LoadGroupType}
     * @memberof LoadGroupWithAmountSaveView
     */
    groupType: LoadGroupType;
}
/**
 * 
 * @export
 * @interface LoadGroupWithAmountView
 */
export interface LoadGroupWithAmountView {
    /**
     * 
     * @type {number}
     * @memberof LoadGroupWithAmountView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof LoadGroupWithAmountView
     */
    itemTypeVariantName: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof LoadGroupWithAmountView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof LoadGroupWithAmountView
     */
    itemTypeExternalId?: string;
    /**
     * 
     * @type {number}
     * @memberof LoadGroupWithAmountView
     */
    requiredAmount: number;
    /**
     * 
     * @type {number}
     * @memberof LoadGroupWithAmountView
     */
    usedAmount: number;
    /**
     * 
     * @type {string}
     * @memberof LoadGroupWithAmountView
     */
    unitType: string;
    /**
     * 
     * @type {LoadGroupType}
     * @memberof LoadGroupWithAmountView
     */
    groupType: LoadGroupType;
}
/**
 * 
 * @export
 * @interface LoadGroupWithLoadCardsSaveView
 */
export interface LoadGroupWithLoadCardsSaveView {
    /**
     * 
     * @type {Array<LoadCardSaveView>}
     * @memberof LoadGroupWithLoadCardsSaveView
     */
    loadCards: Array<LoadCardSaveView>;
    /**
     * 
     * @type {LoadGroupType}
     * @memberof LoadGroupWithLoadCardsSaveView
     */
    groupType: LoadGroupType;
}
/**
 * 
 * @export
 * @interface LoadGroupWithLoadCardsView
 */
export interface LoadGroupWithLoadCardsView {
    /**
     * 
     * @type {string}
     * @memberof LoadGroupWithLoadCardsView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof LoadGroupWithLoadCardsView
     */
    itemTypeExternalId?: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof LoadGroupWithLoadCardsView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {Array<LoadCardView>}
     * @memberof LoadGroupWithLoadCardsView
     */
    loadCards?: Array<LoadCardView>;
    /**
     * 
     * @type {number}
     * @memberof LoadGroupWithLoadCardsView
     */
    requiredAmount: number;
    /**
     * 
     * @type {string}
     * @memberof LoadGroupWithLoadCardsView
     */
    unitType: string;
    /**
     * 
     * @type {LoadGroupType}
     * @memberof LoadGroupWithLoadCardsView
     */
    groupType: LoadGroupType;
}
/**
 * 
 * @export
 * @interface LoadReportSaveView
 */
export interface LoadReportSaveView {
    /**
     * 
     * @type {Array<LoadGroupSaveView>}
     * @memberof LoadReportSaveView
     */
    loadCardsGroups?: Array<LoadGroupSaveView>;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof LoadReportSaveView
     */
    productionLotId: number;
}
/**
 * 
 * @export
 * @interface LoadReportView
 */
export interface LoadReportView {
    /**
     * 
     * @type {Array<LoadGroupView>}
     * @memberof LoadReportView
     */
    loadCardsGroups?: Array<LoadGroupView>;
    /**
     * 
     * @type {boolean}
     * @memberof LoadReportView
     */
    usageReported: boolean;
}
/**
 * 
 * @export
 * @interface LotAssignmentView
 */
export interface LotAssignmentView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof LotAssignmentView
     */
    lotId: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof LotAssignmentView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof LotAssignmentView
     */
    variantName: string;
    /**
     * MachineId
     * @type {number}
     * @memberof LotAssignmentView
     */
    machineId: number;
    /**
     * 
     * @type {string}
     * @memberof LotAssignmentView
     */
    machineName: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof LotAssignmentView
     */
    workerIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LotAssignmentView
     */
    workerNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LotAssignmentView
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof LotAssignmentView
     */
    endTime: string;
    /**
     * 
     * @type {WorkerSelectionContextView}
     * @memberof LotAssignmentView
     */
    selectionContext: WorkerSelectionContextView;
    /**
     * 
     * @type {Array<WorkerPickRationaleView>}
     * @memberof LotAssignmentView
     */
    workerPickRationales?: Array<WorkerPickRationaleView>;
}
/**
 * 
 * @export
 * @interface LotHasActiveDowntime
 */
export interface LotHasActiveDowntime {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof LotHasActiveDowntime
     */
    lotId: number;
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof LotHasActiveDowntime
     */
    downtimeReportId: number;
}
/**
 * 
 * @export
 * @interface LotHasNoMachineAssigned
 */
export interface LotHasNoMachineAssigned {
    /**
     * 
     * @type {string}
     * @memberof LotHasNoMachineAssigned
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LotHasNoMachineAssigned
     */
    description: string;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof LotHasNoMachineAssigned
     */
    id: number;
}
/**
 * 
 * @export
 * @interface LotIsPartOfMultiBatch
 */
export interface LotIsPartOfMultiBatch {
    /**
     * 
     * @type {string}
     * @memberof LotIsPartOfMultiBatch
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LotIsPartOfMultiBatch
     */
    description: string;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof LotIsPartOfMultiBatch
     */
    lotId: number;
    /**
     * BatchId
     * @type {number}
     * @memberof LotIsPartOfMultiBatch
     */
    batchId: number;
}
/**
 * 
 * @export
 * @interface LotNumberUpdate
 */
export interface LotNumberUpdate {
    /**
     * 
     * @type {string}
     * @memberof LotNumberUpdate
     */
    number: string;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof LotNumberUpdate
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface LotsHaveNoMachineAssigned
 */
export interface LotsHaveNoMachineAssigned {
    /**
     * 
     * @type {string}
     * @memberof LotsHaveNoMachineAssigned
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LotsHaveNoMachineAssigned
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof LotsHaveNoMachineAssigned
     */
    ids?: Array<number>;
}
/**
 * 
 * @export
 * @interface Machine
 */
export interface Machine {
    /**
     * MachineId
     * @type {number}
     * @memberof Machine
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    name: string;
    /**
     * MachineAreaId
     * @type {number}
     * @memberof Machine
     */
    areaId: number;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    tag: string;
    /**
     * 
     * @type {number}
     * @memberof Machine
     */
    costPerHour: number;
    /**
     * 
     * @type {number}
     * @memberof Machine
     */
    ordinal: number;
    /**
     * 
     * @type {Array<MachineFeature>}
     * @memberof Machine
     */
    features?: Array<MachineFeature>;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    image?: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof Machine
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Machine
     */
    useCalendarForEstimation: boolean;
    /**
     * 
     * @type {string}
     * @memberof Machine
     */
    externalModifyTime: string;
    /**
     * 
     * @type {boolean}
     * @memberof Machine
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface MachineAreaListViewRow
 */
export interface MachineAreaListViewRow {
    /**
     * MachineAreaId
     * @type {number}
     * @memberof MachineAreaListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MachineAreaListViewRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MachineAreaListViewRow
     */
    hexColor: string;
    /**
     * 
     * @type {string}
     * @memberof MachineAreaListViewRow
     */
    externalId?: string;
}
/**
 * 
 * @export
 * @interface MachineAssignmentsGroupView
 */
export interface MachineAssignmentsGroupView {
    /**
     * MachineId
     * @type {number}
     * @memberof MachineAssignmentsGroupView
     */
    machineId: number;
    /**
     * 
     * @type {string}
     * @memberof MachineAssignmentsGroupView
     */
    machineName: string;
    /**
     * 
     * @type {Array<LotAssignmentView>}
     * @memberof MachineAssignmentsGroupView
     */
    lots?: Array<LotAssignmentView>;
}
/**
 * 
 * @export
 * @interface MachineBatches
 */
export interface MachineBatches {
    /**
     * 
     * @type {Machine}
     * @memberof MachineBatches
     */
    machine: Machine;
    /**
     * 
     * @type {Array<KanbanBatch>}
     * @memberof MachineBatches
     */
    batches?: Array<KanbanBatch>;
}
/**
 * 
 * @export
 * @interface MachineCardSpecification
 */
export interface MachineCardSpecification {
    /**
     * MachineCardSpecificationId
     * @type {number}
     * @memberof MachineCardSpecification
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineCardSpecification
     */
    group: string;
    /**
     * 
     * @type {string}
     * @memberof MachineCardSpecification
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MachineCardSpecification
     */
    value: string;
}
/**
 * 
 * @export
 * @interface MachineDetailsView
 */
export interface MachineDetailsView {
    /**
     * MachineId
     * @type {number}
     * @memberof MachineDetailsView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailsView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailsView
     */
    areaName: string;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailsView
     */
    areaColor: string;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailsView
     */
    tag: string;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailsView
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailsView
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailsView
     */
    useCalendarForEstimation: boolean;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailsView
     */
    externalModifyTime: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MachineDetailsView
     */
    externalIds?: Array<string>;
    /**
     * 
     * @type {Array<MachineFeatureView>}
     * @memberof MachineDetailsView
     */
    features?: Array<MachineFeatureView>;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailsView
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface MachineFeature
 */
export interface MachineFeature {
    /**
     * MachineFeatureKeyId
     * @type {number}
     * @memberof MachineFeature
     */
    machineFeatureKeyId?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineFeature
     */
    key: string;
    /**
     * MachineFeatureValueId
     * @type {number}
     * @memberof MachineFeature
     */
    machineFeatureValueId?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineFeature
     */
    value: string;
}
/**
 * 
 * @export
 * @interface MachineFeatureView
 */
export interface MachineFeatureView {
    /**
     * 
     * @type {string}
     * @memberof MachineFeatureView
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof MachineFeatureView
     */
    value: string;
}
/**
 * 
 * @export
 * @interface MachineFeaturesView
 */
export interface MachineFeaturesView {
    /**
     * Keys are machine parameters for which features are defined
     * @type {{ [key: string]: Array<MachineFeature>; }}
     * @memberof MachineFeaturesView
     */
    features: { [key: string]: Array<MachineFeature>; };
}
/**
 * 
 * @export
 * @interface MachineIndicatorsView
 */
export interface MachineIndicatorsView {
    /**
     * 
     * @type {MachineView}
     * @memberof MachineIndicatorsView
     */
    machine: MachineView;
    /**
     * 
     * @type {GroupLeaderIndicatorsView}
     * @memberof MachineIndicatorsView
     */
    indicators: GroupLeaderIndicatorsView;
}
/**
 * 
 * @export
 * @interface MachinePermissionsView
 */
export interface MachinePermissionsView {
    /**
     * MachineId
     * @type {number}
     * @memberof MachinePermissionsView
     */
    machineId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachinePermissionsView
     */
    allowedUsers?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MachinePermissionsView
     */
    allowedRoles?: Array<number>;
}
/**
 * 
 * @export
 * @interface MachinePlanningView
 */
export interface MachinePlanningView {
    /**
     * 
     * @type {Machine}
     * @memberof MachinePlanningView
     */
    machine: Machine;
    /**
     * Time in ms
     * @type {number}
     * @memberof MachinePlanningView
     */
    durationEstimation: number;
    /**
     * 
     * @type {number}
     * @memberof MachinePlanningView
     */
    amountOfLotsInQueue: number;
    /**
     * 
     * @type {EstimatedDateTime}
     * @memberof MachinePlanningView
     */
    earliestStartDate?: EstimatedDateTime;
    /**
     * 
     * @type {OccurrenceDateTime}
     * @memberof MachinePlanningView
     */
    dueDate?: OccurrenceDateTime;
}
/**
 * 
 * @export
 * @interface MachineRequirement
 */
export interface MachineRequirement {
    /**
     * 
     * @type {MachineFeature}
     * @memberof MachineRequirement
     */
    machineFeature: MachineFeature;
}
/**
 * 
 * @export
 * @interface MachineRequirementView
 */
export interface MachineRequirementView {
    /**
     * MachineFeatureValueId
     * @type {number}
     * @memberof MachineRequirementView
     */
    machineFeatureValueId: number;
}
/**
 * 
 * @export
 * @interface MachineSaveView
 */
export interface MachineSaveView {
    /**
     * MachineId
     * @type {number}
     * @memberof MachineSaveView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineSaveView
     */
    name: string;
    /**
     * MachineAreaId
     * @type {number}
     * @memberof MachineSaveView
     */
    areaId: number;
    /**
     * 
     * @type {string}
     * @memberof MachineSaveView
     */
    tag: string;
    /**
     * 
     * @type {number}
     * @memberof MachineSaveView
     */
    costPerHour: number;
    /**
     * 
     * @type {number}
     * @memberof MachineSaveView
     */
    ordinal: number;
    /**
     * 
     * @type {Array<MachineFeature>}
     * @memberof MachineSaveView
     */
    features?: Array<MachineFeature>;
    /**
     * 
     * @type {string}
     * @memberof MachineSaveView
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof MachineSaveView
     */
    image?: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof MachineSaveView
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof MachineSaveView
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MachineSaveView
     */
    useCalendarForEstimation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineSaveView
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface MachineSpecification
 */
export interface MachineSpecification {
    /**
     * MachineSpecificationId
     * @type {number}
     * @memberof MachineSpecification
     */
    id?: number;
    /**
     * 
     * @type {Array<MachineRequirement>}
     * @memberof MachineSpecification
     */
    parameters?: Array<MachineRequirement>;
}

/**
 * 
 * @export
 */
export const MachineState = {
    production: 1,
    setup: 2,
    idle: 3,
    downtime: 4,
    unknown: 5
} as const;
export type MachineState = typeof MachineState[keyof typeof MachineState];

/**
 * 
 * @export
 * @interface MachineStateChangeData
 */
export interface MachineStateChangeData {
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof MachineStateChangeData
     */
    downtimeReasonId: number;
    /**
     * 
     * @type {string}
     * @memberof MachineStateChangeData
     */
    comment?: string;
}

/**
 * 
 * @export
 */
export const MachineStateDetailsConnectionStatus = {
    Active: 1,
    Connecting: 2,
    InactiveSensor: 3,
    MachinesServerConnectionFailed: 4,
    SensorNotConfigured: 5,
    ConnectionFailed: 6
} as const;
export type MachineStateDetailsConnectionStatus = typeof MachineStateDetailsConnectionStatus[keyof typeof MachineStateDetailsConnectionStatus];

/**
 * 
 * @export
 * @interface MachineStateDisplayConfig
 */
export interface MachineStateDisplayConfig {
    /**
     * 
     * @type {Array<string>}
     * @memberof MachineStateDisplayConfig
     */
    statesToDisplayProducedAmount?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MachineStateDisplayConfig
     */
    statesToDisplayToProduceAmount?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MachineStateDisplayConfig
     */
    statesToDisplayLeftToProduceAmount?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MachineStateDisplayConfig
     */
    statesToDisplayDurationInState?: Array<string>;
}
/**
 * 
 * @export
 * @interface MachineStateTimesView
 */
export interface MachineStateTimesView {
    /**
     * 
     * @type {MachineStateDetailsConnectionStatus}
     * @memberof MachineStateTimesView
     */
    status: MachineStateDetailsConnectionStatus;
    /**
     * 
     * @type {MachineState}
     * @memberof MachineStateTimesView
     */
    state: MachineState;
    /**
     * 
     * @type {number}
     * @memberof MachineStateTimesView
     */
    productionSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof MachineStateTimesView
     */
    setupSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof MachineStateTimesView
     */
    idleSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof MachineStateTimesView
     */
    downtimeSeconds: number;
}
/**
 * 
 * @export
 * @interface MachineView
 */
export interface MachineView {
    /**
     * MachineId
     * @type {number}
     * @memberof MachineView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MachineView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MachineView
     */
    tag: string;
    /**
     * 
     * @type {number}
     * @memberof MachineView
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof MachineView
     */
    color?: string;
    /**
     * MachineAreaId
     * @type {number}
     * @memberof MachineView
     */
    areaId: number;
    /**
     * 
     * @type {boolean}
     * @memberof MachineView
     */
    useCalendarForEstimation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineView
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface ManualRate
 */
export interface ManualRate {
    /**
     * CurrencyExchangeRateId
     * @type {number}
     * @memberof ManualRate
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualRate
     */
    sourceCurrencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof ManualRate
     */
    destinationCurrencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof ManualRate
     */
    exchangeRate: number;
}
/**
 * @type MapFunction1StringPropertyFilterValue
 * 
 * @export
 */
export type MapFunction1StringPropertyFilterValue = { propertyType: '1' } & ItemTypePropertyFilterStringValue | { propertyType: '2' } & ItemTypePropertyFilterRange | { propertyType: '3' } & ItemTypePropertyFilterStringValue;
/**
 * 
 * @export
 * @interface MarketingKeeperUpdateView
 */
export interface MarketingKeeperUpdateView {
    /**
     * UserId
     * @type {number}
     * @memberof MarketingKeeperUpdateView
     */
    marketingKeeperId?: number;
}
/**
 * 
 * @export
 * @interface MarketingKeepersListViewRow
 */
export interface MarketingKeepersListViewRow {
    /**
     * UserId
     * @type {number}
     * @memberof MarketingKeepersListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MarketingKeepersListViewRow
     */
    name: string;
}
/**
 * @type MarketingRule
 * 
 * @export
 */
export type MarketingRule = { marketingRuleType: '1' } & SingleContractorAllItems | { marketingRuleType: '10' } & ReliefPlatePriceForContractor | { marketingRuleType: '11' } & SievePriceForContractor | { marketingRuleType: '2' } & AllContractorsItemGroup | { marketingRuleType: '3' } & AllContractorsSingleItemType | { marketingRuleType: '4' } & ContractorGroupAllItems | { marketingRuleType: '5' } & DeadlineMarketingRuleForContractor | { marketingRuleType: '6' } & SingleContractorItemGroup | { marketingRuleType: '7' } & ContractorGroupItemGroup | { marketingRuleType: '8' } & SingleContractorSingleItem | { marketingRuleType: '9' } & ContractorGroupSingleItem;

/**
 * 
 * @export
 */
export const MarketingRuleType = {
    contractorAll: 1,
    allItemTag: 2,
    allItemType: 3,
    contractorTagAll: 4,
    paymentDeadline: 5,
    contractorItemTag: 6,
    contractorTagItemTag: 7,
    contractorItemType: 8,
    contractorTagItemType: 9,
    reliefPlatePrice: 10,
    sievePrice: 11
} as const;
export type MarketingRuleType = typeof MarketingRuleType[keyof typeof MarketingRuleType];

/**
 * 
 * @export
 * @interface MarketingRulesView
 */
export interface MarketingRulesView {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof MarketingRulesView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingRulesView
     */
    discount: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof MarketingRulesView
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketingRulesView
     */
    contractorName?: string;
    /**
     * ContractorTagId
     * @type {number}
     * @memberof MarketingRulesView
     */
    contractorTagId?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketingRulesView
     */
    contractorTagName?: string;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof MarketingRulesView
     */
    itemTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketingRulesView
     */
    itemTypeName?: string;
    /**
     * ItemTypeTagId
     * @type {number}
     * @memberof MarketingRulesView
     */
    itemTypeTagId?: number;
    /**
     * 
     * @type {string}
     * @memberof MarketingRulesView
     */
    itemTypeTagName?: string;
}

/**
 * 
 * @export
 */
export const MatchConditionType = {
    byProducedVariant: 1,
    byMachineFeatures: 2,
    byProducedItemTags: 3
} as const;
export type MatchConditionType = typeof MatchConditionType[keyof typeof MatchConditionType];

/**
 * 
 * @export
 * @interface MaterialMovementApplyItemView
 */
export interface MaterialMovementApplyItemView {
    /**
     * MaterialMovementItemId
     * @type {number}
     * @memberof MaterialMovementApplyItemView
     */
    materialMovementItemId: number;
    /**
     * 
     * @type {PlaceSelector}
     * @memberof MaterialMovementApplyItemView
     */
    source: PlaceSelector;
    /**
     * StockItemId
     * @type {number}
     * @memberof MaterialMovementApplyItemView
     */
    productionUnitId?: number;
    /**
     * 
     * @type {number}
     * @memberof MaterialMovementApplyItemView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementApplyItemView
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface MaterialMovementApplyView
 */
export interface MaterialMovementApplyView {
    /**
     * MaterialMovementId
     * @type {number}
     * @memberof MaterialMovementApplyView
     */
    id: number;
    /**
     * 
     * @type {Array<MaterialMovementApplyItemView>}
     * @memberof MaterialMovementApplyView
     */
    items?: Array<MaterialMovementApplyItemView>;
}

/**
 * 
 * @export
 */
export const MaterialMovementDemandSourceType = {
    productionLot: 1,
    orderItem: 2
} as const;
export type MaterialMovementDemandSourceType = typeof MaterialMovementDemandSourceType[keyof typeof MaterialMovementDemandSourceType];

/**
 * @type MaterialMovementDemandSourceView
 * 
 * @export
 */
export type MaterialMovementDemandSourceView = { tpe: 'order_item' } & OrderItemDemandSource | { tpe: 'production_lot' } & ProductionLotDemandSource;
/**
 * 
 * @export
 * @interface MaterialMovementItemSaveView
 */
export interface MaterialMovementItemSaveView {
    /**
     * MaterialMovementItemId
     * @type {number}
     * @memberof MaterialMovementItemSaveView
     */
    id?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof MaterialMovementItemSaveView
     */
    variantId: number;
    /**
     * 
     * @type {PlaceSelector}
     * @memberof MaterialMovementItemSaveView
     */
    source: PlaceSelector;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementItemSaveView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof MaterialMovementItemSaveView
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface MaterialMovementItemView
 */
export interface MaterialMovementItemView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof MaterialMovementItemView
     */
    variantId: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementItemView
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementItemView
     */
    variantCode?: string;
    /**
     * StockItemId
     * @type {number}
     * @memberof MaterialMovementItemView
     */
    productionUnitId?: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementItemView
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {PlaceSelectorView}
     * @memberof MaterialMovementItemView
     */
    source?: PlaceSelectorView;
    /**
     * 
     * @type {number}
     * @memberof MaterialMovementItemView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementItemView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof MaterialMovementItemView
     */
    amountInBaseUnit?: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementItemView
     */
    baseUnitType?: string;
    /**
     * 
     * @type {Array<SecondaryUnitType>}
     * @memberof MaterialMovementItemView
     */
    secondaryUnitTypes?: Array<SecondaryUnitType>;
}
/**
 * 
 * @export
 * @interface MaterialMovementItemsView
 */
export interface MaterialMovementItemsView {
    /**
     * 
     * @type {Array<MaterialMovementItemView>}
     * @memberof MaterialMovementItemsView
     */
    items?: Array<MaterialMovementItemView>;
}
/**
 * 
 * @export
 * @interface MaterialMovementListItemView
 */
export interface MaterialMovementListItemView {
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementListItemView
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementListItemView
     */
    variantCode: string;
}
/**
 * 
 * @export
 * @interface MaterialMovementListView
 */
export interface MaterialMovementListView {
    /**
     * MaterialMovementId
     * @type {number}
     * @memberof MaterialMovementListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementListView
     */
    comboSearch: string;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementListView
     */
    number: string;
    /**
     * 
     * @type {Array<MaterialMovementListItemView>}
     * @memberof MaterialMovementListView
     */
    items?: Array<MaterialMovementListItemView>;
    /**
     * 
     * @type {Array<PlaceSelectorView>}
     * @memberof MaterialMovementListView
     */
    sources?: Array<PlaceSelectorView>;
    /**
     * 
     * @type {PlaceSelectorView}
     * @memberof MaterialMovementListView
     */
    destination: PlaceSelectorView;
    /**
     * UserId
     * @type {number}
     * @memberof MaterialMovementListView
     */
    assigneeId?: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementListView
     */
    assigneeName?: string;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementListView
     */
    dueDate: string;
    /**
     * 
     * @type {MaterialMovementStatus}
     * @memberof MaterialMovementListView
     */
    status: MaterialMovementStatus;
    /**
     * 
     * @type {Array<MaterialMovementDemandSourceView>}
     * @memberof MaterialMovementListView
     */
    demandSources?: Array<MaterialMovementDemandSourceView>;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementListView
     */
    applyDate?: string;
}
/**
 * 
 * @export
 * @interface MaterialMovementSaveView
 */
export interface MaterialMovementSaveView {
    /**
     * MaterialMovementId
     * @type {number}
     * @memberof MaterialMovementSaveView
     */
    id?: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof MaterialMovementSaveView
     */
    destination: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementSaveView
     */
    dueDate: string;
    /**
     * 
     * @type {Array<MaterialMovementItemSaveView>}
     * @memberof MaterialMovementSaveView
     */
    items?: Array<MaterialMovementItemSaveView>;
}

/**
 * 
 * @export
 */
export const MaterialMovementStatus = {
    pending: 1,
    inProgress: 2,
    done: 3
} as const;
export type MaterialMovementStatus = typeof MaterialMovementStatus[keyof typeof MaterialMovementStatus];

/**
 * 
 * @export
 * @interface MaterialMovementValidationView
 */
export interface MaterialMovementValidationView {
    /**
     * StockItemId
     * @type {number}
     * @memberof MaterialMovementValidationView
     */
    productionUnitId: number;
    /**
     * 
     * @type {string}
     * @memberof MaterialMovementValidationView
     */
    placeLabel: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof MaterialMovementValidationView
     */
    placeId: number;
    /**
     * 
     * @type {number}
     * @memberof MaterialMovementValidationView
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface Materials
 */
export interface Materials {
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof Materials
     */
    roller?: ItemTypeVariant;
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof Materials
     */
    paper: PropertySetSelectorView;
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof Materials
     */
    additionalPaper?: PropertySetSelectorView;
}
/**
 * 
 * @export
 * @interface MeasuredParameter
 */
export interface MeasuredParameter {
    /**
     * MeasuredParameterId
     * @type {number}
     * @memberof MeasuredParameter
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasuredParameter
     */
    standard?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasuredParameter
     */
    standardParameter: string;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasuredParameter
     */
    measurementType: MeasurementType;
    /**
     * 
     * @type {number}
     * @memberof MeasuredParameter
     */
    minimum?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasuredParameter
     */
    maximum?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasuredParameter
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeasuredParameter
     */
    shouldBeMeasured: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeasuredParameter
     */
    shouldBeCompliant?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MeasuredParameter
     */
    ordinal: number;
}
/**
 * 
 * @export
 * @interface MeasurementCreateView
 */
export interface MeasurementCreateView {
    /**
     * MeasuredParameterId
     * @type {number}
     * @memberof MeasurementCreateView
     */
    measuredParameterId: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementCreateView
     */
    simpleValue?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementCreateView
     */
    textValue?: string;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasurementCreateView
     */
    tpe: MeasurementType;
    /**
     * 
     * @type {string}
     * @memberof MeasurementCreateView
     */
    reportDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementCreateView
     */
    reportTime?: string;
}
/**
 * 
 * @export
 * @interface MeasurementDeleteView
 */
export interface MeasurementDeleteView {
    /**
     * MeasurementId
     * @type {number}
     * @memberof MeasurementDeleteView
     */
    measurementId: number;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasurementDeleteView
     */
    tpe: MeasurementType;
}
/**
 * 
 * @export
 * @interface MeasurementDeviceView
 */
export interface MeasurementDeviceView {
    /**
     * MeasurementDeviceId
     * @type {number}
     * @memberof MeasurementDeviceView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDeviceView
     */
    name: string;
}
/**
 * 
 * @export
 * @interface MeasurementFromTo
 */
export interface MeasurementFromTo {
    /**
     * MeasurementId
     * @type {number}
     * @memberof MeasurementFromTo
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementFromTo
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementFromTo
     */
    to?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementFromTo
     */
    reportDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementFromTo
     */
    reportTime?: string;
    /**
     * 
     * @type {number}
     * @memberof MeasurementFromTo
     */
    ordinal: number;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasurementFromTo
     */
    measurementType: MeasurementType;
}
/**
 * 
 * @export
 * @interface MeasurementMinAvgMax
 */
export interface MeasurementMinAvgMax {
    /**
     * MeasurementId
     * @type {number}
     * @memberof MeasurementMinAvgMax
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementMinAvgMax
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementMinAvgMax
     */
    avg?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementMinAvgMax
     */
    max?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementMinAvgMax
     */
    reportDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementMinAvgMax
     */
    reportTime?: string;
    /**
     * 
     * @type {number}
     * @memberof MeasurementMinAvgMax
     */
    ordinal: number;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasurementMinAvgMax
     */
    measurementType: MeasurementType;
}
/**
 * 
 * @export
 * @interface MeasurementReport
 */
export interface MeasurementReport {
    /**
     * 
     * @type {string}
     * @memberof MeasurementReport
     */
    name: string;
    /**
     * 
     * @type {Array<MeasurementReportParameter>}
     * @memberof MeasurementReport
     */
    parameters?: Array<MeasurementReportParameter>;
}
/**
 * 
 * @export
 * @interface MeasurementReportFilter
 */
export interface MeasurementReportFilter {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof MeasurementReportFilter
     */
    productionLotId: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeasurementReportFilter
     */
    groupNameIn?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MeasurementReportFilter
     */
    parameterNameIn?: Array<string>;
}
/**
 * 
 * @export
 * @interface MeasurementReportParameter
 */
export interface MeasurementReportParameter {
    /**
     * 
     * @type {Array<MeasurementSeries>}
     * @memberof MeasurementReportParameter
     */
    measurementSeries?: Array<MeasurementSeries>;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasurementReportParameter
     */
    measurementType: MeasurementType;
    /**
     * MeasuredParameterId
     * @type {number}
     * @memberof MeasurementReportParameter
     */
    measuredParameterId: number;
    /**
     * value with max length 254
     * @type {string}
     * @memberof MeasurementReportParameter
     */
    standardName?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementReportParameter
     */
    standardParameterName: string;
    /**
     * 
     * @type {number}
     * @memberof MeasurementReportParameter
     */
    minimum?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementReportParameter
     */
    maximum?: number;
    /**
     * value with min length 3 and max length 254
     * @type {string}
     * @memberof MeasurementReportParameter
     */
    measurementDeviceName?: string;
    /**
     * value with min length 3 and max length 254
     * @type {string}
     * @memberof MeasurementReportParameter
     */
    environmentVariables?: string;
    /**
     * 
     * @type {number}
     * @memberof MeasurementReportParameter
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementReportParameter
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeasurementReportParameter
     */
    shouldBeMeasured: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MeasurementReportParameter
     */
    shouldBeCompliant?: boolean;
}
/**
 * 
 * @export
 * @interface MeasurementSeries
 */
export interface MeasurementSeries {
    /**
     * value with min length 1 and max length 254
     * @type {string}
     * @memberof MeasurementSeries
     */
    name?: string;
    /**
     * 
     * @type {Array<GenericMeasurement>}
     * @memberof MeasurementSeries
     */
    measurements?: Array<GenericMeasurement>;
    /**
     * 
     * @type {boolean}
     * @memberof MeasurementSeries
     */
    revised: boolean;
    /**
     * 
     * @type {number}
     * @memberof MeasurementSeries
     */
    ordinal: number;
}
/**
 * 
 * @export
 * @interface MeasurementSimpleVal
 */
export interface MeasurementSimpleVal {
    /**
     * MeasurementId
     * @type {number}
     * @memberof MeasurementSimpleVal
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementSimpleVal
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementSimpleVal
     */
    reportDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementSimpleVal
     */
    reportTime?: string;
    /**
     * UserId
     * @type {number}
     * @memberof MeasurementSimpleVal
     */
    measuredBy?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementSimpleVal
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementSimpleVal
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof MeasurementSimpleVal
     */
    ordinal: number;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasurementSimpleVal
     */
    measurementType: MeasurementType;
}
/**
 * 
 * @export
 * @interface MeasurementSpecification
 */
export interface MeasurementSpecification {
    /**
     * MeasurementSpecificationId
     * @type {number}
     * @memberof MeasurementSpecification
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementSpecification
     */
    name: string;
    /**
     * 
     * @type {Array<MeasuredParameter>}
     * @memberof MeasurementSpecification
     */
    measuredParameters?: Array<MeasuredParameter>;
}
/**
 * 
 * @export
 * @interface MeasurementStandardView
 */
export interface MeasurementStandardView {
    /**
     * MeasurementStandardId
     * @type {number}
     * @memberof MeasurementStandardView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementStandardView
     */
    name: string;
}
/**
 * 
 * @export
 * @interface MeasurementTextSimpleVal
 */
export interface MeasurementTextSimpleVal {
    /**
     * MeasurementId
     * @type {number}
     * @memberof MeasurementTextSimpleVal
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementTextSimpleVal
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeasurementTextSimpleVal
     */
    normSatisfied: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeasurementTextSimpleVal
     */
    reportDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementTextSimpleVal
     */
    reportTime?: string;
    /**
     * UserId
     * @type {number}
     * @memberof MeasurementTextSimpleVal
     */
    measuredBy?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementTextSimpleVal
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof MeasurementTextSimpleVal
     */
    lastName?: string;
    /**
     * 
     * @type {number}
     * @memberof MeasurementTextSimpleVal
     */
    ordinal: number;
    /**
     * 
     * @type {MeasurementType}
     * @memberof MeasurementTextSimpleVal
     */
    measurementType: MeasurementType;
}

/**
 * 
 * @export
 */
export const MeasurementType = {
    minAvgMax: 1,
    fromTo: 2,
    simpleVal: 3,
    textSimpleVal: 4
} as const;
export type MeasurementType = typeof MeasurementType[keyof typeof MeasurementType];

/**
 * 
 * @export
 * @interface MeasurementUpdateView
 */
export interface MeasurementUpdateView {
    /**
     * MeasurementId
     * @type {number}
     * @memberof MeasurementUpdateView
     */
    measurementId: number;
    /**
     * 
     * @type {number}
     * @memberof MeasurementUpdateView
     */
    simpleValue?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementUpdateView
     */
    textValue?: string;
}
/**
 * 
 * @export
 * @interface MergedChildrenError
 */
export interface MergedChildrenError {
    /**
     * 
     * @type {string}
     * @memberof MergedChildrenError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MergedChildrenError
     */
    description: string;
    /**
     * 
     * @type {ProductionLotSavingViewId}
     * @memberof MergedChildrenError
     */
    lotId: ProductionLotSavingViewId;
}
/**
 * 
 * @export
 * @interface MergedProductionLotSavingView
 */
export interface MergedProductionLotSavingView {
    /**
     * 
     * @type {ProductionLotSavingViewId}
     * @memberof MergedProductionLotSavingView
     */
    mergedTo: ProductionLotSavingViewId;
    /**
     * 
     * @type {ProductionLotSavingViewType}
     * @memberof MergedProductionLotSavingView
     */
    tpe: ProductionLotSavingViewType;
}
/**
 * 
 * @export
 * @interface MessagesAction
 */
export interface MessagesAction {
    /**
     * 
     * @type {string}
     * @memberof MessagesAction
     */
    name: string;
    /**
     * 
     * @type {JsObject2}
     * @memberof MessagesAction
     */
    params: JsObject2;
}

/**
 * 
 * @export
 */
export const MethodOfPayment = {
    Gotówka: 1,
    Przelew: 2,
    Inna: 3
} as const;
export type MethodOfPayment = typeof MethodOfPayment[keyof typeof MethodOfPayment];

/**
 * 
 * @export
 * @interface MethodOfPaymentView
 */
export interface MethodOfPaymentView {
    /**
     * MethodOfPaymentId
     * @type {number}
     * @memberof MethodOfPaymentView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MethodOfPaymentView
     */
    name: string;
}
/**
 * 
 * @export
 * @interface MissingProductionReportForLot
 */
export interface MissingProductionReportForLot {
    /**
     * 
     * @type {string}
     * @memberof MissingProductionReportForLot
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MissingProductionReportForLot
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof MissingProductionReportForLot
     */
    productionLotIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModelError
     */
    errors?: Array<string>;
    /**
     * 
     * @type {NexelemMergeImportStateType}
     * @memberof ModelError
     */
    tpe: NexelemMergeImportStateType;
}
/**
 * 
 * @export
 * @interface NarrowedLacquering
 */
export interface NarrowedLacquering {
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof NarrowedLacquering
     */
    material: number;
}
/**
 * 
 * @export
 * @interface NarrowedLacquering1
 */
export interface NarrowedLacquering1 {
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof NarrowedLacquering1
     */
    material: PropertySetSelector;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof NarrowedLacquering1
     */
    reliefPlate?: number;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof NarrowedLacquering1
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof NarrowedLacquering1
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof NarrowedLacquering1
     */
    dosageRoller?: number;
    /**
     * 
     * @type {StepMode}
     * @memberof NarrowedLacquering1
     */
    stepMode: StepMode;
}
/**
 * 
 * @export
 * @interface NarrowedLacqueringView
 */
export interface NarrowedLacqueringView {
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof NarrowedLacqueringView
     */
    material: PropertySetSelectorView;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof NarrowedLacqueringView
     */
    reliefPlate?: ItemTypeVariant;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof NarrowedLacqueringView
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof NarrowedLacqueringView
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof NarrowedLacqueringView
     */
    dosageRoller?: ItemTypeVariant;
    /**
     * 
     * @type {StepMode}
     * @memberof NarrowedLacqueringView
     */
    stepMode: StepMode;
    /**
     * 
     * @type {StepType}
     * @memberof NarrowedLacqueringView
     */
    stepType: StepType;
}
/**
 * 
 * @export
 * @interface NarrowedSieveLacquering
 */
export interface NarrowedSieveLacquering {
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof NarrowedSieveLacquering
     */
    material: number;
}
/**
 * 
 * @export
 * @interface NarrowedSieveLacquering1
 */
export interface NarrowedSieveLacquering1 {
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof NarrowedSieveLacquering1
     */
    material: PropertySetSelector;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof NarrowedSieveLacquering1
     */
    sieve?: number;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof NarrowedSieveLacquering1
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof NarrowedSieveLacquering1
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof NarrowedSieveLacquering1
     */
    dosageRoller?: number;
    /**
     * 
     * @type {StepMode}
     * @memberof NarrowedSieveLacquering1
     */
    stepMode: StepMode;
}
/**
 * 
 * @export
 * @interface NarrowedSieveLacqueringView
 */
export interface NarrowedSieveLacqueringView {
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof NarrowedSieveLacqueringView
     */
    material: PropertySetSelectorView;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof NarrowedSieveLacqueringView
     */
    sieve?: ItemTypeVariant;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof NarrowedSieveLacqueringView
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof NarrowedSieveLacqueringView
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof NarrowedSieveLacqueringView
     */
    dosageRoller?: ItemTypeVariant;
    /**
     * 
     * @type {StepMode}
     * @memberof NarrowedSieveLacqueringView
     */
    stepMode: StepMode;
    /**
     * 
     * @type {StepType}
     * @memberof NarrowedSieveLacqueringView
     */
    stepType: StepType;
}
/**
 * 
 * @export
 * @interface New
 */
export interface New {
    /**
     * 
     * @type {string}
     * @memberof New
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof New
     */
    itemTypeTags?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof New
     */
    unitType: string;
    /**
     * 
     * @type {ItemKind}
     * @memberof New
     */
    kind: ItemKind;
    /**
     * 
     * @type {number}
     * @memberof New
     */
    defaultVariantMinimalStock?: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof New
     */
    defaultPlace?: number;
    /**
     * 
     * @type {string}
     * @memberof New
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof New
     */
    syncToErp: boolean;
    /**
     * 
     * @type {Type}
     * @memberof New
     */
    tpe: Type;
}
/**
 * 
 * @export
 * @interface NewGeneratedPassword
 */
export interface NewGeneratedPassword {
    /**
     * 
     * @type {string}
     * @memberof NewGeneratedPassword
     */
    generatedPassword: string;
}

/**
 * 
 * @export
 */
export const NewLotCreationForUnfinished = {
    Always: 'always',
    Never: 'never',
    UserChoice: 'user_choice',
    PriorityOrClosedTooEarly: 'priority_or_closed_too_early'
} as const;
export type NewLotCreationForUnfinished = typeof NewLotCreationForUnfinished[keyof typeof NewLotCreationForUnfinished];

/**
 * 
 * @export
 * @interface NewManuallyTypedPassword
 */
export interface NewManuallyTypedPassword {
    /**
     * 
     * @type {PasswordWithConfirmation}
     * @memberof NewManuallyTypedPassword
     */
    passwordWithConfirmation: PasswordWithConfirmation;
}
/**
 * @type NewPassword
 * 
 * @export
 */
export type NewPassword = NewGeneratedPassword | NewManuallyTypedPassword;
/**
 * 
 * @export
 * @interface NewPunchingDie
 */
export interface NewPunchingDie {
    /**
     * 
     * @type {NewPunchingDiePunchingDieOrProperties}
     * @memberof NewPunchingDie
     */
    punchingDieOrProperties: NewPunchingDiePunchingDieOrProperties;
}
/**
 * @type NewPunchingDiePunchingDieOrProperties
 * 
 * @export
 */
export type NewPunchingDiePunchingDieOrProperties = PunchingDieProperties | number;
/**
 * @type NexelemMergeImportState
 * 
 * @export
 */
export type NexelemMergeImportState = { tpe: 'Applied' } & Applied | { tpe: 'Error' } & ModelError | { tpe: 'NotExisting' } & NotExisting | { tpe: 'PlanUpdateApplied' } & PlanUpdateApplied | { tpe: 'StartedApplying' } & StartedApplying;

/**
 * 
 * @export
 */
export const NexelemMergeImportStateType = {
    NotExisting: 'NotExisting',
    StartedApplying: 'StartedApplying',
    Error: 'Error',
    Applied: 'Applied',
    PlanUpdateApplied: 'PlanUpdateApplied'
} as const;
export type NexelemMergeImportStateType = typeof NexelemMergeImportStateType[keyof typeof NexelemMergeImportStateType];

/**
 * 
 * @export
 * @interface NoIngredientOfVariantForLot
 */
export interface NoIngredientOfVariantForLot {
    /**
     * 
     * @type {string}
     * @memberof NoIngredientOfVariantForLot
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NoIngredientOfVariantForLot
     */
    description: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof NoIngredientOfVariantForLot
     */
    variantId: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof NoIngredientOfVariantForLot
     */
    lotId: number;
}
/**
 * 
 * @export
 * @interface NoLotWithIdInTree
 */
export interface NoLotWithIdInTree {
    /**
     * 
     * @type {string}
     * @memberof NoLotWithIdInTree
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NoLotWithIdInTree
     */
    description: string;
    /**
     * 
     * @type {ProductionLotSavingViewId}
     * @memberof NoLotWithIdInTree
     */
    lotId: ProductionLotSavingViewId;
}
/**
 * 
 * @export
 * @interface NoPlaceDefined
 */
export interface NoPlaceDefined {
    /**
     * 
     * @type {string}
     * @memberof NoPlaceDefined
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NoPlaceDefined
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof NoPlaceDefined
     */
    index: number;
}
/**
 * 
 * @export
 * @interface NoPunchingDie
 */
export interface NoPunchingDie {
    /**
     * 
     * @type {PunchingDieProperties}
     * @memberof NoPunchingDie
     */
    properties: PunchingDieProperties;
}
/**
 * 
 * @export
 * @interface NoReportsFound
 */
export interface NoReportsFound {
    /**
     * BatchId
     * @type {number}
     * @memberof NoReportsFound
     */
    batchId: number;
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof NoReportsFound
     */
    batchGroupId: number;
}
/**
 * 
 * @export
 * @interface NokWithCause
 */
export interface NokWithCause {
    /**
     * NokWithCauseId
     * @type {number}
     * @memberof NokWithCause
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof NokWithCause
     */
    amount: number;
    /**
     * WasteCauseId
     * @type {number}
     * @memberof NokWithCause
     */
    cause?: number;
}
/**
 * 
 * @export
 * @interface NoksCausePercentage
 */
export interface NoksCausePercentage {
    /**
     * WasteCauseId
     * @type {number}
     * @memberof NoksCausePercentage
     */
    causeId: number;
    /**
     * 
     * @type {string}
     * @memberof NoksCausePercentage
     */
    causeName: string;
    /**
     * 
     * @type {number}
     * @memberof NoksCausePercentage
     */
    percentage: number;
}
/**
 * 
 * @export
 * @interface NoksCausePercentageV2
 */
export interface NoksCausePercentageV2 {
    /**
     * WasteCauseId
     * @type {number}
     * @memberof NoksCausePercentageV2
     */
    causeId?: number;
    /**
     * 
     * @type {string}
     * @memberof NoksCausePercentageV2
     */
    causeName: string;
    /**
     * 
     * @type {number}
     * @memberof NoksCausePercentageV2
     */
    percentage: number;
}
/**
 * 
 * @export
 * @interface NoksEmployeePercentage
 */
export interface NoksEmployeePercentage {
    /**
     * 
     * @type {WorkerView}
     * @memberof NoksEmployeePercentage
     */
    worker: WorkerView;
    /**
     * 
     * @type {number}
     * @memberof NoksEmployeePercentage
     */
    percentage: number;
}
/**
 * 
 * @export
 * @interface NoksOverTimeRequest
 */
export interface NoksOverTimeRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof NoksOverTimeRequest
     */
    nokCauses?: Array<number>;
    /**
     * 
     * @type {GroupLeaderDashboardFilters}
     * @memberof NoksOverTimeRequest
     */
    filters: GroupLeaderDashboardFilters;
}
/**
 * 
 * @export
 * @interface NoksOverTimeRequestV2
 */
export interface NoksOverTimeRequestV2 {
    /**
     * 
     * @type {GroupLeaderDashboardFilters}
     * @memberof NoksOverTimeRequestV2
     */
    filters: GroupLeaderDashboardFilters;
    /**
     * 
     * @type {string}
     * @memberof NoksOverTimeRequestV2
     */
    timeStep: string;
}
/**
 * 
 * @export
 * @interface NoksOverTimeResponse
 */
export interface NoksOverTimeResponse {
    /**
     * 
     * @type {Array<GroupLeaderNoksReport>}
     * @memberof NoksOverTimeResponse
     */
    nokReports?: Array<GroupLeaderNoksReport>;
}
/**
 * 
 * @export
 * @interface NoksOverTimeResponseV2
 */
export interface NoksOverTimeResponseV2 {
    /**
     * 
     * @type {Array<GroupLeaderNoksReportV2>}
     * @memberof NoksOverTimeResponseV2
     */
    nokReports?: Array<GroupLeaderNoksReportV2>;
}
/**
 * 
 * @export
 * @interface NoksProductPercentage
 */
export interface NoksProductPercentage {
    /**
     * 
     * @type {string}
     * @memberof NoksProductPercentage
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof NoksProductPercentage
     */
    productCode?: string;
    /**
     * 
     * @type {number}
     * @memberof NoksProductPercentage
     */
    percentage: number;
}
/**
 * 
 * @export
 * @interface NonPositiveAmount
 */
export interface NonPositiveAmount {
    /**
     * 
     * @type {string}
     * @memberof NonPositiveAmount
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NonPositiveAmount
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof NonPositiveAmount
     */
    estimationIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface NotCalculatedDateTime
 */
export interface NotCalculatedDateTime {
    /**
     * 
     * @type {EstimationStatus}
     * @memberof NotCalculatedDateTime
     */
    status: EstimationStatus;
}
/**
 * 
 * @export
 * @interface NotEnoughAmount
 */
export interface NotEnoughAmount {
    /**
     * 
     * @type {string}
     * @memberof NotEnoughAmount
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NotEnoughAmount
     */
    description: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof NotEnoughAmount
     */
    variantId: number;
    /**
     * StockItemId
     * @type {number}
     * @memberof NotEnoughAmount
     */
    productionUnitId?: number;
    /**
     * 
     * @type {number}
     * @memberof NotEnoughAmount
     */
    required: number;
    /**
     * 
     * @type {number}
     * @memberof NotEnoughAmount
     */
    available: number;
}
/**
 * 
 * @export
 * @interface NotExisting
 */
export interface NotExisting {
    /**
     * 
     * @type {NexelemMergeImportStateType}
     * @memberof NotExisting
     */
    tpe: NexelemMergeImportStateType;
}
/**
 * 
 * @export
 * @interface NotificationSystemSettings
 */
export interface NotificationSystemSettings {
    /**
     * 
     * @type {string}
     * @memberof NotificationSystemSettings
     */
    notificationSystemHost?: string;
    /**
     * 
     * @type {number}
     * @memberof NotificationSystemSettings
     */
    notificationSystemPort?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationSystemSettings
     */
    notificationSystemPathPrefix?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSystemSettings
     */
    notificationSystemSecureWebsocketProtocol?: boolean;
}
/**
 * 
 * @export
 * @interface NumberLotIdentificationCode
 */
export interface NumberLotIdentificationCode {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof NumberLotIdentificationCode
     */
    id: number;
    /**
     * 
     * @type {ProductionLotIdentificationCodeType}
     * @memberof NumberLotIdentificationCode
     */
    tpe: ProductionLotIdentificationCodeType;
}
/**
 * @type OccurrenceDateTime
 * 
 * @export
 */
export type OccurrenceDateTime = { occurrenceType: '1' } & DefinedOccurrence | { occurrenceType: '2' } & UndefinedOccurrence;

/**
 * 
 * @export
 */
export const OccurrenceType = {
    Defined: 1,
    Undefined: 2
} as const;
export type OccurrenceType = typeof OccurrenceType[keyof typeof OccurrenceType];

/**
 * 
 * @export
 * @interface OeeResponse
 */
export interface OeeResponse {
    /**
     * 
     * @type {GroupLeaderIndicatorsView}
     * @memberof OeeResponse
     */
    globalIndicators: GroupLeaderIndicatorsView;
    /**
     * 
     * @type {GroupLeaderIndicatorsView}
     * @memberof OeeResponse
     */
    norms: GroupLeaderIndicatorsView;
    /**
     * 
     * @type {Array<MachineIndicatorsView>}
     * @memberof OeeResponse
     */
    machinesIndicators?: Array<MachineIndicatorsView>;
}
/**
 * 
 * @export
 * @interface OfferAnnotation
 */
export interface OfferAnnotation {
    /**
     * 
     * @type {string}
     * @memberof OfferAnnotation
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof OfferAnnotation
     */
    ordinal?: number;
}
/**
 * 
 * @export
 * @interface OfferItemView
 */
export interface OfferItemView {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof OfferItemView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OfferItemView
     */
    itemTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof OfferItemView
     */
    itemTypeExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferItemView
     */
    itemTypeUnit: string;
    /**
     * 
     * @type {string}
     * @memberof OfferItemView
     */
    itemTypeCatalogNumber?: string;
    /**
     * 
     * @type {VatRateView}
     * @memberof OfferItemView
     */
    salesVat?: VatRateView;
    /**
     * 
     * @type {number}
     * @memberof OfferItemView
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof OfferItemView
     */
    priceBase: number;
    /**
     * 
     * @type {number}
     * @memberof OfferItemView
     */
    discount: number;
    /**
     * 
     * @type {Array<ItemTypeProperty>}
     * @memberof OfferItemView
     */
    properties?: Array<ItemTypeProperty>;
    /**
     * 
     * @type {number}
     * @memberof OfferItemView
     */
    discountedPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OfferItemView
     */
    netValue: number;
    /**
     * 
     * @type {number}
     * @memberof OfferItemView
     */
    totalVatValue: number;
    /**
     * 
     * @type {string}
     * @memberof OfferItemView
     */
    formattedVatRateString?: string;
    /**
     * 
     * @type {CostSet}
     * @memberof OfferItemView
     */
    costEstimateEntries?: CostSet;
    /**
     * 
     * @type {CostSet}
     * @memberof OfferItemView
     */
    additionalCosts?: CostSet;
    /**
     * 
     * @type {CostEstimateSummary}
     * @memberof OfferItemView
     */
    costEstimateSummary: CostEstimateSummary;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferItemView
     */
    productSpecificationSummary?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferItemView
     */
    packagingSummary?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OfferItemView
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof OfferItemView
     */
    ordinal: number;
}
/**
 * 
 * @export
 * @interface OfferListViewRow
 */
export interface OfferListViewRow {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OfferListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    supplierNumber: string;
    /**
     * 
     * @type {OfferStatus}
     * @memberof OfferListViewRow
     */
    status: OfferStatus;
    /**
     * ContractorId
     * @type {number}
     * @memberof OfferListViewRow
     */
    buyerId: number;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    buyerShortName?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    creationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    userResponsibleForOffer?: string;
    /**
     * UserId
     * @type {number}
     * @memberof OfferListViewRow
     */
    userIdResponsibleForOffer?: number;
    /**
     * 
     * @type {string}
     * @memberof OfferListViewRow
     */
    userResponsibleForContractor?: string;
    /**
     * UserId
     * @type {number}
     * @memberof OfferListViewRow
     */
    userIdResponsibleForContractor?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferListViewRow
     */
    netPrice: number;
    /**
     * 
     * @type {number}
     * @memberof OfferListViewRow
     */
    grossPrice: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof OfferListViewRow
     */
    contractorTagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferListViewRow
     */
    contractorTags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferListViewRow
     */
    summary?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferListViewRow
     */
    itemTypeVariantNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof OfferListViewRow
     */
    itemTypeVariantIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof OfferListViewRow
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferListViewRow
     */
    tagsOr?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferListViewRow
     */
    tagsAnd?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferListViewRow
     */
    tagsColors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof OfferListViewRow
     */
    hasConnectedOrders: boolean;
}
/**
 * 
 * @export
 * @interface OfferSaveView
 */
export interface OfferSaveView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OfferSaveView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OfferSaveView
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferSaveView
     */
    buyerNumber?: string;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof OfferSaveView
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * 
     * @type {DeliveryDate}
     * @memberof OfferSaveView
     */
    deliveryDate?: DeliveryDate;
    /**
     * 
     * @type {string}
     * @memberof OfferSaveView
     */
    creationDate?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OfferSaveView
     */
    buyerId?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof OfferSaveView
     */
    recipientId?: number;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof OfferSaveView
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {string}
     * @memberof OfferSaveView
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof OfferSaveView
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OfferSaveView
     */
    marketingRulesApplied: boolean;
    /**
     * UserId
     * @type {number}
     * @memberof OfferSaveView
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof OfferSaveView
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof OfferSaveView
     */
    methodOfPayment?: MethodOfPayment;
    /**
     * MethodOfPaymentId
     * @type {number}
     * @memberof OfferSaveView
     */
    methodOfPaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof OfferSaveView
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyExchangeRate}
     * @memberof OfferSaveView
     */
    exchangeRate?: CurrencyExchangeRate;
    /**
     * 
     * @type {Array<number>}
     * @memberof OfferSaveView
     */
    tagsIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof OfferSaveView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof OfferSaveView
     */
    to?: string;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof OfferSaveView
     */
    items?: Array<SalesEntryItemView>;
    /**
     * 
     * @type {FieldVisibility}
     * @memberof OfferSaveView
     */
    visibility?: FieldVisibility;
    /**
     * 
     * @type {Array<OfferAnnotation>}
     * @memberof OfferSaveView
     */
    offerAnnotations?: Array<OfferAnnotation>;
}

/**
 * 
 * @export
 */
export const OfferStatus = {
    incomplete: 1,
    open: 2,
    withdrawn: 3,
    negotiated: 4,
    accepted: 5,
    rejected: 6
} as const;
export type OfferStatus = typeof OfferStatus[keyof typeof OfferStatus];

/**
 * 
 * @export
 * @interface OfferView
 */
export interface OfferView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OfferView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    supplierNumber?: string;
    /**
     * 
     * @type {OfferStatus}
     * @memberof OfferView
     */
    status: OfferStatus;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof OfferView
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * ContractorId
     * @type {number}
     * @memberof OfferView
     */
    buyerId?: number;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    buyerNumber?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OfferView
     */
    recipientId?: number;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    recipientName?: string;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof OfferView
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {DeliveryDate}
     * @memberof OfferView
     */
    deliveryDate?: DeliveryDate;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    creationDate?: string;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof OfferView
     */
    items?: Array<SalesEntryItemView>;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof OfferView
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {FieldVisibility}
     * @memberof OfferView
     */
    visibility: FieldVisibility;
    /**
     * 
     * @type {boolean}
     * @memberof OfferView
     */
    marketingRulesApplied: boolean;
    /**
     * UserId
     * @type {number}
     * @memberof OfferView
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {User}
     * @memberof OfferView
     */
    responsibleUser?: User;
    /**
     * 
     * @type {Array<OfferAnnotation>}
     * @memberof OfferView
     */
    offerAnnotations?: Array<OfferAnnotation>;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof OfferView
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof OfferView
     */
    methodOfPayment?: MethodOfPayment;
    /**
     * MethodOfPaymentId
     * @type {number}
     * @memberof OfferView
     */
    methodOfPaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    methodOfPaymentName?: string;
    /**
     * 
     * @type {SalesRate}
     * @memberof OfferView
     */
    rate: SalesRate;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyExchangeRate}
     * @memberof OfferView
     */
    exchangeRate?: CurrencyExchangeRate;
    /**
     * 
     * @type {Array<SalesEntryTag>}
     * @memberof OfferView
     */
    tags?: Array<SalesEntryTag>;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    lastViewer?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferView
     */
    lastDateOfView?: string;
    /**
     * 
     * @type {number}
     * @memberof OfferView
     */
    netValue: number;
    /**
     * 
     * @type {number}
     * @memberof OfferView
     */
    attachmentCount: number;
}
/**
 * 
 * @export
 * @interface OperationMissingRecipeError
 */
export interface OperationMissingRecipeError {
    /**
     * 
     * @type {string}
     * @memberof OperationMissingRecipeError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OperationMissingRecipeError
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof OperationMissingRecipeError
     */
    productCode: string;
    /**
     * 
     * @type {string}
     * @memberof OperationMissingRecipeError
     */
    recipeVersionName: string;
    /**
     * 
     * @type {string}
     * @memberof OperationMissingRecipeError
     */
    operationCode?: string;
}
/**
 * 
 * @export
 * @interface OptionalDateRange
 */
export interface OptionalDateRange {
    /**
     * 
     * @type {string}
     * @memberof OptionalDateRange
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionalDateRange
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    column: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    asc: boolean;
}
/**
 * 
 * @export
 * @interface OrderAssignmentEventSaveView
 */
export interface OrderAssignmentEventSaveView {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof OrderAssignmentEventSaveView
     */
    id?: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderAssignmentEventSaveView
     */
    order: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderAssignmentEventSaveView
     */
    assignedWorkers?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof OrderAssignmentEventSaveView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAssignmentEventSaveView
     */
    to: string;
    /**
     * 
     * @type {CalendarEventRecurringOption}
     * @memberof OrderAssignmentEventSaveView
     */
    recurringOption?: CalendarEventRecurringOption;
    /**
     * 
     * @type {string}
     * @memberof OrderAssignmentEventSaveView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface OrderAssignmentEventView
 */
export interface OrderAssignmentEventView {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof OrderAssignmentEventView
     */
    id?: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderAssignmentEventView
     */
    orderId: number;
    /**
     * WorkerId
     * @type {number}
     * @memberof OrderAssignmentEventView
     */
    workerId: number;
    /**
     * 
     * @type {string}
     * @memberof OrderAssignmentEventView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAssignmentEventView
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAssignmentEventView
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderAssignmentEventView
     */
    creatorFullname: string;
}
/**
 * 
 * @export
 * @interface OrderAssignmentsSaveView
 */
export interface OrderAssignmentsSaveView {
    /**
     * WorkerId
     * @type {number}
     * @memberof OrderAssignmentsSaveView
     */
    leader: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderAssignmentsSaveView
     */
    assignedWorkers?: Array<number>;
}
/**
 * 
 * @export
 * @interface OrderAssignmentsView
 */
export interface OrderAssignmentsView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderAssignmentsView
     */
    orderId: number;
    /**
     * 
     * @type {WorkerView}
     * @memberof OrderAssignmentsView
     */
    leader?: WorkerView;
    /**
     * 
     * @type {Array<WorkerView>}
     * @memberof OrderAssignmentsView
     */
    assignedWorkers?: Array<WorkerView>;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderAssignmentsView
     */
    deletedAssignedWorkerIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface OrderDemandsToProductionListView
 */
export interface OrderDemandsToProductionListView {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof OrderDemandsToProductionListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDemandsToProductionListView
     */
    comboSearch: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDemandsToProductionListView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDemandsToProductionListView
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDemandsToProductionListView
     */
    unitType: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderDemandsToProductionListView
     */
    buyerId: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDemandsToProductionListView
     */
    buyerName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDemandsToProductionListView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDemandsToProductionListView
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof OrderDemandsToProductionListView
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDemandsToProductionListView
     */
    orderPositionRef: string;
    /**
     * 
     * @type {number}
     * @memberof OrderDemandsToProductionListView
     */
    orderedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDemandsToProductionListView
     */
    amountToProduce: number;
    /**
     * Count of seconds
     * @type {number}
     * @memberof OrderDemandsToProductionListView
     */
    estimatedTime?: number;
}
/**
 * 
 * @export
 * @interface OrderDraft
 */
export interface OrderDraft {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderDraft
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDraft
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDraft
     */
    buyerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDraft
     */
    supplierNumber?: string;
    /**
     * 
     * @type {OrderSource}
     * @memberof OrderDraft
     */
    source?: OrderSource;
    /**
     * 
     * @type {string}
     * @memberof OrderDraft
     */
    ediUuid?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderDraft
     */
    buyerId?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderDraft
     */
    recipientId?: number;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof OrderDraft
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {string}
     * @memberof OrderDraft
     */
    comments?: string;
    /**
     * 
     * @type {DeliveryDate}
     * @memberof OrderDraft
     */
    deliveryDate: DeliveryDate;
    /**
     * 
     * @type {ShippingDate}
     * @memberof OrderDraft
     */
    shippingDate: ShippingDate;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderDraft
     */
    status: OrderStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDraft
     */
    isExport: boolean;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof OrderDraft
     */
    items?: Array<SalesEntryItemView>;
    /**
     * 
     * @type {number}
     * @memberof OrderDraft
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof OrderDraft
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof OrderDraft
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * UserId
     * @type {number}
     * @memberof OrderDraft
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof OrderDraft
     */
    methodOfPayment?: MethodOfPayment;
    /**
     * 
     * @type {string}
     * @memberof OrderDraft
     */
    methodOfPaymentName?: string;
    /**
     * 
     * @type {SalesOptions}
     * @memberof OrderDraft
     */
    options: SalesOptions;
    /**
     * 
     * @type {SalesRate}
     * @memberof OrderDraft
     */
    rate: SalesRate;
    /**
     * 
     * @type {Array<SalesEntryTag>}
     * @memberof OrderDraft
     */
    tags?: Array<SalesEntryTag>;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDraft
     */
    globalDeliveryDate: boolean;
}
/**
 * 
 * @export
 * @interface OrderFromOffer
 */
export interface OrderFromOffer {
    /**
     * 
     * @type {string}
     * @memberof OrderFromOffer
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderFromOffer
     */
    buyerNumber?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderFromOffer
     */
    buyerId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderFromOffer
     */
    buyerName?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderFromOffer
     */
    recipientId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderFromOffer
     */
    recipientName?: string;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof OrderFromOffer
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {string}
     * @memberof OrderFromOffer
     */
    comments?: string;
    /**
     * 
     * @type {DeliveryDate}
     * @memberof OrderFromOffer
     */
    deliveryDate?: DeliveryDate;
    /**
     * 
     * @type {ShippingDate}
     * @memberof OrderFromOffer
     */
    shippingDate?: ShippingDate;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderFromOffer
     */
    status: OrderStatus;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof OrderFromOffer
     */
    items?: Array<SalesEntryItemView>;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderFromOffer
     */
    offerId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderFromOffer
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof OrderFromOffer
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof OrderFromOffer
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * UserId
     * @type {number}
     * @memberof OrderFromOffer
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof OrderFromOffer
     */
    methodOfPayment?: MethodOfPayment;
    /**
     * 
     * @type {SalesOptions}
     * @memberof OrderFromOffer
     */
    options: SalesOptions;
    /**
     * 
     * @type {SalesRate}
     * @memberof OrderFromOffer
     */
    rate: SalesRate;
    /**
     * 
     * @type {Array<SalesEntryTag>}
     * @memberof OrderFromOffer
     */
    tags?: Array<SalesEntryTag>;
}
/**
 * 
 * @export
 * @interface OrderItemCostsReportItemRow
 */
export interface OrderItemCostsReportItemRow {
    /**
     * OrderItemCostsReportItemId
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    id?: number;
    /**
     * AsyncReportId
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    asyncReportId?: number;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    orderItemId: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    orderId: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    buyerId: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    buyerOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    orderCreationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    deliveryDate?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    unitPriceInBaseCurrency?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    netValue?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    productionTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    estimatedProductionTime?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    productionTimeCost?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    materialsCost?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    expectedMaterialsCost?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    estimatedProductionTimeCost?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    totalCost?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    profitMargin?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    actualVsExpectedCost?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemCostsReportItemRow
     */
    profitPerProductionHour?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemCostsReportItemRow
     */
    contractorName: string;
}
/**
 * 
 * @export
 * @interface OrderItemDemandSource
 */
export interface OrderItemDemandSource {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof OrderItemDemandSource
     */
    orderItemId: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemDemandSource
     */
    number: string;
    /**
     * 
     * @type {MaterialMovementDemandSourceType}
     * @memberof OrderItemDemandSource
     */
    tpe: MaterialMovementDemandSourceType;
}
/**
 * 
 * @export
 * @interface OrderListView
 */
export interface OrderListView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    comboSearch: string;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    buyerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    buyerShortName?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderListView
     */
    buyerId?: number;
    /**
     * 
     * @type {SourceType}
     * @memberof OrderListView
     */
    sourceType: SourceType;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderListView
     */
    status: OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    creationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderListView
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderListView
     */
    hasOrderItems: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderListView
     */
    itemTypeVariantNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderListView
     */
    itemTypeVariantIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    authorName: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderListView
     */
    signed: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    comments?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderListView
     */
    cancelled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderListView
     */
    summary?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof OrderListView
     */
    netPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderListView
     */
    grossPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof OrderListView
     */
    budget?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderListView
     */
    contractorTagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderListView
     */
    contractorTags?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderListView
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderListView
     */
    tagsOr?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderListView
     */
    tagsAnd?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderListView
     */
    tagsColors?: Array<string>;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderListView
     */
    connectedOfferId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    connectedOfferNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    userResponsibleForOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    userResponsibleForContractor?: string;
    /**
     * UserId
     * @type {number}
     * @memberof OrderListView
     */
    userIdResponsibleForOrder?: number;
    /**
     * UserId
     * @type {number}
     * @memberof OrderListView
     */
    userIdResponsibleForContractor?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderListView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderListView
     */
    assignedWorkerIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof OrderListView
     */
    isOverdue: boolean;
}
/**
 * 
 * @export
 * @interface OrderNumberUpdate
 */
export interface OrderNumberUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrderNumberUpdate
     */
    orderNumber: string;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof OrderNumberUpdate
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface OrderSavingView
 */
export interface OrderSavingView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderSavingView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    buyerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    ediUuid?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderSavingView
     */
    buyerId?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderSavingView
     */
    recipientId?: number;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof OrderSavingView
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    deliveryTime?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    shippingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    shippingTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSavingView
     */
    isExport: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    creationDate?: string;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof OrderSavingView
     */
    items?: Array<SalesEntryItemView>;
    /**
     * 
     * @type {number}
     * @memberof OrderSavingView
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof OrderSavingView
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof OrderSavingView
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * UserId
     * @type {number}
     * @memberof OrderSavingView
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof OrderSavingView
     */
    methodOfPayment?: MethodOfPayment;
    /**
     * MethodOfPaymentId
     * @type {number}
     * @memberof OrderSavingView
     */
    methodOfPaymentId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSavingView
     */
    signed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSavingView
     */
    marketingRulesApplied: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingView
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyExchangeRate}
     * @memberof OrderSavingView
     */
    exchangeRate?: CurrencyExchangeRate;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderSavingView
     */
    tagsIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSavingView
     */
    globalDeliveryDate: boolean;
}
/**
 * 
 * @export
 * @interface OrderSavingViewV2
 */
export interface OrderSavingViewV2 {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderSavingViewV2
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingViewV2
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingViewV2
     */
    buyerNumber?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderSavingViewV2
     */
    buyerId?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderSavingViewV2
     */
    recipientId?: number;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof OrderSavingViewV2
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingViewV2
     */
    comments?: string;
    /**
     * 
     * @type {DeliveryDate}
     * @memberof OrderSavingViewV2
     */
    deliveryDate?: DeliveryDate;
    /**
     * 
     * @type {ShippingDate}
     * @memberof OrderSavingViewV2
     */
    shippingDate?: ShippingDate;
    /**
     * 
     * @type {boolean}
     * @memberof OrderSavingViewV2
     */
    isExport: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrderSavingViewV2
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof OrderSavingViewV2
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof OrderSavingViewV2
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * UserId
     * @type {number}
     * @memberof OrderSavingViewV2
     */
    responsibleUserId?: number;
    /**
     * MethodOfPaymentId
     * @type {number}
     * @memberof OrderSavingViewV2
     */
    methodOfPaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderSavingViewV2
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyExchangeRate}
     * @memberof OrderSavingViewV2
     */
    exchangeRate?: CurrencyExchangeRate;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrderSavingViewV2
     */
    tagsIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface OrderSource
 */
export interface OrderSource {
    /**
     * 
     * @type {SourceType}
     * @memberof OrderSource
     */
    sourceType: SourceType;
    /**
     * 
     * @type {Array<SourceAttribute>}
     * @memberof OrderSource
     */
    attributes?: Array<SourceAttribute>;
}

/**
 * 
 * @export
 */
export const OrderSourceAttributeType = {
    label: 1,
    comment: 2,
    username: 3
} as const;
export type OrderSourceAttributeType = typeof OrderSourceAttributeType[keyof typeof OrderSourceAttributeType];


/**
 * 
 * @export
 */
export const OrderStatus = {
    draft: 1,
    new: 2,
    inProgress: 3,
    cancelled: 4,
    done: 5,
    partiallyShipped: 6,
    shipped: 7,
    deleted: 8
} as const;
export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];

/**
 * 
 * @export
 * @interface OrderView
 */
export interface OrderView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    buyerNumber?: string;
    /**
     * 
     * @type {ShipmentArrangerType}
     * @memberof OrderView
     */
    shipmentArranger: ShipmentArrangerType;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    creationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    deliveryTime?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderView
     */
    buyerId?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof OrderView
     */
    recipientId?: number;
    /**
     * 
     * @type {DeliveryPoint}
     * @memberof OrderView
     */
    deliveryPoint?: DeliveryPoint;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    comments?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderView
     */
    paymentDeadline?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderView
     */
    marketingRulesApplied: boolean;
    /**
     * UserId
     * @type {number}
     * @memberof OrderView
     */
    responsibleUserId?: number;
    /**
     * 
     * @type {User}
     * @memberof OrderView
     */
    responsibleUser?: User;
    /**
     * 
     * @type {Array<SalesEntryContact>}
     * @memberof OrderView
     */
    contacts?: Array<SalesEntryContact>;
    /**
     * 
     * @type {MethodOfPayment}
     * @memberof OrderView
     */
    methodOfPayment?: MethodOfPayment;
    /**
     * MethodOfPaymentId
     * @type {number}
     * @memberof OrderView
     */
    methodOfPaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    methodOfPaymentName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyExchangeRate}
     * @memberof OrderView
     */
    exchangeRate?: CurrencyExchangeRate;
    /**
     * 
     * @type {Array<SalesEntryTag>}
     * @memberof OrderView
     */
    tags?: Array<SalesEntryTag>;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    lastViewer?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    lastDateOfView?: string;
    /**
     * 
     * @type {FieldVisibility}
     * @memberof OrderView
     */
    visibility?: FieldVisibility;
    /**
     * 
     * @type {number}
     * @memberof OrderView
     */
    estimatedBudget?: number;
    /**
     * 
     * @type {OrderSource}
     * @memberof OrderView
     */
    source: OrderSource;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    ediUuid?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    shippingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderView
     */
    shippingTime?: string;
    /**
     * UserId
     * @type {number}
     * @memberof OrderView
     */
    authorId?: number;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderView
     */
    status: OrderStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OrderView
     */
    isExport: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderView
     */
    signed: boolean;
    /**
     * 
     * @type {Array<SalesEntryItemView>}
     * @memberof OrderView
     */
    items?: Array<SalesEntryItemView>;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OrderView
     */
    offerId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderView
     */
    globalDeliveryDate: boolean;
    /**
     * 
     * @type {SplitOrder}
     * @memberof OrderView
     */
    splitFrom?: SplitOrder;
    /**
     * 
     * @type {Array<SplitOrder>}
     * @memberof OrderView
     */
    splitTo?: Array<SplitOrder>;
    /**
     * 
     * @type {number}
     * @memberof OrderView
     */
    attachmentCount: number;
}
/**
 * 
 * @export
 * @interface OrderedAmount
 */
export interface OrderedAmount {
    /**
     * 
     * @type {number}
     * @memberof OrderedAmount
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof OrderedAmount
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface OtherDemand
 */
export interface OtherDemand {
    /**
     * OtherDemandId
     * @type {number}
     * @memberof OtherDemand
     */
    id?: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OtherDemand
     */
    salesEntryId: number;
    /**
     * UserId
     * @type {number}
     * @memberof OtherDemand
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof OtherDemand
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof OtherDemand
     */
    creationDate: string;
}
/**
 * 
 * @export
 * @interface OtherDemandListView
 */
export interface OtherDemandListView {
    /**
     * OtherDemandId
     * @type {number}
     * @memberof OtherDemandListView
     */
    id: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OtherDemandListView
     */
    salesEntryId: number;
    /**
     * UserId
     * @type {number}
     * @memberof OtherDemandListView
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof OtherDemandListView
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof OtherDemandListView
     */
    creationDate: string;
}
/**
 * 
 * @export
 * @interface OtherDemandSavingView
 */
export interface OtherDemandSavingView {
    /**
     * OtherDemandId
     * @type {number}
     * @memberof OtherDemandSavingView
     */
    id?: number;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof OtherDemandSavingView
     */
    salesEntryId: number;
    /**
     * UserId
     * @type {number}
     * @memberof OtherDemandSavingView
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof OtherDemandSavingView
     */
    content: string;
}
/**
 * 
 * @export
 * @interface PackagingIngredient
 */
export interface PackagingIngredient {
    /**
     * PackagingIngredientId
     * @type {number}
     * @memberof PackagingIngredient
     */
    id?: number;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof PackagingIngredient
     */
    variant: ItemTypeVariant;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof PackagingIngredient
     */
    amount?: AmountWithUnit;
    /**
     * 
     * @type {number}
     * @memberof PackagingIngredient
     */
    ordinal: number;
}
/**
 * 
 * @export
 * @interface PackagingLevel
 */
export interface PackagingLevel {
    /**
     * PackagingLevelId
     * @type {number}
     * @memberof PackagingLevel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PackagingLevel
     */
    level: number;
    /**
     * 
     * @type {GenericPackaging}
     * @memberof PackagingLevel
     */
    packaging?: GenericPackaging;
}
/**
 * 
 * @export
 * @interface PackagingSpecification
 */
export interface PackagingSpecification {
    /**
     * PackagingSpecificationId
     * @type {number}
     * @memberof PackagingSpecification
     */
    id?: number;
    /**
     * 
     * @type {Array<PackagingLevel>}
     * @memberof PackagingSpecification
     */
    packagingLevels?: Array<PackagingLevel>;
    /**
     * 
     * @type {number}
     * @memberof PackagingSpecification
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof PackagingSpecification
     */
    max?: number;
    /**
     * 
     * @type {string}
     * @memberof PackagingSpecification
     */
    comments?: string;
}
/**
 * 
 * @export
 * @interface PasswordWithConfirmation
 */
export interface PasswordWithConfirmation {
    /**
     * 
     * @type {string}
     * @memberof PasswordWithConfirmation
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordWithConfirmation
     */
    passwordConfirmation: string;
}
/**
 * @type PathNode
 * 
 * @export
 */
export type PathNode = IdxPathNode | KeyPathNode | RecursiveSearch;
/**
 * 
 * @export
 * @interface PauseEventView
 */
export interface PauseEventView {
    /**
     * 
     * @type {GroupLeaderEventIndentification}
     * @memberof PauseEventView
     */
    identification: GroupLeaderEventIndentification;
    /**
     * 
     * @type {GroupLeaderEventType}
     * @memberof PauseEventView
     */
    eventType: GroupLeaderEventType;
}
/**
 * 
 * @export
 * @interface PerformanceDetailsResponse
 */
export interface PerformanceDetailsResponse {
    /**
     * 
     * @type {PerformanceSummary}
     * @memberof PerformanceDetailsResponse
     */
    summary: PerformanceSummary;
    /**
     * 
     * @type {PerformanceNorms}
     * @memberof PerformanceDetailsResponse
     */
    norms: PerformanceNorms;
    /**
     * 
     * @type {Array<WorkstationPerformanceView>}
     * @memberof PerformanceDetailsResponse
     */
    workstations?: Array<WorkstationPerformanceView>;
}
/**
 * 
 * @export
 * @interface PerformanceNorms
 */
export interface PerformanceNorms {
    /**
     * 
     * @type {number}
     * @memberof PerformanceNorms
     */
    normOee: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceNorms
     */
    normPerformance: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceNorms
     */
    lowestIndicator: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceNorms
     */
    highestIndicator: number;
}
/**
 * 
 * @export
 * @interface PerformanceSummary
 */
export interface PerformanceSummary {
    /**
     * 
     * @type {number}
     * @memberof PerformanceSummary
     */
    plannedProductionTimeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceSummary
     */
    reportedProductionTimeMinutes: number;
}
/**
 * 
 * @export
 * @interface Piece
 */
export interface Piece {
    /**
     * RecipePieceId
     * @type {number}
     * @memberof Piece
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Piece
     */
    amount: number;
    /**
     * 
     * @type {ClientSpecification}
     * @memberof Piece
     */
    clientSpecification: ClientSpecification;
}

/**
 * 
 * @export
 */
export const PieceType = {
    itemTypeVariant: 1,
    specification: 2
} as const;
export type PieceType = typeof PieceType[keyof typeof PieceType];

/**
 * 
 * @export
 * @interface Pieces
 */
export interface Pieces {
    /**
     * 
     * @type {string}
     * @memberof Pieces
     */
    name: string;
    /**
     * 
     * @type {TechnologyType}
     * @memberof Pieces
     */
    tpe: TechnologyType;
}
/**
 * 
 * @export
 * @interface PiecesBomCalculationView
 */
export interface PiecesBomCalculationView {
    /**
     * 
     * @type {number}
     * @memberof PiecesBomCalculationView
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof PiecesBomCalculationView
     */
    multiplier: number;
    /**
     * 
     * @type {BomCalculationType}
     * @memberof PiecesBomCalculationView
     */
    calculationType: BomCalculationType;
}
/**
 * 
 * @export
 * @interface PiecesProductSpecification
 */
export interface PiecesProductSpecification {
    /**
     * ProductSpecificationId
     * @type {number}
     * @memberof PiecesProductSpecification
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PiecesProductSpecification
     */
    uuid: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesProductSpecification
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesProductSpecification
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesProductSpecification
     */
    estimationProcessName?: string;
    /**
     * 
     * @type {Array<PiecesProductSpecificationPiece>}
     * @memberof PiecesProductSpecification
     */
    pieces?: Array<PiecesProductSpecificationPiece>;
    /**
     * 
     * @type {ProductSpecificationType}
     * @memberof PiecesProductSpecification
     */
    productSpecificationType: ProductSpecificationType;
}
/**
 * @type PiecesProductSpecificationPiece
 * 
 * @export
 */
export type PiecesProductSpecificationPiece = { pieceType: '1' } & ItemTypeVariantPiece | { pieceType: '2' } & SpecificationPiece;
/**
 * 
 * @export
 * @interface PiecesRecipe
 */
export interface PiecesRecipe {
    /**
     * RecipeId
     * @type {number}
     * @memberof PiecesRecipe
     */
    id?: number;
    /**
     * 
     * @type {Array<Piece>}
     * @memberof PiecesRecipe
     */
    items?: Array<Piece>;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipe
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipe
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipe
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipe
     */
    estimationProcessName?: string;
    /**
     * 
     * @type {Array<RecipeUserDefinedParameter>}
     * @memberof PiecesRecipe
     */
    userDefinedParameters?: Array<RecipeUserDefinedParameter>;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipe
     */
    versionName?: string;
    /**
     * 
     * @type {number}
     * @memberof PiecesRecipe
     */
    minimalLotAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof PiecesRecipe
     */
    recipeType: number;
}
/**
 * 
 * @export
 * @interface PiecesRecipeItemSimpleView
 */
export interface PiecesRecipeItemSimpleView {
    /**
     * RecipePieceId
     * @type {number}
     * @memberof PiecesRecipeItemSimpleView
     */
    id?: number;
    /**
     * ClientSpecificationId
     * @type {number}
     * @memberof PiecesRecipeItemSimpleView
     */
    clientSpecificationId?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof PiecesRecipeItemSimpleView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipeItemSimpleView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {boolean}
     * @memberof PiecesRecipeItemSimpleView
     */
    variantActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof PiecesRecipeItemSimpleView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipeItemSimpleView
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface PiecesRecipeSimpleSavingView
 */
export interface PiecesRecipeSimpleSavingView {
    /**
     * RecipeId
     * @type {number}
     * @memberof PiecesRecipeSimpleSavingView
     */
    id?: number;
    /**
     * 
     * @type {Array<Item1>}
     * @memberof PiecesRecipeSimpleSavingView
     */
    items?: Array<Item1>;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipeSimpleSavingView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipeSimpleSavingView
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface PiecesRecipeSimpleView
 */
export interface PiecesRecipeSimpleView {
    /**
     * RecipeId
     * @type {number}
     * @memberof PiecesRecipeSimpleView
     */
    id?: number;
    /**
     * 
     * @type {Array<PiecesRecipeItemSimpleView>}
     * @memberof PiecesRecipeSimpleView
     */
    items?: Array<PiecesRecipeItemSimpleView>;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipeSimpleView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesRecipeSimpleView
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface Place
 */
export interface Place {
    /**
     * PlaceId
     * @type {number}
     * @memberof Place
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Place
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Place
     */
    iln?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Place
     */
    isDefaultSupply: boolean;
}
/**
 * 
 * @export
 * @interface PlaceLabelUpdate
 */
export interface PlaceLabelUpdate {
    /**
     * 
     * @type {string}
     * @memberof PlaceLabelUpdate
     */
    label: string;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof PlaceLabelUpdate
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface PlaceSelector
 */
export interface PlaceSelector {
    /**
     * PlaceId
     * @type {number}
     * @memberof PlaceSelector
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceSelector
     */
    placeLabel?: string;
}
/**
 * 
 * @export
 * @interface PlaceSelectorView
 */
export interface PlaceSelectorView {
    /**
     * PlaceId
     * @type {number}
     * @memberof PlaceSelectorView
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof PlaceSelectorView
     */
    placeName: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceSelectorView
     */
    placeLabel?: string;
}
/**
 * 
 * @export
 * @interface PlanAlreadyExecuted
 */
export interface PlanAlreadyExecuted {
    /**
     * 
     * @type {string}
     * @memberof PlanAlreadyExecuted
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PlanAlreadyExecuted
     */
    description: string;
    /**
     * ReleasePlanItemId
     * @type {number}
     * @memberof PlanAlreadyExecuted
     */
    planItemId: number;
}
/**
 * 
 * @export
 * @interface PlanUpdateApplied
 */
export interface PlanUpdateApplied {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof PlanUpdateApplied
     */
    mapping: { [key: string]: number; };
    /**
     * 
     * @type {NexelemMergeImportStateType}
     * @memberof PlanUpdateApplied
     */
    tpe: NexelemMergeImportStateType;
}
/**
 * 
 * @export
 * @interface PlannedReleaseInitialView
 */
export interface PlannedReleaseInitialView {
    /**
     * ReleasePlanId
     * @type {number}
     * @memberof PlannedReleaseInitialView
     */
    releasePlanId: number;
    /**
     * 
     * @type {Array<WarehouseTag>}
     * @memberof PlannedReleaseInitialView
     */
    tags?: Array<WarehouseTag>;
    /**
     * 
     * @type {Place}
     * @memberof PlannedReleaseInitialView
     */
    place: Place;
    /**
     * 
     * @type {Array<PlannedReleaseInitialViewItem>}
     * @memberof PlannedReleaseInitialView
     */
    items?: Array<PlannedReleaseInitialViewItem>;
}
/**
 * 
 * @export
 * @interface PlannedReleaseInitialViewItem
 */
export interface PlannedReleaseInitialViewItem {
    /**
     * ReleasePlanItemId
     * @type {number}
     * @memberof PlannedReleaseInitialViewItem
     */
    releasePlanItemId: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof PlannedReleaseInitialViewItem
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof PlannedReleaseInitialViewItem
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedReleaseInitialViewItem
     */
    itemTypeVariantCode?: string;
    /**
     * StockItemId
     * @type {number}
     * @memberof PlannedReleaseInitialViewItem
     */
    productionUnitId?: number;
    /**
     * 
     * @type {string}
     * @memberof PlannedReleaseInitialViewItem
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedReleaseInitialViewItem
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof PlannedReleaseInitialViewItem
     */
    plannedAmount: number;
}
/**
 * 
 * @export
 * @interface PlannedReleaseSavingView
 */
export interface PlannedReleaseSavingView {
    /**
     * ReleasePlanId
     * @type {number}
     * @memberof PlannedReleaseSavingView
     */
    planId: number;
    /**
     * 
     * @type {string}
     * @memberof PlannedReleaseSavingView
     */
    releaseDate: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof PlannedReleaseSavingView
     */
    placeId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PlannedReleaseSavingView
     */
    tags?: Array<number>;
    /**
     * 
     * @type {Array<ReleaseSavingViewItem>}
     * @memberof PlannedReleaseSavingView
     */
    items?: Array<ReleaseSavingViewItem>;
}
/**
 * 
 * @export
 * @interface PlannedSupplyCardCreateView
 */
export interface PlannedSupplyCardCreateView {
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyCardCreateView
     */
    supplyDocumentId?: string;
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof PlannedSupplyCardCreateView
     */
    connectedSupplyOrderId: number;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyCardCreateView
     */
    deliveryDate: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof PlannedSupplyCardCreateView
     */
    placeId?: number;
    /**
     * 
     * @type {Array<PlannedSupplyCardItemCreateView>}
     * @memberof PlannedSupplyCardCreateView
     */
    items?: Array<PlannedSupplyCardItemCreateView>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PlannedSupplyCardCreateView
     */
    tags?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyCardCreateView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface PlannedSupplyCardItemCreateView
 */
export interface PlannedSupplyCardItemCreateView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof PlannedSupplyCardItemCreateView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyCardItemCreateView
     */
    productionUnitNumber: string;
    /**
     * 
     * @type {number}
     * @memberof PlannedSupplyCardItemCreateView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyCardItemCreateView
     */
    unitType?: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof PlannedSupplyCardItemCreateView
     */
    placeId?: number;
}
/**
 * 
 * @export
 * @interface PlannedSupplyInitialView
 */
export interface PlannedSupplyInitialView {
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof PlannedSupplyInitialView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyInitialView
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyInitialView
     */
    internalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyInitialView
     */
    supplierName: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyInitialView
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyInitialView
     */
    creationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyInitialView
     */
    plannedReceptionDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyInitialView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {User}
     * @memberof PlannedSupplyInitialView
     */
    author?: User;
    /**
     * 
     * @type {Array<PlannedSupplyOrderItemView>}
     * @memberof PlannedSupplyInitialView
     */
    items?: Array<PlannedSupplyOrderItemView>;
    /**
     * 
     * @type {Array<WarehouseTag>}
     * @memberof PlannedSupplyInitialView
     */
    tags?: Array<WarehouseTag>;
}
/**
 * 
 * @export
 * @interface PlannedSupplyOrderItemView
 */
export interface PlannedSupplyOrderItemView {
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof PlannedSupplyOrderItemView
     */
    itemTypeVariant: ItemTypeVariant;
    /**
     * 
     * @type {string}
     * @memberof PlannedSupplyOrderItemView
     */
    baseUnitType: string;
    /**
     * 
     * @type {Array<SecondaryUnitType>}
     * @memberof PlannedSupplyOrderItemView
     */
    secondaryUnitTypes?: Array<SecondaryUnitType>;
    /**
     * 
     * @type {number}
     * @memberof PlannedSupplyOrderItemView
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface PlateItemTypeSaveView
 */
export interface PlateItemTypeSaveView {
    /**
     * 
     * @type {string}
     * @memberof PlateItemTypeSaveView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PlateItemTypeSaveView
     */
    lenFileLink?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateItemTypeSaveView
     */
    halftoneShape?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateItemTypeSaveView
     */
    ruling?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateItemTypeSaveView
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlateItemTypeSaveView
     */
    studioRip: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlateItemTypeSaveView
     */
    isDigitalStep: boolean;
}
/**
 * 
 * @export
 * @interface PossibleProductView
 */
export interface PossibleProductView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof PossibleProductView
     */
    productVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof PossibleProductView
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof PossibleProductView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof PossibleProductView
     */
    externalId?: string;
}
/**
 * 
 * @export
 * @interface PostBackContractorsContactsListFilterRequest
 */
export interface PostBackContractorsContactsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackContractorsContactsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackContractorsContactsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackContractorsContactsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackContractorsContactsListFilterRequestData}
     * @memberof PostBackContractorsContactsListFilterRequest
     */
    data: PostBackContractorsContactsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackContractorsContactsListFilterRequestData
 */
export interface PostBackContractorsContactsListFilterRequestData {
    /**
     * ContractorId
     * @type {number}
     * @memberof PostBackContractorsContactsListFilterRequestData
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsContactsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsContactsListFilterRequestData
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsContactsListFilterRequestData
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackContractorsContactsListFilterRequestData
     */
    isPrimary?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackContractorsListFilterRequest
 */
export interface PostBackContractorsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackContractorsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackContractorsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackContractorsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackContractorsListFilterRequestData}
     * @memberof PostBackContractorsListFilterRequest
     */
    data: PostBackContractorsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackContractorsListFilterRequestData
 */
export interface PostBackContractorsListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    shortName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    regon?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    marketingKeeperName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackContractorsListFilterRequestData
     */
    marketingKeeperId?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackContractorsListFilterRequestData
     */
    active?: boolean;
    /**
     * ContractorTagId
     * @type {number}
     * @memberof PostBackContractorsListFilterRequestData
     */
    contractorTagIds?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackContractorsListFilterRequestData
     */
    contractorTags?: Array<string>;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackContractorsListFilterRequestData
     */
    lastActivity?: FilterRangeDateTime;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    comment?: string;
    /**
     * 
     * @type {Array<ContractorKind>}
     * @memberof PostBackContractorsListFilterRequestData
     */
    kinds?: Array<ContractorKind>;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsListFilterRequestData
     */
    comboNameSearch?: string;
}
/**
 * 
 * @export
 * @interface PostBackContractorsMarketingKeepersListFilterRequest
 */
export interface PostBackContractorsMarketingKeepersListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackContractorsMarketingKeepersListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackContractorsMarketingKeepersListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackContractorsMarketingKeepersListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackContractorsMarketingKeepersListFilterRequestData}
     * @memberof PostBackContractorsMarketingKeepersListFilterRequest
     */
    data: PostBackContractorsMarketingKeepersListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackContractorsMarketingKeepersListFilterRequestData
 */
export interface PostBackContractorsMarketingKeepersListFilterRequestData {
    /**
     * UserId
     * @type {number}
     * @memberof PostBackContractorsMarketingKeepersListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackContractorsMarketingKeepersListFilterRequestData
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface PostBackDocumentsDocumentStatusListFilterRequest
 */
export interface PostBackDocumentsDocumentStatusListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackDocumentsDocumentStatusListFilterRequestData}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequest
     */
    data: PostBackDocumentsDocumentStatusListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackDocumentsDocumentStatusListFilterRequestData
 */
export interface PostBackDocumentsDocumentStatusListFilterRequestData {
    /**
     * PushStatusId
     * @type {number}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    internalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    comboNumberSearch?: string;
    /**
     * 
     * @type {Array<InternalEntityType>}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    internalEntityType?: Array<InternalEntityType>;
    /**
     * 
     * @type {Array<DocumentTypes>}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    targetType?: Array<DocumentTypes>;
    /**
     * 
     * @type {Array<PushStatusTypes>}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    pushStatus?: Array<PushStatusTypes>;
    /**
     * 
     * @type {string}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    error?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    syncAttemptTime?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    lastSuccessfulSyncTime?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {Array<DocumentStatusTypes>}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    documentStatus?: Array<DocumentStatusTypes>;
    /**
     * 
     * @type {Array<InternalDocumentTypes>}
     * @memberof PostBackDocumentsDocumentStatusListFilterRequestData
     */
    documentType?: Array<InternalDocumentTypes>;
}
/**
 * 
 * @export
 * @interface PostBackErpSynchronizationStatusesFilterRequest
 */
export interface PostBackErpSynchronizationStatusesFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackErpSynchronizationStatusesFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackErpSynchronizationStatusesFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackErpSynchronizationStatusesFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackErpSynchronizationStatusesFilterRequestData}
     * @memberof PostBackErpSynchronizationStatusesFilterRequest
     */
    data: PostBackErpSynchronizationStatusesFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackErpSynchronizationStatusesFilterRequestData
 */
export interface PostBackErpSynchronizationStatusesFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackErpSynchronizationStatusesFilterRequestData
     */
    unitName?: string;
    /**
     * 
     * @type {Array<ErpSyncUnit>}
     * @memberof PostBackErpSynchronizationStatusesFilterRequestData
     */
    unit?: Array<ErpSyncUnit>;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackErpSynchronizationStatusesFilterRequestData
     */
    syncAttempt?: FilterRangeDateTime;
    /**
     * 
     * @type {Array<SynchronizationStatus>}
     * @memberof PostBackErpSynchronizationStatusesFilterRequestData
     */
    synchronizationStatus?: Array<SynchronizationStatus>;
    /**
     * 
     * @type {string}
     * @memberof PostBackErpSynchronizationStatusesFilterRequestData
     */
    error?: string;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackErpSynchronizationStatusesFilterRequestData
     */
    syncFrom?: FilterRangeDateTime;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackErpSynchronizationStatusesFilterRequestData
     */
    syncTo?: FilterRangeDateTime;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackErpSynchronizationStatusesFilterRequestData
     */
    isEmpty?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackItemsItemTypeTagsListFilterRequest
 */
export interface PostBackItemsItemTypeTagsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsItemTypeTagsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsItemTypeTagsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackItemsItemTypeTagsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackItemsItemTypeTagsListFilterRequestData}
     * @memberof PostBackItemsItemTypeTagsListFilterRequest
     */
    data: PostBackItemsItemTypeTagsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackItemsItemTypeTagsListFilterRequestData
 */
export interface PostBackItemsItemTypeTagsListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsItemTypeTagsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackItemsItemTypeTagsListFilterRequestData
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackItemsPriceListsFilterRequest
 */
export interface PostBackItemsPriceListsFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsPriceListsFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsPriceListsFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackItemsPriceListsFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackItemsPriceListsFilterRequestData}
     * @memberof PostBackItemsPriceListsFilterRequest
     */
    data: PostBackItemsPriceListsFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackItemsPriceListsFilterRequestData
 */
export interface PostBackItemsPriceListsFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsPriceListsFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsPriceListsFilterRequestData
     */
    currencyCode?: string;
}
/**
 * 
 * @export
 * @interface PostBackItemsPropertySetsListFilterRequest
 */
export interface PostBackItemsPropertySetsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsPropertySetsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsPropertySetsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackItemsPropertySetsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackItemsPropertySetsListFilterRequestData}
     * @memberof PostBackItemsPropertySetsListFilterRequest
     */
    data: PostBackItemsPropertySetsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackItemsPropertySetsListFilterRequestData
 */
export interface PostBackItemsPropertySetsListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsPropertySetsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsPropertySetsListFilterRequestData
     */
    itemTypeTag?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackItemsPropertySetsListFilterRequestData
     */
    price?: FilterRangeBigDecimal;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackItemsPropertySetsListFilterRequestData
     */
    isActive?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackItemsPropertyTypesFilterRequest
 */
export interface PostBackItemsPropertyTypesFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsPropertyTypesFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsPropertyTypesFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackItemsPropertyTypesFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackItemsPropertyTypesFilterRequestData}
     * @memberof PostBackItemsPropertyTypesFilterRequest
     */
    data: PostBackItemsPropertyTypesFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackItemsPropertyTypesFilterRequestData
 */
export interface PostBackItemsPropertyTypesFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsPropertyTypesFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsPropertyTypesFilterRequestData
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsPropertyTypesFilterRequestData
     */
    regex?: string;
    /**
     * 
     * @type {Array<PropertyType>}
     * @memberof PostBackItemsPropertyTypesFilterRequestData
     */
    propertyType?: Array<PropertyType>;
}
/**
 * 
 * @export
 * @interface PostBackItemsVariantsFilterRequest
 */
export interface PostBackItemsVariantsFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsVariantsFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsVariantsFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackItemsVariantsFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackItemsVariantsFilterRequestData}
     * @memberof PostBackItemsVariantsFilterRequest
     */
    data: PostBackItemsVariantsFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackItemsVariantsFilterRequestData
 */
export interface PostBackItemsVariantsFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    itemTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    variantName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    comboNameSearch?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    variantActive?: boolean;
    /**
     * PlaceId
     * @type {number}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    defaultPlaceId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    defaultPlaceName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    catalogNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    propertiesString?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {Array<ItemKind>}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    kind?: Array<ItemKind>;
    /**
     * VatRateId
     * @type {number}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    salesVatId?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    availableAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackItemsVariantsFilterRequestData
     */
    isInternal?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackItemsVariantsPropertySetFilterRequest
 */
export interface PostBackItemsVariantsPropertySetFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsVariantsPropertySetFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackItemsVariantsPropertySetFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackItemsVariantsPropertySetFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackItemsVariantsPropertySetFilterRequestData}
     * @memberof PostBackItemsVariantsPropertySetFilterRequest
     */
    data: PostBackItemsVariantsPropertySetFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackItemsVariantsPropertySetFilterRequestData
 */
export interface PostBackItemsVariantsPropertySetFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsPropertySetFilterRequestData
     */
    itemTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsPropertySetFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsPropertySetFilterRequestData
     */
    variantName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackItemsVariantsPropertySetFilterRequestData
     */
    catalogNumber?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackItemsVariantsPropertySetFilterRequestData
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackItemsVariantsPropertySetFilterRequestData
     */
    matchingPropertySet?: Array<string>;
}
/**
 * 
 * @export
 * @interface PostBackMachineAreasListFilterRequest
 */
export interface PostBackMachineAreasListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackMachineAreasListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackMachineAreasListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackMachineAreasListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackMachineAreasListFilterRequestData}
     * @memberof PostBackMachineAreasListFilterRequest
     */
    data: PostBackMachineAreasListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackMachineAreasListFilterRequestData
 */
export interface PostBackMachineAreasListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackMachineAreasListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackMachineAreasListFilterRequestData
     */
    externalId?: string;
}
/**
 * 
 * @export
 * @interface PostBackMachinesListFilterRequest
 */
export interface PostBackMachinesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackMachinesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackMachinesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackMachinesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackMachinesListFilterRequestData}
     * @memberof PostBackMachinesListFilterRequest
     */
    data: PostBackMachinesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackMachinesListFilterRequestData
 */
export interface PostBackMachinesListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackMachinesListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackMachinesListFilterRequestData
     */
    tag?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackMachinesListFilterRequestData
     */
    machineAreaId?: Array<number>;
}
/**
 * 
 * @export
 * @interface PostBackMarketingrulesListFilterRequest
 */
export interface PostBackMarketingrulesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackMarketingrulesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackMarketingrulesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackMarketingrulesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackMarketingrulesListFilterRequestData}
     * @memberof PostBackMarketingrulesListFilterRequest
     */
    data: PostBackMarketingrulesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackMarketingrulesListFilterRequestData
 */
export interface PostBackMarketingrulesListFilterRequestData {
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackMarketingrulesListFilterRequestData
     */
    discount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackMarketingrulesListFilterRequestData
     */
    contractorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackMarketingrulesListFilterRequestData
     */
    contractorTagName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackMarketingrulesListFilterRequestData
     */
    itemTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackMarketingrulesListFilterRequestData
     */
    itemTypeTagName?: string;
}
/**
 * 
 * @export
 * @interface PostBackMaterialMovementsListFilterRequest
 */
export interface PostBackMaterialMovementsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackMaterialMovementsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackMaterialMovementsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackMaterialMovementsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackMaterialMovementsListFilterRequestData}
     * @memberof PostBackMaterialMovementsListFilterRequest
     */
    data: PostBackMaterialMovementsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackMaterialMovementsListFilterRequestData
 */
export interface PostBackMaterialMovementsListFilterRequestData {
    /**
     * MaterialMovementId
     * @type {number}
     * @memberof PostBackMaterialMovementsListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackMaterialMovementsListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackMaterialMovementsListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackMaterialMovementsListFilterRequestData
     */
    assigneeId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackMaterialMovementsListFilterRequestData
     */
    assigneeName?: string;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackMaterialMovementsListFilterRequestData
     */
    dueDate?: FilterRangeDateTime;
    /**
     * 
     * @type {Array<MaterialMovementStatus>}
     * @memberof PostBackMaterialMovementsListFilterRequestData
     */
    status?: Array<MaterialMovementStatus>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackMaterialMovementsListFilterRequestData
     */
    applyDate?: FilterRangeOptionDateTime;
}
/**
 * 
 * @export
 * @interface PostBackMeasurementsMeasurementDevicesFilterRequest
 */
export interface PostBackMeasurementsMeasurementDevicesFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackMeasurementsMeasurementDevicesFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackMeasurementsMeasurementDevicesFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackMeasurementsMeasurementDevicesFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackMeasurementsMeasurementDevicesFilterRequestData}
     * @memberof PostBackMeasurementsMeasurementDevicesFilterRequest
     */
    data: PostBackMeasurementsMeasurementDevicesFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackMeasurementsMeasurementDevicesFilterRequestData
 */
export interface PostBackMeasurementsMeasurementDevicesFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackMeasurementsMeasurementDevicesFilterRequestData
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface PostBackOffersListFilterRequest
 */
export interface PostBackOffersListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackOffersListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackOffersListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackOffersListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackOffersListFilterRequestData}
     * @memberof PostBackOffersListFilterRequest
     */
    data: PostBackOffersListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackOffersListFilterRequestData
 */
export interface PostBackOffersListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackOffersListFilterRequestData
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOffersListFilterRequestData
     */
    supplierNumber?: string;
    /**
     * 
     * @type {Array<OfferStatus>}
     * @memberof PostBackOffersListFilterRequestData
     */
    status?: Array<OfferStatus>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOffersListFilterRequestData
     */
    buyerId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackOffersListFilterRequestData
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOffersListFilterRequestData
     */
    buyerShortName?: string;
    /**
     * 
     * @type {FilterRangeLocalDate}
     * @memberof PostBackOffersListFilterRequestData
     */
    from?: FilterRangeLocalDate;
    /**
     * 
     * @type {FilterRangeOptionLocalDate}
     * @memberof PostBackOffersListFilterRequestData
     */
    to?: FilterRangeOptionLocalDate;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackOffersListFilterRequestData
     */
    creationDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {string}
     * @memberof PostBackOffersListFilterRequestData
     */
    currencyCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOffersListFilterRequestData
     */
    userResponsibleForOffer?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOffersListFilterRequestData
     */
    userIdResponsibleForOffer?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackOffersListFilterRequestData
     */
    userResponsibleForContractor?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOffersListFilterRequestData
     */
    userIdResponsibleForContractor?: Array<number>;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackOffersListFilterRequestData
     */
    netPrice?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackOffersListFilterRequestData
     */
    grossPrice?: FilterRangeBigDecimal;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOffersListFilterRequestData
     */
    contractorTagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackOffersListFilterRequestData
     */
    contractorTags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackOffersListFilterRequestData
     */
    summary?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOffersListFilterRequestData
     */
    itemTypeVariantIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOffersListFilterRequestData
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackOffersListFilterRequestData
     */
    tagsOr?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackOffersListFilterRequestData
     */
    tagsAnd?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackOffersListFilterRequestData
     */
    hasConnectedOrders?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackOrdersEquipmentDemandsListFilterRequest
 */
export interface PostBackOrdersEquipmentDemandsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackOrdersEquipmentDemandsListFilterRequestData}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequest
     */
    data: PostBackOrdersEquipmentDemandsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackOrdersEquipmentDemandsListFilterRequestData
 */
export interface PostBackOrdersEquipmentDemandsListFilterRequestData {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequestData
     */
    salesEntryId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequestData
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequestData
     */
    equipmentName?: string;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequestData
     */
    creationDate?: FilterRangeDateTime;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequestData
     */
    externalIdAndName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersEquipmentDemandsListFilterRequestData
     */
    itemTypeTagsIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface PostBackOrdersListFilterRequest
 */
export interface PostBackOrdersListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackOrdersListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackOrdersListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackOrdersListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackOrdersListFilterRequestData}
     * @memberof PostBackOrdersListFilterRequest
     */
    data: PostBackOrdersListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackOrdersListFilterRequestData
 */
export interface PostBackOrdersListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    buyerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    buyerShortName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    buyerId?: Array<number>;
    /**
     * 
     * @type {Array<SourceType>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    sourceType?: Array<SourceType>;
    /**
     * 
     * @type {Array<OrderStatus>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    status?: Array<OrderStatus>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackOrdersListFilterRequestData
     */
    creationDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionint}
     * @memberof PostBackOrdersListFilterRequestData
     */
    paymentDeadline?: FilterRangeOptionint;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackOrdersListFilterRequestData
     */
    hasOrderItems?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    itemTypeVariantIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    authorName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackOrdersListFilterRequestData
     */
    signed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    comments?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackOrdersListFilterRequestData
     */
    cancelled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    summary?: Array<string>;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackOrdersListFilterRequestData
     */
    netPrice?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackOrdersListFilterRequestData
     */
    grossPrice?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    currency?: string;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackOrdersListFilterRequestData
     */
    budget?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    contractorTagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    contractorTags?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    tagsOr?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    tagsAnd?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    connectedOfferId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    connectedOfferNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    userResponsibleForOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersListFilterRequestData
     */
    userResponsibleForContractor?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    userIdResponsibleForOrder?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    userIdResponsibleForContractor?: Array<number>;
    /**
     * 
     * @type {FilterRangeOptionLocalDate}
     * @memberof PostBackOrdersListFilterRequestData
     */
    deliveryDate?: FilterRangeOptionLocalDate;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackOrdersListFilterRequestData
     */
    assignedWorkerIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackOrdersListFilterRequestData
     */
    isOverdue?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackOrdersOtherDemandsListFilterRequest
 */
export interface PostBackOrdersOtherDemandsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackOrdersOtherDemandsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackOrdersOtherDemandsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackOrdersOtherDemandsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackOrdersOtherDemandsListFilterRequestData}
     * @memberof PostBackOrdersOtherDemandsListFilterRequest
     */
    data: PostBackOrdersOtherDemandsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackOrdersOtherDemandsListFilterRequestData
 */
export interface PostBackOrdersOtherDemandsListFilterRequestData {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof PostBackOrdersOtherDemandsListFilterRequestData
     */
    salesEntryId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackOrdersOtherDemandsListFilterRequestData
     */
    content?: string;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackOrdersOtherDemandsListFilterRequestData
     */
    creationDate?: FilterRangeDateTime;
}
/**
 * 
 * @export
 * @interface PostBackPresentationsOrderItemsItemsGroupListFilterRequest
 */
export interface PostBackPresentationsOrderItemsItemsGroupListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackPresentationsOrderItemsItemsGroupListFilterRequestData}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequest
     */
    data: PostBackPresentationsOrderItemsItemsGroupListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
 */
export interface PostBackPresentationsOrderItemsItemsGroupListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    asyncReportId?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    contractorId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    buyerOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    itemTypeVariantName?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    orderCreationDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    deliveryDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    amount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    unitPriceInBaseCurrency?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    netValue?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    productionTimeCost?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    materialsCost?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    expectedMaterialsCost?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    estimatedProductionTimeCost?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    totalCost?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    profitMargin?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    actualVsExpectedCost?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    profitPerProductionHour?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsOrderItemsItemsGroupListFilterRequestData
     */
    contractorName?: string;
}
/**
 * 
 * @export
 * @interface PostBackPresentationsProductionLotPeriodsGroupListFilterRequest
 */
export interface PostBackPresentationsProductionLotPeriodsGroupListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequest
     */
    data: PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
 */
export interface PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    asyncReportId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    variantName?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    productionStart?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    loadingStateStart?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    productionStateStart?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    unloadingStateStart?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    productionEnd?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    productionStateAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    loadingStateAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    unloadingStateAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    expectedAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    reportedProducedAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    reportedWasteAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    reporter?: string;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    newFlexoColors?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    allFlexoColors?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    newSieveColors?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    allSieveColors?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    newStampings?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    allStampings?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    newNarrowedLacquering?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    allNarrowedLacquering?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    newNarrowedSieveLacquering?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    allNarrowedSieveLacquering?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    newExtrusions?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    allExtrusions?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    newSum?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    allSum?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    avgSpeedProductionPhase?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    actualVsExpectedLoadingTime?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    actualVsPlannedProducedAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    laminationSteps?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    lacqueringSteps?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    firstPunchingDieName?: string;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    numberOfPunchingDies?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    numberOfDefinedMaterials?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    stepsOnGlue?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    stepsOnUnderlay?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    recipeUnitType?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    machineName?: string;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    lacqueringStepsFlexo?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackPresentationsProductionLotPeriodsGroupListFilterRequestData
     */
    allLacqueringSteps?: FilterRangeOptionBigDecimal;
}
/**
 * 
 * @export
 * @interface PostBackProductcatalogListFilterRequest
 */
export interface PostBackProductcatalogListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductcatalogListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductcatalogListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductcatalogListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductcatalogListFilterRequestData}
     * @memberof PostBackProductcatalogListFilterRequest
     */
    data: PostBackProductcatalogListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductcatalogListFilterRequestData
 */
export interface PostBackProductcatalogListFilterRequestData {
    /**
     * ProductCatalogItemId
     * @type {number}
     * @memberof PostBackProductcatalogListFilterRequestData
     */
    id?: number;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof PostBackProductcatalogListFilterRequestData
     */
    itemTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductcatalogListFilterRequestData
     */
    itemTypeName?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductcatalogListFilterRequestData
     */
    price?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductcatalogListFilterRequestData
     */
    actualPrice?: FilterRangeOptionBigDecimal;
    /**
     * ContractorId
     * @type {number}
     * @memberof PostBackProductcatalogListFilterRequestData
     */
    contractorId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductcatalogListFilterRequestData
     */
    contractorName?: string;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersCreatorListFilterRequest
 */
export interface PostBackProductionOrdersCreatorListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersCreatorListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersCreatorListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersCreatorListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersCreatorListFilterRequestData}
     * @memberof PostBackProductionOrdersCreatorListFilterRequest
     */
    data: PostBackProductionOrdersCreatorListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersCreatorListFilterRequestData
 */
export interface PostBackProductionOrdersCreatorListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    productVariantId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    hasDemands?: boolean;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    dueDates?: FilterRangeDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    earliestDueDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    available?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersCreatorListFilterRequestData
     */
    minimalAmount?: FilterRangeOptionBigDecimal;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersLegacyListFilterRequest
 */
export interface PostBackProductionOrdersLegacyListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLegacyListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLegacyListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersLegacyListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersLegacyListFilterRequestData}
     * @memberof PostBackProductionOrdersLegacyListFilterRequest
     */
    data: PostBackProductionOrdersLegacyListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersLegacyListFilterRequestData
 */
export interface PostBackProductionOrdersLegacyListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyListFilterRequestData
     */
    lotNumber?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersLegacyListFilterRequestData
     */
    itemTypeVariantId?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLegacyListFilterRequestData
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {Array<LegacyProductionOrderStatus>}
     * @memberof PostBackProductionOrdersLegacyListFilterRequestData
     */
    status?: Array<LegacyProductionOrderStatus>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLegacyListFilterRequestData
     */
    dueDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackProductionOrdersLegacyListFilterRequestData
     */
    creationDate?: FilterRangeDateTime;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersLegacyLotsFilterRequest
 */
export interface PostBackProductionOrdersLegacyLotsFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersLegacyLotsFilterRequestData}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequest
     */
    data: PostBackProductionOrdersLegacyLotsFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersLegacyLotsFilterRequestData
 */
export interface PostBackProductionOrdersLegacyLotsFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    itemTypeVariantId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    itemTypeVariantName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    batchNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    contractorExternalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {Array<ProductionLotStatus>}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    status?: Array<ProductionLotStatus>;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    amount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    machineName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    specificationTagsOr?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    specificationTagsAnd?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    specificationTaskAssignee?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    specificationTaskCreationDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    specificationTaskDeadline?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    specificationTaskCompletionDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    productionEndDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    dueDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    recipeSummary?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    recipeType?: Array<number>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    orderCreationDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLegacyLotsFilterRequestData
     */
    orderItemDeliveryDate?: FilterRangeOptionDateTime;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersListFilterRequest
 */
export interface PostBackProductionOrdersListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersListFilterRequestData}
     * @memberof PostBackProductionOrdersListFilterRequest
     */
    data: PostBackProductionOrdersListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersListFilterRequestData
 */
export interface PostBackProductionOrdersListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    productIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    productNames?: Array<string>;
    /**
     * 
     * @type {Array<ProductionOrderStatus>}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    status?: Array<ProductionOrderStatus>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    dueDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    productivity?: FilterRangeBigDecimal;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    overdue?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    priority?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    noMaterials?: boolean;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    creationDate?: FilterRangeDateTime;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    productionLotTagIds?: Array<number>;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    progress?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    erpName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    erpValue?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersListFilterRequestData
     */
    comboSearch?: string;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest
 */
export interface PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequest
     */
    data: PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
 */
export interface PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
     */
    productionLotId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
     */
    usage?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
     */
    predictedUsage?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
     */
    minimalState?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLotRawMaterialsUsageListFilterRequestData
     */
    wasteAmount?: number;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersLotsListFilterRequest
 */
export interface PostBackProductionOrdersLotsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLotsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersLotsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersLotsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersLotsListFilterRequestData}
     * @memberof PostBackProductionOrdersLotsListFilterRequest
     */
    data: PostBackProductionOrdersLotsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersLotsListFilterRequestData
 */
export interface PostBackProductionOrdersLotsListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    technologyName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    productCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    orderItemNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    contractorNames?: Array<string>;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    completedAmount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    amount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {Array<ProductionLotViewStatus>}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    status?: Array<ProductionLotViewStatus>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    machineCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    machineName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    workerNames?: Array<string>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    dueDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    productionOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    seriesNumber?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    productId?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    machineId?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersLotsListFilterRequestData
     */
    productionOrderId?: Array<number>;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersOrderDemandsListFilterRequest
 */
export interface PostBackProductionOrdersOrderDemandsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersOrderDemandsListFilterRequestData}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequest
     */
    data: PostBackProductionOrdersOrderDemandsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersOrderDemandsListFilterRequestData
 */
export interface PostBackProductionOrdersOrderDemandsListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    id?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    buyerId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    buyerName?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    deliveryDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    orderNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    ordinal?: number;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    orderedAmount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersOrderDemandsListFilterRequestData
     */
    amountToProduce?: FilterRangeBigDecimal;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersProductionOrderLotsListFilterRequest
 */
export interface PostBackProductionOrdersProductionOrderLotsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersProductionOrderLotsListFilterRequestData}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequest
     */
    data: PostBackProductionOrdersProductionOrderLotsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersProductionOrderLotsListFilterRequestData
 */
export interface PostBackProductionOrdersProductionOrderLotsListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    comboSearch?: string;
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    productionOrderId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    technologyName?: string;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    recipeType?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    priority?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    incomplete?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    productCode?: string;
    /**
     * 
     * @type {Array<ProductionLotStatus>}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    status?: Array<ProductionLotStatus>;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    completedAmount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    noksAmount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    amount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    start?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    end?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    dueDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    workerNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    machineCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    machineName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    orderItemNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    contractorNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    productionOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    externalOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    seriesNumber?: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    productId?: number;
    /**
     * MachineId
     * @type {number}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    machineId?: number;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackProductionOrdersProductionOrderLotsListFilterRequestData
     */
    initialPlannedStartDate?: FilterRangeOptionDateTime;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersRawMaterialsUsageListFilterRequest
 */
export interface PostBackProductionOrdersRawMaterialsUsageListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersRawMaterialsUsageListFilterRequestData}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequest
     */
    data: PostBackProductionOrdersRawMaterialsUsageListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
 */
export interface PostBackProductionOrdersRawMaterialsUsageListFilterRequestData {
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
     */
    productionOrderId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
     */
    usage?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
     */
    predictedUsage?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
     */
    minimalState?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersRawMaterialsUsageListFilterRequestData
     */
    wasteAmount?: number;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersWarehouseStateListFilterRequest
 */
export interface PostBackProductionOrdersWarehouseStateListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersWarehouseStateListFilterRequestData}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequest
     */
    data: PostBackProductionOrdersWarehouseStateListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersWarehouseStateListFilterRequestData
 */
export interface PostBackProductionOrdersWarehouseStateListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    date?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    itemTypeVariantId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    code?: string;
    /**
     * ItemTypeTagIds
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    itemTypeTagIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    available?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    minimalState?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    nowInWarehouses?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    inProduction?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    demand?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    ordered?: FilterRangeBigDecimal;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    placeId?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackProductionOrdersWarehouseStateListFilterRequestData
     */
    hasNegativeAvailable?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersWarehouseToProductionListFilterRequest
 */
export interface PostBackProductionOrdersWarehouseToProductionListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersWarehouseToProductionListFilterRequestData}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequest
     */
    data: PostBackProductionOrdersWarehouseToProductionListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersWarehouseToProductionListFilterRequestData
 */
export interface PostBackProductionOrdersWarehouseToProductionListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    itemTypeVariantId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    available?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    minimalState?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    nowInWarehouses?: FilterRangeBigDecimal;
    /**
     * PlaceId
     * @type {number}
     * @memberof PostBackProductionOrdersWarehouseToProductionListFilterRequestData
     */
    placeId?: number;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersWorktimeListFilterRequest
 */
export interface PostBackProductionOrdersWorktimeListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionOrdersWorktimeListFilterRequestData}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequest
     */
    data: PostBackProductionOrdersWorktimeListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionOrdersWorktimeListFilterRequestData
 */
export interface PostBackProductionOrdersWorktimeListFilterRequestData {
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    productionOrderId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    machineCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    machineName?: string;
    /**
     * 
     * @type {FilterRangeOptionDuration}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    oksProduction?: FilterRangeOptionDuration;
    /**
     * 
     * @type {FilterRangeOptionDuration}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    noksProduction?: FilterRangeOptionDuration;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    wasteRatio?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    workstationEfficiency?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    referenceEfficiency?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionDuration}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    setupState?: FilterRangeOptionDuration;
    /**
     * 
     * @type {FilterRangeOptionDuration}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    idleState?: FilterRangeOptionDuration;
    /**
     * 
     * @type {FilterRangeOptionDuration}
     * @memberof PostBackProductionOrdersWorktimeListFilterRequestData
     */
    totalTime?: FilterRangeOptionDuration;
}
/**
 * 
 * @export
 * @interface PostBackProductionSpecificationTagsListFilterRequest
 */
export interface PostBackProductionSpecificationTagsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionSpecificationTagsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackProductionSpecificationTagsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackProductionSpecificationTagsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackProductionSpecificationTagsListFilterRequestData}
     * @memberof PostBackProductionSpecificationTagsListFilterRequest
     */
    data: PostBackProductionSpecificationTagsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackProductionSpecificationTagsListFilterRequestData
 */
export interface PostBackProductionSpecificationTagsListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackProductionSpecificationTagsListFilterRequestData
     */
    id?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionSpecificationTagsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionSpecificationTagsListFilterRequestData
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackProductionSpecificationTagsListFilterRequestData
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface PostBackPushListFilterRequest
 */
export interface PostBackPushListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackPushListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackPushListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackPushListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackPushListFilterRequestData}
     * @memberof PostBackPushListFilterRequest
     */
    data: PostBackPushListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackPushListFilterRequestData
 */
export interface PostBackPushListFilterRequestData {
    /**
     * PushStatusId
     * @type {number}
     * @memberof PostBackPushListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackPushListFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {Array<DocumentTypes>}
     * @memberof PostBackPushListFilterRequestData
     */
    documentType?: Array<DocumentTypes>;
    /**
     * 
     * @type {Array<PushStatusTypes>}
     * @memberof PostBackPushListFilterRequestData
     */
    status?: Array<PushStatusTypes>;
    /**
     * 
     * @type {string}
     * @memberof PostBackPushListFilterRequestData
     */
    error?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPushListFilterRequestData
     */
    syncAttemptTime?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackPushListFilterRequestData
     */
    lastSuccessfulSyncTime?: FilterRangeOptionDateTime;
}
/**
 * 
 * @export
 * @interface PostBackQsCardListFilterRequest
 */
export interface PostBackQsCardListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackQsCardListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackQsCardListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackQsCardListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackQsCardListFilterRequestData}
     * @memberof PostBackQsCardListFilterRequest
     */
    data: PostBackQsCardListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackQsCardListFilterRequestData
 */
export interface PostBackQsCardListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackQsCardListFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackQsCardListFilterRequestData
     */
    supplyOrderNumber?: string;
    /**
     * SupplyOrderIds
     * @type {Array<number>}
     * @memberof PostBackQsCardListFilterRequestData
     */
    supplyOrderIds?: Array<number>;
    /**
     * ContractorId
     * @type {number}
     * @memberof PostBackQsCardListFilterRequestData
     */
    supplierId?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackQsCardListFilterRequestData
     */
    cardNumbers?: string;
    /**
     * WarehouseTagId
     * @type {Array<number>}
     * @memberof PostBackQsCardListFilterRequestData
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackQsCardListFilterRequestData
     */
    recipientFullName?: string;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackQsCardListFilterRequestData
     */
    deliveryDate?: FilterRangeDateTime;
    /**
     * 
     * @type {string}
     * @memberof PostBackQsCardListFilterRequestData
     */
    contractorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackQsCardListFilterRequestData
     */
    contractorShortName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackQsCardListFilterRequestData
     */
    placeName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackQsCardListFilterRequestData
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackQsCardListFilterRequestData
     */
    isDraft?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostBackQsCardListFilterRequestData
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface PostBackReleasesListFilterRequest
 */
export interface PostBackReleasesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackReleasesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackReleasesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackReleasesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackReleasesListFilterRequestData}
     * @memberof PostBackReleasesListFilterRequest
     */
    data: PostBackReleasesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackReleasesListFilterRequestData
 */
export interface PostBackReleasesListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackReleasesListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesListFilterRequestData
     */
    recipientIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackReleasesListFilterRequestData
     */
    orderNumbers?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesListFilterRequestData
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesListFilterRequestData
     */
    itemTypeTagIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesListFilterRequestData
     */
    variantIds?: Array<number>;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackReleasesListFilterRequestData
     */
    plannedReleaseDueDate?: FilterRangeDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackReleasesListFilterRequestData
     */
    orderDueDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackReleasesListFilterRequestData
     */
    releaseDate?: FilterRangeDateTime;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesListFilterRequestData
     */
    releaserId?: Array<number>;
}
/**
 * 
 * @export
 * @interface PostBackReleasesPlanListFilterRequest
 */
export interface PostBackReleasesPlanListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackReleasesPlanListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackReleasesPlanListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackReleasesPlanListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackReleasesPlanListFilterRequestData}
     * @memberof PostBackReleasesPlanListFilterRequest
     */
    data: PostBackReleasesPlanListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackReleasesPlanListFilterRequestData
 */
export interface PostBackReleasesPlanListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackReleasesPlanListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesPlanListFilterRequestData
     */
    recipientIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackReleasesPlanListFilterRequestData
     */
    orderNumbers?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesPlanListFilterRequestData
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesPlanListFilterRequestData
     */
    itemTypeTagIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReleasesPlanListFilterRequestData
     */
    variantIds?: Array<number>;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackReleasesPlanListFilterRequestData
     */
    dueDate?: FilterRangeDateTime;
    /**
     * 
     * @type {Array<LegacyReleasePlanStatus>}
     * @memberof PostBackReleasesPlanListFilterRequestData
     */
    status?: Array<LegacyReleasePlanStatus>;
}
/**
 * 
 * @export
 * @interface PostBackReportsDowntimeReasonsFilterRequest
 */
export interface PostBackReportsDowntimeReasonsFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackReportsDowntimeReasonsFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackReportsDowntimeReasonsFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackReportsDowntimeReasonsFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackReportsDowntimeReasonsFilterRequestData}
     * @memberof PostBackReportsDowntimeReasonsFilterRequest
     */
    data: PostBackReportsDowntimeReasonsFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackReportsDowntimeReasonsFilterRequestData
 */
export interface PostBackReportsDowntimeReasonsFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackReportsDowntimeReasonsFilterRequestData
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackReportsDowntimeReasonsFilterRequestData
     */
    isBreakdown?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackReportsLoadCardsListFilterRequest
 */
export interface PostBackReportsLoadCardsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackReportsLoadCardsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackReportsLoadCardsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackReportsLoadCardsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackReportsLoadCardsListFilterRequestData}
     * @memberof PostBackReportsLoadCardsListFilterRequest
     */
    data: PostBackReportsLoadCardsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackReportsLoadCardsListFilterRequestData
 */
export interface PostBackReportsLoadCardsListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackReportsLoadCardsListFilterRequestData
     */
    itemTypeVariantId?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackReportsLoadCardsListFilterRequestData
     */
    finalized?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackReportsLoadCardsListFilterRequestData
     */
    linked?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackSalesDocumentsListFilterRequest
 */
export interface PostBackSalesDocumentsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSalesDocumentsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSalesDocumentsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSalesDocumentsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSalesDocumentsListFilterRequestData}
     * @memberof PostBackSalesDocumentsListFilterRequest
     */
    data: PostBackSalesDocumentsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSalesDocumentsListFilterRequestData
 */
export interface PostBackSalesDocumentsListFilterRequestData {
    /**
     * SalesEntryDocumentId
     * @type {number}
     * @memberof PostBackSalesDocumentsListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackSalesDocumentsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSalesDocumentsListFilterRequestData
     */
    fileName?: string;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof PostBackSalesDocumentsListFilterRequestData
     */
    salesEntryId?: number;
    /**
     * 
     * @type {Array<SalesEntryDocumentType>}
     * @memberof PostBackSalesDocumentsListFilterRequestData
     */
    documentType?: Array<SalesEntryDocumentType>;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackSalesDocumentsListFilterRequestData
     */
    amount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackSalesDocumentsListFilterRequestData
     */
    creationDate?: FilterRangeDateTime;
}
/**
 * 
 * @export
 * @interface PostBackSalesTagsListFilterRequest
 */
export interface PostBackSalesTagsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSalesTagsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSalesTagsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSalesTagsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSalesTagsListFilterRequestData}
     * @memberof PostBackSalesTagsListFilterRequest
     */
    data: PostBackSalesTagsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSalesTagsListFilterRequestData
 */
export interface PostBackSalesTagsListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackSalesTagsListFilterRequestData
     */
    id?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackSalesTagsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSalesTagsListFilterRequestData
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSalesTagsListFilterRequestData
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface PostBackShippingDriversListFilterRequest
 */
export interface PostBackShippingDriversListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackShippingDriversListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackShippingDriversListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackShippingDriversListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackShippingDriversListFilterRequestData}
     * @memberof PostBackShippingDriversListFilterRequest
     */
    data: PostBackShippingDriversListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackShippingDriversListFilterRequestData
 */
export interface PostBackShippingDriversListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackShippingDriversListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackShippingDriversListFilterRequestData
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackShippingDriversListFilterRequestData
     */
    externalLogisticsProviderName?: string;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsByMachineFeaturesListFilterRequest
 */
export interface PostBackSpecificationsByMachineFeaturesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsByMachineFeaturesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsByMachineFeaturesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSpecificationsByMachineFeaturesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSpecificationsByMachineFeaturesListFilterRequestData}
     * @memberof PostBackSpecificationsByMachineFeaturesListFilterRequest
     */
    data: PostBackSpecificationsByMachineFeaturesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsByMachineFeaturesListFilterRequestData
 */
export interface PostBackSpecificationsByMachineFeaturesListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsByMachineFeaturesListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsByMachineFeaturesListFilterRequestData
     */
    itemType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackSpecificationsByMachineFeaturesListFilterRequestData
     */
    machineFeatures?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSpecificationsByMachineFeaturesListFilterRequestData
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsByProducedItemTagsListFilterRequest
 */
export interface PostBackSpecificationsByProducedItemTagsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsByProducedItemTagsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsByProducedItemTagsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSpecificationsByProducedItemTagsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSpecificationsByProducedItemTagsListFilterRequestData}
     * @memberof PostBackSpecificationsByProducedItemTagsListFilterRequest
     */
    data: PostBackSpecificationsByProducedItemTagsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsByProducedItemTagsListFilterRequestData
 */
export interface PostBackSpecificationsByProducedItemTagsListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsByProducedItemTagsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackSpecificationsByProducedItemTagsListFilterRequestData
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSpecificationsByProducedItemTagsListFilterRequestData
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsByProducedVariantListFilterRequest
 */
export interface PostBackSpecificationsByProducedVariantListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSpecificationsByProducedVariantListFilterRequestData}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequest
     */
    data: PostBackSpecificationsByProducedVariantListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsByProducedVariantListFilterRequestData
 */
export interface PostBackSpecificationsByProducedVariantListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequestData
     */
    itemType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequestData
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequestData
     */
    _default?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackSpecificationsByProducedVariantListFilterRequestData
     */
    recipeSummary?: Array<string>;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsStandardParametersFilterRequest
 */
export interface PostBackSpecificationsStandardParametersFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsStandardParametersFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsStandardParametersFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSpecificationsStandardParametersFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSpecificationsStandardParametersFilterRequestData}
     * @memberof PostBackSpecificationsStandardParametersFilterRequest
     */
    data: PostBackSpecificationsStandardParametersFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsStandardParametersFilterRequestData
 */
export interface PostBackSpecificationsStandardParametersFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsStandardParametersFilterRequestData
     */
    parameter?: string;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsV2ByProducedVariantListFilterRequest
 */
export interface PostBackSpecificationsV2ByProducedVariantListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSpecificationsV2ByProducedVariantListFilterRequestData}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequest
     */
    data: PostBackSpecificationsV2ByProducedVariantListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSpecificationsV2ByProducedVariantListFilterRequestData
 */
export interface PostBackSpecificationsV2ByProducedVariantListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequestData
     */
    specificationTemplateName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequestData
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequestData
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequestData
     */
    isFromErp?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostBackSpecificationsV2ByProducedVariantListFilterRequestData
     */
    unitType?: string;
}
/**
 * 
 * @export
 * @interface PostBackStocksDemandsListFilterRequest
 */
export interface PostBackStocksDemandsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackStocksDemandsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackStocksDemandsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackStocksDemandsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackStocksDemandsListFilterRequestData}
     * @memberof PostBackStocksDemandsListFilterRequest
     */
    data: PostBackStocksDemandsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackStocksDemandsListFilterRequestData
 */
export interface PostBackStocksDemandsListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocksDemandsListFilterRequestData
     */
    variantId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocksDemandsListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocksDemandsListFilterRequestData
     */
    placeName?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackStocksDemandsListFilterRequestData
     */
    occurrence?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {Array<BaseStockInteractionTypes>}
     * @memberof PostBackStocksDemandsListFilterRequestData
     */
    sourceType?: Array<BaseStockInteractionTypes>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackStocksDemandsListFilterRequestData
     */
    isFulfilled?: boolean;
    /**
     * 
     * @type {Array<DestinationType>}
     * @memberof PostBackStocksDemandsListFilterRequestData
     */
    demandDestination?: Array<DestinationType>;
    /**
     * 
     * @type {Array<CertaintyType>}
     * @memberof PostBackStocksDemandsListFilterRequestData
     */
    certainty?: Array<CertaintyType>;
}
/**
 * 
 * @export
 * @interface PostBackStocksListFilterRequest
 */
export interface PostBackStocksListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackStocksListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackStocksListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackStocksListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackStocksListFilterRequestData}
     * @memberof PostBackStocksListFilterRequest
     */
    data: PostBackStocksListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackStocksListFilterRequestData
 */
export interface PostBackStocksListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocksListFilterRequestData
     */
    variantId?: Array<number>;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackStocksListFilterRequestData
     */
    amount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocksListFilterRequestData
     */
    placeName?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackStocksListFilterRequestData
     */
    occurrence?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {Array<BaseStockInteractionTypes>}
     * @memberof PostBackStocksListFilterRequestData
     */
    sourceType?: Array<BaseStockInteractionTypes>;
    /**
     * 
     * @type {Array<DestinationTypeExtended>}
     * @memberof PostBackStocksListFilterRequestData
     */
    demandDestination?: Array<DestinationTypeExtended>;
}
/**
 * 
 * @export
 * @interface PostBackStocksSupplementListFilterRequest
 */
export interface PostBackStocksSupplementListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackStocksSupplementListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackStocksSupplementListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackStocksSupplementListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackStocksSupplementListFilterRequestData}
     * @memberof PostBackStocksSupplementListFilterRequest
     */
    data: PostBackStocksSupplementListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackStocksSupplementListFilterRequestData
 */
export interface PostBackStocksSupplementListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackStocksSupplementListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackStocksSupplementListFilterRequestData
     */
    occurrenceOfStockUnderMinAmount?: FilterRangeDateTime;
}
/**
 * 
 * @export
 * @interface PostBackStocktakingCountsheetListFilterRequest
 */
export interface PostBackStocktakingCountsheetListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackStocktakingCountsheetListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackStocktakingCountsheetListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackStocktakingCountsheetListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackStocktakingCountsheetListFilterRequestData}
     * @memberof PostBackStocktakingCountsheetListFilterRequest
     */
    data: PostBackStocktakingCountsheetListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackStocktakingCountsheetListFilterRequestData
 */
export interface PostBackStocktakingCountsheetListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    id?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    stocktakingId?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    countsheetId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    productId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    productCode?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    productionUnitId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    systemAmount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    entryAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    diff?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    placeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    placeLabel?: string;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    value?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    valueDiff?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackStocktakingCountsheetListFilterRequestData
     */
    counted?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackStocktakingListFilterRequest
 */
export interface PostBackStocktakingListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackStocktakingListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackStocktakingListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackStocktakingListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackStocktakingListFilterRequestData}
     * @memberof PostBackStocktakingListFilterRequest
     */
    data: PostBackStocktakingListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackStocktakingListFilterRequestData
 */
export interface PostBackStocktakingListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    id?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    places?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    placeNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    workerIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    workerNames?: Array<string>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    start?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    end?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {Array<StocktakingStatus>}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    status?: Array<StocktakingStatus>;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    comment?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    acceptanceDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    acceptorId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    acceptorName?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackStocktakingListFilterRequestData
     */
    progress?: FilterRangeBigDecimal;
}
/**
 * 
 * @export
 * @interface PostBackSupplyListFilterRequest
 */
export interface PostBackSupplyListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSupplyListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSupplyListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSupplyListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSupplyListFilterRequestData}
     * @memberof PostBackSupplyListFilterRequest
     */
    data: PostBackSupplyListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSupplyListFilterRequestData
 */
export interface PostBackSupplyListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyListFilterRequestData
     */
    authorFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyListFilterRequestData
     */
    authorLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyListFilterRequestData
     */
    lockedByUserFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyListFilterRequestData
     */
    internalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyListFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackSupplyListFilterRequestData
     */
    supplierId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyListFilterRequestData
     */
    supplierName?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackSupplyListFilterRequestData
     */
    netValue?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackSupplyListFilterRequestData
     */
    grossValue?: FilterRangeBigDecimal;
    /**
     * 
     * @type {Array<InferredSupplyOrderStatus>}
     * @memberof PostBackSupplyListFilterRequestData
     */
    inferredStatus?: Array<InferredSupplyOrderStatus>;
    /**
     * 
     * @type {Array<SupplyOrderStatus>}
     * @memberof PostBackSupplyListFilterRequestData
     */
    status?: Array<SupplyOrderStatus>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackSupplyListFilterRequestData
     */
    plannedReceptionDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionLocalDate}
     * @memberof PostBackSupplyListFilterRequestData
     */
    deliveryDate?: FilterRangeOptionLocalDate;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackSupplyListFilterRequestData
     */
    creationDate?: FilterRangeDateTime;
    /**
     * WarehouseTagId
     * @type {Array<number>}
     * @memberof PostBackSupplyListFilterRequestData
     */
    tagIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface PostBackSupplyOrdersCreatorListFilterRequest
 */
export interface PostBackSupplyOrdersCreatorListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSupplyOrdersCreatorListFilterRequestData}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequest
     */
    data: PostBackSupplyOrdersCreatorListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSupplyOrdersCreatorListFilterRequestData
 */
export interface PostBackSupplyOrdersCreatorListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    productVariantId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    productName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    hasDemands?: boolean;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    dueDates?: FilterRangeDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    earliestDueDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    available?: FilterRangeBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    minimalAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackSupplyOrdersCreatorListFilterRequestData
     */
    itemTypeTagIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface PostBackSupplyWarehouseTagListFilterRequest
 */
export interface PostBackSupplyWarehouseTagListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackSupplyWarehouseTagListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackSupplyWarehouseTagListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackSupplyWarehouseTagListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackSupplyWarehouseTagListFilterRequestData}
     * @memberof PostBackSupplyWarehouseTagListFilterRequest
     */
    data: PostBackSupplyWarehouseTagListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackSupplyWarehouseTagListFilterRequestData
 */
export interface PostBackSupplyWarehouseTagListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackSupplyWarehouseTagListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackSupplyWarehouseTagListFilterRequestData
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackTicketsListFilterRequest
 */
export interface PostBackTicketsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackTicketsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackTicketsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackTicketsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackTicketsListFilterRequestData}
     * @memberof PostBackTicketsListFilterRequest
     */
    data: PostBackTicketsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackTicketsListFilterRequestData
 */
export interface PostBackTicketsListFilterRequestData {
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackTicketsListFilterRequestData
     */
    dateCreated?: FilterRangeDateTime;
    /**
     * 
     * @type {Array<TaskTicketType>}
     * @memberof PostBackTicketsListFilterRequestData
     */
    ticketType?: Array<TaskTicketType>;
    /**
     * 
     * @type {Array<TaskTicketStatus>}
     * @memberof PostBackTicketsListFilterRequestData
     */
    status?: Array<TaskTicketStatus>;
    /**
     * 
     * @type {string}
     * @memberof PostBackTicketsListFilterRequestData
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackTicketsListFilterRequestData
     */
    resolution?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackTicketsListFilterRequestData
     */
    creatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackTicketsListFilterRequestData
     */
    resolverName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackTicketsListFilterRequestData
     */
    isResolverDefined?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackUnitsBlobsListFilterRequest
 */
export interface PostBackUnitsBlobsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsBlobsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsBlobsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackUnitsBlobsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackUnitsBlobsListFilterRequestData}
     * @memberof PostBackUnitsBlobsListFilterRequest
     */
    data: PostBackUnitsBlobsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackUnitsBlobsListFilterRequestData
 */
export interface PostBackUnitsBlobsListFilterRequestData {
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackUnitsBlobsListFilterRequestData
     */
    itemTypeVariantId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsBlobsListFilterRequestData
     */
    itemTypeVariantName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsBlobsListFilterRequestData
     */
    placeName?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackUnitsBlobsListFilterRequestData
     */
    amount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsBlobsListFilterRequestData
     */
    unitType?: string;
}
/**
 * 
 * @export
 * @interface PostBackUnitsEquipmentListFilterRequest
 */
export interface PostBackUnitsEquipmentListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsEquipmentListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsEquipmentListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackUnitsEquipmentListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackUnitsEquipmentListFilterRequestData}
     * @memberof PostBackUnitsEquipmentListFilterRequest
     */
    data: PostBackUnitsEquipmentListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackUnitsEquipmentListFilterRequestData
 */
export interface PostBackUnitsEquipmentListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    variantName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {Array<BorrowStatus>}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    status?: Array<BorrowStatus>;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    itemTypeShortName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    placeName?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    lastUsage?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    receptionDate?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsEquipmentListFilterRequestData
     */
    defaultPlaceName?: string;
}
/**
 * 
 * @export
 * @interface PostBackUnitsItemsListFilterRequest
 */
export interface PostBackUnitsItemsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsItemsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsItemsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackUnitsItemsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackUnitsItemsListFilterRequestData}
     * @memberof PostBackUnitsItemsListFilterRequest
     */
    data: PostBackUnitsItemsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackUnitsItemsListFilterRequestData
 */
export interface PostBackUnitsItemsListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    catalogNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    amount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {Array<ItemTypeStatus>}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    status?: Array<ItemTypeStatus>;
    /**
     * 
     * @type {Array<ItemKind>}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    kind?: Array<ItemKind>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    propertiesValues?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    variantsNames?: string;
    /**
     * Object with keys equal to property type names and values as objects containing either string (for string values) or range (for numeric values) inside
     * @type {{ [key: string]: MapFunction1StringPropertyFilterValue; }}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    properties?: { [key: string]: MapFunction1StringPropertyFilterValue; };
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    technologyIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    technologyNames?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    technologiesActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    noTechnologies?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    variantsCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    ean?: string;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    minimalAmount?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeOptionBigDecimal}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    minimalAmountPercentageFilled?: FilterRangeOptionBigDecimal;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    creationDate?: FilterRangeDateTime;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsItemsListFilterRequestData
     */
    defaultPlaceName?: string;
}
/**
 * 
 * @export
 * @interface PostBackUnitsListFilterRequest
 */
export interface PostBackUnitsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackUnitsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackUnitsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackUnitsListFilterRequestData}
     * @memberof PostBackUnitsListFilterRequest
     */
    data: PostBackUnitsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackUnitsListFilterRequestData
 */
export interface PostBackUnitsListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackUnitsListFilterRequestData
     */
    isInErp?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsListFilterRequestData
     */
    externalId?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackUnitsListFilterRequestData
     */
    itemTypeVariantId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsListFilterRequestData
     */
    lotNumber?: string;
    /**
     * 
     * @type {FilterRangeBigDecimal}
     * @memberof PostBackUnitsListFilterRequestData
     */
    amount?: FilterRangeBigDecimal;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsListFilterRequestData
     */
    unitType?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackUnitsListFilterRequestData
     */
    placeId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsListFilterRequestData
     */
    placeName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackUnitsListFilterRequestData
     */
    placeLabel?: string;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostBackUnitsListFilterRequestData
     */
    receptionDate?: FilterRangeOptionDateTime;
}
/**
 * 
 * @export
 * @interface PostBackVehiclesListFilterRequest
 */
export interface PostBackVehiclesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackVehiclesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackVehiclesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackVehiclesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackVehiclesListFilterRequestData}
     * @memberof PostBackVehiclesListFilterRequest
     */
    data: PostBackVehiclesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackVehiclesListFilterRequestData
 */
export interface PostBackVehiclesListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackVehiclesListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackVehiclesListFilterRequestData
     */
    registrationNumber?: string;
    /**
     * 
     * @type {Array<VehicleStatus>}
     * @memberof PostBackVehiclesListFilterRequestData
     */
    status?: Array<VehicleStatus>;
}
/**
 * 
 * @export
 * @interface PostBackWorkersCompetenceCategoriesListFilterRequest
 */
export interface PostBackWorkersCompetenceCategoriesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersCompetenceCategoriesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersCompetenceCategoriesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackWorkersCompetenceCategoriesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackWorkersCompetenceCategoriesListFilterRequestData}
     * @memberof PostBackWorkersCompetenceCategoriesListFilterRequest
     */
    data: PostBackWorkersCompetenceCategoriesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackWorkersCompetenceCategoriesListFilterRequestData
 */
export interface PostBackWorkersCompetenceCategoriesListFilterRequestData {
    /**
     * CompetenceCategoryId
     * @type {number}
     * @memberof PostBackWorkersCompetenceCategoriesListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersCompetenceCategoriesListFilterRequestData
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface PostBackWorkersCompetencesListFilterRequest
 */
export interface PostBackWorkersCompetencesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersCompetencesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersCompetencesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackWorkersCompetencesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackWorkersCompetencesListFilterRequestData}
     * @memberof PostBackWorkersCompetencesListFilterRequest
     */
    data: PostBackWorkersCompetencesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackWorkersCompetencesListFilterRequestData
 */
export interface PostBackWorkersCompetencesListFilterRequestData {
    /**
     * CompetenceId
     * @type {number}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    categoryName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    nameAndCategory?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    competenceCategoryId?: Array<number>;
    /**
     * 
     * @type {Array<CompetenceKind>}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    kind?: Array<CompetenceKind>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    hasFiles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    hasAuthority?: boolean;
    /**
     * 
     * @type {Array<EvaluationModeType>}
     * @memberof PostBackWorkersCompetencesListFilterRequestData
     */
    evaluationModeType?: Array<EvaluationModeType>;
}
/**
 * 
 * @export
 * @interface PostBackWorkersCompetencesMatrixListFilterRequest
 */
export interface PostBackWorkersCompetencesMatrixListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackWorkersCompetencesMatrixListFilterRequestData}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequest
     */
    data: PostBackWorkersCompetencesMatrixListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackWorkersCompetencesMatrixListFilterRequestData
 */
export interface PostBackWorkersCompetencesMatrixListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    comboSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    lastName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    roleIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    competenceIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    competenceCategoryIds?: Array<number>;
    /**
     * 
     * @type {Array<CompetenceKind>}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    competenceKinds?: Array<CompetenceKind>;
    /**
     * 
     * @type {Array<EvaluationModeType>}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    competenceEvaluationModes?: Array<EvaluationModeType>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackWorkersCompetencesMatrixListFilterRequestData
     */
    competenceOverdue?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackWorkersDocumentsListFilterRequest
 */
export interface PostBackWorkersDocumentsListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersDocumentsListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersDocumentsListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackWorkersDocumentsListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackWorkersDocumentsListFilterRequestData}
     * @memberof PostBackWorkersDocumentsListFilterRequest
     */
    data: PostBackWorkersDocumentsListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackWorkersDocumentsListFilterRequestData
 */
export interface PostBackWorkersDocumentsListFilterRequestData {
    /**
     * WorkerDocumentId
     * @type {number}
     * @memberof PostBackWorkersDocumentsListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersDocumentsListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersDocumentsListFilterRequestData
     */
    fileName?: string;
    /**
     * WorkerId
     * @type {number}
     * @memberof PostBackWorkersDocumentsListFilterRequestData
     */
    workerId?: number;
    /**
     * 
     * @type {Array<WorkerDocumentType>}
     * @memberof PostBackWorkersDocumentsListFilterRequestData
     */
    documentType?: Array<WorkerDocumentType>;
    /**
     * 
     * @type {FilterRangeOptionLocalDate}
     * @memberof PostBackWorkersDocumentsListFilterRequestData
     */
    dueDate?: FilterRangeOptionLocalDate;
    /**
     * 
     * @type {FilterRangeDateTime}
     * @memberof PostBackWorkersDocumentsListFilterRequestData
     */
    creationDate?: FilterRangeDateTime;
}
/**
 * 
 * @export
 * @interface PostBackWorkersListFilterRequest
 */
export interface PostBackWorkersListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackWorkersListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackWorkersListFilterRequestData}
     * @memberof PostBackWorkersListFilterRequest
     */
    data: PostBackWorkersListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackWorkersListFilterRequestData
 */
export interface PostBackWorkersListFilterRequestData {
    /**
     * WorkerId
     * @type {number}
     * @memberof PostBackWorkersListFilterRequestData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersListFilterRequestData
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersListFilterRequestData
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersListFilterRequestData
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersListFilterRequestData
     */
    login?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersListFilterRequestData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersListFilterRequestData
     */
    phone?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostBackWorkersListFilterRequestData
     */
    roles?: Array<string>;
    /**
     * Array of roles ids
     * @type {Array<number>}
     * @memberof PostBackWorkersListFilterRequestData
     */
    rolesIds?: Array<number>;
    /**
     * List of competences names
     * @type {Array<string>}
     * @memberof PostBackWorkersListFilterRequestData
     */
    competences?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackWorkersListFilterRequestData
     */
    closestDueDate?: boolean;
    /**
     * Array of competences ids
     * @type {Array<number>}
     * @memberof PostBackWorkersListFilterRequestData
     */
    competencesIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackWorkersListFilterRequestData
     */
    active?: boolean;
}
/**
 * 
 * @export
 * @interface PostBackWorkersWorkerCompetencesListFilterRequest
 */
export interface PostBackWorkersWorkerCompetencesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostBackWorkersWorkerCompetencesListFilterRequestData}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequest
     */
    data: PostBackWorkersWorkerCompetencesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostBackWorkersWorkerCompetencesListFilterRequestData
 */
export interface PostBackWorkersWorkerCompetencesListFilterRequestData {
    /**
     * WorkerCompetenceId
     * @type {number}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    workerCompetenceId?: number;
    /**
     * WorkerId
     * @type {number}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    workerId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    competenceId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    competenceName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    competenceCategoryId?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    competenceCategoryName?: string;
    /**
     * 
     * @type {Array<CompetenceRate>}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    rate?: Array<CompetenceRate>;
    /**
     * 
     * @type {string}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    achievementDate?: string;
    /**
     * 
     * @type {FilterRangeOptionLocalDate}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    expiryDate?: FilterRangeOptionLocalDate;
    /**
     * 
     * @type {boolean}
     * @memberof PostBackWorkersWorkerCompetencesListFilterRequestData
     */
    isfileAttached?: boolean;
}
/**
 * 
 * @export
 * @interface PostUmRolesListFilterRequest
 */
export interface PostUmRolesListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostUmRolesListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostUmRolesListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostUmRolesListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostUmRolesListFilterRequestData}
     * @memberof PostUmRolesListFilterRequest
     */
    data: PostUmRolesListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostUmRolesListFilterRequestData
 */
export interface PostUmRolesListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostUmRolesListFilterRequestData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUmRolesListFilterRequestData
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface PostUmUsersListFilterRequest
 */
export interface PostUmUsersListFilterRequest {
    /**
     * 
     * @type {number}
     * @memberof PostUmUsersListFilterRequest
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof PostUmUsersListFilterRequest
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof PostUmUsersListFilterRequest
     */
    ordering?: Order;
    /**
     * 
     * @type {PostUmUsersListFilterRequestData}
     * @memberof PostUmUsersListFilterRequest
     */
    data: PostUmUsersListFilterRequestData;
}
/**
 * 
 * @export
 * @interface PostUmUsersListFilterRequestData
 */
export interface PostUmUsersListFilterRequestData {
    /**
     * 
     * @type {string}
     * @memberof PostUmUsersListFilterRequestData
     */
    login?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUmUsersListFilterRequestData
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUmUsersListFilterRequestData
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUmUsersListFilterRequestData
     */
    comboNameSearch?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUmUsersListFilterRequestData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PostUmUsersListFilterRequestData
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PostUmUsersListFilterRequestData
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostUmUsersListFilterRequestData
     */
    hidden?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostUmUsersListFilterRequestData
     */
    blocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PostUmUsersListFilterRequestData
     */
    isWorker?: boolean;
    /**
     * Array of roles ids
     * @type {Array<number>}
     * @memberof PostUmUsersListFilterRequestData
     */
    roleIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostUmUsersListFilterRequestData
     */
    roleNames?: Array<string>;
    /**
     * 
     * @type {FilterRangeOptionDateTime}
     * @memberof PostUmUsersListFilterRequestData
     */
    lastLogin?: FilterRangeOptionDateTime;
    /**
     * 
     * @type {boolean}
     * @memberof PostUmUsersListFilterRequestData
     */
    hasRfid?: boolean;
}
/**
 * 
 * @export
 * @interface PreviewLink
 */
export interface PreviewLink {
    /**
     * PreviewLinkId
     * @type {number}
     * @memberof PreviewLink
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PreviewLink
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewLink
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PreviewLink
     */
    ordinal?: number;
}
/**
 * 
 * @export
 * @interface PriceCalculationInputView
 */
export interface PriceCalculationInputView {
    /**
     * 
     * @type {ProductSpecificationGraph}
     * @memberof PriceCalculationInputView
     */
    productSpecificationGraph: ProductSpecificationGraph;
    /**
     * ContractorId
     * @type {number}
     * @memberof PriceCalculationInputView
     */
    contractorId: number;
    /**
     * 
     * @type {CalculationInputAmount}
     * @memberof PriceCalculationInputView
     */
    amount: CalculationInputAmount;
    /**
     * 
     * @type {number}
     * @memberof PriceCalculationInputView
     */
    profitMargin?: number;
    /**
     * 
     * @type {PackagingSpecification}
     * @memberof PriceCalculationInputView
     */
    packagingSpecification?: PackagingSpecification;
}
/**
 * 
 * @export
 * @interface PriceList
 */
export interface PriceList {
    /**
     * PriceListId
     * @type {number}
     * @memberof PriceList
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceList
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PriceList
     */
    currencyCode: string;
}
/**
 * 
 * @export
 * @interface PriceListEntrySavingView
 */
export interface PriceListEntrySavingView {
    /**
     * PriceListEntryId
     * @type {number}
     * @memberof PriceListEntrySavingView
     */
    id?: number;
    /**
     * PriceListId
     * @type {number}
     * @memberof PriceListEntrySavingView
     */
    priceListId: number;
    /**
     * 
     * @type {number}
     * @memberof PriceListEntrySavingView
     */
    price: number;
}
/**
 * 
 * @export
 * @interface PriceListEntryView
 */
export interface PriceListEntryView {
    /**
     * PriceListEntryId
     * @type {number}
     * @memberof PriceListEntryView
     */
    id?: number;
    /**
     * PriceListId
     * @type {number}
     * @memberof PriceListEntryView
     */
    priceListId: number;
    /**
     * 
     * @type {PriceList}
     * @memberof PriceListEntryView
     */
    priceList: PriceList;
    /**
     * 
     * @type {number}
     * @memberof PriceListEntryView
     */
    price: number;
}
/**
 * 
 * @export
 * @interface PrinterView
 */
export interface PrinterView {
    /**
     * PrinterId
     * @type {number}
     * @memberof PrinterView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PrinterView
     */
    name: string;
}
/**
 * 
 * @export
 * @interface Printing
 */
export interface Printing {
    /**
     * 
     * @type {TechnologyType}
     * @memberof Printing
     */
    tpe: TechnologyType;
}
/**
 * 
 * @export
 * @interface PrintingProductSpecification
 */
export interface PrintingProductSpecification {
    /**
     * ProductSpecificationId
     * @type {number}
     * @memberof PrintingProductSpecification
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PrintingProductSpecification
     */
    uuid: string;
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof PrintingProductSpecification
     */
    paper: number;
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof PrintingProductSpecification
     */
    additionalPaper?: number;
    /**
     * 
     * @type {number}
     * @memberof PrintingProductSpecification
     */
    sizeAcrossRibbon: number;
    /**
     * 
     * @type {number}
     * @memberof PrintingProductSpecification
     */
    sizeAlongRibbon: number;
    /**
     * 
     * @type {ColorsCount}
     * @memberof PrintingProductSpecification
     */
    flexoColorsCount: ColorsCount;
    /**
     * 
     * @type {ColorsCount}
     * @memberof PrintingProductSpecification
     */
    sieveColorsCount: ColorsCount;
    /**
     * 
     * @type {ColorsCount}
     * @memberof PrintingProductSpecification
     */
    digitalColorsCount: ColorsCount;
    /**
     * 
     * @type {number}
     * @memberof PrintingProductSpecification
     */
    itemsInSet: number;
    /**
     * 
     * @type {number}
     * @memberof PrintingProductSpecification
     */
    layersCount: number;
    /**
     * 
     * @type {Array<PunchingDieData>}
     * @memberof PrintingProductSpecification
     */
    punchingDies?: Array<PunchingDieData>;
    /**
     * 
     * @type {Array<Ennoblement>}
     * @memberof PrintingProductSpecification
     */
    ennoblements?: Array<Ennoblement>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrintingProductSpecification
     */
    summary?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PrintingProductSpecification
     */
    comments?: string;
    /**
     * 
     * @type {ProductSpecificationType}
     * @memberof PrintingProductSpecification
     */
    productSpecificationType: ProductSpecificationType;
}
/**
 * 
 * @export
 * @interface PrintingRecipe
 */
export interface PrintingRecipe {
    /**
     * RecipeId
     * @type {number}
     * @memberof PrintingRecipe
     */
    id?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof PrintingRecipe
     */
    roller?: number;
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof PrintingRecipe
     */
    paper: PropertySetSelector;
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof PrintingRecipe
     */
    additionalPaper?: PropertySetSelector;
    /**
     * 
     * @type {Array<PreviewLink>}
     * @memberof PrintingRecipe
     */
    previewLinks?: Array<PreviewLink>;
    /**
     * 
     * @type {number}
     * @memberof PrintingRecipe
     */
    itemsInSet: number;
    /**
     * 
     * @type {number}
     * @memberof PrintingRecipe
     */
    layersCount: number;
    /**
     * 
     * @type {Array<PrintingRecipeStep>}
     * @memberof PrintingRecipe
     */
    steps?: Array<PrintingRecipeStep>;
    /**
     * 
     * @type {Array<RecipeParameter>}
     * @memberof PrintingRecipe
     */
    parameters?: Array<RecipeParameter>;
    /**
     * 
     * @type {Array<RecipeUserDefinedParameter>}
     * @memberof PrintingRecipe
     */
    userDefinedParameters?: Array<RecipeUserDefinedParameter>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PrintingRecipe
     */
    summary?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PrintingRecipe
     */
    modificationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof PrintingRecipe
     */
    versionName?: string;
    /**
     * 
     * @type {number}
     * @memberof PrintingRecipe
     */
    recipeType: number;
}
/**
 * @type PrintingRecipeStep
 * 
 * @export
 */
export type PrintingRecipeStep = Digital1 | Extrusion1 | FlexoColor | Lacquering1 | Lamination1 | NarrowedLacquering1 | NarrowedSieveLacquering1 | Punching | SieveColor | Stamping1;
/**
 * 
 * @export
 * @interface PrintingRecipeView
 */
export interface PrintingRecipeView {
    /**
     * 
     * @type {Array<PreviewLink>}
     * @memberof PrintingRecipeView
     */
    previewLinks?: Array<PreviewLink>;
    /**
     * 
     * @type {number}
     * @memberof PrintingRecipeView
     */
    itemsInSet: number;
    /**
     * 
     * @type {number}
     * @memberof PrintingRecipeView
     */
    layersCount: number;
    /**
     * 
     * @type {Materials}
     * @memberof PrintingRecipeView
     */
    materials: Materials;
    /**
     * 
     * @type {Array<PrintingRecipeViewPunchingDiesInner>}
     * @memberof PrintingRecipeView
     */
    punchingDies?: Array<PrintingRecipeViewPunchingDiesInner>;
    /**
     * 
     * @type {Array<StepView>}
     * @memberof PrintingRecipeView
     */
    steps?: Array<StepView>;
    /**
     * 
     * @type {string}
     * @memberof PrintingRecipeView
     */
    modificationDate?: string;
    /**
     * 
     * @type {number}
     * @memberof PrintingRecipeView
     */
    recipeType: number;
}
/**
 * @type PrintingRecipeViewPunchingDiesInner
 * 
 * @export
 */
export type PrintingRecipeViewPunchingDiesInner = PunchingDieProperties1 | number;
/**
 * 
 * @export
 * @interface PrintingRequest
 */
export interface PrintingRequest {
    /**
     * 
     * @type {string}
     * @memberof PrintingRequest
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof PrintingRequest
     */
    catalogNumber: string;
    /**
     * 
     * @type {string}
     * @memberof PrintingRequest
     */
    productionDate: string;
    /**
     * 
     * @type {string}
     * @memberof PrintingRequest
     */
    ean: string;
    /**
     * UserId
     * @type {number}
     * @memberof PrintingRequest
     */
    producedById: number;
    /**
     * 
     * @type {string}
     * @memberof PrintingRequest
     */
    batchNumber: string;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty1?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty2?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty3?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty4?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty5?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty6?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty7?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty8?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty9?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty10?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty11?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty12?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty13?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty14?: LabelProperty;
    /**
     * 
     * @type {LabelProperty}
     * @memberof PrintingRequest
     */
    labelProperty15?: LabelProperty;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof PrintingRequest
     */
    productionLotId: number;
    /**
     * 
     * @type {number}
     * @memberof PrintingRequest
     */
    amount: number;
    /**
     * TemplateId
     * @type {number}
     * @memberof PrintingRequest
     */
    templateId: number;
    /**
     * PrinterId
     * @type {number}
     * @memberof PrintingRequest
     */
    printerId: number;
}
/**
 * 
 * @export
 * @interface ProductAmount
 */
export interface ProductAmount {
    /**
     * 
     * @type {number}
     * @memberof ProductAmount
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductAmount
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface ProductCatalogItemListViewRow
 */
export interface ProductCatalogItemListViewRow {
    /**
     * ProductCatalogItemId
     * @type {number}
     * @memberof ProductCatalogItemListViewRow
     */
    id: number;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ProductCatalogItemListViewRow
     */
    itemTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCatalogItemListViewRow
     */
    itemTypeName: string;
    /**
     * 
     * @type {number}
     * @memberof ProductCatalogItemListViewRow
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCatalogItemListViewRow
     */
    actualPrice?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof ProductCatalogItemListViewRow
     */
    contractorId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCatalogItemListViewRow
     */
    contractorName: string;
}
/**
 * 
 * @export
 * @interface ProductData
 */
export interface ProductData {
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    itemTypeName: string;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof ProductData
     */
    itemTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductData
     */
    itemTypeVariantName: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ProductData
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {Array<ItemTypeProperty>}
     * @memberof ProductData
     */
    properties?: Array<ItemTypeProperty>;
    /**
     * 
     * @type {ProductAmount}
     * @memberof ProductData
     */
    amount: ProductAmount;
    /**
     * 
     * @type {ClientSpecification}
     * @memberof ProductData
     */
    clientSpecification?: ClientSpecification;
}
/**
 * 
 * @export
 * @interface ProductMissingError
 */
export interface ProductMissingError {
    /**
     * 
     * @type {string}
     * @memberof ProductMissingError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductMissingError
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ProductMissingError
     */
    productCode: string;
}
/**
 * 
 * @export
 * @interface ProductPropertyTypesView
 */
export interface ProductPropertyTypesView {
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof ProductPropertyTypesView
     */
    labelSizeAcrossRibbon: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof ProductPropertyTypesView
     */
    labelSizeAlongRibbon: ItemTypePropertyType;
}
/**
 * @type ProductSpecification
 * 
 * @export
 */
export type ProductSpecification = { productSpecificationType: '1' } & PrintingProductSpecification | { productSpecificationType: '2' } & PiecesProductSpecification;
/**
 * 
 * @export
 * @interface ProductSpecificationGraph
 */
export interface ProductSpecificationGraph {
    /**
     * ProductSpecificationGraphId
     * @type {number}
     * @memberof ProductSpecificationGraph
     */
    id?: number;
    /**
     * 
     * @type {{ [key: string]: ProductSpecification; }}
     * @memberof ProductSpecificationGraph
     */
    productSpecifications: { [key: string]: ProductSpecification; };
    /**
     * 
     * @type {string}
     * @memberof ProductSpecificationGraph
     */
    topSpecification: string;
}

/**
 * 
 * @export
 */
export const ProductSpecificationType = {
    printing: 1,
    pieces: 2
} as const;
export type ProductSpecificationType = typeof ProductSpecificationType[keyof typeof ProductSpecificationType];

/**
 * 
 * @export
 * @interface ProductSummary
 */
export interface ProductSummary {
    /**
     * 
     * @type {number}
     * @memberof ProductSummary
     */
    oks: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSummary
     */
    noks: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSummary
     */
    sum: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSummary
     */
    total: number;
}
/**
 * 
 * @export
 * @interface ProductionConfirmationDocumentStatusView
 */
export interface ProductionConfirmationDocumentStatusView {
    /**
     * ProductionConfirmationDocumentId
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    productionConfirmationDocumentId: number;
    /**
     * PushStatusId
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    targetId?: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    confirmationDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    accepted: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    externalId?: string;
    /**
     * 
     * @type {DocumentTypes}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    documentType?: DocumentTypes;
    /**
     * 
     * @type {PushStatusTypes}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    status?: PushStatusTypes;
    /**
     * 
     * @type {string}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    sendAttemptTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    syncAttemptTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    failureCounter: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    lastSuccessfulSyncTime?: string;
    /**
     * DocumentStatusId
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    documentStatusId?: number;
    /**
     * AmountReportId
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    amountReportId?: number;
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    downtimeReportId?: number;
    /**
     * NokWithCauseId
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    nokWithCauseId?: number;
    /**
     * UserId
     * @type {number}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    userId?: number;
    /**
     * 
     * @type {ConfirmationType}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    confirmationType: ConfirmationType;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionConfirmationDocumentStatusView
     */
    main: boolean;
}
/**
 * @type ProductionFinishError
 * 
 * @export
 */
export type ProductionFinishError = { name: 'CannotChangeProductionStartDate' } & LemmaSimpleErrorView | { name: 'InconsistentMachinesInTheBatch' } & InconsistentMachinesInTheBatch | { name: 'InvalidSplitPriorityConfiguration' } & LemmaSimpleErrorView | { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'LotHasNoMachineAssigned' } & LotHasNoMachineAssigned | { name: 'LotIsPartOfMultiBatch' } & LotIsPartOfMultiBatch | { name: 'LotsHaveNoMachineAssigned' } & LotsHaveNoMachineAssigned | { name: 'MissingProductionReportForLot' } & MissingProductionReportForLot | { name: 'NoAmountAvailableForSplit' } & LemmaSimpleErrorView | { name: 'NoWorkstationReportsCreated' } & LemmaSimpleErrorView | { name: 'NonPositiveAmountSupplied' } & LemmaSimpleErrorView;
/**
 * 
 * @export
 * @interface ProductionLotDemandSource
 */
export interface ProductionLotDemandSource {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionLotDemandSource
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDemandSource
     */
    number: string;
    /**
     * 
     * @type {MaterialMovementDemandSourceType}
     * @memberof ProductionLotDemandSource
     */
    tpe: MaterialMovementDemandSourceType;
}
/**
 * 
 * @export
 * @interface ProductionLotDetailsView
 */
export interface ProductionLotDetailsView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionLotDetailsView
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    productionLotNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionLotDetailsView
     */
    priority: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionLotDetailsView
     */
    requiresAcceptance: boolean;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof ProductionLotDetailsView
     */
    productionLotStatus: ProductionLotStatus;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    productionStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    productionEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotDetailsView
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    estimatedStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    estimatedEndDate?: string;
    /**
     * MachineId
     * @type {number}
     * @memberof ProductionLotDetailsView
     */
    machineId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    machineName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    machineColor?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotDetailsView
     */
    reportedOksAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotDetailsView
     */
    reportedNoksAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    totalDowntime?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    lastPauseDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotDetailsView
     */
    pauseDurationInMillis: number;
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof ProductionLotDetailsView
     */
    activeDowntimeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotDetailsView
     */
    activeDowntimeStartDate?: string;
    /**
     * 
     * @type {ProductionLotViewStatus}
     * @memberof ProductionLotDetailsView
     */
    lotViewStatus: ProductionLotViewStatus;
    /**
     * BatchId
     * @type {number}
     * @memberof ProductionLotDetailsView
     */
    multiLotBatchId?: number;
}
/**
 * @type ProductionLotIdentificationCode
 * 
 * @export
 */
export type ProductionLotIdentificationCode = { tpe: 'NumberIdentification' } & NumberLotIdentificationCode | { tpe: 'StringIdentification' } & StringLotIdentificationCode;

/**
 * 
 * @export
 */
export const ProductionLotIdentificationCodeType = {
    StringIdentification: 'StringIdentification',
    NumberIdentification: 'NumberIdentification'
} as const;
export type ProductionLotIdentificationCodeType = typeof ProductionLotIdentificationCodeType[keyof typeof ProductionLotIdentificationCodeType];

/**
 * 
 * @export
 * @interface ProductionLotListView
 */
export interface ProductionLotListView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionLotListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    number?: string;
    /**
     * 
     * @type {Technology}
     * @memberof ProductionLotListView
     */
    technologyName?: Technology;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    productCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionLotListView
     */
    orderItemNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionLotListView
     */
    contractorNames?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotListView
     */
    completedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotListView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    unitType: string;
    /**
     * 
     * @type {ProductionLotViewStatus}
     * @memberof ProductionLotListView
     */
    status: ProductionLotViewStatus;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    machineCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    machineName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionLotListView
     */
    workerNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    productionOrderNumber: string;
    /**
     * 
     * @type {Array<ProductionLotTagView>}
     * @memberof ProductionLotListView
     */
    tags?: Array<ProductionLotTagView>;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotListView
     */
    seriesNumber?: string;
}
/**
 * 
 * @export
 * @interface ProductionLotNodeView
 */
export interface ProductionLotNodeView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionLotNodeView
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionLotNodeView
     */
    priority: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotNodeView
     */
    completedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotNodeView
     */
    totalAmount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotNodeView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotNodeView
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotNodeView
     */
    productionOrderNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotNodeView
     */
    productName: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof ProductionLotNodeView
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotNodeView
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotNodeView
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotNodeView
     */
    nodeId: string;
    /**
     * 
     * @type {TraceabilityGraphNodeType}
     * @memberof ProductionLotNodeView
     */
    nodeType: TraceabilityGraphNodeType;
}
/**
 * 
 * @export
 * @interface ProductionLotRawMaterialsUsageListView
 */
export interface ProductionLotRawMaterialsUsageListView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionLotRawMaterialsUsageListView
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotRawMaterialsUsageListView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotRawMaterialsUsageListView
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotRawMaterialsUsageListView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotRawMaterialsUsageListView
     */
    usage: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotRawMaterialsUsageListView
     */
    predictedUsage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotRawMaterialsUsageListView
     */
    minimalState?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionLotRawMaterialsUsageListView
     */
    wasteAmount: number;
}
/**
 * @type ProductionLotSavingView
 * 
 * @export
 */
export type ProductionLotSavingView = { tpe: 'direct' } & DirectProductionLotSavingView | { tpe: 'merged' } & MergedProductionLotSavingView;
/**
 * 
 * @export
 * @interface ProductionLotSavingViewCreationId
 */
export interface ProductionLotSavingViewCreationId {
    /**
     * 
     * @type {string}
     * @memberof ProductionLotSavingViewCreationId
     */
    id: string;
    /**
     * 
     * @type {ProductionLotSavingViewIdType}
     * @memberof ProductionLotSavingViewCreationId
     */
    tpe: ProductionLotSavingViewIdType;
}
/**
 * 
 * @export
 * @interface ProductionLotSavingViewDatabaseId
 */
export interface ProductionLotSavingViewDatabaseId {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionLotSavingViewDatabaseId
     */
    id: number;
    /**
     * 
     * @type {ProductionLotSavingViewIdType}
     * @memberof ProductionLotSavingViewDatabaseId
     */
    tpe: ProductionLotSavingViewIdType;
}
/**
 * @type ProductionLotSavingViewId
 * 
 * @export
 */
export type ProductionLotSavingViewId = { tpe: 'creation' } & ProductionLotSavingViewCreationId | { tpe: 'database' } & ProductionLotSavingViewDatabaseId;

/**
 * 
 * @export
 */
export const ProductionLotSavingViewIdType = {
    Database: 'database',
    Creation: 'creation'
} as const;
export type ProductionLotSavingViewIdType = typeof ProductionLotSavingViewIdType[keyof typeof ProductionLotSavingViewIdType];


/**
 * 
 * @export
 */
export const ProductionLotSavingViewType = {
    Direct: 'direct',
    Merged: 'merged'
} as const;
export type ProductionLotSavingViewType = typeof ProductionLotSavingViewType[keyof typeof ProductionLotSavingViewType];


/**
 * 
 * @export
 */
export const ProductionLotStatus = {
    toSpec: 1,
    specified: 2,
    planned: 3,
    inProduction: 4,
    inWarehouse: 5,
    done: 6,
    archived: 7,
    cancelled: 8,
    draft: 9
} as const;
export type ProductionLotStatus = typeof ProductionLotStatus[keyof typeof ProductionLotStatus];


/**
 * 
 * @export
 */
export const ProductionLotStatusPlannedInProduction = {
    planned: 3,
    inProduction: 4
} as const;
export type ProductionLotStatusPlannedInProduction = typeof ProductionLotStatusPlannedInProduction[keyof typeof ProductionLotStatusPlannedInProduction];

/**
 * 
 * @export
 * @interface ProductionLotTag
 */
export interface ProductionLotTag {
    /**
     * ProductionLotTagId
     * @type {number}
     * @memberof ProductionLotTag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTag
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTag
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ProductionLotTagRow
 */
export interface ProductionLotTagRow {
    /**
     * ProductionLotTagId
     * @type {number}
     * @memberof ProductionLotTagRow
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTagRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTagRow
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTagRow
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ProductionLotTagView
 */
export interface ProductionLotTagView {
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTagView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTagView
     */
    color?: string;
}

/**
 * 
 * @export
 */
export const ProductionLotViewStatus = {
    Simulation: 'simulation',
    NotPlanned: 'not_planned',
    Pending: 'pending',
    InProgress: 'in_progress',
    Complete: 'complete',
    Cancelled: 'cancelled'
} as const;
export type ProductionLotViewStatus = typeof ProductionLotViewStatus[keyof typeof ProductionLotViewStatus];


/**
 * 
 * @export
 */
export const ProductionLotWarning = {
    amountMismatch: 1,
    orderItemCancelled: 2,
    notEnoughTimeToProduce: 3,
    productionOutOfPlanOrder: 4
} as const;
export type ProductionLotWarning = typeof ProductionLotWarning[keyof typeof ProductionLotWarning];

/**
 * 
 * @export
 * @interface ProductionOrderDetailsLotView
 */
export interface ProductionOrderDetailsLotView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionOrderDetailsLotView
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderDetailsLotView
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderDetailsLotView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderDetailsLotView
     */
    productCode?: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof ProductionOrderDetailsLotView
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderDetailsLotView
     */
    producedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderDetailsLotView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderDetailsLotView
     */
    unitType: string;
    /**
     * 
     * @type {Technology}
     * @memberof ProductionOrderDetailsLotView
     */
    technologyName?: Technology;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderDetailsLotView
     */
    noTechnology: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderDetailsLotView
     */
    startDate?: string;
    /**
     * 
     * @type {Array<ProductionOrderDetailsLotView>}
     * @memberof ProductionOrderDetailsLotView
     */
    children?: Array<ProductionOrderDetailsLotView>;
}
/**
 * 
 * @export
 * @interface ProductionOrderEditView
 */
export interface ProductionOrderEditView {
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderEditView
     */
    dueDate: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderEditView
     */
    priority: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductionOrderEditView
     */
    productionLotTagIds?: Array<number>;
}
/**
 * @type ProductionOrderImportError
 * 
 * @export
 */
export type ProductionOrderImportError = { name: 'LegacyLemmaError' } & LegacyLemmaError | { name: 'OperationMissingRecipeError' } & OperationMissingRecipeError | { name: 'ProductMissingError' } & ProductMissingError | { name: 'RecipeWithVersionMissingError' } & RecipeWithVersionMissingError;
/**
 * 
 * @export
 * @interface ProductionOrderListView
 */
export interface ProductionOrderListView {
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof ProductionOrderListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderListView
     */
    number: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductionOrderListView
     */
    productIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionOrderListView
     */
    productNames?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderListView
     */
    progress: number;
    /**
     * 
     * @type {ProductionOrderStatus}
     * @memberof ProductionOrderListView
     */
    status: ProductionOrderStatus;
    /**
     * Count of seconds
     * @type {number}
     * @memberof ProductionOrderListView
     */
    totalProductionTimeSeconds: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderListView
     */
    totalProductionTimeCertain: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderListView
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderListView
     */
    productivity: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderListView
     */
    overdue: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderListView
     */
    priority: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderListView
     */
    noMaterials: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderListView
     */
    creationDate: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionOrderListView
     */
    productionTagNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductionOrderListView
     */
    productionTagIds?: Array<number>;
    /**
     * 
     * @type {ExternalIdView}
     * @memberof ProductionOrderListView
     */
    externalId?: ExternalIdView;
}
/**
 * 
 * @export
 * @interface ProductionOrderLotListView
 */
export interface ProductionOrderLotListView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionOrderLotListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    comboSearch: string;
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof ProductionOrderLotListView
     */
    productionOrderId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    number?: string;
    /**
     * 
     * @type {Technology}
     * @memberof ProductionOrderLotListView
     */
    technologyName?: Technology;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderLotListView
     */
    priority: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderLotListView
     */
    incomplete: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    productCode?: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof ProductionOrderLotListView
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderLotListView
     */
    completedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderLotListView
     */
    noksAmount: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderLotListView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    dueDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionOrderLotListView
     */
    workerNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    machineCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    machineName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionOrderLotListView
     */
    orderItemNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductionOrderLotListView
     */
    contractorNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    productionOrderNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    externalOrderNumber: string;
    /**
     * 
     * @type {Array<ProductionLotTagView>}
     * @memberof ProductionOrderLotListView
     */
    tags?: Array<ProductionLotTagView>;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    seriesNumber?: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ProductionOrderLotListView
     */
    productId: number;
    /**
     * MachineId
     * @type {number}
     * @memberof ProductionOrderLotListView
     */
    machineId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderLotListView
     */
    initialPlannedStartDate?: string;
    /**
     * 
     * @type {ProductionLotViewStatus}
     * @memberof ProductionOrderLotListView
     */
    viewStatus: ProductionLotViewStatus;
}
/**
 * 
 * @export
 * @interface ProductionOrderLotsMergeOutputView
 */
export interface ProductionOrderLotsMergeOutputView {
    /**
     * 
     * @type {Array<ProductionLotSavingView>}
     * @memberof ProductionOrderLotsMergeOutputView
     */
    merged?: Array<ProductionLotSavingView>;
    /**
     * 
     * @type {ProductionLotSavingView}
     * @memberof ProductionOrderLotsMergeOutputView
     */
    target: ProductionLotSavingView;
}
/**
 * 
 * @export
 * @interface ProductionOrderLotsMergeQueryView
 */
export interface ProductionOrderLotsMergeQueryView {
    /**
     * 
     * @type {Array<ProductionLotSavingView>}
     * @memberof ProductionOrderLotsMergeQueryView
     */
    lots?: Array<ProductionLotSavingView>;
    /**
     * 
     * @type {ProductionLotSavingView}
     * @memberof ProductionOrderLotsMergeQueryView
     */
    target: ProductionLotSavingView;
}
/**
 * 
 * @export
 * @interface ProductionOrderLotsSplitOutputView
 */
export interface ProductionOrderLotsSplitOutputView {
    /**
     * 
     * @type {Array<ProductionLotSavingView>}
     * @memberof ProductionOrderLotsSplitOutputView
     */
    lots?: Array<ProductionLotSavingView>;
}
/**
 * 
 * @export
 * @interface ProductionOrderLotsSplitQueryView
 */
export interface ProductionOrderLotsSplitQueryView {
    /**
     * 
     * @type {ProductionLotSavingView}
     * @memberof ProductionOrderLotsSplitQueryView
     */
    lot: ProductionLotSavingView;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductionOrderLotsSplitQueryView
     */
    splits?: Array<number>;
}
/**
 * 
 * @export
 * @interface ProductionOrderRawMaterialsUsageListView
 */
export interface ProductionOrderRawMaterialsUsageListView {
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof ProductionOrderRawMaterialsUsageListView
     */
    productionOrderId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderRawMaterialsUsageListView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderRawMaterialsUsageListView
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderRawMaterialsUsageListView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderRawMaterialsUsageListView
     */
    usage: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderRawMaterialsUsageListView
     */
    predictedUsage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderRawMaterialsUsageListView
     */
    minimalState?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderRawMaterialsUsageListView
     */
    wasteAmount: number;
}
/**
 * @type ProductionOrderSavingSagaFromSimulationErr
 * 
 * @export
 */
export type ProductionOrderSavingSagaFromSimulationErr = { name: 'CannotProduceInput' } & LemmaSimpleErrorView | { name: 'CannotUpdateNonDraft' } & LemmaSimpleErrorView | { name: 'DemandForOrderItemNotFound' } & DemandForOrderItemNotFound | { name: 'IncompatibleOrderItemVariant' } & IncompatibleOrderItemVariant | { name: 'NoIngredientOfVariantForLot' } & NoIngredientOfVariantForLot | { name: 'NonPositiveAmountSupplied' } & LemmaSimpleErrorView | { name: 'NothingToSave' } & LemmaSimpleErrorView | { name: 'SimulationGraphCycle' } & LemmaSimpleErrorView | { name: 'TechnologyMissing' } & TechnologyMissing | { name: 'UnitNotDefinedAsSecondary' } & UnitNotDefinedAsSecondary;
/**
 * 
 * @export
 * @interface ProductionOrderSavingView
 */
export interface ProductionOrderSavingView {
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof ProductionOrderSavingView
     */
    id?: number;
    /**
     * 
     * @type {Array<ProductionLotSavingView>}
     * @memberof ProductionOrderSavingView
     */
    lots: Array<ProductionLotSavingView>;
}
/**
 * @type ProductionOrderSimulationSagaErr
 * 
 * @export
 */
export type ProductionOrderSimulationSagaErr = { name: 'CannotProduceInput' } & LemmaSimpleErrorView | { name: 'DemandForOrderItemNotFound' } & DemandForOrderItemNotFound | { name: 'NoIngredientOfVariantForLot' } & NoIngredientOfVariantForLot | { name: 'SimulationGraphCycle' } & LemmaSimpleErrorView | { name: 'UnitNotDefinedAsSecondary' } & UnitNotDefinedAsSecondary;

/**
 * 
 * @export
 */
export const ProductionOrderStatus = {
    incomplete: 1,
    simulation: 2,
    new: 3,
    production: 4,
    done: 5,
    cancelled: 6
} as const;
export type ProductionOrderStatus = typeof ProductionOrderStatus[keyof typeof ProductionOrderStatus];

/**
 * 
 * @export
 * @interface ProductionOrderStatusNotDeletable
 */
export interface ProductionOrderStatusNotDeletable {
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderStatusNotDeletable
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderStatusNotDeletable
     */
    description: string;
    /**
     * 
     * @type {ProductionOrderStatus}
     * @memberof ProductionOrderStatusNotDeletable
     */
    productionOrderStatus: ProductionOrderStatus;
}
/**
 * 
 * @export
 * @interface ProductionOrderView
 */
export interface ProductionOrderView {
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof ProductionOrderView
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderView
     */
    priority: boolean;
    /**
     * 
     * @type {ProductionOrderStatus}
     * @memberof ProductionOrderView
     */
    status: ProductionOrderStatus;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderView
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderView
     */
    dueDate?: string;
    /**
     * 
     * @type {Array<ProductionLotTag>}
     * @memberof ProductionOrderView
     */
    tags?: Array<ProductionLotTag>;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderView
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderView
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderView
     */
    plannedStart?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderView
     */
    plannedEnd?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderView
     */
    progress: number;
    /**
     * 
     * @type {Array<SalesOrderDetails>}
     * @memberof ProductionOrderView
     */
    salesOrders?: Array<SalesOrderDetails>;
}
/**
 * 
 * @export
 * @interface ProductionOrderWorktimeListView
 */
export interface ProductionOrderWorktimeListView {
    /**
     * ProductionOrderId
     * @type {number}
     * @memberof ProductionOrderWorktimeListView
     */
    productionOrderId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    lotNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    machineCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    machineName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    oksProduction?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    noksProduction?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderWorktimeListView
     */
    wasteRatio?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderWorktimeListView
     */
    workstationEfficiency?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderWorktimeListView
     */
    referenceEfficiency?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    setupState?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    idleState?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderWorktimeListView
     */
    totalTime?: string;
}

/**
 * 
 * @export
 */
export const ProductionSpecificationStatus = {
    draft: 1,
    completed: 2,
    accepted: 3,
    ingredientsDefined: 4
} as const;
export type ProductionSpecificationStatus = typeof ProductionSpecificationStatus[keyof typeof ProductionSpecificationStatus];

/**
 * 
 * @export
 * @interface ProductionSummaryReportItemRow
 */
export interface ProductionSummaryReportItemRow {
    /**
     * ProductionSummaryReportItemId
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    id?: number;
    /**
     * AsyncReportId
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    asyncReportId?: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    variantName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    productionStart?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    loadingStateStart?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    productionStateStart?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    unloadingStateStart?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    productionEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    loadingStateDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    productionStateDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    unloadingStateDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    expectedLoadingTime?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    expectedProductionTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    productionStateAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    loadingStateAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    unloadingStateAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    expectedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    reportedProducedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    reportedWasteAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    lotNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    reporter?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    newFlexoColors?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    allFlexoColors?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    newSieveColors?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    allSieveColors?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    newStampings?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    allStampings?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    newNarrowedLacquering?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    allNarrowedLacquering?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    newNarrowedSieveLacquering?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    allNarrowedSieveLacquering?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    newExtrusions?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    allExtrusions?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    newSum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    allSum?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    avgSpeedsProductionPhase?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    actualVsExpectedLoadingTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    actualVsPlannedProducedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    laminationSteps?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    lacqueringSteps?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    firstPunchingDieName?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    numberOfPunchingDies?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    numberOfDefinedMaterials?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    stepsOnGlue?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    stepsOnUnderlay?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    recipeUnitType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionSummaryReportItemRow
     */
    machineName?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    lacqueringStepsFlexo?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionSummaryReportItemRow
     */
    allLacquering?: number;
}
/**
 * 
 * @export
 * @interface ProductionTimeEstimationDefinition
 */
export interface ProductionTimeEstimationDefinition {
    /**
     * 
     * @type {EstimatedProductionTimeScope}
     * @memberof ProductionTimeEstimationDefinition
     */
    scope: EstimatedProductionTimeScope;
    /**
     * 
     * @type {string}
     * @memberof ProductionTimeEstimationDefinition
     */
    timeCalculationType: string;
    /**
     * Duration in seconds
     * @type {number}
     * @memberof ProductionTimeEstimationDefinition
     */
    duration: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionTimeEstimationDefinition
     */
    description: string;
}
/**
 * 
 * @export
 * @interface ProductionTimeEstimationDefinitions
 */
export interface ProductionTimeEstimationDefinitions {
    /**
     * 
     * @type {Array<ProductionTimeEstimationDefinition>}
     * @memberof ProductionTimeEstimationDefinitions
     */
    values?: Array<ProductionTimeEstimationDefinition>;
}
/**
 * 
 * @export
 * @interface ProductionTimeEstimationItem
 */
export interface ProductionTimeEstimationItem {
    /**
     * EstimationItemId
     * @type {number}
     * @memberof ProductionTimeEstimationItem
     */
    estimationId: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof ProductionTimeEstimationItem
     */
    productionLotId: number;
    /**
     * MachineId
     * @type {number}
     * @memberof ProductionTimeEstimationItem
     */
    machineId: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionTimeEstimationItem
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface ProductionTimeEstimationResult
 */
export interface ProductionTimeEstimationResult {
    /**
     * EstimationItemId
     * @type {number}
     * @memberof ProductionTimeEstimationResult
     */
    estimationId: number;
    /**
     * Duration in seconds
     * @type {number}
     * @memberof ProductionTimeEstimationResult
     */
    duration: number;
}

/**
 * 
 * @export
 */
export const ProductionUnitErpStatus = {
    waiting: 1,
    matching: 2,
    notMatching: 3,
    temporarilyOut: 4
} as const;
export type ProductionUnitErpStatus = typeof ProductionUnitErpStatus[keyof typeof ProductionUnitErpStatus];

/**
 * 
 * @export
 * @interface ProductionUnitListSummary
 */
export interface ProductionUnitListSummary {
    /**
     * 
     * @type {number}
     * @memberof ProductionUnitListSummary
     */
    summedQuantity?: number;
}
/**
 * 
 * @export
 * @interface ProductionUnitListViewRow
 */
export interface ProductionUnitListViewRow {
    /**
     * StockItemId
     * @type {number}
     * @memberof ProductionUnitListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitListViewRow
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionUnitListViewRow
     */
    isInErp: boolean;
    /**
     * 
     * @type {ErpType}
     * @memberof ProductionUnitListViewRow
     */
    erp: ErpType;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitListViewRow
     */
    externalId?: string;
    /**
     * 
     * @type {ProductionUnitErpStatus}
     * @memberof ProductionUnitListViewRow
     */
    erpStatus: ProductionUnitErpStatus;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ProductionUnitListViewRow
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitListViewRow
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitListViewRow
     */
    lotNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionUnitListViewRow
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitListViewRow
     */
    unitType: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof ProductionUnitListViewRow
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitListViewRow
     */
    placeName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitListViewRow
     */
    placeLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionUnitListViewRow
     */
    packagingType: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitListViewRow
     */
    receptionDate?: string;
}
/**
 * 
 * @export
 * @interface ProductionUnitNodeView
 */
export interface ProductionUnitNodeView {
    /**
     * StockItemId
     * @type {number}
     * @memberof ProductionUnitNodeView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitNodeView
     */
    number: string;
    /**
     * 
     * @type {number}
     * @memberof ProductionUnitNodeView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitNodeView
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitNodeView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitNodeView
     */
    placeLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitNodeView
     */
    nodeId: string;
    /**
     * 
     * @type {TraceabilityGraphNodeType}
     * @memberof ProductionUnitNodeView
     */
    nodeType: TraceabilityGraphNodeType;
}
/**
 * 
 * @export
 * @interface ProductionUnitPackaging
 */
export interface ProductionUnitPackaging {
    /**
     * ProductionUnitPackagingId
     * @type {number}
     * @memberof ProductionUnitPackaging
     */
    id?: number;
    /**
     * 
     * @type {GenericPackaging}
     * @memberof ProductionUnitPackaging
     */
    packaging: GenericPackaging;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductionUnitPackaging
     */
    componentProductionUnits?: Array<number>;
}
/**
 * 
 * @export
 * @interface ProductionUnitProperty
 */
export interface ProductionUnitProperty {
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitProperty
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitProperty
     */
    value: string;
}
/**
 * 
 * @export
 * @interface ProductionUnitResult
 */
export interface ProductionUnitResult {
    /**
     * 
     * @type {ProductionUnitView}
     * @memberof ProductionUnitResult
     */
    productionUnit: ProductionUnitView;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof ProductionUnitResult
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface ProductionUnitView
 */
export interface ProductionUnitView {
    /**
     * StockItemId
     * @type {number}
     * @memberof ProductionUnitView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitView
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionUnitView
     */
    utilized: boolean;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof ProductionUnitView
     */
    itemTypeVariantFullNameView: ItemTypeVariant;
    /**
     * 
     * @type {ProductionUnitErpStatus}
     * @memberof ProductionUnitView
     */
    erpStatus: ProductionUnitErpStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionUnitView
     */
    deleted: boolean;
    /**
     * 
     * @type {Place}
     * @memberof ProductionUnitView
     */
    place: Place;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof ProductionUnitView
     */
    amount: AmountWithUnit;
    /**
     * 
     * @type {Array<ProductionUnitProperty>}
     * @memberof ProductionUnitView
     */
    properties?: Array<ProductionUnitProperty>;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnitView
     */
    placeLabel?: string;
    /**
     * 
     * @type {ProductionUnitPackaging}
     * @memberof ProductionUnitView
     */
    productionUnitPackaging: ProductionUnitPackaging;
    /**
     * StockItemId
     * @type {number}
     * @memberof ProductionUnitView
     */
    aggregatingProductionUnitId?: number;
}
/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * UserId
     * @type {number}
     * @memberof Profile
     */
    id?: number;
    /**
     * 
     * @type {NewPassword}
     * @memberof Profile
     */
    newPassword?: NewPassword;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    nickName?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    rfid?: string;
    /**
     * 
     * @type {Lang}
     * @memberof Profile
     */
    language?: Lang;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    location: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Profile
     */
    roles?: Array<number>;
}
/**
 * 
 * @export
 * @interface PropertySetSelector
 */
export interface PropertySetSelector {
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof PropertySetSelector
     */
    propertySet: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof PropertySetSelector
     */
    variant?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PropertySetSelector
     */
    fixedVariant?: boolean;
}
/**
 * 
 * @export
 * @interface PropertySetSelectorView
 */
export interface PropertySetSelectorView {
    /**
     * 
     * @type {ItemTypePropertySet}
     * @memberof PropertySetSelectorView
     */
    propertySet: ItemTypePropertySet;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof PropertySetSelectorView
     */
    variant?: ItemTypeVariant;
    /**
     * 
     * @type {boolean}
     * @memberof PropertySetSelectorView
     */
    fixedVariant?: boolean;
}

/**
 * 
 * @export
 */
export const PropertyType = {
    string: 1,
    numeric: 2,
    link: 3
} as const;
export type PropertyType = typeof PropertyType[keyof typeof PropertyType];

/**
 * 
 * @export
 * @interface PropertyValue
 */
export interface PropertyValue {
    /**
     * 
     * @type {PropertyType}
     * @memberof PropertyValue
     */
    propertyType: PropertyType;
    /**
     * 
     * @type {string}
     * @memberof PropertyValue
     */
    value: string;
}
/**
 * 
 * @export
 * @interface Punching
 */
export interface Punching {
    /**
     * 
     * @type {PrintingRecipeViewPunchingDiesInner}
     * @memberof Punching
     */
    punchingDie: PrintingRecipeViewPunchingDiesInner;
}
/**
 * @type PunchingDieData
 * 
 * @export
 */
export type PunchingDieData = ExistingPunchingDie | NewPunchingDie | NoPunchingDie;
/**
 * 
 * @export
 * @interface PunchingDieProperties
 */
export interface PunchingDieProperties {
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties
     */
    paperWidth: number;
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties
     */
    cogsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties
     */
    labelsCountAcrossRibbon: number;
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties
     */
    innerMarginAcrossRibbon?: number;
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties
     */
    outerMarginAcrossRibbon?: number;
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties
     */
    labelsCountAlongRibbon?: number;
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties
     */
    innerMarginAlongRibbon?: number;
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties
     */
    cornerRadius?: number;
}
/**
 * 
 * @export
 * @interface PunchingDieProperties1
 */
export interface PunchingDieProperties1 {
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties1
     */
    labelSizeAcrossRibbon: number;
    /**
     * 
     * @type {number}
     * @memberof PunchingDieProperties1
     */
    labelSizeAlongRibbon: number;
    /**
     * 
     * @type {PunchingDieProperties}
     * @memberof PunchingDieProperties1
     */
    inner: PunchingDieProperties;
}
/**
 * 
 * @export
 * @interface PunchingDiePropertyTypesView
 */
export interface PunchingDiePropertyTypesView {
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    labelSizeAlongRibbon: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    labelSizeAcrossRibbon: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    paperWidth: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    cogsCount: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    labelsCountAlongRibbon: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    labelsCountAcrossRibbon: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    innerMarginAlongRibbon: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    innerMarginAcrossRibbon: ItemTypePropertyType;
    /**
     * 
     * @type {ItemTypePropertyType}
     * @memberof PunchingDiePropertyTypesView
     */
    outerMarginAcrossRibbon: ItemTypePropertyType;
}
/**
 * 
 * @export
 * @interface PushStatusListView
 */
export interface PushStatusListView {
    /**
     * PushStatusId
     * @type {number}
     * @memberof PushStatusListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PushStatusListView
     */
    externalId?: string;
    /**
     * TargetId
     * @type {number}
     * @memberof PushStatusListView
     */
    targetId: number;
    /**
     * 
     * @type {DocumentTypes}
     * @memberof PushStatusListView
     */
    targetType: DocumentTypes;
    /**
     * 
     * @type {PushStatusTypes}
     * @memberof PushStatusListView
     */
    pushStatus: PushStatusTypes;
    /**
     * 
     * @type {string}
     * @memberof PushStatusListView
     */
    error?: string;
    /**
     * 
     * @type {string}
     * @memberof PushStatusListView
     */
    sendAttemptTime: string;
    /**
     * 
     * @type {string}
     * @memberof PushStatusListView
     */
    syncAttemptTime?: string;
    /**
     * 
     * @type {number}
     * @memberof PushStatusListView
     */
    failureCounter: number;
    /**
     * 
     * @type {string}
     * @memberof PushStatusListView
     */
    lastSuccessfulSyncTime?: string;
}

/**
 * 
 * @export
 */
export const PushStatusTypes = {
    pending: 1,
    sent: 2,
    cancelled: 3,
    failed: 4
} as const;
export type PushStatusTypes = typeof PushStatusTypes[keyof typeof PushStatusTypes];

/**
 * 
 * @export
 * @interface QualityDetailsResponse
 */
export interface QualityDetailsResponse {
    /**
     * 
     * @type {QualitySummary}
     * @memberof QualityDetailsResponse
     */
    summary: QualitySummary;
    /**
     * 
     * @type {QualityNorms}
     * @memberof QualityDetailsResponse
     */
    norms: QualityNorms;
    /**
     * 
     * @type {Array<WorkstationQualityView>}
     * @memberof QualityDetailsResponse
     */
    workstations?: Array<WorkstationQualityView>;
}
/**
 * 
 * @export
 * @interface QualityNorms
 */
export interface QualityNorms {
    /**
     * 
     * @type {number}
     * @memberof QualityNorms
     */
    normOee: number;
    /**
     * 
     * @type {number}
     * @memberof QualityNorms
     */
    normQuality: number;
    /**
     * 
     * @type {number}
     * @memberof QualityNorms
     */
    lowestIndicator: number;
    /**
     * 
     * @type {number}
     * @memberof QualityNorms
     */
    highestIndicator: number;
}
/**
 * 
 * @export
 * @interface QualityParameter
 */
export interface QualityParameter {
    /**
     * QualityParameterId
     * @type {number}
     * @memberof QualityParameter
     */
    id?: number;
    /**
     * 
     * @type {MeasuredParameter}
     * @memberof QualityParameter
     */
    measurementParameter: MeasuredParameter;
    /**
     * 
     * @type {boolean}
     * @memberof QualityParameter
     */
    shouldBeListed: boolean;
}
/**
 * 
 * @export
 * @interface QualitySpecification
 */
export interface QualitySpecification {
    /**
     * QualitySpecificationId
     * @type {number}
     * @memberof QualitySpecification
     */
    id?: number;
    /**
     * 
     * @type {Array<QualityParameter>}
     * @memberof QualitySpecification
     */
    qualityParameters?: Array<QualityParameter>;
    /**
     * 
     * @type {string}
     * @memberof QualitySpecification
     */
    confirmationText?: string;
}

/**
 * 
 * @export
 */
export const QualityStatus = {
    normSatisfied: 1,
    normUnsatisfied: 2,
    toBeReclassified: 3,
    incurredWithDeparture: 4
} as const;
export type QualityStatus = typeof QualityStatus[keyof typeof QualityStatus];

/**
 * 
 * @export
 * @interface QualitySummary
 */
export interface QualitySummary {
    /**
     * 
     * @type {number}
     * @memberof QualitySummary
     */
    okPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof QualitySummary
     */
    nokPercentage: number;
}
/**
 * 
 * @export
 * @interface RangeOfT
 */
export interface RangeOfT {
    /**
     * 
     * @type {string}
     * @memberof RangeOfT
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof RangeOfT
     */
    to: string;
}
/**
 * 
 * @export
 * @interface RawBarcode
 */
export interface RawBarcode {
    /**
     * 
     * @type {string}
     * @memberof RawBarcode
     */
    data: string;
}
/**
 * 
 * @export
 * @interface RecalculateProductionOrderPayload
 */
export interface RecalculateProductionOrderPayload {
    /**
     * 
     * @type {ProductionOrderSavingView}
     * @memberof RecalculateProductionOrderPayload
     */
    productionOrderSavingView: ProductionOrderSavingView;
    /**
     * 
     * @type {ProductionLotSavingViewId}
     * @memberof RecalculateProductionOrderPayload
     */
    lotId: ProductionLotSavingViewId;
}
/**
 * 
 * @export
 * @interface RecipeParameter
 */
export interface RecipeParameter {
    /**
     * 
     * @type {RecipeParameterKey}
     * @memberof RecipeParameter
     */
    id: RecipeParameterKey;
    /**
     * 
     * @type {string}
     * @memberof RecipeParameter
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface RecipeParameterKey
 */
export interface RecipeParameterKey {
    /**
     * 
     * @type {number}
     * @memberof RecipeParameterKey
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RecipeParameterKey
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RecipeParameterKey
     */
    unit: string;
}
/**
 * 
 * @export
 * @interface RecipeTypeView
 */
export interface RecipeTypeView {
    /**
     * 
     * @type {number}
     * @memberof RecipeTypeView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RecipeTypeView
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof RecipeTypeView
     */
    unitType?: string;
}
/**
 * 
 * @export
 * @interface RecipeUserDefinedParameter
 */
export interface RecipeUserDefinedParameter {
    /**
     * 
     * @type {string}
     * @memberof RecipeUserDefinedParameter
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RecipeUserDefinedParameter
     */
    value: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecipeUserDefinedParameter
     */
    exposeWithPossibleValues?: boolean;
    /**
     * RecipeUserDefinedParameterNameId
     * @type {number}
     * @memberof RecipeUserDefinedParameter
     */
    parameterNameId?: number;
}
/**
 * 
 * @export
 * @interface RecipeUserDefinedParameterWithValuesView
 */
export interface RecipeUserDefinedParameterWithValuesView {
    /**
     * RecipeUserDefinedParameterNameId
     * @type {number}
     * @memberof RecipeUserDefinedParameterWithValuesView
     */
    parameterNameId: number;
    /**
     * 
     * @type {string}
     * @memberof RecipeUserDefinedParameterWithValuesView
     */
    parameterName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RecipeUserDefinedParameterWithValuesView
     */
    possibleValues?: Array<string>;
}
/**
 * 
 * @export
 * @interface RecipeWithVersionMissingError
 */
export interface RecipeWithVersionMissingError {
    /**
     * 
     * @type {string}
     * @memberof RecipeWithVersionMissingError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RecipeWithVersionMissingError
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof RecipeWithVersionMissingError
     */
    productCode: string;
    /**
     * 
     * @type {string}
     * @memberof RecipeWithVersionMissingError
     */
    recipeVersionName: string;
}
/**
 * 
 * @export
 * @interface RecursiveSearch
 */
export interface RecursiveSearch {
    /**
     * 
     * @type {string}
     * @memberof RecursiveSearch
     */
    key: string;
}
/**
 * 
 * @export
 * @interface Redirect
 */
export interface Redirect {
    /**
     * 
     * @type {string}
     * @memberof Redirect
     */
    location: string;
}
/**
 * 
 * @export
 * @interface RedirectAction
 */
export interface RedirectAction {
    /**
     * 
     * @type {string}
     * @memberof RedirectAction
     */
    name: string;
    /**
     * 
     * @type {any}
     * @memberof RedirectAction
     */
    parameters: any | null;
}

/**
 * 
 * @export
 */
export const ReferencePattern = {
    kameleon: 1,
    client: 2,
    pantone: 3,
    previousLabel: 4,
    existingLabel: 5,
    seriesColorScheme: 6,
    accordingToSample: 7
} as const;
export type ReferencePattern = typeof ReferencePattern[keyof typeof ReferencePattern];

/**
 * 
 * @export
 * @interface RefreshAfterModal
 */
export interface RefreshAfterModal {
    /**
     * 
     * @type {string}
     * @memberof RefreshAfterModal
     */
    name: string;
}
/**
 * 
 * @export
 * @interface RefreshPageAction
 */
export interface RefreshPageAction {
    /**
     * 
     * @type {string}
     * @memberof RefreshPageAction
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ReleaseItemView
 */
export interface ReleaseItemView {
    /**
     * 
     * @type {string}
     * @memberof ReleaseItemView
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseItemView
     */
    variantCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseItemView
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof ReleaseItemView
     */
    amount: AmountWithUnit;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof ReleaseItemView
     */
    amountInBaseUnitType?: AmountWithUnit;
}
/**
 * 
 * @export
 * @interface ReleaseItemsView
 */
export interface ReleaseItemsView {
    /**
     * 
     * @type {Array<ReleaseItemView>}
     * @memberof ReleaseItemsView
     */
    items?: Array<ReleaseItemView>;
}
/**
 * 
 * @export
 * @interface ReleaseListView
 */
export interface ReleaseListView {
    /**
     * ReleasePlanId
     * @type {number}
     * @memberof ReleaseListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseListView
     */
    number: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReleaseListView
     */
    recipientIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleaseListView
     */
    recipientNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleaseListView
     */
    orderNumbers?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReleaseListView
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleaseListView
     */
    tagNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReleaseListView
     */
    itemTypeTagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleaseListView
     */
    itemTypeTagNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReleaseListView
     */
    variantIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ReleaseListView
     */
    placeName: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseListView
     */
    plannedReleaseDueDate: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseListView
     */
    orderDueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseListView
     */
    releaseDate: string;
    /**
     * UserId
     * @type {number}
     * @memberof ReleaseListView
     */
    releaserId: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseListView
     */
    releaserFullName: string;
}
/**
 * 
 * @export
 * @interface ReleasePlanItemView
 */
export interface ReleasePlanItemView {
    /**
     * 
     * @type {string}
     * @memberof ReleasePlanItemView
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof ReleasePlanItemView
     */
    variantCode?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleasePlanItemView
     */
    productionUnitNumbers?: Array<string>;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof ReleasePlanItemView
     */
    amount: AmountWithUnit;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof ReleasePlanItemView
     */
    amountInBaseUnitType?: AmountWithUnit;
    /**
     * 
     * @type {number}
     * @memberof ReleasePlanItemView
     */
    releasedAmount: number;
}
/**
 * 
 * @export
 * @interface ReleasePlanItemsView
 */
export interface ReleasePlanItemsView {
    /**
     * 
     * @type {Array<ReleasePlanItemView>}
     * @memberof ReleasePlanItemsView
     */
    planned?: Array<ReleasePlanItemView>;
    /**
     * 
     * @type {Array<ReleasePlanItemView>}
     * @memberof ReleasePlanItemsView
     */
    released?: Array<ReleasePlanItemView>;
}
/**
 * 
 * @export
 * @interface ReleasePlanListView
 */
export interface ReleasePlanListView {
    /**
     * ReleasePlanId
     * @type {number}
     * @memberof ReleasePlanListView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ReleasePlanListView
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof ReleasePlanListView
     */
    number: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReleasePlanListView
     */
    recipientIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleasePlanListView
     */
    recipientNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleasePlanListView
     */
    orderNumbers?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReleasePlanListView
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleasePlanListView
     */
    tagNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReleasePlanListView
     */
    itemTypeTagIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleasePlanListView
     */
    itemTypeTagNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReleasePlanListView
     */
    variantIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ReleasePlanListView
     */
    placeName: string;
    /**
     * 
     * @type {string}
     * @memberof ReleasePlanListView
     */
    dueDate: string;
    /**
     * 
     * @type {LegacyReleasePlanStatus}
     * @memberof ReleasePlanListView
     */
    status: LegacyReleasePlanStatus;
}
/**
 * 
 * @export
 * @interface ReleaseSavingViewItem
 */
export interface ReleaseSavingViewItem {
    /**
     * ReleasePlanItemId
     * @type {number}
     * @memberof ReleaseSavingViewItem
     */
    releasePlanItemId?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof ReleaseSavingViewItem
     */
    itemTypeVariantId: number;
    /**
     * StockItemId
     * @type {number}
     * @memberof ReleaseSavingViewItem
     */
    productionUnitId?: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseSavingViewItem
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof ReleaseSavingViewItem
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseSavingViewItem
     */
    missingAmountComment?: string;
}
/**
 * 
 * @export
 * @interface ReliefPlate
 */
export interface ReliefPlate {
    /**
     * 
     * @type {TechnologyType}
     * @memberof ReliefPlate
     */
    tpe: TechnologyType;
}
/**
 * 
 * @export
 * @interface ReliefPlatePriceForContractor
 */
export interface ReliefPlatePriceForContractor {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof ReliefPlatePriceForContractor
     */
    id?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof ReliefPlatePriceForContractor
     */
    contractorId: number;
    /**
     * 
     * @type {number}
     * @memberof ReliefPlatePriceForContractor
     */
    reliefPlatePrice: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof ReliefPlatePriceForContractor
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface ReliefPlateRecipe
 */
export interface ReliefPlateRecipe {
    /**
     * RecipeId
     * @type {number}
     * @memberof ReliefPlateRecipe
     */
    id?: number;
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof ReliefPlateRecipe
     */
    plate: PropertySetSelector;
    /**
     * 
     * @type {string}
     * @memberof ReliefPlateRecipe
     */
    previewLink?: string;
    /**
     * 
     * @type {Array<RecipeParameter>}
     * @memberof ReliefPlateRecipe
     */
    parameters?: Array<RecipeParameter>;
    /**
     * 
     * @type {Array<RecipeUserDefinedParameter>}
     * @memberof ReliefPlateRecipe
     */
    userDefinedParameters?: Array<RecipeUserDefinedParameter>;
    /**
     * 
     * @type {string}
     * @memberof ReliefPlateRecipe
     */
    versionName?: string;
    /**
     * 
     * @type {number}
     * @memberof ReliefPlateRecipe
     */
    recipeType: number;
}
/**
 * 
 * @export
 * @interface ReliefPlateRecipeView
 */
export interface ReliefPlateRecipeView {
    /**
     * RecipeId
     * @type {number}
     * @memberof ReliefPlateRecipeView
     */
    id?: number;
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof ReliefPlateRecipeView
     */
    plate: PropertySetSelectorView;
    /**
     * 
     * @type {string}
     * @memberof ReliefPlateRecipeView
     */
    previewLink?: string;
    /**
     * 
     * @type {number}
     * @memberof ReliefPlateRecipeView
     */
    recipeType: number;
}

/**
 * 
 * @export
 */
export const ReliefPlateType = {
    new: 1,
    old: 2,
    notDefined: 3,
    apla: 4
} as const;
export type ReliefPlateType = typeof ReliefPlateType[keyof typeof ReliefPlateType];

/**
 * 
 * @export
 * @interface ReportThresholds
 */
export interface ReportThresholds {
    /**
     * 
     * @type {number}
     * @memberof ReportThresholds
     */
    warning?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportThresholds
     */
    error?: number;
}
/**
 * 
 * @export
 * @interface ResourceAssignmentsSyncFailed
 */
export interface ResourceAssignmentsSyncFailed {
    /**
     * 
     * @type {string}
     * @memberof ResourceAssignmentsSyncFailed
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ResourceAssignmentsSyncFailed
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ResourceAssignmentsSyncFailed
     */
    message: string;
}
/**
 * 
 * @export
 * @interface RevertDnDOnModalClose
 */
export interface RevertDnDOnModalClose {
    /**
     * 
     * @type {string}
     * @memberof RevertDnDOnModalClose
     */
    name: string;
}
/**
 * 
 * @export
 * @interface Rfid
 */
export interface Rfid {
    /**
     * 
     * @type {string}
     * @memberof Rfid
     */
    rfid: string;
}
/**
 * @type RfidEmptyOrRfidNotUnique
 * 
 * @export
 */
export type RfidEmptyOrRfidNotUnique = { name: 'RfidEmpty' } & LemmaSimpleErrorView | { name: 'RfidNotUnique' } & RfidNotUnique;
/**
 * 
 * @export
 * @interface RfidNotUnique
 */
export interface RfidNotUnique {
    /**
     * 
     * @type {string}
     * @memberof RfidNotUnique
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RfidNotUnique
     */
    description: string;
    /**
     * 
     * @type {Rfid}
     * @memberof RfidNotUnique
     */
    rfid: Rfid;
    /**
     * UserId
     * @type {number}
     * @memberof RfidNotUnique
     */
    userId: number;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Role
     */
    permissions?: Array<string>;
}
/**
 * 
 * @export
 * @interface RoleRow
 */
export interface RoleRow {
    /**
     * 
     * @type {number}
     * @memberof RoleRow
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleRow
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof RoleRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RoleRow
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface RoleView
 */
export interface RoleView {
    /**
     * 
     * @type {number}
     * @memberof RoleView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RoleView
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleView
     */
    permissions?: Array<string>;
}
/**
 * 
 * @export
 * @interface SalesEntryContact
 */
export interface SalesEntryContact {
    /**
     * SalesEntryContactId
     * @type {number}
     * @memberof SalesEntryContact
     */
    id?: number;
    /**
     * 
     * @type {Contact}
     * @memberof SalesEntryContact
     */
    contact: Contact;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryContact
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface SalesEntryDocumentListViewRow
 */
export interface SalesEntryDocumentListViewRow {
    /**
     * SalesEntryDocumentId
     * @type {number}
     * @memberof SalesEntryDocumentListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentListViewRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentListViewRow
     */
    fileName: string;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof SalesEntryDocumentListViewRow
     */
    salesEntryId: number;
    /**
     * 
     * @type {SalesEntryDocumentType}
     * @memberof SalesEntryDocumentListViewRow
     */
    documentType: SalesEntryDocumentType;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryDocumentListViewRow
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentListViewRow
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentListViewRow
     */
    downloadUrl: string;
}
/**
 * 
 * @export
 * @interface SalesEntryDocumentMetadataView
 */
export interface SalesEntryDocumentMetadataView {
    /**
     * SalesEntryDocumentId
     * @type {number}
     * @memberof SalesEntryDocumentMetadataView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentMetadataView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentMetadataView
     */
    fileName: string;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof SalesEntryDocumentMetadataView
     */
    salesEntryId: number;
    /**
     * 
     * @type {SalesEntryDocumentType}
     * @memberof SalesEntryDocumentMetadataView
     */
    documentType: SalesEntryDocumentType;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryDocumentMetadataView
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentMetadataView
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentMetadataView
     */
    downloadUrl: string;
}

/**
 * 
 * @export
 */
export const SalesEntryDocumentType = {
    email: 1,
    image: 2,
    expense: 3,
    other: 4
} as const;
export type SalesEntryDocumentType = typeof SalesEntryDocumentType[keyof typeof SalesEntryDocumentType];

/**
 * 
 * @export
 * @interface SalesEntryDocumentUpdateView
 */
export interface SalesEntryDocumentUpdateView {
    /**
     * SalesEntryDocumentId
     * @type {number}
     * @memberof SalesEntryDocumentUpdateView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentUpdateView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryDocumentUpdateView
     */
    fileName: string;
    /**
     * 
     * @type {SalesEntryDocumentType}
     * @memberof SalesEntryDocumentUpdateView
     */
    documentType: SalesEntryDocumentType;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryDocumentUpdateView
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface SalesEntryItemSavingView
 */
export interface SalesEntryItemSavingView {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SalesEntryItemSavingView
     */
    id?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SalesEntryItemSavingView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {OrderedAmount}
     * @memberof SalesEntryItemSavingView
     */
    amount: OrderedAmount;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemSavingView
     */
    unitPrice: number;
    /**
     * VatRateId
     * @type {number}
     * @memberof SalesEntryItemSavingView
     */
    vat: number;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemSavingView
     */
    discount?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemSavingView
     */
    dueDate?: string;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SalesEntryItemSavingView
     */
    linkedSalesEntryItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemSavingView
     */
    comment?: string;
    /**
     * 
     * @type {Array<VariantCostEntrySavingView>}
     * @memberof SalesEntryItemSavingView
     */
    entries?: Array<VariantCostEntrySavingView>;
}

/**
 * 
 * @export
 */
export const SalesEntryItemStatus = {
    draft: 1,
    new: 2,
    inProgress: 3,
    cancelled: 4,
    done: 5,
    partiallyShipped: 6,
    shipped: 7,
    deleted: 8,
    offer: 9
} as const;
export type SalesEntryItemStatus = typeof SalesEntryItemStatus[keyof typeof SalesEntryItemStatus];

/**
 * 
 * @export
 * @interface SalesEntryItemView
 */
export interface SalesEntryItemView {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SalesEntryItemView
     */
    id?: number;
    /**
     * 
     * @type {ClientSpecification}
     * @memberof SalesEntryItemView
     */
    clientSpecification: ClientSpecification;
    /**
     * 
     * @type {OrderedAmount}
     * @memberof SalesEntryItemView
     */
    amount: OrderedAmount;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView
     */
    priceBase?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView
     */
    priceBaseInBaseCurrency?: number;
    /**
     * 
     * @type {VatRateView}
     * @memberof SalesEntryItemView
     */
    salesVatRate: VatRateView;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView
     */
    discount: number;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemView
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemView
     */
    shippingDate?: string;
    /**
     * 
     * @type {SalesEntryItemStatus}
     * @memberof SalesEntryItemView
     */
    status: SalesEntryItemStatus;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemView
     */
    comments?: string;
    /**
     * 
     * @type {CostEstimate}
     * @memberof SalesEntryItemView
     */
    costEstimate?: CostEstimate;
    /**
     * 
     * @type {CostSet}
     * @memberof SalesEntryItemView
     */
    additionalCosts?: CostSet;
    /**
     * PlaceId
     * @type {number}
     * @memberof SalesEntryItemView
     */
    pickupPointId?: number;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SalesEntryItemView
     */
    offerItemId?: number;
}
/**
 * 
 * @export
 * @interface SalesEntryItemView2
 */
export interface SalesEntryItemView2 {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SalesEntryItemView2
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView2
     */
    ordinal: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SalesEntryItemView2
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemView2
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemView2
     */
    itemTypeVariantCode?: string;
    /**
     * 
     * @type {OrderedAmount}
     * @memberof SalesEntryItemView2
     */
    amount: OrderedAmount;
    /**
     * 
     * @type {Array<string>}
     * @memberof SalesEntryItemView2
     */
    secondaryUnitTypes?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView2
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView2
     */
    discount: number;
    /**
     * 
     * @type {VatRateView}
     * @memberof SalesEntryItemView2
     */
    vat: VatRateView;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView2
     */
    availableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof SalesEntryItemView2
     */
    progress: number;
    /**
     * 
     * @type {SalesEntryItemStatus}
     * @memberof SalesEntryItemView2
     */
    status: SalesEntryItemStatus;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemView2
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemView2
     */
    comment?: string;
    /**
     * 
     * @type {Array<VariantCostEntryView>}
     * @memberof SalesEntryItemView2
     */
    entries?: Array<VariantCostEntryView>;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SalesEntryItemView2
     */
    linkedSalesEntryItemId?: number;
}
/**
 * 
 * @export
 * @interface SalesEntryItemsView
 */
export interface SalesEntryItemsView {
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemsView
     */
    parentDeliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryItemsView
     */
    currency: string;
    /**
     * 
     * @type {Array<SalesEntryItemView2>}
     * @memberof SalesEntryItemsView
     */
    items?: Array<SalesEntryItemView2>;
}
/**
 * 
 * @export
 * @interface SalesEntryTag
 */
export interface SalesEntryTag {
    /**
     * SalesEntryTagId
     * @type {number}
     * @memberof SalesEntryTag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryTag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryTag
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryTag
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface SalesEntryTagRow
 */
export interface SalesEntryTagRow {
    /**
     * SalesEntryTagId
     * @type {number}
     * @memberof SalesEntryTagRow
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryTagRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryTagRow
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesEntryTagRow
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface SalesOptions
 */
export interface SalesOptions {
    /**
     * 
     * @type {boolean}
     * @memberof SalesOptions
     */
    marketingRulesApplied: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SalesOptions
     */
    signed: boolean;
}
/**
 * 
 * @export
 * @interface SalesOrderDetails
 */
export interface SalesOrderDetails {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof SalesOrderDetails
     */
    orderId: number;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetails
     */
    orderNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetails
     */
    buyerName: string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof SalesOrderDetails
     */
    status: OrderStatus;
    /**
     * 
     * @type {Array<number>}
     * @memberof SalesOrderDetails
     */
    ordinals?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SalesOrderDetails
     */
    deliveryDate?: string;
}
/**
 * 
 * @export
 * @interface SalesRate
 */
export interface SalesRate {
    /**
     * 
     * @type {string}
     * @memberof SalesRate
     */
    currencyCode: string;
    /**
     * 
     * @type {CurrencyExchangeRate}
     * @memberof SalesRate
     */
    exchangeRate?: CurrencyExchangeRate;
}
/**
 * 
 * @export
 * @interface Scrolling
 */
export interface Scrolling {
    /**
     * 
     * @type {TechnologyType}
     * @memberof Scrolling
     */
    tpe: TechnologyType;
}
/**
 * 
 * @export
 * @interface ScrollingRecipe
 */
export interface ScrollingRecipe {
    /**
     * RecipeId
     * @type {number}
     * @memberof ScrollingRecipe
     */
    id?: number;
    /**
     * 
     * @type {ClientSpecification}
     * @memberof ScrollingRecipe
     */
    ingredient: ClientSpecification;
    /**
     * 
     * @type {PrintingRecipeViewPunchingDiesInner}
     * @memberof ScrollingRecipe
     */
    ingredientPunchingDie?: PrintingRecipeViewPunchingDiesInner;
    /**
     * 
     * @type {number}
     * @memberof ScrollingRecipe
     */
    itemsInSet: number;
    /**
     * 
     * @type {Array<RecipeParameter>}
     * @memberof ScrollingRecipe
     */
    parameters?: Array<RecipeParameter>;
    /**
     * 
     * @type {Array<RecipeUserDefinedParameter>}
     * @memberof ScrollingRecipe
     */
    userDefinedParameters?: Array<RecipeUserDefinedParameter>;
    /**
     * 
     * @type {string}
     * @memberof ScrollingRecipe
     */
    versionName?: string;
    /**
     * 
     * @type {number}
     * @memberof ScrollingRecipe
     */
    recipeType: number;
}
/**
 * 
 * @export
 * @interface SearchResponseCompetenceAuthority
 */
export interface SearchResponseCompetenceAuthority {
    /**
     * 
     * @type {Array<CompetenceAuthority>}
     * @memberof SearchResponseCompetenceAuthority
     */
    results?: Array<CompetenceAuthority>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResponseCompetenceAuthority
     */
    fullyLoaded: boolean;
}
/**
 * 
 * @export
 * @interface SearchResponseIdWithName
 */
export interface SearchResponseIdWithName {
    /**
     * 
     * @type {Array<IdWithName>}
     * @memberof SearchResponseIdWithName
     */
    results?: Array<IdWithName>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResponseIdWithName
     */
    fullyLoaded: boolean;
}
/**
 * 
 * @export
 * @interface SearchResponseString
 */
export interface SearchResponseString {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchResponseString
     */
    results?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResponseString
     */
    fullyLoaded: boolean;
}
/**
 * 
 * @export
 * @interface SecondaryUnitType
 */
export interface SecondaryUnitType {
    /**
     * 
     * @type {string}
     * @memberof SecondaryUnitType
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof SecondaryUnitType
     */
    multiplier: number;
}
/**
 * 
 * @export
 * @interface SelfProfileUpdateView
 */
export interface SelfProfileUpdateView {
    /**
     * 
     * @type {string}
     * @memberof SelfProfileUpdateView
     */
    currentPassword?: string;
    /**
     * 
     * @type {Profile}
     * @memberof SelfProfileUpdateView
     */
    profile: Profile;
}
/**
 * 
 * @export
 * @interface SensorDowntimeGroupUpdateView
 */
export interface SensorDowntimeGroupUpdateView {
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof SensorDowntimeGroupUpdateView
     */
    groupId: number;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof SensorDowntimeGroupUpdateView
     */
    reason?: number;
    /**
     * 
     * @type {string}
     * @memberof SensorDowntimeGroupUpdateView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface SensorDowntimeUpdateView
 */
export interface SensorDowntimeUpdateView {
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof SensorDowntimeUpdateView
     */
    id: number;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof SensorDowntimeUpdateView
     */
    reason?: number;
    /**
     * 
     * @type {string}
     * @memberof SensorDowntimeUpdateView
     */
    comment?: string;
}

/**
 * 
 * @export
 */
export const ShipmentArrangerType = {
    buyer: 1,
    supplier: 2
} as const;
export type ShipmentArrangerType = typeof ShipmentArrangerType[keyof typeof ShipmentArrangerType];

/**
 * 
 * @export
 * @interface ShippingDate
 */
export interface ShippingDate {
    /**
     * 
     * @type {string}
     * @memberof ShippingDate
     */
    shippingDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingDate
     */
    shippingTime?: string;
}
/**
 * 
 * @export
 * @interface ShowModalAction
 */
export interface ShowModalAction {
    /**
     * 
     * @type {string}
     * @memberof ShowModalAction
     */
    name: string;
    /**
     * 
     * @type {JsObject}
     * @memberof ShowModalAction
     */
    params: JsObject;
}
/**
 * 
 * @export
 * @interface SickLeaveCalendarEvent
 */
export interface SickLeaveCalendarEvent {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof SickLeaveCalendarEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SickLeaveCalendarEvent
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof SickLeaveCalendarEvent
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof SickLeaveCalendarEvent
     */
    registrantName: string;
    /**
     * 
     * @type {string}
     * @memberof SickLeaveCalendarEvent
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SickLeaveCalendarEvent
     */
    allDay: boolean;
    /**
     * 
     * @type {CalendarEventType}
     * @memberof SickLeaveCalendarEvent
     */
    calendarEventType: CalendarEventType;
    /**
     * 
     * @type {WorkerEventCalendarType}
     * @memberof SickLeaveCalendarEvent
     */
    eventType: WorkerEventCalendarType;
}
/**
 * 
 * @export
 * @interface SieveColor
 */
export interface SieveColor {
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof SieveColor
     */
    paint?: PropertySetSelector;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SieveColor
     */
    sieve?: number;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof SieveColor
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof SieveColor
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SieveColor
     */
    dosageRoller?: number;
    /**
     * 
     * @type {StepMode}
     * @memberof SieveColor
     */
    stepMode: StepMode;
}
/**
 * 
 * @export
 * @interface SieveColorView
 */
export interface SieveColorView {
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof SieveColorView
     */
    paint?: PropertySetSelectorView;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof SieveColorView
     */
    sieve?: ItemTypeVariant;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof SieveColorView
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof SieveColorView
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof SieveColorView
     */
    dosageRoller?: ItemTypeVariant;
    /**
     * 
     * @type {StepMode}
     * @memberof SieveColorView
     */
    stepMode: StepMode;
    /**
     * 
     * @type {StepType}
     * @memberof SieveColorView
     */
    stepType: StepType;
}
/**
 * 
 * @export
 * @interface SievePriceForContractor
 */
export interface SievePriceForContractor {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof SievePriceForContractor
     */
    id?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof SievePriceForContractor
     */
    contractorId: number;
    /**
     * 
     * @type {number}
     * @memberof SievePriceForContractor
     */
    sievePrice: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof SievePriceForContractor
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface SimilarOrderInfoView
 */
export interface SimilarOrderInfoView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof SimilarOrderInfoView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SimilarOrderInfoView
     */
    supplierNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarOrderInfoView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarOrderInfoView
     */
    creationDate?: string;
    /**
     * 
     * @type {Array<Item>}
     * @memberof SimilarOrderInfoView
     */
    items?: Array<Item>;
}
/**
 * 
 * @export
 * @interface SimulationCreateProductionLotView
 */
export interface SimulationCreateProductionLotView {
    /**
     * 
     * @type {string}
     * @memberof SimulationCreateProductionLotView
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationCreateProductionLotView
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof SimulationCreateProductionLotView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationCreateProductionLotView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationCreateProductionLotView
     */
    operationCode?: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationCreateProductionLotView
     */
    productCode: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationCreateProductionLotView
     */
    recipeVersionName: string;
    /**
     * 
     * @type {Array<ProductionLotIdentificationCode>}
     * @memberof SimulationCreateProductionLotView
     */
    childrenCodes?: Array<ProductionLotIdentificationCode>;
    /**
     * 
     * @type {Array<ProductionLotIdentificationCode>}
     * @memberof SimulationCreateProductionLotView
     */
    parentCodes?: Array<ProductionLotIdentificationCode>;
    /**
     * 
     * @type {string}
     * @memberof SimulationCreateProductionLotView
     */
    productionOrderCode: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationCreateProductionLotView
     */
    productName?: string;
}
/**
 * 
 * @export
 * @interface SimulationLinkedLotView
 */
export interface SimulationLinkedLotView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SimulationLinkedLotView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationLinkedLotView
     */
    number?: string;
}
/**
 * 
 * @export
 * @interface SimulationLotView
 */
export interface SimulationLotView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SimulationLotView
     */
    id?: number;
    /**
     * 
     * @type {Technology}
     * @memberof SimulationLotView
     */
    technologyName?: Technology;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SimulationLotView
     */
    productVariantId: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SimulationLotView
     */
    variantId: number;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof SimulationLotView
     */
    amountWithUnit: AmountWithUnit;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof SimulationLotView
     */
    productItemTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationLotView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationLotView
     */
    productCode?: string;
    /**
     * 
     * @type {number}
     * @memberof SimulationLotView
     */
    productAmount: number;
    /**
     * Needed amounts by item type variant id
     * @type {{ [key: string]: number; }}
     * @memberof SimulationLotView
     */
    neededAmounts: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof SimulationLotView
     */
    warehouseState: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationLotView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationLotView
     */
    dueDate?: string;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SimulationLotView
     */
    mergedTo?: number;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SimulationLotView
     */
    linkedOrderItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationLotView
     */
    linkedOrderNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof SimulationLotView
     */
    ordinal?: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SimulationLotView
     */
    linkedProductionLotId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationLotView
     */
    linkedProductionLotNumber?: string;
    /**
     * 
     * @type {Array<SimulationOrderItemView>}
     * @memberof SimulationLotView
     */
    linkedOrderItems?: Array<SimulationOrderItemView>;
    /**
     * 
     * @type {Array<SimulationLinkedLotView>}
     * @memberof SimulationLotView
     */
    linkedProductionLots?: Array<SimulationLinkedLotView>;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationLotView
     */
    noTechnology: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationLotView
     */
    noMaterials: boolean;
    /**
     * 
     * @type {Array<SimulationLotView>}
     * @memberof SimulationLotView
     */
    children?: Array<SimulationLotView>;
}
/**
 * 
 * @export
 * @interface SimulationMergeCreateProductionOrderView
 */
export interface SimulationMergeCreateProductionOrderView {
    /**
     * 
     * @type {Array<ApiProductionLotView>}
     * @memberof SimulationMergeCreateProductionOrderView
     */
    lotViews?: Array<ApiProductionLotView>;
    /**
     * 
     * @type {string}
     * @memberof SimulationMergeCreateProductionOrderView
     */
    code: string;
}

/**
 * 
 * @export
 */
export const SimulationMergeStatus = {
    StartedApplying: 'StartedApplying',
    Error: 'Error',
    Applied: 'Applied',
    PlanUpdateApplied: 'PlanUpdateApplied'
} as const;
export type SimulationMergeStatus = typeof SimulationMergeStatus[keyof typeof SimulationMergeStatus];

/**
 * 
 * @export
 * @interface SimulationMergeView
 */
export interface SimulationMergeView {
    /**
     * SimulationId
     * @type {number}
     * @memberof SimulationMergeView
     */
    simulationId: number;
    /**
     * 
     * @type {ErpType}
     * @memberof SimulationMergeView
     */
    erp: ErpType;
    /**
     * 
     * @type {Array<SimulationMergeCreateProductionOrderView>}
     * @memberof SimulationMergeView
     */
    newProductionOrders?: Array<SimulationMergeCreateProductionOrderView>;
    /**
     * 
     * @type {Array<SimulationSplitData>}
     * @memberof SimulationMergeView
     */
    splitLots?: Array<SimulationSplitData>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimulationMergeView
     */
    cancelLots?: Array<number>;
    /**
     * 
     * @type {Array<SimulationSetLotAmountView>}
     * @memberof SimulationMergeView
     */
    setAmounts?: Array<SimulationSetLotAmountView>;
    /**
     * 
     * @type {Array<SimulationCreateProductionLotView>}
     * @memberof SimulationMergeView
     */
    newProductionLots?: Array<SimulationCreateProductionLotView>;
    /**
     * 
     * @type {Array<SimulationProductionOrderCodePriorityView>}
     * @memberof SimulationMergeView
     */
    priorityAssignmentsByOrderCode?: Array<SimulationProductionOrderCodePriorityView>;
    /**
     * 
     * @type {Array<SimulationProductionLotCodeRequiredWorkersView>}
     * @memberof SimulationMergeView
     */
    requiredWorkersAmountByLotCode?: Array<SimulationProductionLotCodeRequiredWorkersView>;
    /**
     * 
     * @type {Array<SimulationReplaceDependenciesView>}
     * @memberof SimulationMergeView
     */
    replaceDependencies?: Array<SimulationReplaceDependenciesView>;
}
/**
 * 
 * @export
 * @interface SimulationOrderItemView
 */
export interface SimulationOrderItemView {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SimulationOrderItemView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationOrderItemView
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationOrderItemView
     */
    orderNumber?: string;
}
/**
 * 
 * @export
 * @interface SimulationProductionLotCodeRequiredWorkersView
 */
export interface SimulationProductionLotCodeRequiredWorkersView {
    /**
     * 
     * @type {string}
     * @memberof SimulationProductionLotCodeRequiredWorkersView
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof SimulationProductionLotCodeRequiredWorkersView
     */
    requiredWorkersAmount: number;
}
/**
 * 
 * @export
 * @interface SimulationProductionOrderCodePriorityView
 */
export interface SimulationProductionOrderCodePriorityView {
    /**
     * 
     * @type {string}
     * @memberof SimulationProductionOrderCodePriorityView
     */
    code: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationProductionOrderCodePriorityView
     */
    priority: boolean;
}
/**
 * 
 * @export
 * @interface SimulationQueryLotView
 */
export interface SimulationQueryLotView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SimulationQueryLotView
     */
    variantId: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationQueryLotView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationQueryLotView
     */
    productCode?: string;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof SimulationQueryLotView
     */
    amountWithUnit: AmountWithUnit;
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SimulationQueryLotView
     */
    linkedOrderItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationQueryLotView
     */
    linkedOrderNumber?: string;
    /**
     * 
     * @type {Array<SimulationOrderItemView>}
     * @memberof SimulationQueryLotView
     */
    linkedOrderItems?: Array<SimulationOrderItemView>;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SimulationQueryLotView
     */
    linkedProductionLotId?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationQueryLotView
     */
    linkedProductionLotNumber?: string;
    /**
     * 
     * @type {Array<SimulationLinkedLotView>}
     * @memberof SimulationQueryLotView
     */
    linkedProductionLots?: Array<SimulationLinkedLotView>;
    /**
     * 
     * @type {number}
     * @memberof SimulationQueryLotView
     */
    ordinal?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationQueryLotView
     */
    noTechnology: boolean;
    /**
     * 
     * @type {Array<SimulationQueryLotView>}
     * @memberof SimulationQueryLotView
     */
    children?: Array<SimulationQueryLotView>;
}
/**
 * 
 * @export
 * @interface SimulationQueryPayload
 */
export interface SimulationQueryPayload {
    /**
     * 
     * @type {Array<number>}
     * @memberof SimulationQueryPayload
     */
    orderDemands?: Array<number>;
    /**
     * 
     * @type {Array<SimulationQueryPayloadLotVariant>}
     * @memberof SimulationQueryPayload
     */
    lotDemands?: Array<SimulationQueryPayloadLotVariant>;
    /**
     * 
     * @type {Array<AmountOfItemTypeVariant>}
     * @memberof SimulationQueryPayload
     */
    items?: Array<AmountOfItemTypeVariant>;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationQueryPayload
     */
    automerge?: boolean;
}
/**
 * 
 * @export
 * @interface SimulationQueryPayloadLotVariant
 */
export interface SimulationQueryPayloadLotVariant {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SimulationQueryPayloadLotVariant
     */
    productionLotId: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SimulationQueryPayloadLotVariant
     */
    itemTypeVariantId: number;
}
/**
 * 
 * @export
 * @interface SimulationQueryView
 */
export interface SimulationQueryView {
    /**
     * 
     * @type {Array<SimulationQueryLotView>}
     * @memberof SimulationQueryView
     */
    roots: Array<SimulationQueryLotView>;
}
/**
 * 
 * @export
 * @interface SimulationReplaceDependenciesView
 */
export interface SimulationReplaceDependenciesView {
    /**
     * 
     * @type {ProductionLotIdentificationCode}
     * @memberof SimulationReplaceDependenciesView
     */
    lotIdentificationCode: ProductionLotIdentificationCode;
    /**
     * 
     * @type {Array<ProductionLotIdentificationCode>}
     * @memberof SimulationReplaceDependenciesView
     */
    childrenIdentificationCodes?: Array<ProductionLotIdentificationCode>;
}
/**
 * 
 * @export
 * @interface SimulationSetLotAmountView
 */
export interface SimulationSetLotAmountView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SimulationSetLotAmountView
     */
    productionLotId: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationSetLotAmountView
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface SimulationSplitData
 */
export interface SimulationSplitData {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SimulationSplitData
     */
    productionLotId: number;
    /**
     * 
     * @type {Array<SimulationSplitLotView>}
     * @memberof SimulationSplitData
     */
    codesWithAmounts: Array<SimulationSplitLotView>;
}
/**
 * 
 * @export
 * @interface SimulationSplitLotView
 */
export interface SimulationSplitLotView {
    /**
     * 
     * @type {string}
     * @memberof SimulationSplitLotView
     */
    lotCode: string;
    /**
     * 
     * @type {number}
     * @memberof SimulationSplitLotView
     */
    amount: number;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationSplitLotView
     */
    cancel: boolean;
}
/**
 * 
 * @export
 * @interface SimulationView
 */
export interface SimulationView {
    /**
     * Needed amounts by item type variant id
     * @type {{ [key: string]: number; }}
     * @memberof SimulationView
     */
    neededAmounts: { [key: string]: number; };
    /**
     * 
     * @type {Array<SimulationLotView>}
     * @memberof SimulationView
     */
    roots?: Array<SimulationLotView>;
}
/**
 * 
 * @export
 * @interface SingleContractorAllItems
 */
export interface SingleContractorAllItems {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof SingleContractorAllItems
     */
    id?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof SingleContractorAllItems
     */
    contractorId: number;
    /**
     * 
     * @type {number}
     * @memberof SingleContractorAllItems
     */
    discount: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof SingleContractorAllItems
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface SingleContractorItemGroup
 */
export interface SingleContractorItemGroup {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof SingleContractorItemGroup
     */
    id?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof SingleContractorItemGroup
     */
    contractorId: number;
    /**
     * 
     * @type {ItemTypeTag}
     * @memberof SingleContractorItemGroup
     */
    itemTypeTag: ItemTypeTag;
    /**
     * 
     * @type {number}
     * @memberof SingleContractorItemGroup
     */
    discount: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof SingleContractorItemGroup
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface SingleContractorSingleItem
 */
export interface SingleContractorSingleItem {
    /**
     * MarketingRuleId
     * @type {number}
     * @memberof SingleContractorSingleItem
     */
    id?: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof SingleContractorSingleItem
     */
    contractorId: number;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof SingleContractorSingleItem
     */
    itemTypeId: number;
    /**
     * 
     * @type {number}
     * @memberof SingleContractorSingleItem
     */
    discount: number;
    /**
     * 
     * @type {MarketingRuleType}
     * @memberof SingleContractorSingleItem
     */
    marketingRuleType: MarketingRuleType;
}
/**
 * 
 * @export
 * @interface SingleMachine
 */
export interface SingleMachine {
    /**
     * MachineId
     * @type {number}
     * @memberof SingleMachine
     */
    machineId: number;
    /**
     * 
     * @type {EstimatedProductionTimeScopeType}
     * @memberof SingleMachine
     */
    scopeType: EstimatedProductionTimeScopeType;
}
/**
 * 
 * @export
 * @interface SourceAttribute
 */
export interface SourceAttribute {
    /**
     * 
     * @type {OrderSourceAttributeType}
     * @memberof SourceAttribute
     */
    attributeType: OrderSourceAttributeType;
    /**
     * 
     * @type {string}
     * @memberof SourceAttribute
     */
    value: string;
}

/**
 * 
 * @export
 */
export const SourceType = {
    lemma: 1,
    clientPortal: 2,
    edi: 3,
    erp: 4,
    csv: 5
} as const;
export type SourceType = typeof SourceType[keyof typeof SourceType];

/**
 * 
 * @export
 * @interface SpecificationDocument
 */
export interface SpecificationDocument {
    /**
     * SpecificationDocumentId
     * @type {number}
     * @memberof SpecificationDocument
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationDocument
     */
    name: string;
    /**
     * FileId
     * @type {number}
     * @memberof SpecificationDocument
     */
    fileId: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationDocument
     */
    creationDate: string;
}
/**
 * 
 * @export
 * @interface SpecificationPiece
 */
export interface SpecificationPiece {
    /**
     * PiecesProductSpecificationPieceId
     * @type {number}
     * @memberof SpecificationPiece
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationPiece
     */
    uuid: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SpecificationPiece
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationPiece
     */
    itemTypeVariantName?: string;
    /**
     * 
     * @type {number}
     * @memberof SpecificationPiece
     */
    amount: number;
    /**
     * CostEntryId
     * @type {number}
     * @memberof SpecificationPiece
     */
    costEntryId?: number;
    /**
     * 
     * @type {PieceType}
     * @memberof SpecificationPiece
     */
    pieceType: PieceType;
}
/**
 * 
 * @export
 * @interface SpecificationTemplate
 */
export interface SpecificationTemplate {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplate
     */
    id?: number;
    /**
     * 
     * @type {QualitySpecification}
     * @memberof SpecificationTemplate
     */
    qualitySpecification: QualitySpecification;
    /**
     * 
     * @type {Array<MeasurementSpecification>}
     * @memberof SpecificationTemplate
     */
    measurementSpecifications?: Array<MeasurementSpecification>;
    /**
     * 
     * @type {Array<MeasurementSpecification>}
     * @memberof SpecificationTemplate
     */
    machineMeasurementSpecifications?: Array<MeasurementSpecification>;
    /**
     * 
     * @type {Array<MachineCardSpecification>}
     * @memberof SpecificationTemplate
     */
    machineCardSpecifications?: Array<MachineCardSpecification>;
    /**
     * 
     * @type {MachineSpecification}
     * @memberof SpecificationTemplate
     */
    machineSpecification: MachineSpecification;
    /**
     * 
     * @type {PackagingSpecification}
     * @memberof SpecificationTemplate
     */
    packagingSpecification: PackagingSpecification;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplate
     */
    productionComments?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplate
     */
    specificationComments?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplate
     */
    templateName: string;
    /**
     * 
     * @type {GenericRecipe}
     * @memberof SpecificationTemplate
     */
    recipe?: GenericRecipe;
    /**
     * 
     * @type {CostSpecification}
     * @memberof SpecificationTemplate
     */
    costSpecification?: CostSpecification;
    /**
     * 
     * @type {Array<number>}
     * @memberof SpecificationTemplate
     */
    reclassificationTemplates?: Array<number>;
    /**
     * 
     * @type {GenericMatchCondition}
     * @memberof SpecificationTemplate
     */
    matchConditions: GenericMatchCondition;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplate
     */
    deleted: boolean;
    /**
     * 
     * @type {Array<SpecificationDocument>}
     * @memberof SpecificationTemplate
     */
    specificationDocuments?: Array<SpecificationDocument>;
    /**
     * 
     * @type {ProductionTimeEstimationDefinitions}
     * @memberof SpecificationTemplate
     */
    productionTimeEstimationDefinitions: ProductionTimeEstimationDefinitions;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateByMachineFeaturesRow
 */
export interface SpecificationTemplateByMachineFeaturesRow {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplateByMachineFeaturesRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateByMachineFeaturesRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateByMachineFeaturesRow
     */
    itemTypeName: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpecificationTemplateByMachineFeaturesRow
     */
    machineFeatures?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateByMachineFeaturesRow
     */
    deleted: boolean;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateByProducedItemTagsRow
 */
export interface SpecificationTemplateByProducedItemTagsRow {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplateByProducedItemTagsRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateByProducedItemTagsRow
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpecificationTemplateByProducedItemTagsRow
     */
    itemTypeTags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateByProducedItemTagsRow
     */
    deleted: boolean;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateByProducedVariantViewRow
 */
export interface SpecificationTemplateByProducedVariantViewRow {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplateByProducedVariantViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateByProducedVariantViewRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateByProducedVariantViewRow
     */
    itemType: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateByProducedVariantViewRow
     */
    specificationActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateByProducedVariantViewRow
     */
    defaultSpecification: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpecificationTemplateByProducedVariantViewRow
     */
    recipeSummary?: Array<string>;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateByProducedVariantViewRowV2
 */
export interface SpecificationTemplateByProducedVariantViewRowV2 {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplateByProducedVariantViewRowV2
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateByProducedVariantViewRowV2
     */
    specificationTemplateName: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateByProducedVariantViewRowV2
     */
    comboSearch: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateByProducedVariantViewRowV2
     */
    isActive: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateByProducedVariantViewRowV2
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateByProducedVariantViewRowV2
     */
    isFromErp: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateByProducedVariantViewRowV2
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateForVariantView
 */
export interface SpecificationTemplateForVariantView {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplateForVariantView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateForVariantView
     */
    specificationTemplateName: string;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof SpecificationTemplateForVariantView
     */
    itemTypeVariant: ItemTypeVariant;
    /**
     * 
     * @type {number}
     * @memberof SpecificationTemplateForVariantView
     */
    matchingProperties: number;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateShortView
 */
export interface SpecificationTemplateShortView {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplateShortView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateShortView
     */
    templateName: string;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateSimpleCreateView
 */
export interface SpecificationTemplateSimpleCreateView {
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateSimpleCreateView
     */
    templateName: string;
    /**
     * 
     * @type {PiecesRecipeSimpleSavingView}
     * @memberof SpecificationTemplateSimpleCreateView
     */
    recipe: PiecesRecipeSimpleSavingView;
    /**
     * 
     * @type {MachineSpecification}
     * @memberof SpecificationTemplateSimpleCreateView
     */
    machineSpecification: MachineSpecification;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateSimpleUpdateView
 */
export interface SpecificationTemplateSimpleUpdateView {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplateSimpleUpdateView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateSimpleUpdateView
     */
    templateName: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateSimpleUpdateView
     */
    deleted: boolean;
    /**
     * 
     * @type {PiecesRecipeSimpleSavingView}
     * @memberof SpecificationTemplateSimpleUpdateView
     */
    recipe: PiecesRecipeSimpleSavingView;
    /**
     * 
     * @type {MachineSpecification}
     * @memberof SpecificationTemplateSimpleUpdateView
     */
    machineSpecification: MachineSpecification;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateSimpleView
 */
export interface SpecificationTemplateSimpleView {
    /**
     * SpecificationTemplateId
     * @type {number}
     * @memberof SpecificationTemplateSimpleView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateSimpleView
     */
    templateName: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpecificationTemplateSimpleView
     */
    deleted: boolean;
    /**
     * 
     * @type {PiecesRecipeSimpleView}
     * @memberof SpecificationTemplateSimpleView
     */
    recipe?: PiecesRecipeSimpleView;
    /**
     * 
     * @type {MachineSpecification}
     * @memberof SpecificationTemplateSimpleView
     */
    machineSpecification: MachineSpecification;
}
/**
 * 
 * @export
 * @interface SpecificationTemplateWithItemTypeSavingView
 */
export interface SpecificationTemplateWithItemTypeSavingView {
    /**
     * 
     * @type {QualitySpecification}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    qualitySpecification: QualitySpecification;
    /**
     * 
     * @type {Array<MeasurementSpecification>}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    measurementSpecifications?: Array<MeasurementSpecification>;
    /**
     * 
     * @type {Array<MeasurementSpecification>}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    machineMeasurementSpecifications?: Array<MeasurementSpecification>;
    /**
     * 
     * @type {Array<MachineCardSpecification>}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    machineCardSpecifications?: Array<MachineCardSpecification>;
    /**
     * 
     * @type {MachineSpecification}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    machineSpecification: MachineSpecification;
    /**
     * 
     * @type {PackagingSpecification}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    packagingSpecification: PackagingSpecification;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    productionComments?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    specificationComments?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    templateName: string;
    /**
     * 
     * @type {GenericRecipe}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    recipe?: GenericRecipe;
    /**
     * 
     * @type {Array<number>}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    reclassificationTemplates?: Array<number>;
    /**
     * 
     * @type {Array<SpecificationDocument>}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    specificationDocuments?: Array<SpecificationDocument>;
    /**
     * 
     * @type {ProductionTimeEstimationDefinitions}
     * @memberof SpecificationTemplateWithItemTypeSavingView
     */
    productionTimeEstimationDefinitions: ProductionTimeEstimationDefinitions;
}
/**
 * 
 * @export
 * @interface SplitOrder
 */
export interface SplitOrder {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof SplitOrder
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SplitOrder
     */
    number: string;
}
/**
 * 
 * @export
 * @interface SpontaneousReleaseSavingView
 */
export interface SpontaneousReleaseSavingView {
    /**
     * ContractorId
     * @type {number}
     * @memberof SpontaneousReleaseSavingView
     */
    recipientId: number;
    /**
     * AddressId
     * @type {number}
     * @memberof SpontaneousReleaseSavingView
     */
    addressId: number;
    /**
     * 
     * @type {string}
     * @memberof SpontaneousReleaseSavingView
     */
    releaseDate: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof SpontaneousReleaseSavingView
     */
    placeId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SpontaneousReleaseSavingView
     */
    tags?: Array<number>;
    /**
     * 
     * @type {Array<ReleaseSavingViewItem>}
     * @memberof SpontaneousReleaseSavingView
     */
    items: Array<ReleaseSavingViewItem>;
}
/**
 * 
 * @export
 * @interface SpontaneousSupplyCardCreateView
 */
export interface SpontaneousSupplyCardCreateView {
    /**
     * ContractorId
     * @type {number}
     * @memberof SpontaneousSupplyCardCreateView
     */
    supplierId: number;
    /**
     * 
     * @type {string}
     * @memberof SpontaneousSupplyCardCreateView
     */
    deliveryDate: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof SpontaneousSupplyCardCreateView
     */
    placeId?: number;
    /**
     * 
     * @type {Array<SpontaneousSupplyCardItemCreateView>}
     * @memberof SpontaneousSupplyCardCreateView
     */
    items?: Array<SpontaneousSupplyCardItemCreateView>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SpontaneousSupplyCardCreateView
     */
    tags?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SpontaneousSupplyCardCreateView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface SpontaneousSupplyCardItemCreateView
 */
export interface SpontaneousSupplyCardItemCreateView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SpontaneousSupplyCardItemCreateView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof SpontaneousSupplyCardItemCreateView
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SpontaneousSupplyCardItemCreateView
     */
    unit: string;
    /**
     * 
     * @type {number}
     * @memberof SpontaneousSupplyCardItemCreateView
     */
    amount: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof SpontaneousSupplyCardItemCreateView
     */
    placeId?: number;
}
/**
 * 
 * @export
 * @interface Stamping
 */
export interface Stamping {
    /**
     * ItemTypePropertySetId
     * @type {number}
     * @memberof Stamping
     */
    material: number;
}
/**
 * 
 * @export
 * @interface Stamping1
 */
export interface Stamping1 {
    /**
     * 
     * @type {PropertySetSelector}
     * @memberof Stamping1
     */
    material: PropertySetSelector;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof Stamping1
     */
    reliefPlate?: number;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof Stamping1
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof Stamping1
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof Stamping1
     */
    dosageRoller?: number;
    /**
     * 
     * @type {StepMode}
     * @memberof Stamping1
     */
    stepMode: StepMode;
}
/**
 * 
 * @export
 * @interface StampingView
 */
export interface StampingView {
    /**
     * 
     * @type {PropertySetSelectorView}
     * @memberof StampingView
     */
    material: PropertySetSelectorView;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof StampingView
     */
    reliefPlate?: ItemTypeVariant;
    /**
     * 
     * @type {ReliefPlateType}
     * @memberof StampingView
     */
    reliefPlateType: ReliefPlateType;
    /**
     * 
     * @type {Array<ReferencePattern>}
     * @memberof StampingView
     */
    referencePatterns?: Array<ReferencePattern>;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof StampingView
     */
    dosageRoller?: ItemTypeVariant;
    /**
     * 
     * @type {StepMode}
     * @memberof StampingView
     */
    stepMode: StepMode;
    /**
     * 
     * @type {StepType}
     * @memberof StampingView
     */
    stepType: StepType;
}
/**
 * 
 * @export
 * @interface StandardParameterView
 */
export interface StandardParameterView {
    /**
     * StandardParameterId
     * @type {number}
     * @memberof StandardParameterView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StandardParameterView
     */
    parameter: string;
}
/**
 * 
 * @export
 * @interface StartedApplying
 */
export interface StartedApplying {
    /**
     * 
     * @type {NexelemMergeImportStateType}
     * @memberof StartedApplying
     */
    tpe: NexelemMergeImportStateType;
}

/**
 * 
 * @export
 */
export const StepMode = {
    onBase: 1,
    onGlue: 2,
    onTop: 3,
    onUnderlay: 4
} as const;
export type StepMode = typeof StepMode[keyof typeof StepMode];


/**
 * 
 * @export
 */
export const StepType = {
    flexoColor: 1,
    sieveColor: 2,
    stamping: 3,
    lamination: 4,
    lacquering: 5,
    punching: 6,
    extrusion: 7,
    narrowedLacquering: 8,
    narrowedSieveLacquering: 9,
    digital: 10
} as const;
export type StepType = typeof StepType[keyof typeof StepType];

/**
 * @type StepView
 * 
 * @export
 */
export type StepView = { stepType: '1' } & FlexoColorView | { stepType: '10' } & DigitalView | { stepType: '2' } & SieveColorView | { stepType: '3' } & StampingView | { stepType: '4' } & LaminationView | { stepType: '5' } & LacqueringView | { stepType: '7' } & ExtrusionView | { stepType: '8' } & NarrowedLacqueringView | { stepType: '9' } & NarrowedSieveLacqueringView;
/**
 * 
 * @export
 * @interface StockAmountView
 */
export interface StockAmountView {
    /**
     * 
     * @type {number}
     * @memberof StockAmountView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof StockAmountView
     */
    date: string;
    /**
     * 
     * @type {BaseStockInteractionTypes}
     * @memberof StockAmountView
     */
    stockInteractionType?: BaseStockInteractionTypes;
    /**
     * 
     * @type {number}
     * @memberof StockAmountView
     */
    stockInteractionId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof StockAmountView
     */
    description?: Array<string>;
    /**
     * 
     * @type {CertaintyType}
     * @memberof StockAmountView
     */
    certainty: CertaintyType;
}
/**
 * 
 * @export
 * @interface StockInteractionView
 */
export interface StockInteractionView {
    /**
     * StockInteractionId
     * @type {number}
     * @memberof StockInteractionView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof StockInteractionView
     */
    stockType: string;
    /**
     * 
     * @type {string}
     * @memberof StockInteractionView
     */
    itemTypeVariantName: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof StockInteractionView
     */
    variantId: number;
    /**
     * 
     * @type {number}
     * @memberof StockInteractionView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof StockInteractionView
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof StockInteractionView
     */
    placeName: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof StockInteractionView
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof StockInteractionView
     */
    occurrence?: string;
    /**
     * 
     * @type {OccurrenceType}
     * @memberof StockInteractionView
     */
    occurrenceType: OccurrenceType;
    /**
     * 
     * @type {number}
     * @memberof StockInteractionView
     */
    sourceId: number;
    /**
     * 
     * @type {BaseStockInteractionTypes}
     * @memberof StockInteractionView
     */
    sourceType: BaseStockInteractionTypes;
    /**
     * 
     * @type {Array<DemandDestination>}
     * @memberof StockInteractionView
     */
    destinations?: Array<DemandDestination>;
}
/**
 * 
 * @export
 * @interface StocktakingListCountsheetView
 */
export interface StocktakingListCountsheetView {
    /**
     * CountsheetId
     * @type {number}
     * @memberof StocktakingListCountsheetView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof StocktakingListCountsheetView
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListCountsheetView
     */
    placeName: string;
    /**
     * 
     * @type {number}
     * @memberof StocktakingListCountsheetView
     */
    plannedEntries: number;
    /**
     * 
     * @type {number}
     * @memberof StocktakingListCountsheetView
     */
    entries: number;
    /**
     * 
     * @type {CountsheetStatus}
     * @memberof StocktakingListCountsheetView
     */
    status: CountsheetStatus;
    /**
     * UserId
     * @type {number}
     * @memberof StocktakingListCountsheetView
     */
    responsiblePersonId?: number;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListCountsheetView
     */
    responsiblePersonName?: string;
}
/**
 * 
 * @export
 * @interface StocktakingListRow
 */
export interface StocktakingListRow {
    /**
     * StocktakingId
     * @type {number}
     * @memberof StocktakingListRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListRow
     */
    comboSearch: string;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListRow
     */
    number?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof StocktakingListRow
     */
    places?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StocktakingListRow
     */
    placeNames?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof StocktakingListRow
     */
    workerIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof StocktakingListRow
     */
    workerNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListRow
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListRow
     */
    end?: string;
    /**
     * 
     * @type {StocktakingStatus}
     * @memberof StocktakingListRow
     */
    status: StocktakingStatus;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListRow
     */
    comment?: string;
    /**
     * 
     * @type {Array<WarehouseTag>}
     * @memberof StocktakingListRow
     */
    warehouseTags?: Array<WarehouseTag>;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListRow
     */
    acceptanceDate?: string;
    /**
     * UserId
     * @type {number}
     * @memberof StocktakingListRow
     */
    acceptorId?: number;
    /**
     * 
     * @type {string}
     * @memberof StocktakingListRow
     */
    acceptorName?: string;
    /**
     * 
     * @type {number}
     * @memberof StocktakingListRow
     */
    differencesCount: number;
    /**
     * 
     * @type {number}
     * @memberof StocktakingListRow
     */
    progress: number;
    /**
     * 
     * @type {Array<StocktakingListCountsheetView>}
     * @memberof StocktakingListRow
     */
    countsheets?: Array<StocktakingListCountsheetView>;
    /**
     * 
     * @type {number}
     * @memberof StocktakingListRow
     */
    netValueDiff?: number;
    /**
     * 
     * @type {number}
     * @memberof StocktakingListRow
     */
    grossValueDiff?: number;
}
/**
 * 
 * @export
 * @interface StocktakingSaveView
 */
export interface StocktakingSaveView {
    /**
     * StocktakingId
     * @type {number}
     * @memberof StocktakingSaveView
     */
    id?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof StocktakingSaveView
     */
    placeIds?: Array<number>;
    /**
     * 
     * @type {RangeOfT}
     * @memberof StocktakingSaveView
     */
    period: RangeOfT;
    /**
     * 
     * @type {Array<number>}
     * @memberof StocktakingSaveView
     */
    warehouseTagIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof StocktakingSaveView
     */
    comment?: string;
    /**
     * 
     * @type {Array<CountsheetSaveView>}
     * @memberof StocktakingSaveView
     */
    countsheets?: Array<CountsheetSaveView>;
}

/**
 * 
 * @export
 */
export const StocktakingStatus = {
    open: 1,
    inProgress: 2,
    toAccept: 3,
    done: 4,
    partiallyAccepted: 5
} as const;
export type StocktakingStatus = typeof StocktakingStatus[keyof typeof StocktakingStatus];

/**
 * 
 * @export
 * @interface StringLotIdentificationCode
 */
export interface StringLotIdentificationCode {
    /**
     * 
     * @type {string}
     * @memberof StringLotIdentificationCode
     */
    id: string;
    /**
     * 
     * @type {ProductionLotIdentificationCodeType}
     * @memberof StringLotIdentificationCode
     */
    tpe: ProductionLotIdentificationCodeType;
}
/**
 * @type SubordersHaveMultipleSuppliers
 * 
 * @export
 */
export type SubordersHaveMultipleSuppliers = { name: 'SubordersHaveMultipleSuppliers' } & LemmaSimpleErrorView;
/**
 * 
 * @export
 * @interface SupplyCardDetailsView
 */
export interface SupplyCardDetailsView {
    /**
     * 
     * @type {Array<SupplyOrderDetails>}
     * @memberof SupplyCardDetailsView
     */
    supplyOrdersDetails?: Array<SupplyOrderDetails>;
    /**
     * 
     * @type {Array<SupplyCardItemSimpleView>}
     * @memberof SupplyCardDetailsView
     */
    supplied?: Array<SupplyCardItemSimpleView>;
}
/**
 * 
 * @export
 * @interface SupplyCardItemSimpleView
 */
export interface SupplyCardItemSimpleView {
    /**
     * SupplyCardItemId
     * @type {number}
     * @memberof SupplyCardItemSimpleView
     */
    id: number;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof SupplyCardItemSimpleView
     */
    itemTypeVariant: ItemTypeVariant;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardItemSimpleView
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardItemSimpleView
     */
    supplyPlaceName: string;
    /**
     * 
     * @type {number}
     * @memberof SupplyCardItemSimpleView
     */
    amount: number;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof SupplyCardItemSimpleView
     */
    amountInBaseUnitType: AmountWithUnit;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardItemSimpleView
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface SupplyCardListView
 */
export interface SupplyCardListView {
    /**
     * SupplyCardId
     * @type {number}
     * @memberof SupplyCardListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    externalId?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    supplyOrderNumber: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupplyCardListView
     */
    supplyOrderIds?: Array<number>;
    /**
     * ContractorId
     * @type {number}
     * @memberof SupplyCardListView
     */
    supplierId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    cardNumbers?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupplyCardListView
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<WarehouseTag>}
     * @memberof SupplyCardListView
     */
    tags?: Array<WarehouseTag>;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    recipientFullName: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    deliveryDate: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    contractorName: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    contractorShortName: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    placeName: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupplyCardListView
     */
    isDeleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SupplyCardListView
     */
    isDraft: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplyCardListView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface SupplyOrderAcceptanceResolution
 */
export interface SupplyOrderAcceptanceResolution {
    /**
     * 
     * @type {boolean}
     * @memberof SupplyOrderAcceptanceResolution
     */
    requiresAcceptance: boolean;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderAcceptanceResolution
     */
    valueThreshold?: number;
}
/**
 * 
 * @export
 * @interface SupplyOrderBasicData
 */
export interface SupplyOrderBasicData {
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderBasicData
     */
    deliveryDate: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupplyOrderBasicData
     */
    warehouseTags?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderBasicData
     */
    externalNumber?: string;
}
/**
 * 
 * @export
 * @interface SupplyOrderConfirmationSavingView
 */
export interface SupplyOrderConfirmationSavingView {
    /**
     * 
     * @type {Array<SupplyOrderConfirmationSuborderSavingView>}
     * @memberof SupplyOrderConfirmationSavingView
     */
    suborders?: Array<SupplyOrderConfirmationSuborderSavingView>;
}
/**
 * 
 * @export
 * @interface SupplyOrderConfirmationSuborderSavingView
 */
export interface SupplyOrderConfirmationSuborderSavingView {
    /**
     * ContractorId
     * @type {number}
     * @memberof SupplyOrderConfirmationSuborderSavingView
     */
    supplierId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderConfirmationSuborderSavingView
     */
    externalNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderConfirmationSuborderSavingView
     */
    deliveryDate: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderConfirmationSuborderSavingView
     */
    comment?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupplyOrderConfirmationSuborderSavingView
     */
    tags?: Array<number>;
    /**
     * 
     * @type {Array<SupplyOrderItemSavingView>}
     * @memberof SupplyOrderConfirmationSuborderSavingView
     */
    items?: Array<SupplyOrderItemSavingView>;
}
/**
 * 
 * @export
 * @interface SupplyOrderConfirmationSuborderView
 */
export interface SupplyOrderConfirmationSuborderView {
    /**
     * ContractorId
     * @type {number}
     * @memberof SupplyOrderConfirmationSuborderView
     */
    supplierId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderConfirmationSuborderView
     */
    supplierName: string;
    /**
     * 
     * @type {Array<SupplyOrderItemSavingView>}
     * @memberof SupplyOrderConfirmationSuborderView
     */
    items?: Array<SupplyOrderItemSavingView>;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderConfirmationSuborderView
     */
    value: number;
}
/**
 * 
 * @export
 * @interface SupplyOrderConfirmationView
 */
export interface SupplyOrderConfirmationView {
    /**
     * 
     * @type {Array<SupplyOrderConfirmationSuborderView>}
     * @memberof SupplyOrderConfirmationView
     */
    suborders?: Array<SupplyOrderConfirmationSuborderView>;
}
/**
 * 
 * @export
 * @interface SupplyOrderDetails
 */
export interface SupplyOrderDetails {
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof SupplyOrderDetails
     */
    supplyOrderId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetails
     */
    supplyOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetails
     */
    plannedReceptionDate?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof SupplyOrderDetails
     */
    supplierId?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetails
     */
    supplierName?: string;
    /**
     * UserId
     * @type {number}
     * @memberof SupplyOrderDetails
     */
    authorId?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetails
     */
    authorFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetails
     */
    externalId?: string;
}
/**
 * 
 * @export
 * @interface SupplyOrderDetailsView
 */
export interface SupplyOrderDetailsView {
    /**
     * 
     * @type {Array<SupplyOrderItemSimpleView>}
     * @memberof SupplyOrderDetailsView
     */
    planned?: Array<SupplyOrderItemSimpleView>;
    /**
     * 
     * @type {Array<SupplyOrderItemSimpleView>}
     * @memberof SupplyOrderDetailsView
     */
    supplied?: Array<SupplyOrderItemSimpleView>;
}
/**
 * 
 * @export
 * @interface SupplyOrderDetailsView2
 */
export interface SupplyOrderDetailsView2 {
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetailsView2
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetailsView2
     */
    externalNumber?: string;
    /**
     * 
     * @type {InferredSupplyOrderStatus}
     * @memberof SupplyOrderDetailsView2
     */
    status: InferredSupplyOrderStatus;
    /**
     * 
     * @type {SupplyOrderAcceptanceResolution}
     * @memberof SupplyOrderDetailsView2
     */
    acceptanceResolution: SupplyOrderAcceptanceResolution;
    /**
     * ContractorId
     * @type {number}
     * @memberof SupplyOrderDetailsView2
     */
    supplierId?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetailsView2
     */
    supplierName?: string;
    /**
     * 
     * @type {Contact}
     * @memberof SupplyOrderDetailsView2
     */
    contact?: Contact;
    /**
     * UserId
     * @type {number}
     * @memberof SupplyOrderDetailsView2
     */
    responsiblePersonId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetailsView2
     */
    responsiblePersonName: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetailsView2
     */
    creationDate: string;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderDetailsView2
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetailsView2
     */
    deliveryDate?: string;
    /**
     * 
     * @type {Array<WarehouseTag>}
     * @memberof SupplyOrderDetailsView2
     */
    warehouseTags?: Array<WarehouseTag>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SupplyOrderDetailsView2
     */
    supplyCards?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDetailsView2
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface SupplyOrderDoesNotRequireAcceptance
 */
export interface SupplyOrderDoesNotRequireAcceptance {
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDoesNotRequireAcceptance
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderDoesNotRequireAcceptance
     */
    description: string;
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof SupplyOrderDoesNotRequireAcceptance
     */
    supplyOrderId: number;
}
/**
 * 
 * @export
 * @interface SupplyOrderHasNoContractor
 */
export interface SupplyOrderHasNoContractor {
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderHasNoContractor
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderHasNoContractor
     */
    description: string;
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof SupplyOrderHasNoContractor
     */
    supplyOrderId: number;
}
/**
 * 
 * @export
 * @interface SupplyOrderInitView
 */
export interface SupplyOrderInitView {
    /**
     * 
     * @type {Array<SupplyOrderItemInitView>}
     * @memberof SupplyOrderInitView
     */
    items?: Array<SupplyOrderItemInitView>;
}
/**
 * 
 * @export
 * @interface SupplyOrderItemInitView
 */
export interface SupplyOrderItemInitView {
    /**
     * SupplyOrderItemId
     * @type {number}
     * @memberof SupplyOrderItemInitView
     */
    id?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SupplyOrderItemInitView
     */
    variantId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemInitView
     */
    variantName: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemInitView
     */
    variantCode?: string;
    /**
     * 
     * @type {Array<SupplyOrderItemProductionLotDemand>}
     * @memberof SupplyOrderItemInitView
     */
    productionLots?: Array<SupplyOrderItemProductionLotDemand>;
    /**
     * 
     * @type {Array<SupplyOrderItemOrderItemDemand>}
     * @memberof SupplyOrderItemInitView
     */
    orderItems?: Array<SupplyOrderItemOrderItemDemand>;
    /**
     * ContractorId
     * @type {number}
     * @memberof SupplyOrderItemInitView
     */
    supplierId?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemInitView
     */
    supplierName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemInitView
     */
    unitType: string;
    /**
     * 
     * @type {Array<SecondaryUnitType>}
     * @memberof SupplyOrderItemInitView
     */
    secondaryUnitTypes?: Array<SecondaryUnitType>;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemInitView
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemInitView
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemInitView
     */
    amountInBaseUnit?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemInitView
     */
    baseUnitType?: string;
}
/**
 * 
 * @export
 * @interface SupplyOrderItemOrderItemDemand
 */
export interface SupplyOrderItemOrderItemDemand {
    /**
     * SalesEntryItemId
     * @type {number}
     * @memberof SupplyOrderItemOrderItemDemand
     */
    orderItemId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemOrderItemDemand
     */
    orderNumber: string;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemOrderItemDemand
     */
    ordinal: number;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemOrderItemDemand
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface SupplyOrderItemProductionLotDemand
 */
export interface SupplyOrderItemProductionLotDemand {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof SupplyOrderItemProductionLotDemand
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemProductionLotDemand
     */
    productionLotNumber: string;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemProductionLotDemand
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface SupplyOrderItemSavingView
 */
export interface SupplyOrderItemSavingView {
    /**
     * SupplyOrderItemId
     * @type {number}
     * @memberof SupplyOrderItemSavingView
     */
    id?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SupplyOrderItemSavingView
     */
    variantId: number;
    /**
     * ContractorId
     * @type {number}
     * @memberof SupplyOrderItemSavingView
     */
    supplierId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupplyOrderItemSavingView
     */
    productionLotIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupplyOrderItemSavingView
     */
    orderItemIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemSavingView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemSavingView
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemSavingView
     */
    unitPrice: number;
}
/**
 * 
 * @export
 * @interface SupplyOrderItemSimpleView
 */
export interface SupplyOrderItemSimpleView {
    /**
     * SupplyOrderItemId
     * @type {number}
     * @memberof SupplyOrderItemSimpleView
     */
    id: number;
    /**
     * 
     * @type {ItemTypeVariant}
     * @memberof SupplyOrderItemSimpleView
     */
    itemTypeVariant: ItemTypeVariant;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemSimpleView
     */
    productionUnitNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemSimpleView
     */
    supplyPlaceName?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderItemSimpleView
     */
    amount: number;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof SupplyOrderItemSimpleView
     */
    amountInBaseUnitType?: AmountWithUnit;
    /**
     * 
     * @type {boolean}
     * @memberof SupplyOrderItemSimpleView
     */
    supplied: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemSimpleView
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface SupplyOrderItemsAlreadyExists
 */
export interface SupplyOrderItemsAlreadyExists {
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemsAlreadyExists
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderItemsAlreadyExists
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupplyOrderItemsAlreadyExists
     */
    itemIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface SupplyOrderItemsSavingView
 */
export interface SupplyOrderItemsSavingView {
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof SupplyOrderItemsSavingView
     */
    supplyOrderId?: number;
    /**
     * 
     * @type {Array<SupplyOrderItemSavingView>}
     * @memberof SupplyOrderItemsSavingView
     */
    items?: Array<SupplyOrderItemSavingView>;
}
/**
 * 
 * @export
 * @interface SupplyOrderListView
 */
export interface SupplyOrderListView {
    /**
     * SupplyOrderId
     * @type {number}
     * @memberof SupplyOrderListView
     */
    id: number;
    /**
     * UserId
     * @type {number}
     * @memberof SupplyOrderListView
     */
    authorId?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    authorFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    authorLastName?: string;
    /**
     * UserId
     * @type {number}
     * @memberof SupplyOrderListView
     */
    lockedByUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    lockedByUserFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    internalId?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    externalId?: string;
    /**
     * ContractorId
     * @type {number}
     * @memberof SupplyOrderListView
     */
    supplierId?: number;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    supplierName?: string;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderListView
     */
    netValue: number;
    /**
     * 
     * @type {number}
     * @memberof SupplyOrderListView
     */
    grossValue: number;
    /**
     * 
     * @type {InferredSupplyOrderStatus}
     * @memberof SupplyOrderListView
     */
    inferredStatus: InferredSupplyOrderStatus;
    /**
     * 
     * @type {SupplyOrderStatus}
     * @memberof SupplyOrderListView
     */
    status: SupplyOrderStatus;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    plannedReceptionDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderListView
     */
    comments?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupplyOrderListView
     */
    tagIds?: Array<number>;
    /**
     * 
     * @type {Array<WarehouseTag>}
     * @memberof SupplyOrderListView
     */
    tags?: Array<WarehouseTag>;
}
/**
 * 
 * @export
 * @interface SupplyOrderLocked
 */
export interface SupplyOrderLocked {
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderLocked
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderLocked
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SupplyOrderLocked
     */
    user: string;
}
/**
 * @type SupplyOrderNotLocked
 * 
 * @export
 */
export type SupplyOrderNotLocked = { name: 'SupplyOrderNotLocked' } & LemmaSimpleErrorView;

/**
 * 
 * @export
 */
export const SupplyOrderStatus = {
    draft: 1,
    cancelled: 2,
    shipped: 3,
    sent: 4,
    inProduction: 5,
    readyToShip: 6,
    manualSent: 7,
    received: 8
} as const;
export type SupplyOrderStatus = typeof SupplyOrderStatus[keyof typeof SupplyOrderStatus];

/**
 * 
 * @export
 * @interface SupplyWarehouseStateWithPlannedDeliveriesViewRow
 */
export interface SupplyWarehouseStateWithPlannedDeliveriesViewRow {
    /**
     * 
     * @type {string}
     * @memberof SupplyWarehouseStateWithPlannedDeliveriesViewRow
     */
    date: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof SupplyWarehouseStateWithPlannedDeliveriesViewRow
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {number}
     * @memberof SupplyWarehouseStateWithPlannedDeliveriesViewRow
     */
    warehouseAmountBaseUnits: number;
    /**
     * 
     * @type {number}
     * @memberof SupplyWarehouseStateWithPlannedDeliveriesViewRow
     */
    plannedDeliveryAmountBaseUnits: number;
    /**
     * 
     * @type {number}
     * @memberof SupplyWarehouseStateWithPlannedDeliveriesViewRow
     */
    totalStateBaseUnits: number;
}

/**
 * 
 * @export
 */
export const SynchronizationStatus = {
    pending: 1,
    successful: 2,
    failed: 3
} as const;
export type SynchronizationStatus = typeof SynchronizationStatus[keyof typeof SynchronizationStatus];

/**
 * 
 * @export
 * @interface SynchronizationStatusListView
 */
export interface SynchronizationStatusListView {
    /**
     * ErpSynchronizationStatusId
     * @type {number}
     * @memberof SynchronizationStatusListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SynchronizationStatusListView
     */
    unitName: string;
    /**
     * 
     * @type {ErpSyncUnit}
     * @memberof SynchronizationStatusListView
     */
    unit: ErpSyncUnit;
    /**
     * 
     * @type {string}
     * @memberof SynchronizationStatusListView
     */
    syncAttempt: string;
    /**
     * 
     * @type {SynchronizationStatus}
     * @memberof SynchronizationStatusListView
     */
    synchronizationStatus: SynchronizationStatus;
    /**
     * 
     * @type {string}
     * @memberof SynchronizationStatusListView
     */
    error?: string;
    /**
     * 
     * @type {number}
     * @memberof SynchronizationStatusListView
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SynchronizationStatusListView
     */
    syncFrom: string;
    /**
     * 
     * @type {string}
     * @memberof SynchronizationStatusListView
     */
    syncTo: string;
    /**
     * 
     * @type {boolean}
     * @memberof SynchronizationStatusListView
     */
    isEmpty: boolean;
}
/**
 * 
 * @export
 * @interface SynchronizationTriggerError
 */
export interface SynchronizationTriggerError {
    /**
     * 
     * @type {string}
     * @memberof SynchronizationTriggerError
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SynchronizationTriggerError
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof SynchronizationTriggerError
     */
    message: string;
}
/**
 * 
 * @export
 * @interface SynchronizedRate
 */
export interface SynchronizedRate {
    /**
     * CurrencyExchangeRateId
     * @type {number}
     * @memberof SynchronizedRate
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SynchronizedRate
     */
    sourceCurrencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof SynchronizedRate
     */
    destinationCurrencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof SynchronizedRate
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof SynchronizedRate
     */
    exchangeRate: number;
}
/**
 * 
 * @export
 * @interface TaskTicketListElementView
 */
export interface TaskTicketListElementView {
    /**
     * TaskTicketId
     * @type {number}
     * @memberof TaskTicketListElementView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TaskTicketListElementView
     */
    dateCreated: string;
    /**
     * 
     * @type {TaskTicketType}
     * @memberof TaskTicketListElementView
     */
    ticketType: TaskTicketType;
    /**
     * 
     * @type {TaskTicketStatus}
     * @memberof TaskTicketListElementView
     */
    status: TaskTicketStatus;
    /**
     * 
     * @type {string}
     * @memberof TaskTicketListElementView
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTicketListElementView
     */
    resolution?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTicketListElementView
     */
    creatorName?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTicketListElementView
     */
    resolverName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTicketListElementView
     */
    isResolverDefined: boolean;
}

/**
 * 
 * @export
 */
export const TaskTicketStatus = {
    open: 1,
    inProgress: 2,
    resolved: 3
} as const;
export type TaskTicketStatus = typeof TaskTicketStatus[keyof typeof TaskTicketStatus];


/**
 * 
 * @export
 */
export const TaskTicketType = {
    task: 1,
    warrantyComplaint: 2
} as const;
export type TaskTicketType = typeof TaskTicketType[keyof typeof TaskTicketType];

/**
 * @type Technology
 * 
 * @export
 */
export type Technology = { tpe: 'pieces' } & Pieces | { tpe: 'printing' } & Printing | { tpe: 'reliefPlate' } & ReliefPlate | { tpe: 'scrolling' } & Scrolling;
/**
 * 
 * @export
 * @interface TechnologyMissing
 */
export interface TechnologyMissing {
    /**
     * 
     * @type {string}
     * @memberof TechnologyMissing
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TechnologyMissing
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TechnologyMissing
     */
    items: Array<string>;
}

/**
 * 
 * @export
 */
export const TechnologyType = {
    Printing: 'printing',
    Scrolling: 'scrolling',
    ReliefPlate: 'reliefPlate',
    Pieces: 'pieces'
} as const;
export type TechnologyType = typeof TechnologyType[keyof typeof TechnologyType];

/**
 * 
 * @export
 * @interface TechnologyView
 */
export interface TechnologyView {
    /**
     * 
     * @type {number}
     * @memberof TechnologyView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TechnologyView
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TechnologyView
     */
    active?: boolean;
}

/**
 * 
 * @export
 */
export const TemplateType = {
    offer: 1,
    zplLabel: 2,
    order: 3
} as const;
export type TemplateType = typeof TemplateType[keyof typeof TemplateType];

/**
 * 
 * @export
 * @interface TemplateView
 */
export interface TemplateView {
    /**
     * TemplateId
     * @type {number}
     * @memberof TemplateView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TemplateView
     */
    name: string;
}
/**
 * 
 * @export
 * @interface TimeRecordAssignment
 */
export interface TimeRecordAssignment {
    /**
     * 
     * @type {string}
     * @memberof TimeRecordAssignment
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof TimeRecordAssignment
     */
    to: string;
    /**
     * 
     * @type {TimeRecordType}
     * @memberof TimeRecordAssignment
     */
    timeRecordType: TimeRecordType;
}
/**
 * 
 * @export
 * @interface TimeRecordEventGetView
 */
export interface TimeRecordEventGetView {
    /**
     * SalesEntryId
     * @type {number}
     * @memberof TimeRecordEventGetView
     */
    orderId: number;
    /**
     * 
     * @type {string}
     * @memberof TimeRecordEventGetView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof TimeRecordEventGetView
     */
    to: string;
}
/**
 * 
 * @export
 * @interface TimeRecordEventView
 */
export interface TimeRecordEventView {
    /**
     * Time records grouped by worker ids
     * @type {{ [key: string]: Array<TimeRecordAssignment>; }}
     * @memberof TimeRecordEventView
     */
    workerTimeRecords: { [key: string]: Array<TimeRecordAssignment>; };
}

/**
 * 
 * @export
 */
export const TimeRecordType = {
    Availability: 2,
    AnnualLeave: 4,
    SickLeave: 5
} as const;
export type TimeRecordType = typeof TimeRecordType[keyof typeof TimeRecordType];

/**
 * 
 * @export
 * @interface TopDowntimesResponse
 */
export interface TopDowntimesResponse {
    /**
     * 
     * @type {Array<DowntimeCausePercentage>}
     * @memberof TopDowntimesResponse
     */
    topCauses?: Array<DowntimeCausePercentage>;
    /**
     * 
     * @type {Array<DowntimeProductTime>}
     * @memberof TopDowntimesResponse
     */
    topProducts?: Array<DowntimeProductTime>;
    /**
     * 
     * @type {Array<DowntimeEmployeeTime>}
     * @memberof TopDowntimesResponse
     */
    topEmployees?: Array<DowntimeEmployeeTime>;
}
/**
 * 
 * @export
 * @interface TopDowntimesResponseV2
 */
export interface TopDowntimesResponseV2 {
    /**
     * 
     * @type {Array<DowntimeReasonPercentageV2>}
     * @memberof TopDowntimesResponseV2
     */
    topCauses?: Array<DowntimeReasonPercentageV2>;
    /**
     * 
     * @type {Array<DowntimeProductTimeV2>}
     * @memberof TopDowntimesResponseV2
     */
    topProducts?: Array<DowntimeProductTimeV2>;
    /**
     * 
     * @type {Array<DowntimeEmployeeTimeV2>}
     * @memberof TopDowntimesResponseV2
     */
    topEmployees?: Array<DowntimeEmployeeTimeV2>;
}
/**
 * 
 * @export
 * @interface TopNoksResponse
 */
export interface TopNoksResponse {
    /**
     * 
     * @type {Array<NoksCausePercentage>}
     * @memberof TopNoksResponse
     */
    topCauses?: Array<NoksCausePercentage>;
    /**
     * 
     * @type {Array<NoksProductPercentage>}
     * @memberof TopNoksResponse
     */
    topProducts?: Array<NoksProductPercentage>;
    /**
     * 
     * @type {Array<NoksEmployeePercentage>}
     * @memberof TopNoksResponse
     */
    topEmployees?: Array<NoksEmployeePercentage>;
}
/**
 * 
 * @export
 * @interface TopNoksResponseV2
 */
export interface TopNoksResponseV2 {
    /**
     * 
     * @type {Array<NoksCausePercentageV2>}
     * @memberof TopNoksResponseV2
     */
    topCauses?: Array<NoksCausePercentageV2>;
    /**
     * 
     * @type {Array<NoksProductPercentage>}
     * @memberof TopNoksResponseV2
     */
    topProducts?: Array<NoksProductPercentage>;
    /**
     * 
     * @type {Array<NoksEmployeePercentage>}
     * @memberof TopNoksResponseV2
     */
    topEmployees?: Array<NoksEmployeePercentage>;
}
/**
 * 
 * @export
 * @interface TotalAvailabilityQuery
 */
export interface TotalAvailabilityQuery {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof TotalAvailabilityQuery
     */
    variantId: number;
    /**
     * 
     * @type {string}
     * @memberof TotalAvailabilityQuery
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof TotalAvailabilityQuery
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface TotalAvailabilityView
 */
export interface TotalAvailabilityView {
    /**
     * 
     * @type {number}
     * @memberof TotalAvailabilityView
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface TotalCounts
 */
export interface TotalCounts {
    /**
     * Counts for production lot statuses
     * @type {{ [key: string]: number; }}
     * @memberof TotalCounts
     */
    counts: { [key: string]: number; };
    /**
     * 
     * @type {KanbanWebsocketOutputType}
     * @memberof TotalCounts
     */
    outputType: KanbanWebsocketOutputType;
}
/**
 * 
 * @export
 * @interface TraceabilityGraphEdge
 */
export interface TraceabilityGraphEdge {
    /**
     * 
     * @type {string}
     * @memberof TraceabilityGraphEdge
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityGraphEdge
     */
    to: string;
    /**
     * 
     * @type {TraceabilityGraphEdgeType}
     * @memberof TraceabilityGraphEdge
     */
    edgeType: TraceabilityGraphEdgeType;
}

/**
 * 
 * @export
 */
export const TraceabilityGraphEdgeType = {
    ProductionLotToLotEdge: 'ProductionLotToLotEdge',
    ProductionUnitToLotEdge: 'ProductionUnitToLotEdge'
} as const;
export type TraceabilityGraphEdgeType = typeof TraceabilityGraphEdgeType[keyof typeof TraceabilityGraphEdgeType];

/**
 * @type TraceabilityGraphNode
 * 
 * @export
 */
export type TraceabilityGraphNode = { nodeType: 'ProductionLotNode' } & ProductionLotNodeView | { nodeType: 'ProductionUnitNode' } & ProductionUnitNodeView;

/**
 * 
 * @export
 */
export const TraceabilityGraphNodeType = {
    ProductionLotNode: 'ProductionLotNode',
    ProductionUnitNode: 'ProductionUnitNode'
} as const;
export type TraceabilityGraphNodeType = typeof TraceabilityGraphNodeType[keyof typeof TraceabilityGraphNodeType];

/**
 * 
 * @export
 * @interface TraceabilityGraphPart
 */
export interface TraceabilityGraphPart {
    /**
     * 
     * @type {Array<TraceabilityGraphNode>}
     * @memberof TraceabilityGraphPart
     */
    nodes?: Array<TraceabilityGraphNode>;
    /**
     * 
     * @type {Array<TraceabilityGraphEdge>}
     * @memberof TraceabilityGraphPart
     */
    edges?: Array<TraceabilityGraphEdge>;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityGraphPart
     */
    sourceNodeId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TraceabilityGraphPart
     */
    toHighlightIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface TraceabilityProductionUnitDetails
 */
export interface TraceabilityProductionUnitDetails {
    /**
     * StockItemId
     * @type {number}
     * @memberof TraceabilityProductionUnitDetails
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityProductionUnitDetails
     */
    externalId: string;
    /**
     * PlaceId
     * @type {number}
     * @memberof TraceabilityProductionUnitDetails
     */
    placeId: number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityProductionUnitDetails
     */
    placeName: string;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityProductionUnitDetails
     */
    placeLabel?: string;
    /**
     * 
     * @type {TraceabilityProductionUnitType}
     * @memberof TraceabilityProductionUnitDetails
     */
    productionUnitType: TraceabilityProductionUnitType;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityProductionUnitDetails
     */
    supplierName?: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof TraceabilityProductionUnitDetails
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof TraceabilityProductionUnitDetails
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {number}
     * @memberof TraceabilityProductionUnitDetails
     */
    currentStocks: number;
}

/**
 * 
 * @export
 */
export const TraceabilityProductionUnitType = {
    Product: 'product',
    Material: 'material'
} as const;
export type TraceabilityProductionUnitType = typeof TraceabilityProductionUnitType[keyof typeof TraceabilityProductionUnitType];

/**
 * 
 * @export
 * @interface TriedToStartMergeFromIllegalState
 */
export interface TriedToStartMergeFromIllegalState {
    /**
     * 
     * @type {string}
     * @memberof TriedToStartMergeFromIllegalState
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TriedToStartMergeFromIllegalState
     */
    description: string;
    /**
     * SimulationId
     * @type {number}
     * @memberof TriedToStartMergeFromIllegalState
     */
    simulationId: number;
    /**
     * 
     * @type {SimulationMergeStatus}
     * @memberof TriedToStartMergeFromIllegalState
     */
    state?: SimulationMergeStatus;
}
/**
 * 
 * @export
 * @interface Tuple2JsPathSeqJsonValidationError
 */
export interface Tuple2JsPathSeqJsonValidationError {
    /**
     * 
     * @type {JsPath}
     * @memberof Tuple2JsPathSeqJsonValidationError
     */
    _1: JsPath;
    /**
     * 
     * @type {Array<JsonValidationError>}
     * @memberof Tuple2JsPathSeqJsonValidationError
     */
    _2?: Array<JsonValidationError>;
}

/**
 * 
 * @export
 */
export const Type = {
    External: 'external',
    Internal: 'internal',
    New: 'new'
} as const;
export type Type = typeof Type[keyof typeof Type];

/**
 * 
 * @export
 * @interface UnassignedLotContextView
 */
export interface UnassignedLotContextView {
    /**
     * 
     * @type {number}
     * @memberof UnassignedLotContextView
     */
    qualifiedOnMachineWorkerCount: number;
    /**
     * 
     * @type {number}
     * @memberof UnassignedLotContextView
     */
    qualifiedAfterBrigadeFilterWorkerCount: number;
    /**
     * 
     * @type {number}
     * @memberof UnassignedLotContextView
     */
    passedAvailabilityChecksWorkerCount: number;
    /**
     * 
     * @type {number}
     * @memberof UnassignedLotContextView
     */
    passedHistoricalRequirementWorkerCount: number;
    /**
     * 
     * @type {number}
     * @memberof UnassignedLotContextView
     */
    alreadyAssignedWorkerCount: number;
    /**
     * 
     * @type {number}
     * @memberof UnassignedLotContextView
     */
    targetWorkerCount: number;
    /**
     * 
     * @type {string}
     * @memberof UnassignedLotContextView
     */
    humanReadableReason: string;
    /**
     * 
     * @type {number}
     * @memberof UnassignedLotContextView
     */
    calendarUnavailableWorkerCount: number;
    /**
     * 
     * @type {Array<ConflictingAssignmentView>}
     * @memberof UnassignedLotContextView
     */
    conflictingLotAssignments?: Array<ConflictingAssignmentView>;
}
/**
 * 
 * @export
 * @interface UnassignedLotView
 */
export interface UnassignedLotView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof UnassignedLotView
     */
    lotId: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof UnassignedLotView
     */
    variantId: number;
    /**
     * 
     * @type {string}
     * @memberof UnassignedLotView
     */
    variantName: string;
    /**
     * MachineId
     * @type {number}
     * @memberof UnassignedLotView
     */
    machineId?: number;
    /**
     * 
     * @type {string}
     * @memberof UnassignedLotView
     */
    machineName?: string;
    /**
     * 
     * @type {string}
     * @memberof UnassignedLotView
     */
    plannedStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof UnassignedLotView
     */
    plannedEndDate?: string;
    /**
     * 
     * @type {UnassignedLotContextView}
     * @memberof UnassignedLotView
     */
    noAssignmentContext: UnassignedLotContextView;
}
/**
 * 
 * @export
 * @interface UndefinedOccurrence
 */
export interface UndefinedOccurrence {
    /**
     * 
     * @type {OccurrenceType}
     * @memberof UndefinedOccurrence
     */
    occurrenceType: OccurrenceType;
}
/**
 * 
 * @export
 * @interface UnitNotDefinedAsSecondary
 */
export interface UnitNotDefinedAsSecondary {
    /**
     * 
     * @type {string}
     * @memberof UnitNotDefinedAsSecondary
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnitNotDefinedAsSecondary
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UnitNotDefinedAsSecondary
     */
    unitType: string;
    /**
     * ItemTypeId
     * @type {number}
     * @memberof UnitNotDefinedAsSecondary
     */
    itemTypeId: number;
}
/**
 * 
 * @export
 * @interface UnknownWorkerGroupIds
 */
export interface UnknownWorkerGroupIds {
    /**
     * 
     * @type {string}
     * @memberof UnknownWorkerGroupIds
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnknownWorkerGroupIds
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UnknownWorkerGroupIds
     */
    workerGroupIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface Unrecognized
 */
export interface Unrecognized {
    /**
     * 
     * @type {string}
     * @memberof Unrecognized
     */
    value: string;
    /**
     * 
     * @type {BarcodeActionType}
     * @memberof Unrecognized
     */
    tpe: BarcodeActionType;
}
/**
 * 
 * @export
 * @interface UnresolvedWorkerAssignment
 */
export interface UnresolvedWorkerAssignment {
    /**
     * 
     * @type {string}
     * @memberof UnresolvedWorkerAssignment
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedWorkerAssignment
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UnresolvedWorkerAssignment
     */
    workerIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface Url
 */
export interface Url {
    /**
     * 
     * @type {string}
     * @memberof Url
     */
    data: string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * UserId
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    nickName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    rfid?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    location: string;
    /**
     * 
     * @type {Lang}
     * @memberof User
     */
    language?: Lang;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    passwordChangeNeeded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    hidden: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    blocked: boolean;
}
/**
 * 
 * @export
 * @interface UserContextView
 */
export interface UserContextView {
    /**
     * UserId
     * @type {number}
     * @memberof UserContextView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserContextView
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof UserContextView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserContextView
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserContextView
     */
    nickName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserContextView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserContextView
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof UserContextView
     */
    rfid?: string;
    /**
     * 
     * @type {string}
     * @memberof UserContextView
     */
    location: string;
    /**
     * 
     * @type {Lang}
     * @memberof UserContextView
     */
    language?: Lang;
    /**
     * 
     * @type {boolean}
     * @memberof UserContextView
     */
    passwordChangeNeeded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserContextView
     */
    hidden: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserContextView
     */
    blocked: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserContextView
     */
    permissions?: Array<string>;
    /**
     * 
     * @type {Array<RoleView>}
     * @memberof UserContextView
     */
    roles?: Array<RoleView>;
    /**
     * 
     * @type {boolean}
     * @memberof UserContextView
     */
    isSuperAdmin: boolean;
}
/**
 * 
 * @export
 * @interface UserCreationView
 */
export interface UserCreationView {
    /**
     * 
     * @type {string}
     * @memberof UserCreationView
     */
    login: string;
    /**
     * 
     * @type {NewPassword}
     * @memberof UserCreationView
     */
    newPassword: NewPassword;
    /**
     * 
     * @type {string}
     * @memberof UserCreationView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreationView
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreationView
     */
    nickName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreationView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreationView
     */
    phone?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserCreationView
     */
    roles?: Array<number>;
    /**
     * 
     * @type {Lang}
     * @memberof UserCreationView
     */
    language?: Lang;
    /**
     * 
     * @type {string}
     * @memberof UserCreationView
     */
    rfid?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCreationView
     */
    location: string;
}
/**
 * 
 * @export
 * @interface UserListView
 */
export interface UserListView {
    /**
     * UserId
     * @type {number}
     * @memberof UserListView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserListView
     */
    login: string;
    /**
     * 
     * @type {string}
     * @memberof UserListView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserListView
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserListView
     */
    comboNameSearch: string;
    /**
     * 
     * @type {string}
     * @memberof UserListView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserListView
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserListView
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserListView
     */
    hidden: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserListView
     */
    blocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserListView
     */
    isWorker: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserListView
     */
    roleIds?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserListView
     */
    roleNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserListView
     */
    lastLogin?: string;
    /**
     * 
     * @type {number}
     * @memberof UserListView
     */
    workerId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserListView
     */
    hasRfid: boolean;
}
/**
 * 
 * @export
 * @interface UserShortView
 */
export interface UserShortView {
    /**
     * UserId
     * @type {number}
     * @memberof UserShortView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserShortView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserShortView
     */
    lastName: string;
}
/**
 * 
 * @export
 * @interface UserView
 */
export interface UserView {
    /**
     * UserId
     * @type {number}
     * @memberof UserView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserView
     */
    lastName: string;
}
/**
 * 
 * @export
 * @interface UserView1
 */
export interface UserView1 {
    /**
     * UserId
     * @type {number}
     * @memberof UserView1
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserView1
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserView1
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserView1
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserView1
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserView1
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserView1
     */
    workerId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserView1
     */
    roleNames?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserView1
     */
    hasRfid: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserView1
     */
    lastLogin?: string;
}
/**
 * 
 * @export
 * @interface ValidationResult
 */
export interface ValidationResult {
    /**
     * 
     * @type {string}
     * @memberof ValidationResult
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof ValidationResult
     */
    errors: object;
}
/**
 * 
 * @export
 * @interface VariantAvailabilityView
 */
export interface VariantAvailabilityView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof VariantAvailabilityView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof VariantAvailabilityView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof VariantAvailabilityView
     */
    currentDate: string;
    /**
     * 
     * @type {Array<AmountInPlace>}
     * @memberof VariantAvailabilityView
     */
    currentAvailability?: Array<AmountInPlace>;
    /**
     * 
     * @type {string}
     * @memberof VariantAvailabilityView
     */
    deadlineDate: string;
    /**
     * 
     * @type {Array<AmountInPlace>}
     * @memberof VariantAvailabilityView
     */
    deadlineAvailability?: Array<AmountInPlace>;
    /**
     * 
     * @type {string}
     * @memberof VariantAvailabilityView
     */
    unitType: string;
}
/**
 * 
 * @export
 * @interface VariantCostEntrySavingView
 */
export interface VariantCostEntrySavingView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof VariantCostEntrySavingView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {number}
     * @memberof VariantCostEntrySavingView
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof VariantCostEntrySavingView
     */
    unitPrice: number;
}
/**
 * 
 * @export
 * @interface VariantCostEntryView
 */
export interface VariantCostEntryView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof VariantCostEntryView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof VariantCostEntryView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof VariantCostEntryView
     */
    itemTypeVariantCode?: string;
    /**
     * 
     * @type {number}
     * @memberof VariantCostEntryView
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof VariantCostEntryView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof VariantCostEntryView
     */
    unitPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof VariantCostEntryView
     */
    availableAmount: number;
}
/**
 * 
 * @export
 * @interface VariantDescription
 */
export interface VariantDescription {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof VariantDescription
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {CostUnit}
     * @memberof VariantDescription
     */
    costUnit: CostUnit;
}
/**
 * 
 * @export
 * @interface VariantMismatch
 */
export interface VariantMismatch {
    /**
     * 
     * @type {string}
     * @memberof VariantMismatch
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VariantMismatch
     */
    description: string;
    /**
     * ReleasePlanItemId
     * @type {number}
     * @memberof VariantMismatch
     */
    planItemId: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof VariantMismatch
     */
    expected: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof VariantMismatch
     */
    got: number;
}
/**
 * 
 * @export
 * @interface VatRateView
 */
export interface VatRateView {
    /**
     * VatRateId
     * @type {number}
     * @memberof VatRateView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof VatRateView
     */
    vatRate: number;
    /**
     * 
     * @type {string}
     * @memberof VatRateView
     */
    name: string;
}
/**
 * 
 * @export
 * @interface VehicleListView
 */
export interface VehicleListView {
    /**
     * VehicleId
     * @type {number}
     * @memberof VehicleListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleListView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleListView
     */
    registrationNumber: string;
    /**
     * 
     * @type {VehicleStatus}
     * @memberof VehicleListView
     */
    vehicleStatus: VehicleStatus;
}

/**
 * 
 * @export
 */
export const VehicleStatus = {
    free: 1,
    busy: 2,
    inRepair: 3,
    removed: 4
} as const;
export type VehicleStatus = typeof VehicleStatus[keyof typeof VehicleStatus];

/**
 * 
 * @export
 * @interface VersionT
 */
export interface VersionT {
    /**
     * 
     * @type {number}
     * @memberof VersionT
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof VersionT
     */
    creationDate: string;
    /**
     * 
     * @type {ItemTypeFootprint}
     * @memberof VersionT
     */
    footprint: ItemTypeFootprint;
}
/**
 * 
 * @export
 * @interface WarehouseStateListViewRow
 */
export interface WarehouseStateListViewRow {
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateListViewRow
     */
    date: string;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateListViewRow
     */
    comboSearch: string;
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateListViewRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateListViewRow
     */
    code?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof WarehouseStateListViewRow
     */
    itemTypeTagIds?: Array<number>;
    /**
     * 
     * @type {Array<ItemTypeTag>}
     * @memberof WarehouseStateListViewRow
     */
    itemTypeTags?: Array<ItemTypeTag>;
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateListViewRow
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    available: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    forecastAmount: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    historyAmount: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    minimalState: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    nowInWarehouses: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    inProduction: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    demand: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateListViewRow
     */
    ordered: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WarehouseStateListViewRow
     */
    placeId?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseStateListViewRow
     */
    hasNegativeAvailable: boolean;
}
/**
 * 
 * @export
 * @interface WarehouseStateToProductionListView
 */
export interface WarehouseStateToProductionListView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof WarehouseStateToProductionListView
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateToProductionListView
     */
    comboSearch: string;
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateToProductionListView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateToProductionListView
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof WarehouseStateToProductionListView
     */
    unitType: string;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateToProductionListView
     */
    available: number;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateToProductionListView
     */
    minimalState: number;
    /**
     * 
     * @type {AmountToProduce}
     * @memberof WarehouseStateToProductionListView
     */
    amountToProduce: AmountToProduce;
    /**
     * 
     * @type {number}
     * @memberof WarehouseStateToProductionListView
     */
    nowInWarehouses: number;
    /**
     * PlaceId
     * @type {number}
     * @memberof WarehouseStateToProductionListView
     */
    placeId?: number;
}
/**
 * 
 * @export
 * @interface WarehouseTag
 */
export interface WarehouseTag {
    /**
     * WarehouseTagId
     * @type {number}
     * @memberof WarehouseTag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseTag
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseTag
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface WarehouseTagListView
 */
export interface WarehouseTagListView {
    /**
     * WarehouseTagId
     * @type {number}
     * @memberof WarehouseTagListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WarehouseTagListView
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof WarehouseTagListView
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface WasteCauseView
 */
export interface WasteCauseView {
    /**
     * WasteCauseId
     * @type {number}
     * @memberof WasteCauseView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WasteCauseView
     */
    name: string;
}
/**
 * 
 * @export
 * @interface WorkReportCalendarEvent
 */
export interface WorkReportCalendarEvent {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof WorkReportCalendarEvent
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkReportCalendarEvent
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof WorkReportCalendarEvent
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof WorkReportCalendarEvent
     */
    registrantName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkReportCalendarEvent
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkReportCalendarEvent
     */
    salesEntryName: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkReportCalendarEvent
     */
    allDay: boolean;
    /**
     * 
     * @type {CalendarEventType}
     * @memberof WorkReportCalendarEvent
     */
    calendarEventType: CalendarEventType;
    /**
     * SalesEntryId
     * @type {number}
     * @memberof WorkReportCalendarEvent
     */
    salesEntryId: number;
    /**
     * 
     * @type {WorkerEventCalendarType}
     * @memberof WorkReportCalendarEvent
     */
    eventType: WorkerEventCalendarType;
}
/**
 * 
 * @export
 * @interface WorkerAddView
 */
export interface WorkerAddView {
    /**
     * 
     * @type {string}
     * @memberof WorkerAddView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerAddView
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerAddView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerAddView
     */
    phone?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkerAddView
     */
    roles?: Array<number>;
    /**
     * UserId
     * @type {number}
     * @memberof WorkerAddView
     */
    userId?: number;
}
/**
 * 
 * @export
 * @interface WorkerAssignmentRankingConfig
 */
export interface WorkerAssignmentRankingConfig {
    /**
     * 
     * @type {Array<WorkerAssignmentRankingCriterionWeight>}
     * @memberof WorkerAssignmentRankingConfig
     */
    criteria?: Array<WorkerAssignmentRankingCriterionWeight>;
}
/**
 * 
 * @export
 * @interface WorkerAssignmentRankingCriterionWeight
 */
export interface WorkerAssignmentRankingCriterionWeight {
    /**
     * 
     * @type {string}
     * @memberof WorkerAssignmentRankingCriterionWeight
     */
    criterion: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerAssignmentRankingCriterionWeight
     */
    enabled: boolean;
}
/**
 * 
 * @export
 * @interface WorkerAutoAssignmentDefaultsView
 */
export interface WorkerAutoAssignmentDefaultsView {
    /**
     * 
     * @type {number}
     * @memberof WorkerAutoAssignmentDefaultsView
     */
    minAvailabilityCoveragePercent: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerAutoAssignmentDefaultsView
     */
    requireHistoricalAssignment: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkerAutoAssignmentDefaultsView
     */
    historicalAssignmentsLookbackMonths: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerAutoAssignmentDefaultsView
     */
    minOverlapsForPairPerMonth: number;
}
/**
 * 
 * @export
 * @interface WorkerAutoAssignmentPolicySettings
 */
export interface WorkerAutoAssignmentPolicySettings {
    /**
     * 
     * @type {boolean}
     * @memberof WorkerAutoAssignmentPolicySettings
     */
    requireHistoricalAssignment?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkerAutoAssignmentPolicySettings
     */
    minAvailabilityCoveragePercent?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerAutoAssignmentPolicySettings
     */
    historicalAssignmentsLookbackMonths?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerAutoAssignmentPolicySettings
     */
    minOverlapsForPairPerMonth?: number;
}
/**
 * @type WorkerAutoAssignmentValidationSagaAutoAssignWorkersError
 * 
 * @export
 */
export type WorkerAutoAssignmentValidationSagaAutoAssignWorkersError = { name: 'AutoAssignmentRunningError' } & LemmaSimpleErrorView | { name: 'EmptyMachineAreaIds' } & LemmaSimpleErrorView | { name: 'EmptyWorkerGroupIds' } & LemmaSimpleErrorView | { name: 'InvalidAssignTimeWindow' } & InvalidAssignTimeWindow | { name: 'ResourceAssignmentsSyncFailed' } & ResourceAssignmentsSyncFailed | { name: 'UnknownWorkerGroupIds' } & UnknownWorkerGroupIds | { name: 'UnresolvedWorkerAssignment' } & UnresolvedWorkerAssignment | { name: 'WorkerGroupsOutsideMachineAreas' } & WorkerGroupsOutsideMachineAreas;
/**
 * 
 * @export
 * @interface WorkerCompetenceLevel
 */
export interface WorkerCompetenceLevel {
    /**
     * 
     * @type {CompetenceRate}
     * @memberof WorkerCompetenceLevel
     */
    rate?: CompetenceRate;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceLevel
     */
    achievementDate: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceLevel
     */
    expiryDate?: string;
}
/**
 * 
 * @export
 * @interface WorkerCompetenceListViewRow
 */
export interface WorkerCompetenceListViewRow {
    /**
     * WorkerCompetenceId
     * @type {number}
     * @memberof WorkerCompetenceListViewRow
     */
    workerCompetenceId: number;
    /**
     * WorkerId
     * @type {number}
     * @memberof WorkerCompetenceListViewRow
     */
    workerId: number;
    /**
     * CompetenceId
     * @type {number}
     * @memberof WorkerCompetenceListViewRow
     */
    competenceId: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceListViewRow
     */
    competenceName: string;
    /**
     * CompetenceCategoryId
     * @type {number}
     * @memberof WorkerCompetenceListViewRow
     */
    competenceCategoryId: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceListViewRow
     */
    competenceCategoryName: string;
    /**
     * 
     * @type {CompetenceRate}
     * @memberof WorkerCompetenceListViewRow
     */
    rate?: CompetenceRate;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceListViewRow
     */
    achievementDate: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceListViewRow
     */
    expiryDate?: string;
    /**
     * 
     * @type {Array<WorkerCompetenceLevel>}
     * @memberof WorkerCompetenceListViewRow
     */
    pastLevels?: Array<WorkerCompetenceLevel>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerCompetenceListViewRow
     */
    isfileAttached: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceListViewRow
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface WorkerCompetenceSaveView
 */
export interface WorkerCompetenceSaveView {
    /**
     * WorkerId
     * @type {number}
     * @memberof WorkerCompetenceSaveView
     */
    workerId: number;
    /**
     * CompetenceId
     * @type {number}
     * @memberof WorkerCompetenceSaveView
     */
    competenceId: number;
    /**
     * 
     * @type {CompetenceRate}
     * @memberof WorkerCompetenceSaveView
     */
    rate?: CompetenceRate;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceSaveView
     */
    achievementDate: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceSaveView
     */
    validityDate?: string;
    /**
     * CompetenceAuthorityId
     * @type {number}
     * @memberof WorkerCompetenceSaveView
     */
    authority?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceSaveView
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface WorkerCompetenceView
 */
export interface WorkerCompetenceView {
    /**
     * 
     * @type {CompetenceRate}
     * @memberof WorkerCompetenceView
     */
    rate?: CompetenceRate;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerCompetenceView
     */
    validityDate?: string;
}
/**
 * 
 * @export
 * @interface WorkerDocumentListViewRow
 */
export interface WorkerDocumentListViewRow {
    /**
     * WorkerDocumentId
     * @type {number}
     * @memberof WorkerDocumentListViewRow
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentListViewRow
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentListViewRow
     */
    fileName: string;
    /**
     * WorkerId
     * @type {number}
     * @memberof WorkerDocumentListViewRow
     */
    workerId: number;
    /**
     * 
     * @type {WorkerDocumentType}
     * @memberof WorkerDocumentListViewRow
     */
    documentType: WorkerDocumentType;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentListViewRow
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentListViewRow
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentListViewRow
     */
    downloadUrl: string;
}
/**
 * 
 * @export
 * @interface WorkerDocumentMetadataView
 */
export interface WorkerDocumentMetadataView {
    /**
     * WorkerDocumentId
     * @type {number}
     * @memberof WorkerDocumentMetadataView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentMetadataView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentMetadataView
     */
    fileName: string;
    /**
     * WorkerId
     * @type {number}
     * @memberof WorkerDocumentMetadataView
     */
    workerId: number;
    /**
     * 
     * @type {WorkerDocumentType}
     * @memberof WorkerDocumentMetadataView
     */
    documentType: WorkerDocumentType;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentMetadataView
     */
    dueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentMetadataView
     */
    creationDate: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentMetadataView
     */
    downloadUrl: string;
}

/**
 * 
 * @export
 */
export const WorkerDocumentType = {
    qualification: 1,
    examination: 2
} as const;
export type WorkerDocumentType = typeof WorkerDocumentType[keyof typeof WorkerDocumentType];

/**
 * 
 * @export
 * @interface WorkerDocumentUpdateView
 */
export interface WorkerDocumentUpdateView {
    /**
     * WorkerDocumentId
     * @type {number}
     * @memberof WorkerDocumentUpdateView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentUpdateView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentUpdateView
     */
    fileName: string;
    /**
     * 
     * @type {WorkerDocumentType}
     * @memberof WorkerDocumentUpdateView
     */
    documentType: WorkerDocumentType;
    /**
     * 
     * @type {string}
     * @memberof WorkerDocumentUpdateView
     */
    dueDate?: string;
}

/**
 * 
 * @export
 */
export const WorkerEventCalendarType = {
    WorkReport: 1,
    WorkerAnnualLeave: 2,
    WorkerSickLeave: 3,
    WorkerCompetenceDueDate: 4,
    WorkerDocumentDueDate: 5
} as const;
export type WorkerEventCalendarType = typeof WorkerEventCalendarType[keyof typeof WorkerEventCalendarType];

/**
 * @type WorkerEventCalendarView
 * 
 * @export
 */
export type WorkerEventCalendarView = { eventType: '1' } & WorkReportCalendarEvent | { eventType: '2' } & AnnualLeaveCalendarEvent | { eventType: '3' } & SickLeaveCalendarEvent | { eventType: '4' } & CompetenceDueDateCalendarEvent | { eventType: '5' } & DocumentDueDateCalendarEvent;
/**
 * 
 * @export
 * @interface WorkerEventFilterView
 */
export interface WorkerEventFilterView {
    /**
     * 
     * @type {string}
     * @memberof WorkerEventFilterView
     */
    date: string;
    /**
     * 
     * @type {Array<WorkerEventCalendarType>}
     * @memberof WorkerEventFilterView
     */
    calendarEventTypes?: Array<WorkerEventCalendarType>;
}
/**
 * 
 * @export
 * @interface WorkerEventSaveView
 */
export interface WorkerEventSaveView {
    /**
     * CalendarEventId
     * @type {number}
     * @memberof WorkerEventSaveView
     */
    id?: number;
    /**
     * WorkerId
     * @type {number}
     * @memberof WorkerEventSaveView
     */
    workerId: number;
    /**
     * 
     * @type {CalendarEventType}
     * @memberof WorkerEventSaveView
     */
    absenceType: CalendarEventType;
    /**
     * 
     * @type {string}
     * @memberof WorkerEventSaveView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerEventSaveView
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerEventSaveView
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerEventSaveView
     */
    allDay?: boolean;
}
/**
 * 
 * @export
 * @interface WorkerGroupsOutsideMachineAreas
 */
export interface WorkerGroupsOutsideMachineAreas {
    /**
     * 
     * @type {string}
     * @memberof WorkerGroupsOutsideMachineAreas
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerGroupsOutsideMachineAreas
     */
    description: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkerGroupsOutsideMachineAreas
     */
    workerGroupIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface WorkerListView
 */
export interface WorkerListView {
    /**
     * WorkerId
     * @type {number}
     * @memberof WorkerListView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerListView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerListView
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerListView
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerListView
     */
    login?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerListView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerListView
     */
    phone?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkerListView
     */
    roles?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkerListView
     */
    rolesIds?: Array<number>;
    /**
     * 
     * @type {Array<WorkerCompetenceView>}
     * @memberof WorkerListView
     */
    competences?: Array<WorkerCompetenceView>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerListView
     */
    hasCloseDueDate: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkerListView
     */
    competencesIds?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerListView
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface WorkerPickRationaleView
 */
export interface WorkerPickRationaleView {
    /**
     * UserId
     * @type {number}
     * @memberof WorkerPickRationaleView
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerPickRationaleView
     */
    summary: string;
    /**
     * 
     * @type {number}
     * @memberof WorkerPickRationaleView
     */
    rankAmongWorkersEligibleForRanking: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerPickRationaleView
     */
    historicalCombinedVariantAndMachineAssignmentCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerPickRationaleView
     */
    historicalVariantAssignmentCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerPickRationaleView
     */
    historicalMachineAssignmentCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerPickRationaleView
     */
    currentMachineInMemoryAssignmentCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerPickRationaleView
     */
    currentActiveLotAssignmentCount: number;
}
/**
 * 
 * @export
 * @interface WorkerSelectionContextView
 */
export interface WorkerSelectionContextView {
    /**
     * 
     * @type {number}
     * @memberof WorkerSelectionContextView
     */
    qualifiedOnMachineWorkerCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerSelectionContextView
     */
    qualifiedAfterBrigadeFilterWorkerCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerSelectionContextView
     */
    passedAvailabilityChecksWorkerCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerSelectionContextView
     */
    workersEligibleForRankingCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerSelectionContextView
     */
    workersAlreadyOnLotBeforeRunCount: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerSelectionContextView
     */
    targetWorkerCountForLot: number;
    /**
     * 
     * @type {number}
     * @memberof WorkerSelectionContextView
     */
    historicalAssignmentLookbackMonths: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkerSelectionContextView
     */
    mainCompetenceRequirements?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkerSelectionContextView
     */
    detailedCompetenceRequirements?: Array<string>;
}
/**
 * 
 * @export
 * @interface WorkerUpdateView
 */
export interface WorkerUpdateView {
    /**
     * WorkerId
     * @type {number}
     * @memberof WorkerUpdateView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerUpdateView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerUpdateView
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerUpdateView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerUpdateView
     */
    phone?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkerUpdateView
     */
    roles?: Array<number>;
}
/**
 * 
 * @export
 * @interface WorkerView
 */
export interface WorkerView {
    /**
     * WorkerId
     * @type {number}
     * @memberof WorkerView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkerView
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerView
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerView
     */
    login?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerView
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerView
     */
    phone?: string;
    /**
     * 
     * @type {Array<Role>}
     * @memberof WorkerView
     */
    roles?: Array<Role>;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerView
     */
    active: boolean;
    /**
     * 
     * @type {Array<WorkerCompetenceView>}
     * @memberof WorkerView
     */
    competences?: Array<WorkerCompetenceView>;
}
/**
 * 
 * @export
 * @interface Workstation
 */
export interface Workstation {
    /**
     * MachineId
     * @type {number}
     * @memberof Workstation
     */
    machineId: number;
    /**
     * 
     * @type {string}
     * @memberof Workstation
     */
    machineName: string;
    /**
     * 
     * @type {string}
     * @memberof Workstation
     */
    machineTag: string;
    /**
     * 
     * @type {WorkstationStatus}
     * @memberof Workstation
     */
    status: WorkstationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Workstation
     */
    isMyTask: boolean;
}
/**
 * 
 * @export
 * @interface WorkstationAmountReport
 */
export interface WorkstationAmountReport {
    /**
     * AmountReportId
     * @type {number}
     * @memberof WorkstationAmountReport
     */
    amountReportId: number;
    /**
     * ProductionLotId
     * @type {number}
     * @memberof WorkstationAmountReport
     */
    productionLotId: number;
    /**
     * UserId
     * @type {number}
     * @memberof WorkstationAmountReport
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationAmountReport
     */
    fullUserName?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationAmountReport
     */
    closingTime?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationAmountReport
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationAmountReport
     */
    isByproduct: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAmountReport
     */
    oks: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAmountReport
     */
    noks: number;
    /**
     * 
     * @type {Array<NokWithCause>}
     * @memberof WorkstationAmountReport
     */
    noksWithCauses?: Array<NokWithCause>;
    /**
     * 
     * @type {string}
     * @memberof WorkstationAmountReport
     */
    unitType: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationAmountReport
     */
    productCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationAmountReport
     */
    fromSensorReading: boolean;
}
/**
 * 
 * @export
 * @interface WorkstationAmountReportSaveView
 */
export interface WorkstationAmountReportSaveView {
    /**
     * AmountReportId
     * @type {number}
     * @memberof WorkstationAmountReportSaveView
     */
    amountReportId?: number;
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof WorkstationAmountReportSaveView
     */
    productVariantId: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAmountReportSaveView
     */
    oks: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAmountReportSaveView
     */
    noks: number;
    /**
     * 
     * @type {Array<NokWithCause>}
     * @memberof WorkstationAmountReportSaveView
     */
    noksWithCauses?: Array<NokWithCause>;
    /**
     * 
     * @type {string}
     * @memberof WorkstationAmountReportSaveView
     */
    readingDate?: string;
    /**
     * UserId
     * @type {number}
     * @memberof WorkstationAmountReportSaveView
     */
    workerId?: number;
}
/**
 * 
 * @export
 * @interface WorkstationAmountReportView
 */
export interface WorkstationAmountReportView {
    /**
     * 
     * @type {Array<WorkstationAmountReport>}
     * @memberof WorkstationAmountReportView
     */
    reports?: Array<WorkstationAmountReport>;
    /**
     * Product summary by product variant id
     * @type {{ [key: string]: ProductSummary; }}
     * @memberof WorkstationAmountReportView
     */
    summaries: { [key: string]: ProductSummary; };
    /**
     * Product summary by production lot id
     * @type {{ [key: string]: ProductSummary; }}
     * @memberof WorkstationAmountReportView
     */
    productionLotSummaries: { [key: string]: ProductSummary; };
}
/**
 * 
 * @export
 * @interface WorkstationAvailabilityView
 */
export interface WorkstationAvailabilityView {
    /**
     * 
     * @type {MachineView}
     * @memberof WorkstationAvailabilityView
     */
    machine: MachineView;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    workTimeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    workPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    breakTimeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    breakPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    downtimeTimeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    downtimePercentage: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    failureTimeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    failurePercentage: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    serviceTimeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    servicePercentage: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationAvailabilityView
     */
    availabilityPercentage: number;
}
/**
 * 
 * @export
 * @interface WorkstationBatchView
 */
export interface WorkstationBatchView {
    /**
     * BatchId
     * @type {number}
     * @memberof WorkstationBatchView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    name: string;
    /**
     * 
     * @type {ProductionLotStatusPlannedInProduction}
     * @memberof WorkstationBatchView
     */
    status: ProductionLotStatusPlannedInProduction;
    /**
     * 
     * @type {Array<WorkstationDashboardView>}
     * @memberof WorkstationBatchView
     */
    lots?: Array<WorkstationDashboardView>;
    /**
     * 
     * @type {number}
     * @memberof WorkstationBatchView
     */
    reportedOks?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationBatchView
     */
    noksPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationBatchView
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationBatchView
     */
    progress: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    productionStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    productionEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    estimatedStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    estimatedEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    productionPlanDueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    lastPauseDate?: string;
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof WorkstationBatchView
     */
    activeDowntimeBatchGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    activeDowntimeStart?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    totalDowntime: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchView
     */
    totalPauseTime: string;
}
/**
 * 
 * @export
 * @interface WorkstationBatchViewBase
 */
export interface WorkstationBatchViewBase {
    /**
     * BatchId
     * @type {number}
     * @memberof WorkstationBatchViewBase
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    name: string;
    /**
     * 
     * @type {ProductionLotStatusPlannedInProduction}
     * @memberof WorkstationBatchViewBase
     */
    status: ProductionLotStatusPlannedInProduction;
    /**
     * 
     * @type {Array<WorkstationDashboardView>}
     * @memberof WorkstationBatchViewBase
     */
    lots?: Array<WorkstationDashboardView>;
    /**
     * 
     * @type {number}
     * @memberof WorkstationBatchViewBase
     */
    reportedOks?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationBatchViewBase
     */
    noksPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationBatchViewBase
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationBatchViewBase
     */
    progress: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    productionStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    productionEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    estimatedStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    estimatedEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    productionPlanDueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    lastPauseDate?: string;
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof WorkstationBatchViewBase
     */
    activeDowntimeBatchGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    activeDowntimeStart?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    totalDowntime: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationBatchViewBase
     */
    totalPauseTime: string;
    /**
     * 
     * @type {WorkstationType}
     * @memberof WorkstationBatchViewBase
     */
    tpe: WorkstationType;
}
/**
 * 
 * @export
 * @interface WorkstationDashboardView
 */
export interface WorkstationDashboardView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    productionLotNumber: string;
    /**
     * 
     * @type {ProductionLotStatusPlannedInProduction}
     * @memberof WorkstationDashboardView
     */
    productionLotStatus: ProductionLotStatusPlannedInProduction;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    productionStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    productionEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    productionPlanDueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    overduePeriodThreshold: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    estimatedStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    estimatedEndDate?: string;
    /**
     * MachineId
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    machineId: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    machineName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    machineTag: string;
    /**
     * 
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    reportedOksAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    reportedNoksAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    unitType: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardView
     */
    requiresLoading: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardView
     */
    isLoaded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardView
     */
    canHaveByproducts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardView
     */
    hasSensor: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardView
     */
    hasMeasurements: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    totalDowntime: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    lastPauseDate?: string;
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    activeDowntimeId?: number;
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    activeDowntimeBatchGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    activeDowntimeStart?: string;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof WorkstationDashboardView
     */
    activeDowntimeReasonId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardView
     */
    isBehindSchedule: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardView
     */
    totalPauseTime: string;
}
/**
 * 
 * @export
 * @interface WorkstationDashboardViewBase
 */
export interface WorkstationDashboardViewBase {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    productionLotId: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    productionLotNumber: string;
    /**
     * 
     * @type {ProductionLotStatusPlannedInProduction}
     * @memberof WorkstationDashboardViewBase
     */
    productionLotStatus: ProductionLotStatusPlannedInProduction;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    productionStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    productionEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    productionPlanDueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    overduePeriodThreshold: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    productCode?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    estimatedStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    estimatedEndDate?: string;
    /**
     * MachineId
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    machineId: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    machineName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    machineTag: string;
    /**
     * 
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    reportedOksAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    reportedNoksAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    unitType: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardViewBase
     */
    requiresLoading: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardViewBase
     */
    isLoaded: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardViewBase
     */
    canHaveByproducts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardViewBase
     */
    hasSensor: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardViewBase
     */
    hasMeasurements: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    totalDowntime: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    lastPauseDate?: string;
    /**
     * DowntimeReportId
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    activeDowntimeId?: number;
    /**
     * DowntimeBatchGroupId
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    activeDowntimeBatchGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    activeDowntimeStart?: string;
    /**
     * DowntimeReasonId
     * @type {number}
     * @memberof WorkstationDashboardViewBase
     */
    activeDowntimeReasonId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationDashboardViewBase
     */
    isBehindSchedule: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDashboardViewBase
     */
    totalPauseTime: string;
    /**
     * 
     * @type {WorkstationType}
     * @memberof WorkstationDashboardViewBase
     */
    tpe: WorkstationType;
}
/**
 * 
 * @export
 * @interface WorkstationDocument
 */
export interface WorkstationDocument {
    /**
     * 
     * @type {string}
     * @memberof WorkstationDocument
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDocument
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationDocument
     */
    added?: string;
    /**
     * FileId
     * @type {number}
     * @memberof WorkstationDocument
     */
    fileId: number;
}
/**
 * @type WorkstationObjectView
 * 
 * @export
 */
export type WorkstationObjectView = { tpe: 'batch' } & WorkstationBatchViewBase | { tpe: 'lot' } & WorkstationDashboardViewBase;
/**
 * 
 * @export
 * @interface WorkstationPerformanceView
 */
export interface WorkstationPerformanceView {
    /**
     * 
     * @type {MachineView}
     * @memberof WorkstationPerformanceView
     */
    machine: MachineView;
    /**
     * 
     * @type {number}
     * @memberof WorkstationPerformanceView
     */
    plannedTimeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationPerformanceView
     */
    reportedTimeMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationPerformanceView
     */
    performancePercentage: number;
}
/**
 * 
 * @export
 * @interface WorkstationQualityView
 */
export interface WorkstationQualityView {
    /**
     * 
     * @type {MachineView}
     * @memberof WorkstationQualityView
     */
    machine: MachineView;
    /**
     * 
     * @type {number}
     * @memberof WorkstationQualityView
     */
    okPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationQualityView
     */
    nokPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationQualityView
     */
    qualityPercentage: number;
}

/**
 * 
 * @export
 */
export const WorkstationReportAmountType = {
    Oks: 'oks',
    Noks: 'noks'
} as const;
export type WorkstationReportAmountType = typeof WorkstationReportAmountType[keyof typeof WorkstationReportAmountType];

/**
 * 
 * @export
 * @interface WorkstationReportThresholds
 */
export interface WorkstationReportThresholds {
    /**
     * 
     * @type {ReportThresholds}
     * @memberof WorkstationReportThresholds
     */
    oks: ReportThresholds;
    /**
     * 
     * @type {ReportThresholds}
     * @memberof WorkstationReportThresholds
     */
    noks: ReportThresholds;
}
/**
 * 
 * @export
 * @interface WorkstationSensorActiveView
 */
export interface WorkstationSensorActiveView {
    /**
     * ItemTypeVariantId
     * @type {number}
     * @memberof WorkstationSensorActiveView
     */
    productVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationSensorActiveView
     */
    readingDate: string;
    /**
     * 
     * @type {number}
     * @memberof WorkstationSensorActiveView
     */
    oks?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationSensorActiveView
     */
    noks?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationSensorActiveView
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationSensorActiveView
     */
    isActive: boolean;
}
/**
 * @type WorkstationSensorAmountView
 * 
 * @export
 */
export type WorkstationSensorAmountView = { isActive: 'false' } & WorkstationSensorErrorView | { isActive: 'true' } & WorkstationSensorActiveView;
/**
 * 
 * @export
 * @interface WorkstationSensorErrorView
 */
export interface WorkstationSensorErrorView {
    /**
     * 
     * @type {MachineStateDetailsConnectionStatus}
     * @memberof WorkstationSensorErrorView
     */
    status: MachineStateDetailsConnectionStatus;
    /**
     * 
     * @type {boolean}
     * @memberof WorkstationSensorErrorView
     */
    isActive: boolean;
}

/**
 * 
 * @export
 */
export const WorkstationStatus = {
    inProgress: 1,
    inQueue: 2,
    noTasks: 3
} as const;
export type WorkstationStatus = typeof WorkstationStatus[keyof typeof WorkstationStatus];

/**
 * 
 * @export
 * @interface WorkstationTodoBatchView
 */
export interface WorkstationTodoBatchView {
    /**
     * BatchId
     * @type {number}
     * @memberof WorkstationTodoBatchView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoBatchView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoBatchView
     */
    number: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof WorkstationTodoBatchView
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoBatchView
     */
    reportedOks?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoBatchView
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoBatchView
     */
    progress: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoBatchView
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoBatchView
     */
    end?: string;
    /**
     * 
     * @type {Array<WorkstationTodoLotViewBase>}
     * @memberof WorkstationTodoBatchView
     */
    lots: Array<WorkstationTodoLotViewBase>;
    /**
     * 
     * @type {WorkstationTodoType}
     * @memberof WorkstationTodoBatchView
     */
    tpe: WorkstationTodoType;
}
/**
 * 
 * @export
 * @interface WorkstationTodoLotView
 */
export interface WorkstationTodoLotView {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof WorkstationTodoLotView
     */
    id: number;
    /**
     * BatchId
     * @type {number}
     * @memberof WorkstationTodoLotView
     */
    batchId?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    lotNumber: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    productCode?: string;
    /**
     * 
     * @type {Technology}
     * @memberof WorkstationTodoLotView
     */
    technologyName: Technology;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoLotView
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoLotView
     */
    progress: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoLotView
     */
    productAmount: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    unitType: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof WorkstationTodoLotView
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    areaName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    areaColor: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    machineName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    machineCode: string;
    /**
     * MachineId
     * @type {number}
     * @memberof WorkstationTodoLotView
     */
    machineId: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoLotView
     */
    oks: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    lastPauseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotView
     */
    activeDowntimeStart?: string;
    /**
     * 
     * @type {WorkstationTodoType}
     * @memberof WorkstationTodoLotView
     */
    tpe: WorkstationTodoType;
}
/**
 * 
 * @export
 * @interface WorkstationTodoLotViewBase
 */
export interface WorkstationTodoLotViewBase {
    /**
     * ProductionLotId
     * @type {number}
     * @memberof WorkstationTodoLotViewBase
     */
    id: number;
    /**
     * BatchId
     * @type {number}
     * @memberof WorkstationTodoLotViewBase
     */
    batchId?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    lotNumber: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    productCode?: string;
    /**
     * 
     * @type {Technology}
     * @memberof WorkstationTodoLotViewBase
     */
    technologyName: Technology;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoLotViewBase
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoLotViewBase
     */
    progress: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoLotViewBase
     */
    productAmount: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    unitType: string;
    /**
     * 
     * @type {ProductionLotStatus}
     * @memberof WorkstationTodoLotViewBase
     */
    status: ProductionLotStatus;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    areaName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    areaColor: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    machineName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    machineCode: string;
    /**
     * MachineId
     * @type {number}
     * @memberof WorkstationTodoLotViewBase
     */
    machineId: number;
    /**
     * 
     * @type {number}
     * @memberof WorkstationTodoLotViewBase
     */
    oks: number;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    lastPauseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkstationTodoLotViewBase
     */
    activeDowntimeStart?: string;
}

/**
 * 
 * @export
 */
export const WorkstationTodoType = {
    Lot: 'lot',
    Batch: 'batch'
} as const;
export type WorkstationTodoType = typeof WorkstationTodoType[keyof typeof WorkstationTodoType];

/**
 * @type WorkstationTodoView
 * 
 * @export
 */
export type WorkstationTodoView = { tpe: 'batch' } & WorkstationTodoBatchView | { tpe: 'lot' } & WorkstationTodoLotView;

/**
 * 
 * @export
 */
export const WorkstationType = {
    Lot: 'lot',
    Batch: 'batch'
} as const;
export type WorkstationType = typeof WorkstationType[keyof typeof WorkstationType];

